// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}

.fa,
.fa-classic,
.fa-sharp,
.fas,
.fa-solid,
.far,
.fa-regular,
.fab,
.fa-brands {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fas,
.fa-classic,
.fa-solid,
.far,
.fa-regular {
  font-family: "Font Awesome 6 Free";
}

.fab,
.fa-brands {
  font-family: "Font Awesome 6 Brands";
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0::before {
  content: "\\30 ";
}

.fa-1::before {
  content: "\\31 ";
}

.fa-2::before {
  content: "\\32 ";
}

.fa-3::before {
  content: "\\33 ";
}

.fa-4::before {
  content: "\\34 ";
}

.fa-5::before {
  content: "\\35 ";
}

.fa-6::before {
  content: "\\36 ";
}

.fa-7::before {
  content: "\\37 ";
}

.fa-8::before {
  content: "\\38 ";
}

.fa-9::before {
  content: "\\39 ";
}

.fa-fill-drip::before {
  content: "\\f576";
}

.fa-arrows-to-circle::before {
  content: "\\e4bd";
}

.fa-circle-chevron-right::before {
  content: "\\f138";
}

.fa-chevron-circle-right::before {
  content: "\\f138";
}

.fa-at::before {
  content: "\\@";
}

.fa-trash-can::before {
  content: "\\f2ed";
}

.fa-trash-alt::before {
  content: "\\f2ed";
}

.fa-text-height::before {
  content: "\\f034";
}

.fa-user-xmark::before {
  content: "\\f235";
}

.fa-user-times::before {
  content: "\\f235";
}

.fa-stethoscope::before {
  content: "\\f0f1";
}

.fa-message::before {
  content: "\\f27a";
}

.fa-comment-alt::before {
  content: "\\f27a";
}

.fa-info::before {
  content: "\\f129";
}

.fa-down-left-and-up-right-to-center::before {
  content: "\\f422";
}

.fa-compress-alt::before {
  content: "\\f422";
}

.fa-explosion::before {
  content: "\\e4e9";
}

.fa-file-lines::before {
  content: "\\f15c";
}

.fa-file-alt::before {
  content: "\\f15c";
}

.fa-file-text::before {
  content: "\\f15c";
}

.fa-wave-square::before {
  content: "\\f83e";
}

.fa-ring::before {
  content: "\\f70b";
}

.fa-building-un::before {
  content: "\\e4d9";
}

.fa-dice-three::before {
  content: "\\f527";
}

.fa-calendar-days::before {
  content: "\\f073";
}

.fa-calendar-alt::before {
  content: "\\f073";
}

.fa-anchor-circle-check::before {
  content: "\\e4aa";
}

.fa-building-circle-arrow-right::before {
  content: "\\e4d1";
}

.fa-volleyball::before {
  content: "\\f45f";
}

.fa-volleyball-ball::before {
  content: "\\f45f";
}

.fa-arrows-up-to-line::before {
  content: "\\e4c2";
}

.fa-sort-down::before {
  content: "\\f0dd";
}

.fa-sort-desc::before {
  content: "\\f0dd";
}

.fa-circle-minus::before {
  content: "\\f056";
}

.fa-minus-circle::before {
  content: "\\f056";
}

.fa-door-open::before {
  content: "\\f52b";
}

.fa-right-from-bracket::before {
  content: "\\f2f5";
}

.fa-sign-out-alt::before {
  content: "\\f2f5";
}

.fa-atom::before {
  content: "\\f5d2";
}

.fa-soap::before {
  content: "\\e06e";
}

.fa-icons::before {
  content: "\\f86d";
}

.fa-heart-music-camera-bolt::before {
  content: "\\f86d";
}

.fa-microphone-lines-slash::before {
  content: "\\f539";
}

.fa-microphone-alt-slash::before {
  content: "\\f539";
}

.fa-bridge-circle-check::before {
  content: "\\e4c9";
}

.fa-pump-medical::before {
  content: "\\e06a";
}

.fa-fingerprint::before {
  content: "\\f577";
}

.fa-hand-point-right::before {
  content: "\\f0a4";
}

.fa-magnifying-glass-location::before {
  content: "\\f689";
}

.fa-search-location::before {
  content: "\\f689";
}

.fa-forward-step::before {
  content: "\\f051";
}

.fa-step-forward::before {
  content: "\\f051";
}

.fa-face-smile-beam::before {
  content: "\\f5b8";
}

.fa-smile-beam::before {
  content: "\\f5b8";
}

.fa-flag-checkered::before {
  content: "\\f11e";
}

.fa-football::before {
  content: "\\f44e";
}

.fa-football-ball::before {
  content: "\\f44e";
}

.fa-school-circle-exclamation::before {
  content: "\\e56c";
}

.fa-crop::before {
  content: "\\f125";
}

.fa-angles-down::before {
  content: "\\f103";
}

.fa-angle-double-down::before {
  content: "\\f103";
}

.fa-users-rectangle::before {
  content: "\\e594";
}

.fa-people-roof::before {
  content: "\\e537";
}

.fa-people-line::before {
  content: "\\e534";
}

.fa-beer-mug-empty::before {
  content: "\\f0fc";
}

.fa-beer::before {
  content: "\\f0fc";
}

.fa-diagram-predecessor::before {
  content: "\\e477";
}

.fa-arrow-up-long::before {
  content: "\\f176";
}

.fa-long-arrow-up::before {
  content: "\\f176";
}

.fa-fire-flame-simple::before {
  content: "\\f46a";
}

.fa-burn::before {
  content: "\\f46a";
}

.fa-person::before {
  content: "\\f183";
}

.fa-male::before {
  content: "\\f183";
}

.fa-laptop::before {
  content: "\\f109";
}

.fa-file-csv::before {
  content: "\\f6dd";
}

.fa-menorah::before {
  content: "\\f676";
}

.fa-truck-plane::before {
  content: "\\e58f";
}

.fa-record-vinyl::before {
  content: "\\f8d9";
}

.fa-face-grin-stars::before {
  content: "\\f587";
}

.fa-grin-stars::before {
  content: "\\f587";
}

.fa-bong::before {
  content: "\\f55c";
}

.fa-spaghetti-monster-flying::before {
  content: "\\f67b";
}

.fa-pastafarianism::before {
  content: "\\f67b";
}

.fa-arrow-down-up-across-line::before {
  content: "\\e4af";
}

.fa-spoon::before {
  content: "\\f2e5";
}

.fa-utensil-spoon::before {
  content: "\\f2e5";
}

.fa-jar-wheat::before {
  content: "\\e517";
}

.fa-envelopes-bulk::before {
  content: "\\f674";
}

.fa-mail-bulk::before {
  content: "\\f674";
}

.fa-file-circle-exclamation::before {
  content: "\\e4eb";
}

.fa-circle-h::before {
  content: "\\f47e";
}

.fa-hospital-symbol::before {
  content: "\\f47e";
}

.fa-pager::before {
  content: "\\f815";
}

.fa-address-book::before {
  content: "\\f2b9";
}

.fa-contact-book::before {
  content: "\\f2b9";
}

.fa-strikethrough::before {
  content: "\\f0cc";
}

.fa-k::before {
  content: "K";
}

.fa-landmark-flag::before {
  content: "\\e51c";
}

.fa-pencil::before {
  content: "\\f303";
}

.fa-pencil-alt::before {
  content: "\\f303";
}

.fa-backward::before {
  content: "\\f04a";
}

.fa-caret-right::before {
  content: "\\f0da";
}

.fa-comments::before {
  content: "\\f086";
}

.fa-paste::before {
  content: "\\f0ea";
}

.fa-file-clipboard::before {
  content: "\\f0ea";
}

.fa-code-pull-request::before {
  content: "\\e13c";
}

.fa-clipboard-list::before {
  content: "\\f46d";
}

.fa-truck-ramp-box::before {
  content: "\\f4de";
}

.fa-truck-loading::before {
  content: "\\f4de";
}

.fa-user-check::before {
  content: "\\f4fc";
}

.fa-vial-virus::before {
  content: "\\e597";
}

.fa-sheet-plastic::before {
  content: "\\e571";
}

.fa-blog::before {
  content: "\\f781";
}

.fa-user-ninja::before {
  content: "\\f504";
}

.fa-person-arrow-up-from-line::before {
  content: "\\e539";
}

.fa-scroll-torah::before {
  content: "\\f6a0";
}

.fa-torah::before {
  content: "\\f6a0";
}

.fa-broom-ball::before {
  content: "\\f458";
}

.fa-quidditch::before {
  content: "\\f458";
}

.fa-quidditch-broom-ball::before {
  content: "\\f458";
}

.fa-toggle-off::before {
  content: "\\f204";
}

.fa-box-archive::before {
  content: "\\f187";
}

.fa-archive::before {
  content: "\\f187";
}

.fa-person-drowning::before {
  content: "\\e545";
}

.fa-arrow-down-9-1::before {
  content: "\\f886";
}

.fa-sort-numeric-desc::before {
  content: "\\f886";
}

.fa-sort-numeric-down-alt::before {
  content: "\\f886";
}

.fa-face-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-spray-can::before {
  content: "\\f5bd";
}

.fa-truck-monster::before {
  content: "\\f63b";
}

.fa-w::before {
  content: "W";
}

.fa-earth-africa::before {
  content: "\\f57c";
}

.fa-globe-africa::before {
  content: "\\f57c";
}

.fa-rainbow::before {
  content: "\\f75b";
}

.fa-circle-notch::before {
  content: "\\f1ce";
}

.fa-tablet-screen-button::before {
  content: "\\f3fa";
}

.fa-tablet-alt::before {
  content: "\\f3fa";
}

.fa-paw::before {
  content: "\\f1b0";
}

.fa-cloud::before {
  content: "\\f0c2";
}

.fa-trowel-bricks::before {
  content: "\\e58a";
}

.fa-face-flushed::before {
  content: "\\f579";
}

.fa-flushed::before {
  content: "\\f579";
}

.fa-hospital-user::before {
  content: "\\f80d";
}

.fa-tent-arrow-left-right::before {
  content: "\\e57f";
}

.fa-gavel::before {
  content: "\\f0e3";
}

.fa-legal::before {
  content: "\\f0e3";
}

.fa-binoculars::before {
  content: "\\f1e5";
}

.fa-microphone-slash::before {
  content: "\\f131";
}

.fa-box-tissue::before {
  content: "\\e05b";
}

.fa-motorcycle::before {
  content: "\\f21c";
}

.fa-bell-concierge::before {
  content: "\\f562";
}

.fa-concierge-bell::before {
  content: "\\f562";
}

.fa-pen-ruler::before {
  content: "\\f5ae";
}

.fa-pencil-ruler::before {
  content: "\\f5ae";
}

.fa-people-arrows::before {
  content: "\\e068";
}

.fa-people-arrows-left-right::before {
  content: "\\e068";
}

.fa-mars-and-venus-burst::before {
  content: "\\e523";
}

.fa-square-caret-right::before {
  content: "\\f152";
}

.fa-caret-square-right::before {
  content: "\\f152";
}

.fa-scissors::before {
  content: "\\f0c4";
}

.fa-cut::before {
  content: "\\f0c4";
}

.fa-sun-plant-wilt::before {
  content: "\\e57a";
}

.fa-toilets-portable::before {
  content: "\\e584";
}

.fa-hockey-puck::before {
  content: "\\f453";
}

.fa-table::before {
  content: "\\f0ce";
}

.fa-magnifying-glass-arrow-right::before {
  content: "\\e521";
}

.fa-tachograph-digital::before {
  content: "\\f566";
}

.fa-digital-tachograph::before {
  content: "\\f566";
}

.fa-users-slash::before {
  content: "\\e073";
}

.fa-clover::before {
  content: "\\e139";
}

.fa-reply::before {
  content: "\\f3e5";
}

.fa-mail-reply::before {
  content: "\\f3e5";
}

.fa-star-and-crescent::before {
  content: "\\f699";
}

.fa-house-fire::before {
  content: "\\e50c";
}

.fa-square-minus::before {
  content: "\\f146";
}

.fa-minus-square::before {
  content: "\\f146";
}

.fa-helicopter::before {
  content: "\\f533";
}

.fa-compass::before {
  content: "\\f14e";
}

.fa-square-caret-down::before {
  content: "\\f150";
}

.fa-caret-square-down::before {
  content: "\\f150";
}

.fa-file-circle-question::before {
  content: "\\e4ef";
}

.fa-laptop-code::before {
  content: "\\f5fc";
}

.fa-swatchbook::before {
  content: "\\f5c3";
}

.fa-prescription-bottle::before {
  content: "\\f485";
}

.fa-bars::before {
  content: "\\f0c9";
}

.fa-navicon::before {
  content: "\\f0c9";
}

.fa-people-group::before {
  content: "\\e533";
}

.fa-hourglass-end::before {
  content: "\\f253";
}

.fa-hourglass-3::before {
  content: "\\f253";
}

.fa-heart-crack::before {
  content: "\\f7a9";
}

.fa-heart-broken::before {
  content: "\\f7a9";
}

.fa-square-up-right::before {
  content: "\\f360";
}

.fa-external-link-square-alt::before {
  content: "\\f360";
}

.fa-face-kiss-beam::before {
  content: "\\f597";
}

.fa-kiss-beam::before {
  content: "\\f597";
}

.fa-film::before {
  content: "\\f008";
}

.fa-ruler-horizontal::before {
  content: "\\f547";
}

.fa-people-robbery::before {
  content: "\\e536";
}

.fa-lightbulb::before {
  content: "\\f0eb";
}

.fa-caret-left::before {
  content: "\\f0d9";
}

.fa-circle-exclamation::before {
  content: "\\f06a";
}

.fa-exclamation-circle::before {
  content: "\\f06a";
}

.fa-school-circle-xmark::before {
  content: "\\e56d";
}

.fa-arrow-right-from-bracket::before {
  content: "\\f08b";
}

.fa-sign-out::before {
  content: "\\f08b";
}

.fa-circle-chevron-down::before {
  content: "\\f13a";
}

.fa-chevron-circle-down::before {
  content: "\\f13a";
}

.fa-unlock-keyhole::before {
  content: "\\f13e";
}

.fa-unlock-alt::before {
  content: "\\f13e";
}

.fa-cloud-showers-heavy::before {
  content: "\\f740";
}

.fa-headphones-simple::before {
  content: "\\f58f";
}

.fa-headphones-alt::before {
  content: "\\f58f";
}

.fa-sitemap::before {
  content: "\\f0e8";
}

.fa-circle-dollar-to-slot::before {
  content: "\\f4b9";
}

.fa-donate::before {
  content: "\\f4b9";
}

.fa-memory::before {
  content: "\\f538";
}

.fa-road-spikes::before {
  content: "\\e568";
}

.fa-fire-burner::before {
  content: "\\e4f1";
}

.fa-flag::before {
  content: "\\f024";
}

.fa-hanukiah::before {
  content: "\\f6e6";
}

.fa-feather::before {
  content: "\\f52d";
}

.fa-volume-low::before {
  content: "\\f027";
}

.fa-volume-down::before {
  content: "\\f027";
}

.fa-comment-slash::before {
  content: "\\f4b3";
}

.fa-cloud-sun-rain::before {
  content: "\\f743";
}

.fa-compress::before {
  content: "\\f066";
}

.fa-wheat-awn::before {
  content: "\\e2cd";
}

.fa-wheat-alt::before {
  content: "\\e2cd";
}

.fa-ankh::before {
  content: "\\f644";
}

.fa-hands-holding-child::before {
  content: "\\e4fa";
}

.fa-asterisk::before {
  content: "\\*";
}

.fa-square-check::before {
  content: "\\f14a";
}

.fa-check-square::before {
  content: "\\f14a";
}

.fa-peseta-sign::before {
  content: "\\e221";
}

.fa-heading::before {
  content: "\\f1dc";
}

.fa-header::before {
  content: "\\f1dc";
}

.fa-ghost::before {
  content: "\\f6e2";
}

.fa-list::before {
  content: "\\f03a";
}

.fa-list-squares::before {
  content: "\\f03a";
}

.fa-square-phone-flip::before {
  content: "\\f87b";
}

.fa-phone-square-alt::before {
  content: "\\f87b";
}

.fa-cart-plus::before {
  content: "\\f217";
}

.fa-gamepad::before {
  content: "\\f11b";
}

.fa-circle-dot::before {
  content: "\\f192";
}

.fa-dot-circle::before {
  content: "\\f192";
}

.fa-face-dizzy::before {
  content: "\\f567";
}

.fa-dizzy::before {
  content: "\\f567";
}

.fa-egg::before {
  content: "\\f7fb";
}

.fa-house-medical-circle-xmark::before {
  content: "\\e513";
}

.fa-campground::before {
  content: "\\f6bb";
}

.fa-folder-plus::before {
  content: "\\f65e";
}

.fa-futbol::before {
  content: "\\f1e3";
}

.fa-futbol-ball::before {
  content: "\\f1e3";
}

.fa-soccer-ball::before {
  content: "\\f1e3";
}

.fa-paintbrush::before {
  content: "\\f1fc";
}

.fa-paint-brush::before {
  content: "\\f1fc";
}

.fa-lock::before {
  content: "\\f023";
}

.fa-gas-pump::before {
  content: "\\f52f";
}

.fa-hot-tub-person::before {
  content: "\\f593";
}

.fa-hot-tub::before {
  content: "\\f593";
}

.fa-map-location::before {
  content: "\\f59f";
}

.fa-map-marked::before {
  content: "\\f59f";
}

.fa-house-flood-water::before {
  content: "\\e50e";
}

.fa-tree::before {
  content: "\\f1bb";
}

.fa-bridge-lock::before {
  content: "\\e4cc";
}

.fa-sack-dollar::before {
  content: "\\f81d";
}

.fa-pen-to-square::before {
  content: "\\f044";
}

.fa-edit::before {
  content: "\\f044";
}

.fa-car-side::before {
  content: "\\f5e4";
}

.fa-share-nodes::before {
  content: "\\f1e0";
}

.fa-share-alt::before {
  content: "\\f1e0";
}

.fa-heart-circle-minus::before {
  content: "\\e4ff";
}

.fa-hourglass-half::before {
  content: "\\f252";
}

.fa-hourglass-2::before {
  content: "\\f252";
}

.fa-microscope::before {
  content: "\\f610";
}

.fa-sink::before {
  content: "\\e06d";
}

.fa-bag-shopping::before {
  content: "\\f290";
}

.fa-shopping-bag::before {
  content: "\\f290";
}

.fa-arrow-down-z-a::before {
  content: "\\f881";
}

.fa-sort-alpha-desc::before {
  content: "\\f881";
}

.fa-sort-alpha-down-alt::before {
  content: "\\f881";
}

.fa-mitten::before {
  content: "\\f7b5";
}

.fa-person-rays::before {
  content: "\\e54d";
}

.fa-users::before {
  content: "\\f0c0";
}

.fa-eye-slash::before {
  content: "\\f070";
}

.fa-flask-vial::before {
  content: "\\e4f3";
}

.fa-hand::before {
  content: "\\f256";
}

.fa-hand-paper::before {
  content: "\\f256";
}

.fa-om::before {
  content: "\\f679";
}

.fa-worm::before {
  content: "\\e599";
}

.fa-house-circle-xmark::before {
  content: "\\e50b";
}

.fa-plug::before {
  content: "\\f1e6";
}

.fa-chevron-up::before {
  content: "\\f077";
}

.fa-hand-spock::before {
  content: "\\f259";
}

.fa-stopwatch::before {
  content: "\\f2f2";
}

.fa-face-kiss::before {
  content: "\\f596";
}

.fa-kiss::before {
  content: "\\f596";
}

.fa-bridge-circle-xmark::before {
  content: "\\e4cb";
}

.fa-face-grin-tongue::before {
  content: "\\f589";
}

.fa-grin-tongue::before {
  content: "\\f589";
}

.fa-chess-bishop::before {
  content: "\\f43a";
}

.fa-face-grin-wink::before {
  content: "\\f58c";
}

.fa-grin-wink::before {
  content: "\\f58c";
}

.fa-ear-deaf::before {
  content: "\\f2a4";
}

.fa-deaf::before {
  content: "\\f2a4";
}

.fa-deafness::before {
  content: "\\f2a4";
}

.fa-hard-of-hearing::before {
  content: "\\f2a4";
}

.fa-road-circle-check::before {
  content: "\\e564";
}

.fa-dice-five::before {
  content: "\\f523";
}

.fa-square-rss::before {
  content: "\\f143";
}

.fa-rss-square::before {
  content: "\\f143";
}

.fa-land-mine-on::before {
  content: "\\e51b";
}

.fa-i-cursor::before {
  content: "\\f246";
}

.fa-stamp::before {
  content: "\\f5bf";
}

.fa-stairs::before {
  content: "\\e289";
}

.fa-i::before {
  content: "I";
}

.fa-hryvnia-sign::before {
  content: "\\f6f2";
}

.fa-hryvnia::before {
  content: "\\f6f2";
}

.fa-pills::before {
  content: "\\f484";
}

.fa-face-grin-wide::before {
  content: "\\f581";
}

.fa-grin-alt::before {
  content: "\\f581";
}

.fa-tooth::before {
  content: "\\f5c9";
}

.fa-v::before {
  content: "V";
}

.fa-bangladeshi-taka-sign::before {
  content: "\\e2e6";
}

.fa-bicycle::before {
  content: "\\f206";
}

.fa-staff-snake::before {
  content: "\\e579";
}

.fa-rod-asclepius::before {
  content: "\\e579";
}

.fa-rod-snake::before {
  content: "\\e579";
}

.fa-staff-aesculapius::before {
  content: "\\e579";
}

.fa-head-side-cough-slash::before {
  content: "\\e062";
}

.fa-truck-medical::before {
  content: "\\f0f9";
}

.fa-ambulance::before {
  content: "\\f0f9";
}

.fa-wheat-awn-circle-exclamation::before {
  content: "\\e598";
}

.fa-snowman::before {
  content: "\\f7d0";
}

.fa-mortar-pestle::before {
  content: "\\f5a7";
}

.fa-road-barrier::before {
  content: "\\e562";
}

.fa-school::before {
  content: "\\f549";
}

.fa-igloo::before {
  content: "\\f7ae";
}

.fa-joint::before {
  content: "\\f595";
}

.fa-angle-right::before {
  content: "\\f105";
}

.fa-horse::before {
  content: "\\f6f0";
}

.fa-q::before {
  content: "Q";
}

.fa-g::before {
  content: "G";
}

.fa-notes-medical::before {
  content: "\\f481";
}

.fa-temperature-half::before {
  content: "\\f2c9";
}

.fa-temperature-2::before {
  content: "\\f2c9";
}

.fa-thermometer-2::before {
  content: "\\f2c9";
}

.fa-thermometer-half::before {
  content: "\\f2c9";
}

.fa-dong-sign::before {
  content: "\\e169";
}

.fa-capsules::before {
  content: "\\f46b";
}

.fa-poo-storm::before {
  content: "\\f75a";
}

.fa-poo-bolt::before {
  content: "\\f75a";
}

.fa-face-frown-open::before {
  content: "\\f57a";
}

.fa-frown-open::before {
  content: "\\f57a";
}

.fa-hand-point-up::before {
  content: "\\f0a6";
}

.fa-money-bill::before {
  content: "\\f0d6";
}

.fa-bookmark::before {
  content: "\\f02e";
}

.fa-align-justify::before {
  content: "\\f039";
}

.fa-umbrella-beach::before {
  content: "\\f5ca";
}

.fa-helmet-un::before {
  content: "\\e503";
}

.fa-bullseye::before {
  content: "\\f140";
}

.fa-bacon::before {
  content: "\\f7e5";
}

.fa-hand-point-down::before {
  content: "\\f0a7";
}

.fa-arrow-up-from-bracket::before {
  content: "\\e09a";
}

.fa-folder::before {
  content: "\\f07b";
}

.fa-folder-blank::before {
  content: "\\f07b";
}

.fa-file-waveform::before {
  content: "\\f478";
}

.fa-file-medical-alt::before {
  content: "\\f478";
}

.fa-radiation::before {
  content: "\\f7b9";
}

.fa-chart-simple::before {
  content: "\\e473";
}

.fa-mars-stroke::before {
  content: "\\f229";
}

.fa-vial::before {
  content: "\\f492";
}

.fa-gauge::before {
  content: "\\f624";
}

.fa-dashboard::before {
  content: "\\f624";
}

.fa-gauge-med::before {
  content: "\\f624";
}

.fa-tachometer-alt-average::before {
  content: "\\f624";
}

.fa-wand-magic-sparkles::before {
  content: "\\e2ca";
}

.fa-magic-wand-sparkles::before {
  content: "\\e2ca";
}

.fa-e::before {
  content: "E";
}

.fa-pen-clip::before {
  content: "\\f305";
}

.fa-pen-alt::before {
  content: "\\f305";
}

.fa-bridge-circle-exclamation::before {
  content: "\\e4ca";
}

.fa-user::before {
  content: "\\f007";
}

.fa-school-circle-check::before {
  content: "\\e56b";
}

.fa-dumpster::before {
  content: "\\f793";
}

.fa-van-shuttle::before {
  content: "\\f5b6";
}

.fa-shuttle-van::before {
  content: "\\f5b6";
}

.fa-building-user::before {
  content: "\\e4da";
}

.fa-square-caret-left::before {
  content: "\\f191";
}

.fa-caret-square-left::before {
  content: "\\f191";
}

.fa-highlighter::before {
  content: "\\f591";
}

.fa-key::before {
  content: "\\f084";
}

.fa-bullhorn::before {
  content: "\\f0a1";
}

.fa-globe::before {
  content: "\\f0ac";
}

.fa-synagogue::before {
  content: "\\f69b";
}

.fa-person-half-dress::before {
  content: "\\e548";
}

.fa-road-bridge::before {
  content: "\\e563";
}

.fa-location-arrow::before {
  content: "\\f124";
}

.fa-c::before {
  content: "C";
}

.fa-tablet-button::before {
  content: "\\f10a";
}

.fa-building-lock::before {
  content: "\\e4d6";
}

.fa-pizza-slice::before {
  content: "\\f818";
}

.fa-money-bill-wave::before {
  content: "\\f53a";
}

.fa-chart-area::before {
  content: "\\f1fe";
}

.fa-area-chart::before {
  content: "\\f1fe";
}

.fa-house-flag::before {
  content: "\\e50d";
}

.fa-person-circle-minus::before {
  content: "\\e540";
}

.fa-ban::before {
  content: "\\f05e";
}

.fa-cancel::before {
  content: "\\f05e";
}

.fa-camera-rotate::before {
  content: "\\e0d8";
}

.fa-spray-can-sparkles::before {
  content: "\\f5d0";
}

.fa-air-freshener::before {
  content: "\\f5d0";
}

.fa-star::before {
  content: "\\f005";
}

.fa-repeat::before {
  content: "\\f363";
}

.fa-cross::before {
  content: "\\f654";
}

.fa-box::before {
  content: "\\f466";
}

.fa-venus-mars::before {
  content: "\\f228";
}

.fa-arrow-pointer::before {
  content: "\\f245";
}

.fa-mouse-pointer::before {
  content: "\\f245";
}

.fa-maximize::before {
  content: "\\f31e";
}

.fa-expand-arrows-alt::before {
  content: "\\f31e";
}

.fa-charging-station::before {
  content: "\\f5e7";
}

.fa-shapes::before {
  content: "\\f61f";
}

.fa-triangle-circle-square::before {
  content: "\\f61f";
}

.fa-shuffle::before {
  content: "\\f074";
}

.fa-random::before {
  content: "\\f074";
}

.fa-person-running::before {
  content: "\\f70c";
}

.fa-running::before {
  content: "\\f70c";
}

.fa-mobile-retro::before {
  content: "\\e527";
}

.fa-grip-lines-vertical::before {
  content: "\\f7a5";
}

.fa-spider::before {
  content: "\\f717";
}

.fa-hands-bound::before {
  content: "\\e4f9";
}

.fa-file-invoice-dollar::before {
  content: "\\f571";
}

.fa-plane-circle-exclamation::before {
  content: "\\e556";
}

.fa-x-ray::before {
  content: "\\f497";
}

.fa-spell-check::before {
  content: "\\f891";
}

.fa-slash::before {
  content: "\\f715";
}

.fa-computer-mouse::before {
  content: "\\f8cc";
}

.fa-mouse::before {
  content: "\\f8cc";
}

.fa-arrow-right-to-bracket::before {
  content: "\\f090";
}

.fa-sign-in::before {
  content: "\\f090";
}

.fa-shop-slash::before {
  content: "\\e070";
}

.fa-store-alt-slash::before {
  content: "\\e070";
}

.fa-server::before {
  content: "\\f233";
}

.fa-virus-covid-slash::before {
  content: "\\e4a9";
}

.fa-shop-lock::before {
  content: "\\e4a5";
}

.fa-hourglass-start::before {
  content: "\\f251";
}

.fa-hourglass-1::before {
  content: "\\f251";
}

.fa-blender-phone::before {
  content: "\\f6b6";
}

.fa-building-wheat::before {
  content: "\\e4db";
}

.fa-person-breastfeeding::before {
  content: "\\e53a";
}

.fa-right-to-bracket::before {
  content: "\\f2f6";
}

.fa-sign-in-alt::before {
  content: "\\f2f6";
}

.fa-venus::before {
  content: "\\f221";
}

.fa-passport::before {
  content: "\\f5ab";
}

.fa-heart-pulse::before {
  content: "\\f21e";
}

.fa-heartbeat::before {
  content: "\\f21e";
}

.fa-people-carry-box::before {
  content: "\\f4ce";
}

.fa-people-carry::before {
  content: "\\f4ce";
}

.fa-temperature-high::before {
  content: "\\f769";
}

.fa-microchip::before {
  content: "\\f2db";
}

.fa-crown::before {
  content: "\\f521";
}

.fa-weight-hanging::before {
  content: "\\f5cd";
}

.fa-xmarks-lines::before {
  content: "\\e59a";
}

.fa-file-prescription::before {
  content: "\\f572";
}

.fa-weight-scale::before {
  content: "\\f496";
}

.fa-weight::before {
  content: "\\f496";
}

.fa-user-group::before {
  content: "\\f500";
}

.fa-user-friends::before {
  content: "\\f500";
}

.fa-arrow-up-a-z::before {
  content: "\\f15e";
}

.fa-sort-alpha-up::before {
  content: "\\f15e";
}

.fa-chess-knight::before {
  content: "\\f441";
}

.fa-face-laugh-squint::before {
  content: "\\f59b";
}

.fa-laugh-squint::before {
  content: "\\f59b";
}

.fa-wheelchair::before {
  content: "\\f193";
}

.fa-circle-arrow-up::before {
  content: "\\f0aa";
}

.fa-arrow-circle-up::before {
  content: "\\f0aa";
}

.fa-toggle-on::before {
  content: "\\f205";
}

.fa-person-walking::before {
  content: "\\f554";
}

.fa-walking::before {
  content: "\\f554";
}

.fa-l::before {
  content: "L";
}

.fa-fire::before {
  content: "\\f06d";
}

.fa-bed-pulse::before {
  content: "\\f487";
}

.fa-procedures::before {
  content: "\\f487";
}

.fa-shuttle-space::before {
  content: "\\f197";
}

.fa-space-shuttle::before {
  content: "\\f197";
}

.fa-face-laugh::before {
  content: "\\f599";
}

.fa-laugh::before {
  content: "\\f599";
}

.fa-folder-open::before {
  content: "\\f07c";
}

.fa-heart-circle-plus::before {
  content: "\\e500";
}

.fa-code-fork::before {
  content: "\\e13b";
}

.fa-city::before {
  content: "\\f64f";
}

.fa-microphone-lines::before {
  content: "\\f3c9";
}

.fa-microphone-alt::before {
  content: "\\f3c9";
}

.fa-pepper-hot::before {
  content: "\\f816";
}

.fa-unlock::before {
  content: "\\f09c";
}

.fa-colon-sign::before {
  content: "\\e140";
}

.fa-headset::before {
  content: "\\f590";
}

.fa-store-slash::before {
  content: "\\e071";
}

.fa-road-circle-xmark::before {
  content: "\\e566";
}

.fa-user-minus::before {
  content: "\\f503";
}

.fa-mars-stroke-up::before {
  content: "\\f22a";
}

.fa-mars-stroke-v::before {
  content: "\\f22a";
}

.fa-champagne-glasses::before {
  content: "\\f79f";
}

.fa-glass-cheers::before {
  content: "\\f79f";
}

.fa-clipboard::before {
  content: "\\f328";
}

.fa-house-circle-exclamation::before {
  content: "\\e50a";
}

.fa-file-arrow-up::before {
  content: "\\f574";
}

.fa-file-upload::before {
  content: "\\f574";
}

.fa-wifi::before {
  content: "\\f1eb";
}

.fa-wifi-3::before {
  content: "\\f1eb";
}

.fa-wifi-strong::before {
  content: "\\f1eb";
}

.fa-bath::before {
  content: "\\f2cd";
}

.fa-bathtub::before {
  content: "\\f2cd";
}

.fa-underline::before {
  content: "\\f0cd";
}

.fa-user-pen::before {
  content: "\\f4ff";
}

.fa-user-edit::before {
  content: "\\f4ff";
}

.fa-signature::before {
  content: "\\f5b7";
}

.fa-stroopwafel::before {
  content: "\\f551";
}

.fa-bold::before {
  content: "\\f032";
}

.fa-anchor-lock::before {
  content: "\\e4ad";
}

.fa-building-ngo::before {
  content: "\\e4d7";
}

.fa-manat-sign::before {
  content: "\\e1d5";
}

.fa-not-equal::before {
  content: "\\f53e";
}

.fa-border-top-left::before {
  content: "\\f853";
}

.fa-border-style::before {
  content: "\\f853";
}

.fa-map-location-dot::before {
  content: "\\f5a0";
}

.fa-map-marked-alt::before {
  content: "\\f5a0";
}

.fa-jedi::before {
  content: "\\f669";
}

.fa-square-poll-vertical::before {
  content: "\\f681";
}

.fa-poll::before {
  content: "\\f681";
}

.fa-mug-hot::before {
  content: "\\f7b6";
}

.fa-car-battery::before {
  content: "\\f5df";
}

.fa-battery-car::before {
  content: "\\f5df";
}

.fa-gift::before {
  content: "\\f06b";
}

.fa-dice-two::before {
  content: "\\f528";
}

.fa-chess-queen::before {
  content: "\\f445";
}

.fa-glasses::before {
  content: "\\f530";
}

.fa-chess-board::before {
  content: "\\f43c";
}

.fa-building-circle-check::before {
  content: "\\e4d2";
}

.fa-person-chalkboard::before {
  content: "\\e53d";
}

.fa-mars-stroke-right::before {
  content: "\\f22b";
}

.fa-mars-stroke-h::before {
  content: "\\f22b";
}

.fa-hand-back-fist::before {
  content: "\\f255";
}

.fa-hand-rock::before {
  content: "\\f255";
}

.fa-square-caret-up::before {
  content: "\\f151";
}

.fa-caret-square-up::before {
  content: "\\f151";
}

.fa-cloud-showers-water::before {
  content: "\\e4e4";
}

.fa-chart-bar::before {
  content: "\\f080";
}

.fa-bar-chart::before {
  content: "\\f080";
}

.fa-hands-bubbles::before {
  content: "\\e05e";
}

.fa-hands-wash::before {
  content: "\\e05e";
}

.fa-less-than-equal::before {
  content: "\\f537";
}

.fa-train::before {
  content: "\\f238";
}

.fa-eye-low-vision::before {
  content: "\\f2a8";
}

.fa-low-vision::before {
  content: "\\f2a8";
}

.fa-crow::before {
  content: "\\f520";
}

.fa-sailboat::before {
  content: "\\e445";
}

.fa-window-restore::before {
  content: "\\f2d2";
}

.fa-square-plus::before {
  content: "\\f0fe";
}

.fa-plus-square::before {
  content: "\\f0fe";
}

.fa-torii-gate::before {
  content: "\\f6a1";
}

.fa-frog::before {
  content: "\\f52e";
}

.fa-bucket::before {
  content: "\\e4cf";
}

.fa-image::before {
  content: "\\f03e";
}

.fa-microphone::before {
  content: "\\f130";
}

.fa-cow::before {
  content: "\\f6c8";
}

.fa-caret-up::before {
  content: "\\f0d8";
}

.fa-screwdriver::before {
  content: "\\f54a";
}

.fa-folder-closed::before {
  content: "\\e185";
}

.fa-house-tsunami::before {
  content: "\\e515";
}

.fa-square-nfi::before {
  content: "\\e576";
}

.fa-arrow-up-from-ground-water::before {
  content: "\\e4b5";
}

.fa-martini-glass::before {
  content: "\\f57b";
}

.fa-glass-martini-alt::before {
  content: "\\f57b";
}

.fa-rotate-left::before {
  content: "\\f2ea";
}

.fa-rotate-back::before {
  content: "\\f2ea";
}

.fa-rotate-backward::before {
  content: "\\f2ea";
}

.fa-undo-alt::before {
  content: "\\f2ea";
}

.fa-table-columns::before {
  content: "\\f0db";
}

.fa-columns::before {
  content: "\\f0db";
}

.fa-lemon::before {
  content: "\\f094";
}

.fa-head-side-mask::before {
  content: "\\e063";
}

.fa-handshake::before {
  content: "\\f2b5";
}

.fa-gem::before {
  content: "\\f3a5";
}

.fa-dolly::before {
  content: "\\f472";
}

.fa-dolly-box::before {
  content: "\\f472";
}

.fa-smoking::before {
  content: "\\f48d";
}

.fa-minimize::before {
  content: "\\f78c";
}

.fa-compress-arrows-alt::before {
  content: "\\f78c";
}

.fa-monument::before {
  content: "\\f5a6";
}

.fa-snowplow::before {
  content: "\\f7d2";
}

.fa-angles-right::before {
  content: "\\f101";
}

.fa-angle-double-right::before {
  content: "\\f101";
}

.fa-cannabis::before {
  content: "\\f55f";
}

.fa-circle-play::before {
  content: "\\f144";
}

.fa-play-circle::before {
  content: "\\f144";
}

.fa-tablets::before {
  content: "\\f490";
}

.fa-ethernet::before {
  content: "\\f796";
}

.fa-euro-sign::before {
  content: "\\f153";
}

.fa-eur::before {
  content: "\\f153";
}

.fa-euro::before {
  content: "\\f153";
}

.fa-chair::before {
  content: "\\f6c0";
}

.fa-circle-check::before {
  content: "\\f058";
}

.fa-check-circle::before {
  content: "\\f058";
}

.fa-circle-stop::before {
  content: "\\f28d";
}

.fa-stop-circle::before {
  content: "\\f28d";
}

.fa-compass-drafting::before {
  content: "\\f568";
}

.fa-drafting-compass::before {
  content: "\\f568";
}

.fa-plate-wheat::before {
  content: "\\e55a";
}

.fa-icicles::before {
  content: "\\f7ad";
}

.fa-person-shelter::before {
  content: "\\e54f";
}

.fa-neuter::before {
  content: "\\f22c";
}

.fa-id-badge::before {
  content: "\\f2c1";
}

.fa-marker::before {
  content: "\\f5a1";
}

.fa-face-laugh-beam::before {
  content: "\\f59a";
}

.fa-laugh-beam::before {
  content: "\\f59a";
}

.fa-helicopter-symbol::before {
  content: "\\e502";
}

.fa-universal-access::before {
  content: "\\f29a";
}

.fa-circle-chevron-up::before {
  content: "\\f139";
}

.fa-chevron-circle-up::before {
  content: "\\f139";
}

.fa-lari-sign::before {
  content: "\\e1c8";
}

.fa-volcano::before {
  content: "\\f770";
}

.fa-person-walking-dashed-line-arrow-right::before {
  content: "\\e553";
}

.fa-sterling-sign::before {
  content: "\\f154";
}

.fa-gbp::before {
  content: "\\f154";
}

.fa-pound-sign::before {
  content: "\\f154";
}

.fa-viruses::before {
  content: "\\e076";
}

.fa-square-person-confined::before {
  content: "\\e577";
}

.fa-user-tie::before {
  content: "\\f508";
}

.fa-arrow-down-long::before {
  content: "\\f175";
}

.fa-long-arrow-down::before {
  content: "\\f175";
}

.fa-tent-arrow-down-to-line::before {
  content: "\\e57e";
}

.fa-certificate::before {
  content: "\\f0a3";
}

.fa-reply-all::before {
  content: "\\f122";
}

.fa-mail-reply-all::before {
  content: "\\f122";
}

.fa-suitcase::before {
  content: "\\f0f2";
}

.fa-person-skating::before {
  content: "\\f7c5";
}

.fa-skating::before {
  content: "\\f7c5";
}

.fa-filter-circle-dollar::before {
  content: "\\f662";
}

.fa-funnel-dollar::before {
  content: "\\f662";
}

.fa-camera-retro::before {
  content: "\\f083";
}

.fa-circle-arrow-down::before {
  content: "\\f0ab";
}

.fa-arrow-circle-down::before {
  content: "\\f0ab";
}

.fa-file-import::before {
  content: "\\f56f";
}

.fa-arrow-right-to-file::before {
  content: "\\f56f";
}

.fa-square-arrow-up-right::before {
  content: "\\f14c";
}

.fa-external-link-square::before {
  content: "\\f14c";
}

.fa-box-open::before {
  content: "\\f49e";
}

.fa-scroll::before {
  content: "\\f70e";
}

.fa-spa::before {
  content: "\\f5bb";
}

.fa-location-pin-lock::before {
  content: "\\e51f";
}

.fa-pause::before {
  content: "\\f04c";
}

.fa-hill-avalanche::before {
  content: "\\e507";
}

.fa-temperature-empty::before {
  content: "\\f2cb";
}

.fa-temperature-0::before {
  content: "\\f2cb";
}

.fa-thermometer-0::before {
  content: "\\f2cb";
}

.fa-thermometer-empty::before {
  content: "\\f2cb";
}

.fa-bomb::before {
  content: "\\f1e2";
}

.fa-registered::before {
  content: "\\f25d";
}

.fa-address-card::before {
  content: "\\f2bb";
}

.fa-contact-card::before {
  content: "\\f2bb";
}

.fa-vcard::before {
  content: "\\f2bb";
}

.fa-scale-unbalanced-flip::before {
  content: "\\f516";
}

.fa-balance-scale-right::before {
  content: "\\f516";
}

.fa-subscript::before {
  content: "\\f12c";
}

.fa-diamond-turn-right::before {
  content: "\\f5eb";
}

.fa-directions::before {
  content: "\\f5eb";
}

.fa-burst::before {
  content: "\\e4dc";
}

.fa-house-laptop::before {
  content: "\\e066";
}

.fa-laptop-house::before {
  content: "\\e066";
}

.fa-face-tired::before {
  content: "\\f5c8";
}

.fa-tired::before {
  content: "\\f5c8";
}

.fa-money-bills::before {
  content: "\\e1f3";
}

.fa-smog::before {
  content: "\\f75f";
}

.fa-crutch::before {
  content: "\\f7f7";
}

.fa-cloud-arrow-up::before {
  content: "\\f0ee";
}

.fa-cloud-upload::before {
  content: "\\f0ee";
}

.fa-cloud-upload-alt::before {
  content: "\\f0ee";
}

.fa-palette::before {
  content: "\\f53f";
}

.fa-arrows-turn-right::before {
  content: "\\e4c0";
}

.fa-vest::before {
  content: "\\e085";
}

.fa-ferry::before {
  content: "\\e4ea";
}

.fa-arrows-down-to-people::before {
  content: "\\e4b9";
}

.fa-seedling::before {
  content: "\\f4d8";
}

.fa-sprout::before {
  content: "\\f4d8";
}

.fa-left-right::before {
  content: "\\f337";
}

.fa-arrows-alt-h::before {
  content: "\\f337";
}

.fa-boxes-packing::before {
  content: "\\e4c7";
}

.fa-circle-arrow-left::before {
  content: "\\f0a8";
}

.fa-arrow-circle-left::before {
  content: "\\f0a8";
}

.fa-group-arrows-rotate::before {
  content: "\\e4f6";
}

.fa-bowl-food::before {
  content: "\\e4c6";
}

.fa-candy-cane::before {
  content: "\\f786";
}

.fa-arrow-down-wide-short::before {
  content: "\\f160";
}

.fa-sort-amount-asc::before {
  content: "\\f160";
}

.fa-sort-amount-down::before {
  content: "\\f160";
}

.fa-cloud-bolt::before {
  content: "\\f76c";
}

.fa-thunderstorm::before {
  content: "\\f76c";
}

.fa-text-slash::before {
  content: "\\f87d";
}

.fa-remove-format::before {
  content: "\\f87d";
}

.fa-face-smile-wink::before {
  content: "\\f4da";
}

.fa-smile-wink::before {
  content: "\\f4da";
}

.fa-file-word::before {
  content: "\\f1c2";
}

.fa-file-powerpoint::before {
  content: "\\f1c4";
}

.fa-arrows-left-right::before {
  content: "\\f07e";
}

.fa-arrows-h::before {
  content: "\\f07e";
}

.fa-house-lock::before {
  content: "\\e510";
}

.fa-cloud-arrow-down::before {
  content: "\\f0ed";
}

.fa-cloud-download::before {
  content: "\\f0ed";
}

.fa-cloud-download-alt::before {
  content: "\\f0ed";
}

.fa-children::before {
  content: "\\e4e1";
}

.fa-chalkboard::before {
  content: "\\f51b";
}

.fa-blackboard::before {
  content: "\\f51b";
}

.fa-user-large-slash::before {
  content: "\\f4fa";
}

.fa-user-alt-slash::before {
  content: "\\f4fa";
}

.fa-envelope-open::before {
  content: "\\f2b6";
}

.fa-handshake-simple-slash::before {
  content: "\\e05f";
}

.fa-handshake-alt-slash::before {
  content: "\\e05f";
}

.fa-mattress-pillow::before {
  content: "\\e525";
}

.fa-guarani-sign::before {
  content: "\\e19a";
}

.fa-arrows-rotate::before {
  content: "\\f021";
}

.fa-refresh::before {
  content: "\\f021";
}

.fa-sync::before {
  content: "\\f021";
}

.fa-fire-extinguisher::before {
  content: "\\f134";
}

.fa-cruzeiro-sign::before {
  content: "\\e152";
}

.fa-greater-than-equal::before {
  content: "\\f532";
}

.fa-shield-halved::before {
  content: "\\f3ed";
}

.fa-shield-alt::before {
  content: "\\f3ed";
}

.fa-book-atlas::before {
  content: "\\f558";
}

.fa-atlas::before {
  content: "\\f558";
}

.fa-virus::before {
  content: "\\e074";
}

.fa-envelope-circle-check::before {
  content: "\\e4e8";
}

.fa-layer-group::before {
  content: "\\f5fd";
}

.fa-arrows-to-dot::before {
  content: "\\e4be";
}

.fa-archway::before {
  content: "\\f557";
}

.fa-heart-circle-check::before {
  content: "\\e4fd";
}

.fa-house-chimney-crack::before {
  content: "\\f6f1";
}

.fa-house-damage::before {
  content: "\\f6f1";
}

.fa-file-zipper::before {
  content: "\\f1c6";
}

.fa-file-archive::before {
  content: "\\f1c6";
}

.fa-square::before {
  content: "\\f0c8";
}

.fa-martini-glass-empty::before {
  content: "\\f000";
}

.fa-glass-martini::before {
  content: "\\f000";
}

.fa-couch::before {
  content: "\\f4b8";
}

.fa-cedi-sign::before {
  content: "\\e0df";
}

.fa-italic::before {
  content: "\\f033";
}

.fa-table-cells-column-lock::before {
  content: "\\e678";
}

.fa-church::before {
  content: "\\f51d";
}

.fa-comments-dollar::before {
  content: "\\f653";
}

.fa-democrat::before {
  content: "\\f747";
}

.fa-z::before {
  content: "Z";
}

.fa-person-skiing::before {
  content: "\\f7c9";
}

.fa-skiing::before {
  content: "\\f7c9";
}

.fa-road-lock::before {
  content: "\\e567";
}

.fa-a::before {
  content: "A";
}

.fa-temperature-arrow-down::before {
  content: "\\e03f";
}

.fa-temperature-down::before {
  content: "\\e03f";
}

.fa-feather-pointed::before {
  content: "\\f56b";
}

.fa-feather-alt::before {
  content: "\\f56b";
}

.fa-p::before {
  content: "P";
}

.fa-snowflake::before {
  content: "\\f2dc";
}

.fa-newspaper::before {
  content: "\\f1ea";
}

.fa-rectangle-ad::before {
  content: "\\f641";
}

.fa-ad::before {
  content: "\\f641";
}

.fa-circle-arrow-right::before {
  content: "\\f0a9";
}

.fa-arrow-circle-right::before {
  content: "\\f0a9";
}

.fa-filter-circle-xmark::before {
  content: "\\e17b";
}

.fa-locust::before {
  content: "\\e520";
}

.fa-sort::before {
  content: "\\f0dc";
}

.fa-unsorted::before {
  content: "\\f0dc";
}

.fa-list-ol::before {
  content: "\\f0cb";
}

.fa-list-1-2::before {
  content: "\\f0cb";
}

.fa-list-numeric::before {
  content: "\\f0cb";
}

.fa-person-dress-burst::before {
  content: "\\e544";
}

.fa-money-check-dollar::before {
  content: "\\f53d";
}

.fa-money-check-alt::before {
  content: "\\f53d";
}

.fa-vector-square::before {
  content: "\\f5cb";
}

.fa-bread-slice::before {
  content: "\\f7ec";
}

.fa-language::before {
  content: "\\f1ab";
}

.fa-face-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-filter::before {
  content: "\\f0b0";
}

.fa-question::before {
  content: "\\?";
}

.fa-file-signature::before {
  content: "\\f573";
}

.fa-up-down-left-right::before {
  content: "\\f0b2";
}

.fa-arrows-alt::before {
  content: "\\f0b2";
}

.fa-house-chimney-user::before {
  content: "\\e065";
}

.fa-hand-holding-heart::before {
  content: "\\f4be";
}

.fa-puzzle-piece::before {
  content: "\\f12e";
}

.fa-money-check::before {
  content: "\\f53c";
}

.fa-star-half-stroke::before {
  content: "\\f5c0";
}

.fa-star-half-alt::before {
  content: "\\f5c0";
}

.fa-code::before {
  content: "\\f121";
}

.fa-whiskey-glass::before {
  content: "\\f7a0";
}

.fa-glass-whiskey::before {
  content: "\\f7a0";
}

.fa-building-circle-exclamation::before {
  content: "\\e4d3";
}

.fa-magnifying-glass-chart::before {
  content: "\\e522";
}

.fa-arrow-up-right-from-square::before {
  content: "\\f08e";
}

.fa-external-link::before {
  content: "\\f08e";
}

.fa-cubes-stacked::before {
  content: "\\e4e6";
}

.fa-won-sign::before {
  content: "\\f159";
}

.fa-krw::before {
  content: "\\f159";
}

.fa-won::before {
  content: "\\f159";
}

.fa-virus-covid::before {
  content: "\\e4a8";
}

.fa-austral-sign::before {
  content: "\\e0a9";
}

.fa-f::before {
  content: "F";
}

.fa-leaf::before {
  content: "\\f06c";
}

.fa-road::before {
  content: "\\f018";
}

.fa-taxi::before {
  content: "\\f1ba";
}

.fa-cab::before {
  content: "\\f1ba";
}

.fa-person-circle-plus::before {
  content: "\\e541";
}

.fa-chart-pie::before {
  content: "\\f200";
}

.fa-pie-chart::before {
  content: "\\f200";
}

.fa-bolt-lightning::before {
  content: "\\e0b7";
}

.fa-sack-xmark::before {
  content: "\\e56a";
}

.fa-file-excel::before {
  content: "\\f1c3";
}

.fa-file-contract::before {
  content: "\\f56c";
}

.fa-fish-fins::before {
  content: "\\e4f2";
}

.fa-building-flag::before {
  content: "\\e4d5";
}

.fa-face-grin-beam::before {
  content: "\\f582";
}

.fa-grin-beam::before {
  content: "\\f582";
}

.fa-object-ungroup::before {
  content: "\\f248";
}

.fa-poop::before {
  content: "\\f619";
}

.fa-location-pin::before {
  content: "\\f041";
}

.fa-map-marker::before {
  content: "\\f041";
}

.fa-kaaba::before {
  content: "\\f66b";
}

.fa-toilet-paper::before {
  content: "\\f71e";
}

.fa-helmet-safety::before {
  content: "\\f807";
}

.fa-hard-hat::before {
  content: "\\f807";
}

.fa-hat-hard::before {
  content: "\\f807";
}

.fa-eject::before {
  content: "\\f052";
}

.fa-circle-right::before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-right::before {
  content: "\\f35a";
}

.fa-plane-circle-check::before {
  content: "\\e555";
}

.fa-face-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-meh-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-object-group::before {
  content: "\\f247";
}

.fa-chart-line::before {
  content: "\\f201";
}

.fa-line-chart::before {
  content: "\\f201";
}

.fa-mask-ventilator::before {
  content: "\\e524";
}

.fa-arrow-right::before {
  content: "\\f061";
}

.fa-signs-post::before {
  content: "\\f277";
}

.fa-map-signs::before {
  content: "\\f277";
}

.fa-cash-register::before {
  content: "\\f788";
}

.fa-person-circle-question::before {
  content: "\\e542";
}

.fa-h::before {
  content: "H";
}

.fa-tarp::before {
  content: "\\e57b";
}

.fa-screwdriver-wrench::before {
  content: "\\f7d9";
}

.fa-tools::before {
  content: "\\f7d9";
}

.fa-arrows-to-eye::before {
  content: "\\e4bf";
}

.fa-plug-circle-bolt::before {
  content: "\\e55b";
}

.fa-heart::before {
  content: "\\f004";
}

.fa-mars-and-venus::before {
  content: "\\f224";
}

.fa-house-user::before {
  content: "\\e1b0";
}

.fa-home-user::before {
  content: "\\e1b0";
}

.fa-dumpster-fire::before {
  content: "\\f794";
}

.fa-house-crack::before {
  content: "\\e3b1";
}

.fa-martini-glass-citrus::before {
  content: "\\f561";
}

.fa-cocktail::before {
  content: "\\f561";
}

.fa-face-surprise::before {
  content: "\\f5c2";
}

.fa-surprise::before {
  content: "\\f5c2";
}

.fa-bottle-water::before {
  content: "\\e4c5";
}

.fa-circle-pause::before {
  content: "\\f28b";
}

.fa-pause-circle::before {
  content: "\\f28b";
}

.fa-toilet-paper-slash::before {
  content: "\\e072";
}

.fa-apple-whole::before {
  content: "\\f5d1";
}

.fa-apple-alt::before {
  content: "\\f5d1";
}

.fa-kitchen-set::before {
  content: "\\e51a";
}

.fa-r::before {
  content: "R";
}

.fa-temperature-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-1::before {
  content: "\\f2ca";
}

.fa-thermometer-1::before {
  content: "\\f2ca";
}

.fa-thermometer-quarter::before {
  content: "\\f2ca";
}

.fa-cube::before {
  content: "\\f1b2";
}

.fa-bitcoin-sign::before {
  content: "\\e0b4";
}

.fa-shield-dog::before {
  content: "\\e573";
}

.fa-solar-panel::before {
  content: "\\f5ba";
}

.fa-lock-open::before {
  content: "\\f3c1";
}

.fa-elevator::before {
  content: "\\e16d";
}

.fa-money-bill-transfer::before {
  content: "\\e528";
}

.fa-money-bill-trend-up::before {
  content: "\\e529";
}

.fa-house-flood-water-circle-arrow-right::before {
  content: "\\e50f";
}

.fa-square-poll-horizontal::before {
  content: "\\f682";
}

.fa-poll-h::before {
  content: "\\f682";
}

.fa-circle::before {
  content: "\\f111";
}

.fa-backward-fast::before {
  content: "\\f049";
}

.fa-fast-backward::before {
  content: "\\f049";
}

.fa-recycle::before {
  content: "\\f1b8";
}

.fa-user-astronaut::before {
  content: "\\f4fb";
}

.fa-plane-slash::before {
  content: "\\e069";
}

.fa-trademark::before {
  content: "\\f25c";
}

.fa-basketball::before {
  content: "\\f434";
}

.fa-basketball-ball::before {
  content: "\\f434";
}

.fa-satellite-dish::before {
  content: "\\f7c0";
}

.fa-circle-up::before {
  content: "\\f35b";
}

.fa-arrow-alt-circle-up::before {
  content: "\\f35b";
}

.fa-mobile-screen-button::before {
  content: "\\f3cd";
}

.fa-mobile-alt::before {
  content: "\\f3cd";
}

.fa-volume-high::before {
  content: "\\f028";
}

.fa-volume-up::before {
  content: "\\f028";
}

.fa-users-rays::before {
  content: "\\e593";
}

.fa-wallet::before {
  content: "\\f555";
}

.fa-clipboard-check::before {
  content: "\\f46c";
}

.fa-file-audio::before {
  content: "\\f1c7";
}

.fa-burger::before {
  content: "\\f805";
}

.fa-hamburger::before {
  content: "\\f805";
}

.fa-wrench::before {
  content: "\\f0ad";
}

.fa-bugs::before {
  content: "\\e4d0";
}

.fa-rupee-sign::before {
  content: "\\f156";
}

.fa-rupee::before {
  content: "\\f156";
}

.fa-file-image::before {
  content: "\\f1c5";
}

.fa-circle-question::before {
  content: "\\f059";
}

.fa-question-circle::before {
  content: "\\f059";
}

.fa-plane-departure::before {
  content: "\\f5b0";
}

.fa-handshake-slash::before {
  content: "\\e060";
}

.fa-book-bookmark::before {
  content: "\\e0bb";
}

.fa-code-branch::before {
  content: "\\f126";
}

.fa-hat-cowboy::before {
  content: "\\f8c0";
}

.fa-bridge::before {
  content: "\\e4c8";
}

.fa-phone-flip::before {
  content: "\\f879";
}

.fa-phone-alt::before {
  content: "\\f879";
}

.fa-truck-front::before {
  content: "\\e2b7";
}

.fa-cat::before {
  content: "\\f6be";
}

.fa-anchor-circle-exclamation::before {
  content: "\\e4ab";
}

.fa-truck-field::before {
  content: "\\e58d";
}

.fa-route::before {
  content: "\\f4d7";
}

.fa-clipboard-question::before {
  content: "\\e4e3";
}

.fa-panorama::before {
  content: "\\e209";
}

.fa-comment-medical::before {
  content: "\\f7f5";
}

.fa-teeth-open::before {
  content: "\\f62f";
}

.fa-file-circle-minus::before {
  content: "\\e4ed";
}

.fa-tags::before {
  content: "\\f02c";
}

.fa-wine-glass::before {
  content: "\\f4e3";
}

.fa-forward-fast::before {
  content: "\\f050";
}

.fa-fast-forward::before {
  content: "\\f050";
}

.fa-face-meh-blank::before {
  content: "\\f5a4";
}

.fa-meh-blank::before {
  content: "\\f5a4";
}

.fa-square-parking::before {
  content: "\\f540";
}

.fa-parking::before {
  content: "\\f540";
}

.fa-house-signal::before {
  content: "\\e012";
}

.fa-bars-progress::before {
  content: "\\f828";
}

.fa-tasks-alt::before {
  content: "\\f828";
}

.fa-faucet-drip::before {
  content: "\\e006";
}

.fa-cart-flatbed::before {
  content: "\\f474";
}

.fa-dolly-flatbed::before {
  content: "\\f474";
}

.fa-ban-smoking::before {
  content: "\\f54d";
}

.fa-smoking-ban::before {
  content: "\\f54d";
}

.fa-terminal::before {
  content: "\\f120";
}

.fa-mobile-button::before {
  content: "\\f10b";
}

.fa-house-medical-flag::before {
  content: "\\e514";
}

.fa-basket-shopping::before {
  content: "\\f291";
}

.fa-shopping-basket::before {
  content: "\\f291";
}

.fa-tape::before {
  content: "\\f4db";
}

.fa-bus-simple::before {
  content: "\\f55e";
}

.fa-bus-alt::before {
  content: "\\f55e";
}

.fa-eye::before {
  content: "\\f06e";
}

.fa-face-sad-cry::before {
  content: "\\f5b3";
}

.fa-sad-cry::before {
  content: "\\f5b3";
}

.fa-audio-description::before {
  content: "\\f29e";
}

.fa-person-military-to-person::before {
  content: "\\e54c";
}

.fa-file-shield::before {
  content: "\\e4f0";
}

.fa-user-slash::before {
  content: "\\f506";
}

.fa-pen::before {
  content: "\\f304";
}

.fa-tower-observation::before {
  content: "\\e586";
}

.fa-file-code::before {
  content: "\\f1c9";
}

.fa-signal::before {
  content: "\\f012";
}

.fa-signal-5::before {
  content: "\\f012";
}

.fa-signal-perfect::before {
  content: "\\f012";
}

.fa-bus::before {
  content: "\\f207";
}

.fa-heart-circle-xmark::before {
  content: "\\e501";
}

.fa-house-chimney::before {
  content: "\\e3af";
}

.fa-home-lg::before {
  content: "\\e3af";
}

.fa-window-maximize::before {
  content: "\\f2d0";
}

.fa-face-frown::before {
  content: "\\f119";
}

.fa-frown::before {
  content: "\\f119";
}

.fa-prescription::before {
  content: "\\f5b1";
}

.fa-shop::before {
  content: "\\f54f";
}

.fa-store-alt::before {
  content: "\\f54f";
}

.fa-floppy-disk::before {
  content: "\\f0c7";
}

.fa-save::before {
  content: "\\f0c7";
}

.fa-vihara::before {
  content: "\\f6a7";
}

.fa-scale-unbalanced::before {
  content: "\\f515";
}

.fa-balance-scale-left::before {
  content: "\\f515";
}

.fa-sort-up::before {
  content: "\\f0de";
}

.fa-sort-asc::before {
  content: "\\f0de";
}

.fa-comment-dots::before {
  content: "\\f4ad";
}

.fa-commenting::before {
  content: "\\f4ad";
}

.fa-plant-wilt::before {
  content: "\\e5aa";
}

.fa-diamond::before {
  content: "\\f219";
}

.fa-face-grin-squint::before {
  content: "\\f585";
}

.fa-grin-squint::before {
  content: "\\f585";
}

.fa-hand-holding-dollar::before {
  content: "\\f4c0";
}

.fa-hand-holding-usd::before {
  content: "\\f4c0";
}

.fa-bacterium::before {
  content: "\\e05a";
}

.fa-hand-pointer::before {
  content: "\\f25a";
}

.fa-drum-steelpan::before {
  content: "\\f56a";
}

.fa-hand-scissors::before {
  content: "\\f257";
}

.fa-hands-praying::before {
  content: "\\f684";
}

.fa-praying-hands::before {
  content: "\\f684";
}

.fa-arrow-rotate-right::before {
  content: "\\f01e";
}

.fa-arrow-right-rotate::before {
  content: "\\f01e";
}

.fa-arrow-rotate-forward::before {
  content: "\\f01e";
}

.fa-redo::before {
  content: "\\f01e";
}

.fa-biohazard::before {
  content: "\\f780";
}

.fa-location-crosshairs::before {
  content: "\\f601";
}

.fa-location::before {
  content: "\\f601";
}

.fa-mars-double::before {
  content: "\\f227";
}

.fa-child-dress::before {
  content: "\\e59c";
}

.fa-users-between-lines::before {
  content: "\\e591";
}

.fa-lungs-virus::before {
  content: "\\e067";
}

.fa-face-grin-tears::before {
  content: "\\f588";
}

.fa-grin-tears::before {
  content: "\\f588";
}

.fa-phone::before {
  content: "\\f095";
}

.fa-calendar-xmark::before {
  content: "\\f273";
}

.fa-calendar-times::before {
  content: "\\f273";
}

.fa-child-reaching::before {
  content: "\\e59d";
}

.fa-head-side-virus::before {
  content: "\\e064";
}

.fa-user-gear::before {
  content: "\\f4fe";
}

.fa-user-cog::before {
  content: "\\f4fe";
}

.fa-arrow-up-1-9::before {
  content: "\\f163";
}

.fa-sort-numeric-up::before {
  content: "\\f163";
}

.fa-door-closed::before {
  content: "\\f52a";
}

.fa-shield-virus::before {
  content: "\\e06c";
}

.fa-dice-six::before {
  content: "\\f526";
}

.fa-mosquito-net::before {
  content: "\\e52c";
}

.fa-bridge-water::before {
  content: "\\e4ce";
}

.fa-person-booth::before {
  content: "\\f756";
}

.fa-text-width::before {
  content: "\\f035";
}

.fa-hat-wizard::before {
  content: "\\f6e8";
}

.fa-pen-fancy::before {
  content: "\\f5ac";
}

.fa-person-digging::before {
  content: "\\f85e";
}

.fa-digging::before {
  content: "\\f85e";
}

.fa-trash::before {
  content: "\\f1f8";
}

.fa-gauge-simple::before {
  content: "\\f629";
}

.fa-gauge-simple-med::before {
  content: "\\f629";
}

.fa-tachometer-average::before {
  content: "\\f629";
}

.fa-book-medical::before {
  content: "\\f7e6";
}

.fa-poo::before {
  content: "\\f2fe";
}

.fa-quote-right::before {
  content: "\\f10e";
}

.fa-quote-right-alt::before {
  content: "\\f10e";
}

.fa-shirt::before {
  content: "\\f553";
}

.fa-t-shirt::before {
  content: "\\f553";
}

.fa-tshirt::before {
  content: "\\f553";
}

.fa-cubes::before {
  content: "\\f1b3";
}

.fa-divide::before {
  content: "\\f529";
}

.fa-tenge-sign::before {
  content: "\\f7d7";
}

.fa-tenge::before {
  content: "\\f7d7";
}

.fa-headphones::before {
  content: "\\f025";
}

.fa-hands-holding::before {
  content: "\\f4c2";
}

.fa-hands-clapping::before {
  content: "\\e1a8";
}

.fa-republican::before {
  content: "\\f75e";
}

.fa-arrow-left::before {
  content: "\\f060";
}

.fa-person-circle-xmark::before {
  content: "\\e543";
}

.fa-ruler::before {
  content: "\\f545";
}

.fa-align-left::before {
  content: "\\f036";
}

.fa-dice-d6::before {
  content: "\\f6d1";
}

.fa-restroom::before {
  content: "\\f7bd";
}

.fa-j::before {
  content: "J";
}

.fa-users-viewfinder::before {
  content: "\\e595";
}

.fa-file-video::before {
  content: "\\f1c8";
}

.fa-up-right-from-square::before {
  content: "\\f35d";
}

.fa-external-link-alt::before {
  content: "\\f35d";
}

.fa-table-cells::before {
  content: "\\f00a";
}

.fa-th::before {
  content: "\\f00a";
}

.fa-file-pdf::before {
  content: "\\f1c1";
}

.fa-book-bible::before {
  content: "\\f647";
}

.fa-bible::before {
  content: "\\f647";
}

.fa-o::before {
  content: "O";
}

.fa-suitcase-medical::before {
  content: "\\f0fa";
}

.fa-medkit::before {
  content: "\\f0fa";
}

.fa-user-secret::before {
  content: "\\f21b";
}

.fa-otter::before {
  content: "\\f700";
}

.fa-person-dress::before {
  content: "\\f182";
}

.fa-female::before {
  content: "\\f182";
}

.fa-comment-dollar::before {
  content: "\\f651";
}

.fa-business-time::before {
  content: "\\f64a";
}

.fa-briefcase-clock::before {
  content: "\\f64a";
}

.fa-table-cells-large::before {
  content: "\\f009";
}

.fa-th-large::before {
  content: "\\f009";
}

.fa-book-tanakh::before {
  content: "\\f827";
}

.fa-tanakh::before {
  content: "\\f827";
}

.fa-phone-volume::before {
  content: "\\f2a0";
}

.fa-volume-control-phone::before {
  content: "\\f2a0";
}

.fa-hat-cowboy-side::before {
  content: "\\f8c1";
}

.fa-clipboard-user::before {
  content: "\\f7f3";
}

.fa-child::before {
  content: "\\f1ae";
}

.fa-lira-sign::before {
  content: "\\f195";
}

.fa-satellite::before {
  content: "\\f7bf";
}

.fa-plane-lock::before {
  content: "\\e558";
}

.fa-tag::before {
  content: "\\f02b";
}

.fa-comment::before {
  content: "\\f075";
}

.fa-cake-candles::before {
  content: "\\f1fd";
}

.fa-birthday-cake::before {
  content: "\\f1fd";
}

.fa-cake::before {
  content: "\\f1fd";
}

.fa-envelope::before {
  content: "\\f0e0";
}

.fa-angles-up::before {
  content: "\\f102";
}

.fa-angle-double-up::before {
  content: "\\f102";
}

.fa-paperclip::before {
  content: "\\f0c6";
}

.fa-arrow-right-to-city::before {
  content: "\\e4b3";
}

.fa-ribbon::before {
  content: "\\f4d6";
}

.fa-lungs::before {
  content: "\\f604";
}

.fa-arrow-up-9-1::before {
  content: "\\f887";
}

.fa-sort-numeric-up-alt::before {
  content: "\\f887";
}

.fa-litecoin-sign::before {
  content: "\\e1d3";
}

.fa-border-none::before {
  content: "\\f850";
}

.fa-circle-nodes::before {
  content: "\\e4e2";
}

.fa-parachute-box::before {
  content: "\\f4cd";
}

.fa-indent::before {
  content: "\\f03c";
}

.fa-truck-field-un::before {
  content: "\\e58e";
}

.fa-hourglass::before {
  content: "\\f254";
}

.fa-hourglass-empty::before {
  content: "\\f254";
}

.fa-mountain::before {
  content: "\\f6fc";
}

.fa-user-doctor::before {
  content: "\\f0f0";
}

.fa-user-md::before {
  content: "\\f0f0";
}

.fa-circle-info::before {
  content: "\\f05a";
}

.fa-info-circle::before {
  content: "\\f05a";
}

.fa-cloud-meatball::before {
  content: "\\f73b";
}

.fa-camera::before {
  content: "\\f030";
}

.fa-camera-alt::before {
  content: "\\f030";
}

.fa-square-virus::before {
  content: "\\e578";
}

.fa-meteor::before {
  content: "\\f753";
}

.fa-car-on::before {
  content: "\\e4dd";
}

.fa-sleigh::before {
  content: "\\f7cc";
}

.fa-arrow-down-1-9::before {
  content: "\\f162";
}

.fa-sort-numeric-asc::before {
  content: "\\f162";
}

.fa-sort-numeric-down::before {
  content: "\\f162";
}

.fa-hand-holding-droplet::before {
  content: "\\f4c1";
}

.fa-hand-holding-water::before {
  content: "\\f4c1";
}

.fa-water::before {
  content: "\\f773";
}

.fa-calendar-check::before {
  content: "\\f274";
}

.fa-braille::before {
  content: "\\f2a1";
}

.fa-prescription-bottle-medical::before {
  content: "\\f486";
}

.fa-prescription-bottle-alt::before {
  content: "\\f486";
}

.fa-landmark::before {
  content: "\\f66f";
}

.fa-truck::before {
  content: "\\f0d1";
}

.fa-crosshairs::before {
  content: "\\f05b";
}

.fa-person-cane::before {
  content: "\\e53c";
}

.fa-tent::before {
  content: "\\e57d";
}

.fa-vest-patches::before {
  content: "\\e086";
}

.fa-check-double::before {
  content: "\\f560";
}

.fa-arrow-down-a-z::before {
  content: "\\f15d";
}

.fa-sort-alpha-asc::before {
  content: "\\f15d";
}

.fa-sort-alpha-down::before {
  content: "\\f15d";
}

.fa-money-bill-wheat::before {
  content: "\\e52a";
}

.fa-cookie::before {
  content: "\\f563";
}

.fa-arrow-rotate-left::before {
  content: "\\f0e2";
}

.fa-arrow-left-rotate::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-back::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-backward::before {
  content: "\\f0e2";
}

.fa-undo::before {
  content: "\\f0e2";
}

.fa-hard-drive::before {
  content: "\\f0a0";
}

.fa-hdd::before {
  content: "\\f0a0";
}

.fa-face-grin-squint-tears::before {
  content: "\\f586";
}

.fa-grin-squint-tears::before {
  content: "\\f586";
}

.fa-dumbbell::before {
  content: "\\f44b";
}

.fa-rectangle-list::before {
  content: "\\f022";
}

.fa-list-alt::before {
  content: "\\f022";
}

.fa-tarp-droplet::before {
  content: "\\e57c";
}

.fa-house-medical-circle-check::before {
  content: "\\e511";
}

.fa-person-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-calendar-plus::before {
  content: "\\f271";
}

.fa-plane-arrival::before {
  content: "\\f5af";
}

.fa-circle-left::before {
  content: "\\f359";
}

.fa-arrow-alt-circle-left::before {
  content: "\\f359";
}

.fa-train-subway::before {
  content: "\\f239";
}

.fa-subway::before {
  content: "\\f239";
}

.fa-chart-gantt::before {
  content: "\\e0e4";
}

.fa-indian-rupee-sign::before {
  content: "\\e1bc";
}

.fa-indian-rupee::before {
  content: "\\e1bc";
}

.fa-inr::before {
  content: "\\e1bc";
}

.fa-crop-simple::before {
  content: "\\f565";
}

.fa-crop-alt::before {
  content: "\\f565";
}

.fa-money-bill-1::before {
  content: "\\f3d1";
}

.fa-money-bill-alt::before {
  content: "\\f3d1";
}

.fa-left-long::before {
  content: "\\f30a";
}

.fa-long-arrow-alt-left::before {
  content: "\\f30a";
}

.fa-dna::before {
  content: "\\f471";
}

.fa-virus-slash::before {
  content: "\\e075";
}

.fa-minus::before {
  content: "\\f068";
}

.fa-subtract::before {
  content: "\\f068";
}

.fa-chess::before {
  content: "\\f439";
}

.fa-arrow-left-long::before {
  content: "\\f177";
}

.fa-long-arrow-left::before {
  content: "\\f177";
}

.fa-plug-circle-check::before {
  content: "\\e55c";
}

.fa-street-view::before {
  content: "\\f21d";
}

.fa-franc-sign::before {
  content: "\\e18f";
}

.fa-volume-off::before {
  content: "\\f026";
}

.fa-hands-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-gear::before {
  content: "\\f013";
}

.fa-cog::before {
  content: "\\f013";
}

.fa-droplet-slash::before {
  content: "\\f5c7";
}

.fa-tint-slash::before {
  content: "\\f5c7";
}

.fa-mosque::before {
  content: "\\f678";
}

.fa-mosquito::before {
  content: "\\e52b";
}

.fa-star-of-david::before {
  content: "\\f69a";
}

.fa-person-military-rifle::before {
  content: "\\e54b";
}

.fa-cart-shopping::before {
  content: "\\f07a";
}

.fa-shopping-cart::before {
  content: "\\f07a";
}

.fa-vials::before {
  content: "\\f493";
}

.fa-plug-circle-plus::before {
  content: "\\e55f";
}

.fa-place-of-worship::before {
  content: "\\f67f";
}

.fa-grip-vertical::before {
  content: "\\f58e";
}

.fa-arrow-turn-up::before {
  content: "\\f148";
}

.fa-level-up::before {
  content: "\\f148";
}

.fa-u::before {
  content: "U";
}

.fa-square-root-variable::before {
  content: "\\f698";
}

.fa-square-root-alt::before {
  content: "\\f698";
}

.fa-clock::before {
  content: "\\f017";
}

.fa-clock-four::before {
  content: "\\f017";
}

.fa-backward-step::before {
  content: "\\f048";
}

.fa-step-backward::before {
  content: "\\f048";
}

.fa-pallet::before {
  content: "\\f482";
}

.fa-faucet::before {
  content: "\\e005";
}

.fa-baseball-bat-ball::before {
  content: "\\f432";
}

.fa-s::before {
  content: "S";
}

.fa-timeline::before {
  content: "\\e29c";
}

.fa-keyboard::before {
  content: "\\f11c";
}

.fa-caret-down::before {
  content: "\\f0d7";
}

.fa-house-chimney-medical::before {
  content: "\\f7f2";
}

.fa-clinic-medical::before {
  content: "\\f7f2";
}

.fa-temperature-three-quarters::before {
  content: "\\f2c8";
}

.fa-temperature-3::before {
  content: "\\f2c8";
}

.fa-thermometer-3::before {
  content: "\\f2c8";
}

.fa-thermometer-three-quarters::before {
  content: "\\f2c8";
}

.fa-mobile-screen::before {
  content: "\\f3cf";
}

.fa-mobile-android-alt::before {
  content: "\\f3cf";
}

.fa-plane-up::before {
  content: "\\e22d";
}

.fa-piggy-bank::before {
  content: "\\f4d3";
}

.fa-battery-half::before {
  content: "\\f242";
}

.fa-battery-3::before {
  content: "\\f242";
}

.fa-mountain-city::before {
  content: "\\e52e";
}

.fa-coins::before {
  content: "\\f51e";
}

.fa-khanda::before {
  content: "\\f66d";
}

.fa-sliders::before {
  content: "\\f1de";
}

.fa-sliders-h::before {
  content: "\\f1de";
}

.fa-folder-tree::before {
  content: "\\f802";
}

.fa-network-wired::before {
  content: "\\f6ff";
}

.fa-map-pin::before {
  content: "\\f276";
}

.fa-hamsa::before {
  content: "\\f665";
}

.fa-cent-sign::before {
  content: "\\e3f5";
}

.fa-flask::before {
  content: "\\f0c3";
}

.fa-person-pregnant::before {
  content: "\\e31e";
}

.fa-wand-sparkles::before {
  content: "\\f72b";
}

.fa-ellipsis-vertical::before {
  content: "\\f142";
}

.fa-ellipsis-v::before {
  content: "\\f142";
}

.fa-ticket::before {
  content: "\\f145";
}

.fa-power-off::before {
  content: "\\f011";
}

.fa-right-long::before {
  content: "\\f30b";
}

.fa-long-arrow-alt-right::before {
  content: "\\f30b";
}

.fa-flag-usa::before {
  content: "\\f74d";
}

.fa-laptop-file::before {
  content: "\\e51d";
}

.fa-tty::before {
  content: "\\f1e4";
}

.fa-teletype::before {
  content: "\\f1e4";
}

.fa-diagram-next::before {
  content: "\\e476";
}

.fa-person-rifle::before {
  content: "\\e54e";
}

.fa-house-medical-circle-exclamation::before {
  content: "\\e512";
}

.fa-closed-captioning::before {
  content: "\\f20a";
}

.fa-person-hiking::before {
  content: "\\f6ec";
}

.fa-hiking::before {
  content: "\\f6ec";
}

.fa-venus-double::before {
  content: "\\f226";
}

.fa-images::before {
  content: "\\f302";
}

.fa-calculator::before {
  content: "\\f1ec";
}

.fa-people-pulling::before {
  content: "\\e535";
}

.fa-n::before {
  content: "N";
}

.fa-cable-car::before {
  content: "\\f7da";
}

.fa-tram::before {
  content: "\\f7da";
}

.fa-cloud-rain::before {
  content: "\\f73d";
}

.fa-building-circle-xmark::before {
  content: "\\e4d4";
}

.fa-ship::before {
  content: "\\f21a";
}

.fa-arrows-down-to-line::before {
  content: "\\e4b8";
}

.fa-download::before {
  content: "\\f019";
}

.fa-face-grin::before {
  content: "\\f580";
}

.fa-grin::before {
  content: "\\f580";
}

.fa-delete-left::before {
  content: "\\f55a";
}

.fa-backspace::before {
  content: "\\f55a";
}

.fa-eye-dropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-empty::before {
  content: "\\f1fb";
}

.fa-eyedropper::before {
  content: "\\f1fb";
}

.fa-file-circle-check::before {
  content: "\\e5a0";
}

.fa-forward::before {
  content: "\\f04e";
}

.fa-mobile::before {
  content: "\\f3ce";
}

.fa-mobile-android::before {
  content: "\\f3ce";
}

.fa-mobile-phone::before {
  content: "\\f3ce";
}

.fa-face-meh::before {
  content: "\\f11a";
}

.fa-meh::before {
  content: "\\f11a";
}

.fa-align-center::before {
  content: "\\f037";
}

.fa-book-skull::before {
  content: "\\f6b7";
}

.fa-book-dead::before {
  content: "\\f6b7";
}

.fa-id-card::before {
  content: "\\f2c2";
}

.fa-drivers-license::before {
  content: "\\f2c2";
}

.fa-outdent::before {
  content: "\\f03b";
}

.fa-dedent::before {
  content: "\\f03b";
}

.fa-heart-circle-exclamation::before {
  content: "\\e4fe";
}

.fa-house::before {
  content: "\\f015";
}

.fa-home::before {
  content: "\\f015";
}

.fa-home-alt::before {
  content: "\\f015";
}

.fa-home-lg-alt::before {
  content: "\\f015";
}

.fa-calendar-week::before {
  content: "\\f784";
}

.fa-laptop-medical::before {
  content: "\\f812";
}

.fa-b::before {
  content: "B";
}

.fa-file-medical::before {
  content: "\\f477";
}

.fa-dice-one::before {
  content: "\\f525";
}

.fa-kiwi-bird::before {
  content: "\\f535";
}

.fa-arrow-right-arrow-left::before {
  content: "\\f0ec";
}

.fa-exchange::before {
  content: "\\f0ec";
}

.fa-rotate-right::before {
  content: "\\f2f9";
}

.fa-redo-alt::before {
  content: "\\f2f9";
}

.fa-rotate-forward::before {
  content: "\\f2f9";
}

.fa-utensils::before {
  content: "\\f2e7";
}

.fa-cutlery::before {
  content: "\\f2e7";
}

.fa-arrow-up-wide-short::before {
  content: "\\f161";
}

.fa-sort-amount-up::before {
  content: "\\f161";
}

.fa-mill-sign::before {
  content: "\\e1ed";
}

.fa-bowl-rice::before {
  content: "\\e2eb";
}

.fa-skull::before {
  content: "\\f54c";
}

.fa-tower-broadcast::before {
  content: "\\f519";
}

.fa-broadcast-tower::before {
  content: "\\f519";
}

.fa-truck-pickup::before {
  content: "\\f63c";
}

.fa-up-long::before {
  content: "\\f30c";
}

.fa-long-arrow-alt-up::before {
  content: "\\f30c";
}

.fa-stop::before {
  content: "\\f04d";
}

.fa-code-merge::before {
  content: "\\f387";
}

.fa-upload::before {
  content: "\\f093";
}

.fa-hurricane::before {
  content: "\\f751";
}

.fa-mound::before {
  content: "\\e52d";
}

.fa-toilet-portable::before {
  content: "\\e583";
}

.fa-compact-disc::before {
  content: "\\f51f";
}

.fa-file-arrow-down::before {
  content: "\\f56d";
}

.fa-file-download::before {
  content: "\\f56d";
}

.fa-caravan::before {
  content: "\\f8ff";
}

.fa-shield-cat::before {
  content: "\\e572";
}

.fa-bolt::before {
  content: "\\f0e7";
}

.fa-zap::before {
  content: "\\f0e7";
}

.fa-glass-water::before {
  content: "\\e4f4";
}

.fa-oil-well::before {
  content: "\\e532";
}

.fa-vault::before {
  content: "\\e2c5";
}

.fa-mars::before {
  content: "\\f222";
}

.fa-toilet::before {
  content: "\\f7d8";
}

.fa-plane-circle-xmark::before {
  content: "\\e557";
}

.fa-yen-sign::before {
  content: "\\f157";
}

.fa-cny::before {
  content: "\\f157";
}

.fa-jpy::before {
  content: "\\f157";
}

.fa-rmb::before {
  content: "\\f157";
}

.fa-yen::before {
  content: "\\f157";
}

.fa-ruble-sign::before {
  content: "\\f158";
}

.fa-rouble::before {
  content: "\\f158";
}

.fa-rub::before {
  content: "\\f158";
}

.fa-ruble::before {
  content: "\\f158";
}

.fa-sun::before {
  content: "\\f185";
}

.fa-guitar::before {
  content: "\\f7a6";
}

.fa-face-laugh-wink::before {
  content: "\\f59c";
}

.fa-laugh-wink::before {
  content: "\\f59c";
}

.fa-horse-head::before {
  content: "\\f7ab";
}

.fa-bore-hole::before {
  content: "\\e4c3";
}

.fa-industry::before {
  content: "\\f275";
}

.fa-circle-down::before {
  content: "\\f358";
}

.fa-arrow-alt-circle-down::before {
  content: "\\f358";
}

.fa-arrows-turn-to-dots::before {
  content: "\\e4c1";
}

.fa-florin-sign::before {
  content: "\\e184";
}

.fa-arrow-down-short-wide::before {
  content: "\\f884";
}

.fa-sort-amount-desc::before {
  content: "\\f884";
}

.fa-sort-amount-down-alt::before {
  content: "\\f884";
}

.fa-less-than::before {
  content: "\\<";
}

.fa-angle-down::before {
  content: "\\f107";
}

.fa-car-tunnel::before {
  content: "\\e4de";
}

.fa-head-side-cough::before {
  content: "\\e061";
}

.fa-grip-lines::before {
  content: "\\f7a4";
}

.fa-thumbs-down::before {
  content: "\\f165";
}

.fa-user-lock::before {
  content: "\\f502";
}

.fa-arrow-right-long::before {
  content: "\\f178";
}

.fa-long-arrow-right::before {
  content: "\\f178";
}

.fa-anchor-circle-xmark::before {
  content: "\\e4ac";
}

.fa-ellipsis::before {
  content: "\\f141";
}

.fa-ellipsis-h::before {
  content: "\\f141";
}

.fa-chess-pawn::before {
  content: "\\f443";
}

.fa-kit-medical::before {
  content: "\\f479";
}

.fa-first-aid::before {
  content: "\\f479";
}

.fa-person-through-window::before {
  content: "\\e5a9";
}

.fa-toolbox::before {
  content: "\\f552";
}

.fa-hands-holding-circle::before {
  content: "\\e4fb";
}

.fa-bug::before {
  content: "\\f188";
}

.fa-credit-card::before {
  content: "\\f09d";
}

.fa-credit-card-alt::before {
  content: "\\f09d";
}

.fa-car::before {
  content: "\\f1b9";
}

.fa-automobile::before {
  content: "\\f1b9";
}

.fa-hand-holding-hand::before {
  content: "\\e4f7";
}

.fa-book-open-reader::before {
  content: "\\f5da";
}

.fa-book-reader::before {
  content: "\\f5da";
}

.fa-mountain-sun::before {
  content: "\\e52f";
}

.fa-arrows-left-right-to-line::before {
  content: "\\e4ba";
}

.fa-dice-d20::before {
  content: "\\f6cf";
}

.fa-truck-droplet::before {
  content: "\\e58c";
}

.fa-file-circle-xmark::before {
  content: "\\e5a1";
}

.fa-temperature-arrow-up::before {
  content: "\\e040";
}

.fa-temperature-up::before {
  content: "\\e040";
}

.fa-medal::before {
  content: "\\f5a2";
}

.fa-bed::before {
  content: "\\f236";
}

.fa-square-h::before {
  content: "\\f0fd";
}

.fa-h-square::before {
  content: "\\f0fd";
}

.fa-podcast::before {
  content: "\\f2ce";
}

.fa-temperature-full::before {
  content: "\\f2c7";
}

.fa-temperature-4::before {
  content: "\\f2c7";
}

.fa-thermometer-4::before {
  content: "\\f2c7";
}

.fa-thermometer-full::before {
  content: "\\f2c7";
}

.fa-bell::before {
  content: "\\f0f3";
}

.fa-superscript::before {
  content: "\\f12b";
}

.fa-plug-circle-xmark::before {
  content: "\\e560";
}

.fa-star-of-life::before {
  content: "\\f621";
}

.fa-phone-slash::before {
  content: "\\f3dd";
}

.fa-paint-roller::before {
  content: "\\f5aa";
}

.fa-handshake-angle::before {
  content: "\\f4c4";
}

.fa-hands-helping::before {
  content: "\\f4c4";
}

.fa-location-dot::before {
  content: "\\f3c5";
}

.fa-map-marker-alt::before {
  content: "\\f3c5";
}

.fa-file::before {
  content: "\\f15b";
}

.fa-greater-than::before {
  content: "\\>";
}

.fa-person-swimming::before {
  content: "\\f5c4";
}

.fa-swimmer::before {
  content: "\\f5c4";
}

.fa-arrow-down::before {
  content: "\\f063";
}

.fa-droplet::before {
  content: "\\f043";
}

.fa-tint::before {
  content: "\\f043";
}

.fa-eraser::before {
  content: "\\f12d";
}

.fa-earth-americas::before {
  content: "\\f57d";
}

.fa-earth::before {
  content: "\\f57d";
}

.fa-earth-america::before {
  content: "\\f57d";
}

.fa-globe-americas::before {
  content: "\\f57d";
}

.fa-person-burst::before {
  content: "\\e53b";
}

.fa-dove::before {
  content: "\\f4ba";
}

.fa-battery-empty::before {
  content: "\\f244";
}

.fa-battery-0::before {
  content: "\\f244";
}

.fa-socks::before {
  content: "\\f696";
}

.fa-inbox::before {
  content: "\\f01c";
}

.fa-section::before {
  content: "\\e447";
}

.fa-gauge-high::before {
  content: "\\f625";
}

.fa-tachometer-alt::before {
  content: "\\f625";
}

.fa-tachometer-alt-fast::before {
  content: "\\f625";
}

.fa-envelope-open-text::before {
  content: "\\f658";
}

.fa-hospital::before {
  content: "\\f0f8";
}

.fa-hospital-alt::before {
  content: "\\f0f8";
}

.fa-hospital-wide::before {
  content: "\\f0f8";
}

.fa-wine-bottle::before {
  content: "\\f72f";
}

.fa-chess-rook::before {
  content: "\\f447";
}

.fa-bars-staggered::before {
  content: "\\f550";
}

.fa-reorder::before {
  content: "\\f550";
}

.fa-stream::before {
  content: "\\f550";
}

.fa-dharmachakra::before {
  content: "\\f655";
}

.fa-hotdog::before {
  content: "\\f80f";
}

.fa-person-walking-with-cane::before {
  content: "\\f29d";
}

.fa-blind::before {
  content: "\\f29d";
}

.fa-drum::before {
  content: "\\f569";
}

.fa-ice-cream::before {
  content: "\\f810";
}

.fa-heart-circle-bolt::before {
  content: "\\e4fc";
}

.fa-fax::before {
  content: "\\f1ac";
}

.fa-paragraph::before {
  content: "\\f1dd";
}

.fa-check-to-slot::before {
  content: "\\f772";
}

.fa-vote-yea::before {
  content: "\\f772";
}

.fa-star-half::before {
  content: "\\f089";
}

.fa-boxes-stacked::before {
  content: "\\f468";
}

.fa-boxes::before {
  content: "\\f468";
}

.fa-boxes-alt::before {
  content: "\\f468";
}

.fa-link::before {
  content: "\\f0c1";
}

.fa-chain::before {
  content: "\\f0c1";
}

.fa-ear-listen::before {
  content: "\\f2a2";
}

.fa-assistive-listening-systems::before {
  content: "\\f2a2";
}

.fa-tree-city::before {
  content: "\\e587";
}

.fa-play::before {
  content: "\\f04b";
}

.fa-font::before {
  content: "\\f031";
}

.fa-table-cells-row-lock::before {
  content: "\\e67a";
}

.fa-rupiah-sign::before {
  content: "\\e23d";
}

.fa-magnifying-glass::before {
  content: "\\f002";
}

.fa-search::before {
  content: "\\f002";
}

.fa-table-tennis-paddle-ball::before {
  content: "\\f45d";
}

.fa-ping-pong-paddle-ball::before {
  content: "\\f45d";
}

.fa-table-tennis::before {
  content: "\\f45d";
}

.fa-person-dots-from-line::before {
  content: "\\f470";
}

.fa-diagnoses::before {
  content: "\\f470";
}

.fa-trash-can-arrow-up::before {
  content: "\\f82a";
}

.fa-trash-restore-alt::before {
  content: "\\f82a";
}

.fa-naira-sign::before {
  content: "\\e1f6";
}

.fa-cart-arrow-down::before {
  content: "\\f218";
}

.fa-walkie-talkie::before {
  content: "\\f8ef";
}

.fa-file-pen::before {
  content: "\\f31c";
}

.fa-file-edit::before {
  content: "\\f31c";
}

.fa-receipt::before {
  content: "\\f543";
}

.fa-square-pen::before {
  content: "\\f14b";
}

.fa-pen-square::before {
  content: "\\f14b";
}

.fa-pencil-square::before {
  content: "\\f14b";
}

.fa-suitcase-rolling::before {
  content: "\\f5c1";
}

.fa-person-circle-exclamation::before {
  content: "\\e53f";
}

.fa-chevron-down::before {
  content: "\\f078";
}

.fa-battery-full::before {
  content: "\\f240";
}

.fa-battery::before {
  content: "\\f240";
}

.fa-battery-5::before {
  content: "\\f240";
}

.fa-skull-crossbones::before {
  content: "\\f714";
}

.fa-code-compare::before {
  content: "\\e13a";
}

.fa-list-ul::before {
  content: "\\f0ca";
}

.fa-list-dots::before {
  content: "\\f0ca";
}

.fa-school-lock::before {
  content: "\\e56f";
}

.fa-tower-cell::before {
  content: "\\e585";
}

.fa-down-long::before {
  content: "\\f309";
}

.fa-long-arrow-alt-down::before {
  content: "\\f309";
}

.fa-ranking-star::before {
  content: "\\e561";
}

.fa-chess-king::before {
  content: "\\f43f";
}

.fa-person-harassing::before {
  content: "\\e549";
}

.fa-brazilian-real-sign::before {
  content: "\\e46c";
}

.fa-landmark-dome::before {
  content: "\\f752";
}

.fa-landmark-alt::before {
  content: "\\f752";
}

.fa-arrow-up::before {
  content: "\\f062";
}

.fa-tv::before {
  content: "\\f26c";
}

.fa-television::before {
  content: "\\f26c";
}

.fa-tv-alt::before {
  content: "\\f26c";
}

.fa-shrimp::before {
  content: "\\e448";
}

.fa-list-check::before {
  content: "\\f0ae";
}

.fa-tasks::before {
  content: "\\f0ae";
}

.fa-jug-detergent::before {
  content: "\\e519";
}

.fa-circle-user::before {
  content: "\\f2bd";
}

.fa-user-circle::before {
  content: "\\f2bd";
}

.fa-user-shield::before {
  content: "\\f505";
}

.fa-wind::before {
  content: "\\f72e";
}

.fa-car-burst::before {
  content: "\\f5e1";
}

.fa-car-crash::before {
  content: "\\f5e1";
}

.fa-y::before {
  content: "Y";
}

.fa-person-snowboarding::before {
  content: "\\f7ce";
}

.fa-snowboarding::before {
  content: "\\f7ce";
}

.fa-truck-fast::before {
  content: "\\f48b";
}

.fa-shipping-fast::before {
  content: "\\f48b";
}

.fa-fish::before {
  content: "\\f578";
}

.fa-user-graduate::before {
  content: "\\f501";
}

.fa-circle-half-stroke::before {
  content: "\\f042";
}

.fa-adjust::before {
  content: "\\f042";
}

.fa-clapperboard::before {
  content: "\\e131";
}

.fa-circle-radiation::before {
  content: "\\f7ba";
}

.fa-radiation-alt::before {
  content: "\\f7ba";
}

.fa-baseball::before {
  content: "\\f433";
}

.fa-baseball-ball::before {
  content: "\\f433";
}

.fa-jet-fighter-up::before {
  content: "\\e518";
}

.fa-diagram-project::before {
  content: "\\f542";
}

.fa-project-diagram::before {
  content: "\\f542";
}

.fa-copy::before {
  content: "\\f0c5";
}

.fa-volume-xmark::before {
  content: "\\f6a9";
}

.fa-volume-mute::before {
  content: "\\f6a9";
}

.fa-volume-times::before {
  content: "\\f6a9";
}

.fa-hand-sparkles::before {
  content: "\\e05d";
}

.fa-grip::before {
  content: "\\f58d";
}

.fa-grip-horizontal::before {
  content: "\\f58d";
}

.fa-share-from-square::before {
  content: "\\f14d";
}

.fa-share-square::before {
  content: "\\f14d";
}

.fa-child-combatant::before {
  content: "\\e4e0";
}

.fa-child-rifle::before {
  content: "\\e4e0";
}

.fa-gun::before {
  content: "\\e19b";
}

.fa-square-phone::before {
  content: "\\f098";
}

.fa-phone-square::before {
  content: "\\f098";
}

.fa-plus::before {
  content: "\\+";
}

.fa-add::before {
  content: "\\+";
}

.fa-expand::before {
  content: "\\f065";
}

.fa-computer::before {
  content: "\\e4e5";
}

.fa-xmark::before {
  content: "\\f00d";
}

.fa-close::before {
  content: "\\f00d";
}

.fa-multiply::before {
  content: "\\f00d";
}

.fa-remove::before {
  content: "\\f00d";
}

.fa-times::before {
  content: "\\f00d";
}

.fa-arrows-up-down-left-right::before {
  content: "\\f047";
}

.fa-arrows::before {
  content: "\\f047";
}

.fa-chalkboard-user::before {
  content: "\\f51c";
}

.fa-chalkboard-teacher::before {
  content: "\\f51c";
}

.fa-peso-sign::before {
  content: "\\e222";
}

.fa-building-shield::before {
  content: "\\e4d8";
}

.fa-baby::before {
  content: "\\f77c";
}

.fa-users-line::before {
  content: "\\e592";
}

.fa-quote-left::before {
  content: "\\f10d";
}

.fa-quote-left-alt::before {
  content: "\\f10d";
}

.fa-tractor::before {
  content: "\\f722";
}

.fa-trash-arrow-up::before {
  content: "\\f829";
}

.fa-trash-restore::before {
  content: "\\f829";
}

.fa-arrow-down-up-lock::before {
  content: "\\e4b0";
}

.fa-lines-leaning::before {
  content: "\\e51e";
}

.fa-ruler-combined::before {
  content: "\\f546";
}

.fa-copyright::before {
  content: "\\f1f9";
}

.fa-equals::before {
  content: "\\=";
}

.fa-blender::before {
  content: "\\f517";
}

.fa-teeth::before {
  content: "\\f62e";
}

.fa-shekel-sign::before {
  content: "\\f20b";
}

.fa-ils::before {
  content: "\\f20b";
}

.fa-shekel::before {
  content: "\\f20b";
}

.fa-sheqel::before {
  content: "\\f20b";
}

.fa-sheqel-sign::before {
  content: "\\f20b";
}

.fa-map::before {
  content: "\\f279";
}

.fa-rocket::before {
  content: "\\f135";
}

.fa-photo-film::before {
  content: "\\f87c";
}

.fa-photo-video::before {
  content: "\\f87c";
}

.fa-folder-minus::before {
  content: "\\f65d";
}

.fa-store::before {
  content: "\\f54e";
}

.fa-arrow-trend-up::before {
  content: "\\e098";
}

.fa-plug-circle-minus::before {
  content: "\\e55e";
}

.fa-sign-hanging::before {
  content: "\\f4d9";
}

.fa-sign::before {
  content: "\\f4d9";
}

.fa-bezier-curve::before {
  content: "\\f55b";
}

.fa-bell-slash::before {
  content: "\\f1f6";
}

.fa-tablet::before {
  content: "\\f3fb";
}

.fa-tablet-android::before {
  content: "\\f3fb";
}

.fa-school-flag::before {
  content: "\\e56e";
}

.fa-fill::before {
  content: "\\f575";
}

.fa-angle-up::before {
  content: "\\f106";
}

.fa-drumstick-bite::before {
  content: "\\f6d7";
}

.fa-holly-berry::before {
  content: "\\f7aa";
}

.fa-chevron-left::before {
  content: "\\f053";
}

.fa-bacteria::before {
  content: "\\e059";
}

.fa-hand-lizard::before {
  content: "\\f258";
}

.fa-notdef::before {
  content: "\\e1fe";
}

.fa-disease::before {
  content: "\\f7fa";
}

.fa-briefcase-medical::before {
  content: "\\f469";
}

.fa-genderless::before {
  content: "\\f22d";
}

.fa-chevron-right::before {
  content: "\\f054";
}

.fa-retweet::before {
  content: "\\f079";
}

.fa-car-rear::before {
  content: "\\f5de";
}

.fa-car-alt::before {
  content: "\\f5de";
}

.fa-pump-soap::before {
  content: "\\e06b";
}

.fa-video-slash::before {
  content: "\\f4e2";
}

.fa-battery-quarter::before {
  content: "\\f243";
}

.fa-battery-2::before {
  content: "\\f243";
}

.fa-radio::before {
  content: "\\f8d7";
}

.fa-baby-carriage::before {
  content: "\\f77d";
}

.fa-carriage-baby::before {
  content: "\\f77d";
}

.fa-traffic-light::before {
  content: "\\f637";
}

.fa-thermometer::before {
  content: "\\f491";
}

.fa-vr-cardboard::before {
  content: "\\f729";
}

.fa-hand-middle-finger::before {
  content: "\\f806";
}

.fa-percent::before {
  content: "\\%";
}

.fa-percentage::before {
  content: "\\%";
}

.fa-truck-moving::before {
  content: "\\f4df";
}

.fa-glass-water-droplet::before {
  content: "\\e4f5";
}

.fa-display::before {
  content: "\\e163";
}

.fa-face-smile::before {
  content: "\\f118";
}

.fa-smile::before {
  content: "\\f118";
}

.fa-thumbtack::before {
  content: "\\f08d";
}

.fa-thumb-tack::before {
  content: "\\f08d";
}

.fa-trophy::before {
  content: "\\f091";
}

.fa-person-praying::before {
  content: "\\f683";
}

.fa-pray::before {
  content: "\\f683";
}

.fa-hammer::before {
  content: "\\f6e3";
}

.fa-hand-peace::before {
  content: "\\f25b";
}

.fa-rotate::before {
  content: "\\f2f1";
}

.fa-sync-alt::before {
  content: "\\f2f1";
}

.fa-spinner::before {
  content: "\\f110";
}

.fa-robot::before {
  content: "\\f544";
}

.fa-peace::before {
  content: "\\f67c";
}

.fa-gears::before {
  content: "\\f085";
}

.fa-cogs::before {
  content: "\\f085";
}

.fa-warehouse::before {
  content: "\\f494";
}

.fa-arrow-up-right-dots::before {
  content: "\\e4b7";
}

.fa-splotch::before {
  content: "\\f5bc";
}

.fa-face-grin-hearts::before {
  content: "\\f584";
}

.fa-grin-hearts::before {
  content: "\\f584";
}

.fa-dice-four::before {
  content: "\\f524";
}

.fa-sim-card::before {
  content: "\\f7c4";
}

.fa-transgender::before {
  content: "\\f225";
}

.fa-transgender-alt::before {
  content: "\\f225";
}

.fa-mercury::before {
  content: "\\f223";
}

.fa-arrow-turn-down::before {
  content: "\\f149";
}

.fa-level-down::before {
  content: "\\f149";
}

.fa-person-falling-burst::before {
  content: "\\e547";
}

.fa-award::before {
  content: "\\f559";
}

.fa-ticket-simple::before {
  content: "\\f3ff";
}

.fa-ticket-alt::before {
  content: "\\f3ff";
}

.fa-building::before {
  content: "\\f1ad";
}

.fa-angles-left::before {
  content: "\\f100";
}

.fa-angle-double-left::before {
  content: "\\f100";
}

.fa-qrcode::before {
  content: "\\f029";
}

.fa-clock-rotate-left::before {
  content: "\\f1da";
}

.fa-history::before {
  content: "\\f1da";
}

.fa-face-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-file-export::before {
  content: "\\f56e";
}

.fa-arrow-right-from-file::before {
  content: "\\f56e";
}

.fa-shield::before {
  content: "\\f132";
}

.fa-shield-blank::before {
  content: "\\f132";
}

.fa-arrow-up-short-wide::before {
  content: "\\f885";
}

.fa-sort-amount-up-alt::before {
  content: "\\f885";
}

.fa-house-medical::before {
  content: "\\e3b2";
}

.fa-golf-ball-tee::before {
  content: "\\f450";
}

.fa-golf-ball::before {
  content: "\\f450";
}

.fa-circle-chevron-left::before {
  content: "\\f137";
}

.fa-chevron-circle-left::before {
  content: "\\f137";
}

.fa-house-chimney-window::before {
  content: "\\e00d";
}

.fa-pen-nib::before {
  content: "\\f5ad";
}

.fa-tent-arrow-turn-left::before {
  content: "\\e580";
}

.fa-tents::before {
  content: "\\e582";
}

.fa-wand-magic::before {
  content: "\\f0d0";
}

.fa-magic::before {
  content: "\\f0d0";
}

.fa-dog::before {
  content: "\\f6d3";
}

.fa-carrot::before {
  content: "\\f787";
}

.fa-moon::before {
  content: "\\f186";
}

.fa-wine-glass-empty::before {
  content: "\\f5ce";
}

.fa-wine-glass-alt::before {
  content: "\\f5ce";
}

.fa-cheese::before {
  content: "\\f7ef";
}

.fa-yin-yang::before {
  content: "\\f6ad";
}

.fa-music::before {
  content: "\\f001";
}

.fa-code-commit::before {
  content: "\\f386";
}

.fa-temperature-low::before {
  content: "\\f76b";
}

.fa-person-biking::before {
  content: "\\f84a";
}

.fa-biking::before {
  content: "\\f84a";
}

.fa-broom::before {
  content: "\\f51a";
}

.fa-shield-heart::before {
  content: "\\e574";
}

.fa-gopuram::before {
  content: "\\f664";
}

.fa-earth-oceania::before {
  content: "\\e47b";
}

.fa-globe-oceania::before {
  content: "\\e47b";
}

.fa-square-xmark::before {
  content: "\\f2d3";
}

.fa-times-square::before {
  content: "\\f2d3";
}

.fa-xmark-square::before {
  content: "\\f2d3";
}

.fa-hashtag::before {
  content: "\\#";
}

.fa-up-right-and-down-left-from-center::before {
  content: "\\f424";
}

.fa-expand-alt::before {
  content: "\\f424";
}

.fa-oil-can::before {
  content: "\\f613";
}

.fa-t::before {
  content: "T";
}

.fa-hippo::before {
  content: "\\f6ed";
}

.fa-chart-column::before {
  content: "\\e0e3";
}

.fa-infinity::before {
  content: "\\f534";
}

.fa-vial-circle-check::before {
  content: "\\e596";
}

.fa-person-arrow-down-to-line::before {
  content: "\\e538";
}

.fa-voicemail::before {
  content: "\\f897";
}

.fa-fan::before {
  content: "\\f863";
}

.fa-person-walking-luggage::before {
  content: "\\e554";
}

.fa-up-down::before {
  content: "\\f338";
}

.fa-arrows-alt-v::before {
  content: "\\f338";
}

.fa-cloud-moon-rain::before {
  content: "\\f73c";
}

.fa-calendar::before {
  content: "\\f133";
}

.fa-trailer::before {
  content: "\\e041";
}

.fa-bahai::before {
  content: "\\f666";
}

.fa-haykal::before {
  content: "\\f666";
}

.fa-sd-card::before {
  content: "\\f7c2";
}

.fa-dragon::before {
  content: "\\f6d5";
}

.fa-shoe-prints::before {
  content: "\\f54b";
}

.fa-circle-plus::before {
  content: "\\f055";
}

.fa-plus-circle::before {
  content: "\\f055";
}

.fa-face-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-hand-holding::before {
  content: "\\f4bd";
}

.fa-plug-circle-exclamation::before {
  content: "\\e55d";
}

.fa-link-slash::before {
  content: "\\f127";
}

.fa-chain-broken::before {
  content: "\\f127";
}

.fa-chain-slash::before {
  content: "\\f127";
}

.fa-unlink::before {
  content: "\\f127";
}

.fa-clone::before {
  content: "\\f24d";
}

.fa-person-walking-arrow-loop-left::before {
  content: "\\e551";
}

.fa-arrow-up-z-a::before {
  content: "\\f882";
}

.fa-sort-alpha-up-alt::before {
  content: "\\f882";
}

.fa-fire-flame-curved::before {
  content: "\\f7e4";
}

.fa-fire-alt::before {
  content: "\\f7e4";
}

.fa-tornado::before {
  content: "\\f76f";
}

.fa-file-circle-plus::before {
  content: "\\e494";
}

.fa-book-quran::before {
  content: "\\f687";
}

.fa-quran::before {
  content: "\\f687";
}

.fa-anchor::before {
  content: "\\f13d";
}

.fa-border-all::before {
  content: "\\f84c";
}

.fa-face-angry::before {
  content: "\\f556";
}

.fa-angry::before {
  content: "\\f556";
}

.fa-cookie-bite::before {
  content: "\\f564";
}

.fa-arrow-trend-down::before {
  content: "\\e097";
}

.fa-rss::before {
  content: "\\f09e";
}

.fa-feed::before {
  content: "\\f09e";
}

.fa-draw-polygon::before {
  content: "\\f5ee";
}

.fa-scale-balanced::before {
  content: "\\f24e";
}

.fa-balance-scale::before {
  content: "\\f24e";
}

.fa-gauge-simple-high::before {
  content: "\\f62a";
}

.fa-tachometer::before {
  content: "\\f62a";
}

.fa-tachometer-fast::before {
  content: "\\f62a";
}

.fa-shower::before {
  content: "\\f2cc";
}

.fa-desktop::before {
  content: "\\f390";
}

.fa-desktop-alt::before {
  content: "\\f390";
}

.fa-m::before {
  content: "M";
}

.fa-table-list::before {
  content: "\\f00b";
}

.fa-th-list::before {
  content: "\\f00b";
}

.fa-comment-sms::before {
  content: "\\f7cd";
}

.fa-sms::before {
  content: "\\f7cd";
}

.fa-book::before {
  content: "\\f02d";
}

.fa-user-plus::before {
  content: "\\f234";
}

.fa-check::before {
  content: "\\f00c";
}

.fa-battery-three-quarters::before {
  content: "\\f241";
}

.fa-battery-4::before {
  content: "\\f241";
}

.fa-house-circle-check::before {
  content: "\\e509";
}

.fa-angle-left::before {
  content: "\\f104";
}

.fa-diagram-successor::before {
  content: "\\e47a";
}

.fa-truck-arrow-right::before {
  content: "\\e58b";
}

.fa-arrows-split-up-and-left::before {
  content: "\\e4bc";
}

.fa-hand-fist::before {
  content: "\\f6de";
}

.fa-fist-raised::before {
  content: "\\f6de";
}

.fa-cloud-moon::before {
  content: "\\f6c3";
}

.fa-briefcase::before {
  content: "\\f0b1";
}

.fa-person-falling::before {
  content: "\\e546";
}

.fa-image-portrait::before {
  content: "\\f3e0";
}

.fa-portrait::before {
  content: "\\f3e0";
}

.fa-user-tag::before {
  content: "\\f507";
}

.fa-rug::before {
  content: "\\e569";
}

.fa-earth-europe::before {
  content: "\\f7a2";
}

.fa-globe-europe::before {
  content: "\\f7a2";
}

.fa-cart-flatbed-suitcase::before {
  content: "\\f59d";
}

.fa-luggage-cart::before {
  content: "\\f59d";
}

.fa-rectangle-xmark::before {
  content: "\\f410";
}

.fa-rectangle-times::before {
  content: "\\f410";
}

.fa-times-rectangle::before {
  content: "\\f410";
}

.fa-window-close::before {
  content: "\\f410";
}

.fa-baht-sign::before {
  content: "\\e0ac";
}

.fa-book-open::before {
  content: "\\f518";
}

.fa-book-journal-whills::before {
  content: "\\f66a";
}

.fa-journal-whills::before {
  content: "\\f66a";
}

.fa-handcuffs::before {
  content: "\\e4f8";
}

.fa-triangle-exclamation::before {
  content: "\\f071";
}

.fa-exclamation-triangle::before {
  content: "\\f071";
}

.fa-warning::before {
  content: "\\f071";
}

.fa-database::before {
  content: "\\f1c0";
}

.fa-share::before {
  content: "\\f064";
}

.fa-mail-forward::before {
  content: "\\f064";
}

.fa-bottle-droplet::before {
  content: "\\e4c4";
}

.fa-mask-face::before {
  content: "\\e1d7";
}

.fa-hill-rockslide::before {
  content: "\\e508";
}

.fa-right-left::before {
  content: "\\f362";
}

.fa-exchange-alt::before {
  content: "\\f362";
}

.fa-paper-plane::before {
  content: "\\f1d8";
}

.fa-road-circle-exclamation::before {
  content: "\\e565";
}

.fa-dungeon::before {
  content: "\\f6d9";
}

.fa-align-right::before {
  content: "\\f038";
}

.fa-money-bill-1-wave::before {
  content: "\\f53b";
}

.fa-money-bill-wave-alt::before {
  content: "\\f53b";
}

.fa-life-ring::before {
  content: "\\f1cd";
}

.fa-hands::before {
  content: "\\f2a7";
}

.fa-sign-language::before {
  content: "\\f2a7";
}

.fa-signing::before {
  content: "\\f2a7";
}

.fa-calendar-day::before {
  content: "\\f783";
}

.fa-water-ladder::before {
  content: "\\f5c5";
}

.fa-ladder-water::before {
  content: "\\f5c5";
}

.fa-swimming-pool::before {
  content: "\\f5c5";
}

.fa-arrows-up-down::before {
  content: "\\f07d";
}

.fa-arrows-v::before {
  content: "\\f07d";
}

.fa-face-grimace::before {
  content: "\\f57f";
}

.fa-grimace::before {
  content: "\\f57f";
}

.fa-wheelchair-move::before {
  content: "\\e2ce";
}

.fa-wheelchair-alt::before {
  content: "\\e2ce";
}

.fa-turn-down::before {
  content: "\\f3be";
}

.fa-level-down-alt::before {
  content: "\\f3be";
}

.fa-person-walking-arrow-right::before {
  content: "\\e552";
}

.fa-square-envelope::before {
  content: "\\f199";
}

.fa-envelope-square::before {
  content: "\\f199";
}

.fa-dice::before {
  content: "\\f522";
}

.fa-bowling-ball::before {
  content: "\\f436";
}

.fa-brain::before {
  content: "\\f5dc";
}

.fa-bandage::before {
  content: "\\f462";
}

.fa-band-aid::before {
  content: "\\f462";
}

.fa-calendar-minus::before {
  content: "\\f272";
}

.fa-circle-xmark::before {
  content: "\\f057";
}

.fa-times-circle::before {
  content: "\\f057";
}

.fa-xmark-circle::before {
  content: "\\f057";
}

.fa-gifts::before {
  content: "\\f79c";
}

.fa-hotel::before {
  content: "\\f594";
}

.fa-earth-asia::before {
  content: "\\f57e";
}

.fa-globe-asia::before {
  content: "\\f57e";
}

.fa-id-card-clip::before {
  content: "\\f47f";
}

.fa-id-card-alt::before {
  content: "\\f47f";
}

.fa-magnifying-glass-plus::before {
  content: "\\f00e";
}

.fa-search-plus::before {
  content: "\\f00e";
}

.fa-thumbs-up::before {
  content: "\\f164";
}

.fa-user-clock::before {
  content: "\\f4fd";
}

.fa-hand-dots::before {
  content: "\\f461";
}

.fa-allergies::before {
  content: "\\f461";
}

.fa-file-invoice::before {
  content: "\\f570";
}

.fa-window-minimize::before {
  content: "\\f2d1";
}

.fa-mug-saucer::before {
  content: "\\f0f4";
}

.fa-coffee::before {
  content: "\\f0f4";
}

.fa-brush::before {
  content: "\\f55d";
}

.fa-mask::before {
  content: "\\f6fa";
}

.fa-magnifying-glass-minus::before {
  content: "\\f010";
}

.fa-search-minus::before {
  content: "\\f010";
}

.fa-ruler-vertical::before {
  content: "\\f548";
}

.fa-user-large::before {
  content: "\\f406";
}

.fa-user-alt::before {
  content: "\\f406";
}

.fa-train-tram::before {
  content: "\\e5b4";
}

.fa-user-nurse::before {
  content: "\\f82f";
}

.fa-syringe::before {
  content: "\\f48e";
}

.fa-cloud-sun::before {
  content: "\\f6c4";
}

.fa-stopwatch-20::before {
  content: "\\e06f";
}

.fa-square-full::before {
  content: "\\f45c";
}

.fa-magnet::before {
  content: "\\f076";
}

.fa-jar::before {
  content: "\\e516";
}

.fa-note-sticky::before {
  content: "\\f249";
}

.fa-sticky-note::before {
  content: "\\f249";
}

.fa-bug-slash::before {
  content: "\\e490";
}

.fa-arrow-up-from-water-pump::before {
  content: "\\e4b6";
}

.fa-bone::before {
  content: "\\f5d7";
}

.fa-user-injured::before {
  content: "\\f728";
}

.fa-face-sad-tear::before {
  content: "\\f5b4";
}

.fa-sad-tear::before {
  content: "\\f5b4";
}

.fa-plane::before {
  content: "\\f072";
}

.fa-tent-arrows-down::before {
  content: "\\e581";
}

.fa-exclamation::before {
  content: "\\!";
}

.fa-arrows-spin::before {
  content: "\\e4bb";
}

.fa-print::before {
  content: "\\f02f";
}

.fa-turkish-lira-sign::before {
  content: "\\e2bb";
}

.fa-try::before {
  content: "\\e2bb";
}

.fa-turkish-lira::before {
  content: "\\e2bb";
}

.fa-dollar-sign::before {
  content: "\\\$";
}

.fa-dollar::before {
  content: "\\\$";
}

.fa-usd::before {
  content: "\\\$";
}

.fa-x::before {
  content: "X";
}

.fa-magnifying-glass-dollar::before {
  content: "\\f688";
}

.fa-search-dollar::before {
  content: "\\f688";
}

.fa-users-gear::before {
  content: "\\f509";
}

.fa-users-cog::before {
  content: "\\f509";
}

.fa-person-military-pointing::before {
  content: "\\e54a";
}

.fa-building-columns::before {
  content: "\\f19c";
}

.fa-bank::before {
  content: "\\f19c";
}

.fa-institution::before {
  content: "\\f19c";
}

.fa-museum::before {
  content: "\\f19c";
}

.fa-university::before {
  content: "\\f19c";
}

.fa-umbrella::before {
  content: "\\f0e9";
}

.fa-trowel::before {
  content: "\\e589";
}

.fa-d::before {
  content: "D";
}

.fa-stapler::before {
  content: "\\e5af";
}

.fa-masks-theater::before {
  content: "\\f630";
}

.fa-theater-masks::before {
  content: "\\f630";
}

.fa-kip-sign::before {
  content: "\\e1c4";
}

.fa-hand-point-left::before {
  content: "\\f0a5";
}

.fa-handshake-simple::before {
  content: "\\f4c6";
}

.fa-handshake-alt::before {
  content: "\\f4c6";
}

.fa-jet-fighter::before {
  content: "\\f0fb";
}

.fa-fighter-jet::before {
  content: "\\f0fb";
}

.fa-square-share-nodes::before {
  content: "\\f1e1";
}

.fa-share-alt-square::before {
  content: "\\f1e1";
}

.fa-barcode::before {
  content: "\\f02a";
}

.fa-plus-minus::before {
  content: "\\e43c";
}

.fa-video::before {
  content: "\\f03d";
}

.fa-video-camera::before {
  content: "\\f03d";
}

.fa-graduation-cap::before {
  content: "\\f19d";
}

.fa-mortar-board::before {
  content: "\\f19d";
}

.fa-hand-holding-medical::before {
  content: "\\e05c";
}

.fa-person-circle-check::before {
  content: "\\e53e";
}

.fa-turn-up::before {
  content: "\\f3bf";
}

.fa-level-up-alt::before {
  content: "\\f3bf";
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-brands: "Font Awesome 6 Brands";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

@font-face {
  font-family: "Font Awesome 6 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
.fab,
.fa-brands {
  font-weight: 400;
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-cloudflare:before {
  content: "\\e07d";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-pixiv:before {
  content: "\\e640";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-guilded:before {
  content: "\\e07e";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-square-js:before {
  content: "\\f3b9";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-jxl:before {
  content: "\\e67b";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-unity:before {
  content: "\\e049";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-square-reddit:before {
  content: "\\f1a2";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-square-font-awesome:before {
  content: "\\e5ad";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-brave:before {
  content: "\\e63c";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-square-instagram:before {
  content: "\\e055";
}

.fa-instagram-square:before {
  content: "\\e055";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-square-hacker-news:before {
  content: "\\f3af";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-threads:before {
  content: "\\e618";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-square-snapchat:before {
  content: "\\f2ad";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-square-font-awesome-stroke:before {
  content: "\\f35c";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-watchman-monitoring:before {
  content: "\\e087";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-square-viadeo:before {
  content: "\\f2aa";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-opensuse:before {
  content: "\\e62b";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-square-dribbble:before {
  content: "\\f397";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-node:before {
  content: "\\f419";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-debian:before {
  content: "\\e60b";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-instalod:before {
  content: "\\e081";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-square-twitter:before {
  content: "\\f081";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-golang:before {
  content: "\\e40f";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-square-kickstarter:before {
  content: "\\f3bb";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-uncharted:before {
  content: "\\e084";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-square-youtube:before {
  content: "\\f431";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-rendact:before {
  content: "\\f3e4";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-nfc-directional:before {
  content: "\\e530";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-meta:before {
  content: "\\e49b";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-square-letterboxd:before {
  content: "\\e62e";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-shoelace:before {
  content: "\\e60c";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-unsplash:before {
  content: "\\e07c";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-square-steam:before {
  content: "\\f1b7";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-square-vimeo:before {
  content: "\\f194";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-flag:before {
  content: "\\f2b4";
}

.fa-font-awesome-logo-full:before {
  content: "\\f2b4";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-hive:before {
  content: "\\e07f";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-padlet:before {
  content: "\\e4a0";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-square-github:before {
  content: "\\f092";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-shopify:before {
  content: "\\e057";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-square-threads:before {
  content: "\\e619";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-google-scholar:before {
  content: "\\e63b";
}

.fa-square-gitlab:before {
  content: "\\e5ae";
}

.fa-gitlab-square:before {
  content: "\\e5ae";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-square-odnoklassniki:before {
  content: "\\f264";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-hashnode:before {
  content: "\\e499";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-square-pinterest:before {
  content: "\\f0d3";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-signal-messenger:before {
  content: "\\e663";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-dailymotion:before {
  content: "\\e052";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-nfc-symbol:before {
  content: "\\e531";
}

.fa-mintbit:before {
  content: "\\e62f";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-brave-reverse:before {
  content: "\\e63d";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-square-google-plus:before {
  content: "\\f0d4";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-web-awesome:before {
  content: "\\e682";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-square-xing:before {
  content: "\\f169";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-letterboxd:before {
  content: "\\e62d";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-bilibili:before {
  content: "\\e3d9";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-x-twitter:before {
  content: "\\e61b";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-42-group:before {
  content: "\\e080";
}

.fa-innosoft:before {
  content: "\\e080";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-square-pied-piper:before {
  content: "\\e01e";
}

.fa-pied-piper-square:before {
  content: "\\e01e";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-square-web-awesome-stroke:before {
  content: "\\e684";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-tiktok:before {
  content: "\\e07b";
}

.fa-square-facebook:before {
  content: "\\f082";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-mixer:before {
  content: "\\e056";
}

.fa-square-lastfm:before {
  content: "\\f203";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-cmplid:before {
  content: "\\e360";
}

.fa-upwork:before {
  content: "\\e641";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-square-upwork:before {
  content: "\\e67c";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-deezer:before {
  content: "\\e077";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-screenpal:before {
  content: "\\e570";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-microblog:before {
  content: "\\e01a";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-square-web-awesome:before {
  content: "\\e683";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-wirsindhandwerk:before {
  content: "\\e2d0";
}

.fa-wsh:before {
  content: "\\e2d0";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-octopus-deploy:before {
  content: "\\e082";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-bluesky:before {
  content: "\\e671";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ab";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-rust:before {
  content: "\\e07a";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-square-behance:before {
  content: "\\f1b5";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-webflow:before {
  content: "\\e65c";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-space-awesome:before {
  content: "\\e5ac";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-square-git:before {
  content: "\\f1d2";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-square-tumblr:before {
  content: "\\f174";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-perbyte:before {
  content: "\\e083";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-bots:before {
  content: "\\e340";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-ideal:before {
  content: "\\e013";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-php:before {
  content: "\\f457";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-firefox-browser:before {
  content: "\\e007";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-stubber:before {
  content: "\\e5c7";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f2c6";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-odysee:before {
  content: "\\e5c6";
}

.fa-square-whatsapp:before {
  content: "\\f40c";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-edge-legacy:before {
  content: "\\e078";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f198";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-square-x-twitter:before {
  content: "\\e61a";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f23a";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-sitrox:before {
  content: "\\e44a";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-wodu:before {
  content: "\\e088";
}

.fa-google-pay:before {
  content: "\\e079";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-pix:before {
  content: "\\e43a";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-classic: "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.fas,
.fa-solid {
  font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_core.scss","webpack://./src/scss/fontawesome.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_sizing.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_mixins.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_fixed-width.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_variables.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_list.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_bordered-pulled.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_animated.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_rotated-flipped.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_stacked.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_icons.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/_screen-reader.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/brands.scss","webpack://./node_modules/@fortawesome/fontawesome-free/scss/solid.scss"],"names":[],"mappings":"AAAA;;;;EAAA;ACGA;EACE,0DAAA;EACA,iCAAA;ACGF;;ADAA;;;;;;;;;EASE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;ACGF;;ADAA;;;;;EAKE,kCAAA;ACGF;;ADAA;;EAEE,oCAAA;ACGF;;AClCE;EACE,cAAA;ADqCJ;;ACtCE;EACE,cAAA;ADyCJ;;AC1CE;EACE,cAAA;AD6CJ;;AC9CE;EACE,cAAA;ADiDJ;;AClDE;EACE,cAAA;ADqDJ;;ACtDE;EACE,cAAA;ADyDJ;;AC1DE;EACE,cAAA;AD6DJ;;AC9DE;EACE,cAAA;ADiEJ;;AClEE;EACE,cAAA;ADqEJ;;ACtEE;EACE,eAAA;ADyEJ;;ACnEE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;AFmEF;;ACzEE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;AFyEF;;AC/EE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;AF+EF;;ACrFE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;AFqFF;;AC3FE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;AF2FF;;ACjGE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;AFiGF;;AGhHA;EACE,kBAAA;EACA,aCIwB;AJ+G1B;;AKrHA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;ALwHF;AKtHE;EAAO,kBAAA;ALyHT;;AKtHA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;ALyHF;;AMtIA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;ANyIF;;AMtIA;EACE,WAAA;EACA,0CAAA;ANyIF;;AMtIA;EACE,YAAA;EACA,yCAAA;ANyIF;;AOxJA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AP2JF;;AOxJA;EACE,yBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,wFAAA;AP2JF;;AOxJA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AP2JF;;AOxJA;EACE,4BAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AP2JF;;AOxJA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AP2JF;;AOxJA;EACE,wBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AP2JF;;AOxJA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AP2JF;;AOxJA;EACE,iCAAA;AP2JF;;AOxJA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;AP2JF;;AOrJA;EACE;;;;;;;;;IASE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;EPwJF;AACF;AOrJA;EACE;IAAU,mBAAA;EPwJV;EOvJA;IAAM,4CAAA;EP0JN;AACF;AOxJA;EACE;IAAO,oCAAA;EP2JP;EO1JA;IAAO,wGAAA;EP6JP;EO5JA;IAAO,oIAAA;EP+JP;EO9JA;IAAO,wGAAA;EPiKP;EOhKA;IAAO,qEAAA;EPmKP;EOlKA;IAAO,oCAAA;EPqKP;EOpKA;IAAO,oCAAA;EPuKP;AACF;AOrKA;EACE;IAAM,oCAAA;EPwKN;AACF;AOtKA;EACE;IACE,yCAAA;IACA,mBAAA;EPwKF;EOtKA;IACE,UAAA;IACA,kDAAA;EPwKF;AACF;AOrKA;EACE;IACE,iHAAA;EPuKF;AACF;AOpKA;EACE;IAAK,yBAAA;EPuKL;EOtKA;IAAK,wBAAA;EPyKL;EOxKA;IAAU,yBAAA;EP2KV;EO1KA;IAAW,wBAAA;EP6KX;EO5KA;IAAM,yBAAA;EP+KN;EO9KA;IAAM,wBAAA;EPiLN;EOhLA;IAAM,yBAAA;EPmLN;EOlLA;IAAM,wBAAA;EPqLN;EOpLA;IAAY,uBAAA;EPuLZ;AACF;AOrLA;EACE;IAAK,uBAAA;EPwLL;EOvLA;IAAO,yBAAA;EP0LP;AACF;AQ9UA;EACE,wBAAA;ARgVF;;AQ7UA;EACE,yBAAA;ARgVF;;AQ7UA;EACE,yBAAA;ARgVF;;AQ7UA;EACE,uBAAA;ARgVF;;AQ7UA;EACE,uBAAA;ARgVF;;AQ7UA;;EAEE,wBAAA;ARgVF;;AQ7UA;EACE,4CAAA;ARgVF;;AS1WA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLmCwB;EKlCxB,YLmCwB;AJ0U1B;;AS1WA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;AT6WF;;AS1WA;EACE,oBAAA;AT6WF;;AS1WA;EACE,cAAA;AT6WF;;AS1WA;EACE,8BAAA;AT6WF;;AUxYA;gEAAA;AAIE;EAAsC,eAAA;AV0YxC;;AU1YE;EAAsC,eAAA;AV8YxC;;AU9YE;EAAsC,eAAA;AVkZxC;;AUlZE;EAAsC,eAAA;AVsZxC;;AUtZE;EAAsC,eAAA;AV0ZxC;;AU1ZE;EAAsC,eAAA;AV8ZxC;;AU9ZE;EAAsC,eAAA;AVkaxC;;AUlaE;EAAsC,eAAA;AVsaxC;;AUtaE;EAAsC,eAAA;AV0axC;;AU1aE;EAAsC,eAAA;AV8axC;;AU9aE;EAAsC,gBAAA;AVkbxC;;AUlbE;EAAsC,gBAAA;AVsbxC;;AUtbE;EAAsC,gBAAA;AV0bxC;;AU1bE;EAAsC,gBAAA;AV8bxC;;AU9bE;EAAsC,aAAA;AVkcxC;;AUlcE;EAAsC,gBAAA;AVscxC;;AUtcE;EAAsC,gBAAA;AV0cxC;;AU1cE;EAAsC,gBAAA;AV8cxC;;AU9cE;EAAsC,gBAAA;AVkdxC;;AUldE;EAAsC,gBAAA;AVsdxC;;AUtdE;EAAsC,gBAAA;AV0dxC;;AU1dE;EAAsC,gBAAA;AV8dxC;;AU9dE;EAAsC,gBAAA;AVkexC;;AUleE;EAAsC,gBAAA;AVsexC;;AUteE;EAAsC,gBAAA;AV0exC;;AU1eE;EAAsC,gBAAA;AV8exC;;AU9eE;EAAsC,gBAAA;AVkfxC;;AUlfE;EAAsC,gBAAA;AVsfxC;;AUtfE;EAAsC,gBAAA;AV0fxC;;AU1fE;EAAsC,gBAAA;AV8fxC;;AU9fE;EAAsC,gBAAA;AVkgBxC;;AUlgBE;EAAsC,gBAAA;AVsgBxC;;AUtgBE;EAAsC,gBAAA;AV0gBxC;;AU1gBE;EAAsC,gBAAA;AV8gBxC;;AU9gBE;EAAsC,gBAAA;AVkhBxC;;AUlhBE;EAAsC,gBAAA;AVshBxC;;AUthBE;EAAsC,gBAAA;AV0hBxC;;AU1hBE;EAAsC,gBAAA;AV8hBxC;;AU9hBE;EAAsC,gBAAA;AVkiBxC;;AUliBE;EAAsC,gBAAA;AVsiBxC;;AUtiBE;EAAsC,gBAAA;AV0iBxC;;AU1iBE;EAAsC,gBAAA;AV8iBxC;;AU9iBE;EAAsC,gBAAA;AVkjBxC;;AUljBE;EAAsC,gBAAA;AVsjBxC;;AUtjBE;EAAsC,gBAAA;AV0jBxC;;AU1jBE;EAAsC,gBAAA;AV8jBxC;;AU9jBE;EAAsC,gBAAA;AVkkBxC;;AUlkBE;EAAsC,gBAAA;AVskBxC;;AUtkBE;EAAsC,gBAAA;AV0kBxC;;AU1kBE;EAAsC,gBAAA;AV8kBxC;;AU9kBE;EAAsC,gBAAA;AVklBxC;;AUllBE;EAAsC,gBAAA;AVslBxC;;AUtlBE;EAAsC,gBAAA;AV0lBxC;;AU1lBE;EAAsC,gBAAA;AV8lBxC;;AU9lBE;EAAsC,gBAAA;AVkmBxC;;AUlmBE;EAAsC,gBAAA;AVsmBxC;;AUtmBE;EAAsC,gBAAA;AV0mBxC;;AU1mBE;EAAsC,gBAAA;AV8mBxC;;AU9mBE;EAAsC,gBAAA;AVknBxC;;AUlnBE;EAAsC,gBAAA;AVsnBxC;;AUtnBE;EAAsC,gBAAA;AV0nBxC;;AU1nBE;EAAsC,gBAAA;AV8nBxC;;AU9nBE;EAAsC,gBAAA;AVkoBxC;;AUloBE;EAAsC,gBAAA;AVsoBxC;;AUtoBE;EAAsC,gBAAA;AV0oBxC;;AU1oBE;EAAsC,gBAAA;AV8oBxC;;AU9oBE;EAAsC,gBAAA;AVkpBxC;;AUlpBE;EAAsC,gBAAA;AVspBxC;;AUtpBE;EAAsC,gBAAA;AV0pBxC;;AU1pBE;EAAsC,gBAAA;AV8pBxC;;AU9pBE;EAAsC,gBAAA;AVkqBxC;;AUlqBE;EAAsC,gBAAA;AVsqBxC;;AUtqBE;EAAsC,gBAAA;AV0qBxC;;AU1qBE;EAAsC,gBAAA;AV8qBxC;;AU9qBE;EAAsC,gBAAA;AVkrBxC;;AUlrBE;EAAsC,gBAAA;AVsrBxC;;AUtrBE;EAAsC,gBAAA;AV0rBxC;;AU1rBE;EAAsC,gBAAA;AV8rBxC;;AU9rBE;EAAsC,gBAAA;AVksBxC;;AUlsBE;EAAsC,gBAAA;AVssBxC;;AUtsBE;EAAsC,gBAAA;AV0sBxC;;AU1sBE;EAAsC,gBAAA;AV8sBxC;;AU9sBE;EAAsC,gBAAA;AVktBxC;;AUltBE;EAAsC,gBAAA;AVstBxC;;AUttBE;EAAsC,gBAAA;AV0tBxC;;AU1tBE;EAAsC,gBAAA;AV8tBxC;;AU9tBE;EAAsC,gBAAA;AVkuBxC;;AUluBE;EAAsC,gBAAA;AVsuBxC;;AUtuBE;EAAsC,gBAAA;AV0uBxC;;AU1uBE;EAAsC,gBAAA;AV8uBxC;;AU9uBE;EAAsC,gBAAA;AVkvBxC;;AUlvBE;EAAsC,gBAAA;AVsvBxC;;AUtvBE;EAAsC,gBAAA;AV0vBxC;;AU1vBE;EAAsC,gBAAA;AV8vBxC;;AU9vBE;EAAsC,gBAAA;AVkwBxC;;AUlwBE;EAAsC,gBAAA;AVswBxC;;AUtwBE;EAAsC,gBAAA;AV0wBxC;;AU1wBE;EAAsC,gBAAA;AV8wBxC;;AU9wBE;EAAsC,gBAAA;AVkxBxC;;AUlxBE;EAAsC,gBAAA;AVsxBxC;;AUtxBE;EAAsC,gBAAA;AV0xBxC;;AU1xBE;EAAsC,gBAAA;AV8xBxC;;AU9xBE;EAAsC,gBAAA;AVkyBxC;;AUlyBE;EAAsC,gBAAA;AVsyBxC;;AUtyBE;EAAsC,gBAAA;AV0yBxC;;AU1yBE;EAAsC,gBAAA;AV8yBxC;;AU9yBE;EAAsC,YAAA;AVkzBxC;;AUlzBE;EAAsC,gBAAA;AVszBxC;;AUtzBE;EAAsC,gBAAA;AV0zBxC;;AU1zBE;EAAsC,gBAAA;AV8zBxC;;AU9zBE;EAAsC,gBAAA;AVk0BxC;;AUl0BE;EAAsC,gBAAA;AVs0BxC;;AUt0BE;EAAsC,gBAAA;AV00BxC;;AU10BE;EAAsC,gBAAA;AV80BxC;;AU90BE;EAAsC,gBAAA;AVk1BxC;;AUl1BE;EAAsC,gBAAA;AVs1BxC;;AUt1BE;EAAsC,gBAAA;AV01BxC;;AU11BE;EAAsC,gBAAA;AV81BxC;;AU91BE;EAAsC,gBAAA;AVk2BxC;;AUl2BE;EAAsC,gBAAA;AVs2BxC;;AUt2BE;EAAsC,gBAAA;AV02BxC;;AU12BE;EAAsC,gBAAA;AV82BxC;;AU92BE;EAAsC,gBAAA;AVk3BxC;;AUl3BE;EAAsC,gBAAA;AVs3BxC;;AUt3BE;EAAsC,gBAAA;AV03BxC;;AU13BE;EAAsC,gBAAA;AV83BxC;;AU93BE;EAAsC,gBAAA;AVk4BxC;;AUl4BE;EAAsC,gBAAA;AVs4BxC;;AUt4BE;EAAsC,gBAAA;AV04BxC;;AU14BE;EAAsC,gBAAA;AV84BxC;;AU94BE;EAAsC,gBAAA;AVk5BxC;;AUl5BE;EAAsC,gBAAA;AVs5BxC;;AUt5BE;EAAsC,gBAAA;AV05BxC;;AU15BE;EAAsC,gBAAA;AV85BxC;;AU95BE;EAAsC,gBAAA;AVk6BxC;;AUl6BE;EAAsC,gBAAA;AVs6BxC;;AUt6BE;EAAsC,gBAAA;AV06BxC;;AU16BE;EAAsC,gBAAA;AV86BxC;;AU96BE;EAAsC,gBAAA;AVk7BxC;;AUl7BE;EAAsC,gBAAA;AVs7BxC;;AUt7BE;EAAsC,gBAAA;AV07BxC;;AU17BE;EAAsC,YAAA;AV87BxC;;AU97BE;EAAsC,gBAAA;AVk8BxC;;AUl8BE;EAAsC,gBAAA;AVs8BxC;;AUt8BE;EAAsC,gBAAA;AV08BxC;;AU18BE;EAAsC,gBAAA;AV88BxC;;AU98BE;EAAsC,gBAAA;AVk9BxC;;AUl9BE;EAAsC,gBAAA;AVs9BxC;;AUt9BE;EAAsC,gBAAA;AV09BxC;;AU19BE;EAAsC,gBAAA;AV89BxC;;AU99BE;EAAsC,gBAAA;AVk+BxC;;AUl+BE;EAAsC,gBAAA;AVs+BxC;;AUt+BE;EAAsC,gBAAA;AV0+BxC;;AU1+BE;EAAsC,gBAAA;AV8+BxC;;AU9+BE;EAAsC,gBAAA;AVk/BxC;;AUl/BE;EAAsC,gBAAA;AVs/BxC;;AUt/BE;EAAsC,gBAAA;AV0/BxC;;AU1/BE;EAAsC,gBAAA;AV8/BxC;;AU9/BE;EAAsC,gBAAA;AVkgCxC;;AUlgCE;EAAsC,gBAAA;AVsgCxC;;AUtgCE;EAAsC,gBAAA;AV0gCxC;;AU1gCE;EAAsC,gBAAA;AV8gCxC;;AU9gCE;EAAsC,gBAAA;AVkhCxC;;AUlhCE;EAAsC,gBAAA;AVshCxC;;AUthCE;EAAsC,gBAAA;AV0hCxC;;AU1hCE;EAAsC,gBAAA;AV8hCxC;;AU9hCE;EAAsC,gBAAA;AVkiCxC;;AUliCE;EAAsC,gBAAA;AVsiCxC;;AUtiCE;EAAsC,gBAAA;AV0iCxC;;AU1iCE;EAAsC,gBAAA;AV8iCxC;;AU9iCE;EAAsC,gBAAA;AVkjCxC;;AUljCE;EAAsC,gBAAA;AVsjCxC;;AUtjCE;EAAsC,gBAAA;AV0jCxC;;AU1jCE;EAAsC,gBAAA;AV8jCxC;;AU9jCE;EAAsC,gBAAA;AVkkCxC;;AUlkCE;EAAsC,gBAAA;AVskCxC;;AUtkCE;EAAsC,gBAAA;AV0kCxC;;AU1kCE;EAAsC,gBAAA;AV8kCxC;;AU9kCE;EAAsC,gBAAA;AVklCxC;;AUllCE;EAAsC,gBAAA;AVslCxC;;AUtlCE;EAAsC,gBAAA;AV0lCxC;;AU1lCE;EAAsC,gBAAA;AV8lCxC;;AU9lCE;EAAsC,gBAAA;AVkmCxC;;AUlmCE;EAAsC,gBAAA;AVsmCxC;;AUtmCE;EAAsC,gBAAA;AV0mCxC;;AU1mCE;EAAsC,gBAAA;AV8mCxC;;AU9mCE;EAAsC,gBAAA;AVknCxC;;AUlnCE;EAAsC,gBAAA;AVsnCxC;;AUtnCE;EAAsC,gBAAA;AV0nCxC;;AU1nCE;EAAsC,gBAAA;AV8nCxC;;AU9nCE;EAAsC,gBAAA;AVkoCxC;;AUloCE;EAAsC,gBAAA;AVsoCxC;;AUtoCE;EAAsC,gBAAA;AV0oCxC;;AU1oCE;EAAsC,gBAAA;AV8oCxC;;AU9oCE;EAAsC,gBAAA;AVkpCxC;;AUlpCE;EAAsC,gBAAA;AVspCxC;;AUtpCE;EAAsC,gBAAA;AV0pCxC;;AU1pCE;EAAsC,gBAAA;AV8pCxC;;AU9pCE;EAAsC,gBAAA;AVkqCxC;;AUlqCE;EAAsC,gBAAA;AVsqCxC;;AUtqCE;EAAsC,gBAAA;AV0qCxC;;AU1qCE;EAAsC,gBAAA;AV8qCxC;;AU9qCE;EAAsC,gBAAA;AVkrCxC;;AUlrCE;EAAsC,gBAAA;AVsrCxC;;AUtrCE;EAAsC,gBAAA;AV0rCxC;;AU1rCE;EAAsC,gBAAA;AV8rCxC;;AU9rCE;EAAsC,gBAAA;AVksCxC;;AUlsCE;EAAsC,gBAAA;AVssCxC;;AUtsCE;EAAsC,gBAAA;AV0sCxC;;AU1sCE;EAAsC,gBAAA;AV8sCxC;;AU9sCE;EAAsC,gBAAA;AVktCxC;;AUltCE;EAAsC,gBAAA;AVstCxC;;AUttCE;EAAsC,gBAAA;AV0tCxC;;AU1tCE;EAAsC,gBAAA;AV8tCxC;;AU9tCE;EAAsC,gBAAA;AVkuCxC;;AUluCE;EAAsC,gBAAA;AVsuCxC;;AUtuCE;EAAsC,gBAAA;AV0uCxC;;AU1uCE;EAAsC,gBAAA;AV8uCxC;;AU9uCE;EAAsC,gBAAA;AVkvCxC;;AUlvCE;EAAsC,gBAAA;AVsvCxC;;AUtvCE;EAAsC,gBAAA;AV0vCxC;;AU1vCE;EAAsC,gBAAA;AV8vCxC;;AU9vCE;EAAsC,gBAAA;AVkwCxC;;AUlwCE;EAAsC,gBAAA;AVswCxC;;AUtwCE;EAAsC,gBAAA;AV0wCxC;;AU1wCE;EAAsC,gBAAA;AV8wCxC;;AU9wCE;EAAsC,gBAAA;AVkxCxC;;AUlxCE;EAAsC,gBAAA;AVsxCxC;;AUtxCE;EAAsC,gBAAA;AV0xCxC;;AU1xCE;EAAsC,gBAAA;AV8xCxC;;AU9xCE;EAAsC,gBAAA;AVkyCxC;;AUlyCE;EAAsC,gBAAA;AVsyCxC;;AUtyCE;EAAsC,gBAAA;AV0yCxC;;AU1yCE;EAAsC,gBAAA;AV8yCxC;;AU9yCE;EAAsC,gBAAA;AVkzCxC;;AUlzCE;EAAsC,gBAAA;AVszCxC;;AUtzCE;EAAsC,gBAAA;AV0zCxC;;AU1zCE;EAAsC,gBAAA;AV8zCxC;;AU9zCE;EAAsC,gBAAA;AVk0CxC;;AUl0CE;EAAsC,gBAAA;AVs0CxC;;AUt0CE;EAAsC,gBAAA;AV00CxC;;AU10CE;EAAsC,aAAA;AV80CxC;;AU90CE;EAAsC,gBAAA;AVk1CxC;;AUl1CE;EAAsC,gBAAA;AVs1CxC;;AUt1CE;EAAsC,gBAAA;AV01CxC;;AU11CE;EAAsC,gBAAA;AV81CxC;;AU91CE;EAAsC,gBAAA;AVk2CxC;;AUl2CE;EAAsC,gBAAA;AVs2CxC;;AUt2CE;EAAsC,gBAAA;AV02CxC;;AU12CE;EAAsC,gBAAA;AV82CxC;;AU92CE;EAAsC,gBAAA;AVk3CxC;;AUl3CE;EAAsC,gBAAA;AVs3CxC;;AUt3CE;EAAsC,gBAAA;AV03CxC;;AU13CE;EAAsC,gBAAA;AV83CxC;;AU93CE;EAAsC,gBAAA;AVk4CxC;;AUl4CE;EAAsC,gBAAA;AVs4CxC;;AUt4CE;EAAsC,gBAAA;AV04CxC;;AU14CE;EAAsC,gBAAA;AV84CxC;;AU94CE;EAAsC,gBAAA;AVk5CxC;;AUl5CE;EAAsC,gBAAA;AVs5CxC;;AUt5CE;EAAsC,gBAAA;AV05CxC;;AU15CE;EAAsC,gBAAA;AV85CxC;;AU95CE;EAAsC,gBAAA;AVk6CxC;;AUl6CE;EAAsC,gBAAA;AVs6CxC;;AUt6CE;EAAsC,gBAAA;AV06CxC;;AU16CE;EAAsC,gBAAA;AV86CxC;;AU96CE;EAAsC,gBAAA;AVk7CxC;;AUl7CE;EAAsC,gBAAA;AVs7CxC;;AUt7CE;EAAsC,gBAAA;AV07CxC;;AU17CE;EAAsC,gBAAA;AV87CxC;;AU97CE;EAAsC,gBAAA;AVk8CxC;;AUl8CE;EAAsC,gBAAA;AVs8CxC;;AUt8CE;EAAsC,gBAAA;AV08CxC;;AU18CE;EAAsC,gBAAA;AV88CxC;;AU98CE;EAAsC,gBAAA;AVk9CxC;;AUl9CE;EAAsC,gBAAA;AVs9CxC;;AUt9CE;EAAsC,gBAAA;AV09CxC;;AU19CE;EAAsC,gBAAA;AV89CxC;;AU99CE;EAAsC,gBAAA;AVk+CxC;;AUl+CE;EAAsC,gBAAA;AVs+CxC;;AUt+CE;EAAsC,gBAAA;AV0+CxC;;AU1+CE;EAAsC,gBAAA;AV8+CxC;;AU9+CE;EAAsC,gBAAA;AVk/CxC;;AUl/CE;EAAsC,gBAAA;AVs/CxC;;AUt/CE;EAAsC,gBAAA;AV0/CxC;;AU1/CE;EAAsC,gBAAA;AV8/CxC;;AU9/CE;EAAsC,gBAAA;AVkgDxC;;AUlgDE;EAAsC,gBAAA;AVsgDxC;;AUtgDE;EAAsC,gBAAA;AV0gDxC;;AU1gDE;EAAsC,gBAAA;AV8gDxC;;AU9gDE;EAAsC,gBAAA;AVkhDxC;;AUlhDE;EAAsC,gBAAA;AVshDxC;;AUthDE;EAAsC,gBAAA;AV0hDxC;;AU1hDE;EAAsC,gBAAA;AV8hDxC;;AU9hDE;EAAsC,gBAAA;AVkiDxC;;AUliDE;EAAsC,gBAAA;AVsiDxC;;AUtiDE;EAAsC,gBAAA;AV0iDxC;;AU1iDE;EAAsC,gBAAA;AV8iDxC;;AU9iDE;EAAsC,gBAAA;AVkjDxC;;AUljDE;EAAsC,gBAAA;AVsjDxC;;AUtjDE;EAAsC,gBAAA;AV0jDxC;;AU1jDE;EAAsC,gBAAA;AV8jDxC;;AU9jDE;EAAsC,gBAAA;AVkkDxC;;AUlkDE;EAAsC,gBAAA;AVskDxC;;AUtkDE;EAAsC,gBAAA;AV0kDxC;;AU1kDE;EAAsC,gBAAA;AV8kDxC;;AU9kDE;EAAsC,gBAAA;AVklDxC;;AUllDE;EAAsC,gBAAA;AVslDxC;;AUtlDE;EAAsC,gBAAA;AV0lDxC;;AU1lDE;EAAsC,gBAAA;AV8lDxC;;AU9lDE;EAAsC,gBAAA;AVkmDxC;;AUlmDE;EAAsC,gBAAA;AVsmDxC;;AUtmDE;EAAsC,gBAAA;AV0mDxC;;AU1mDE;EAAsC,gBAAA;AV8mDxC;;AU9mDE;EAAsC,gBAAA;AVknDxC;;AUlnDE;EAAsC,gBAAA;AVsnDxC;;AUtnDE;EAAsC,gBAAA;AV0nDxC;;AU1nDE;EAAsC,gBAAA;AV8nDxC;;AU9nDE;EAAsC,gBAAA;AVkoDxC;;AUloDE;EAAsC,gBAAA;AVsoDxC;;AUtoDE;EAAsC,gBAAA;AV0oDxC;;AU1oDE;EAAsC,gBAAA;AV8oDxC;;AU9oDE;EAAsC,gBAAA;AVkpDxC;;AUlpDE;EAAsC,gBAAA;AVspDxC;;AUtpDE;EAAsC,gBAAA;AV0pDxC;;AU1pDE;EAAsC,gBAAA;AV8pDxC;;AU9pDE;EAAsC,YAAA;AVkqDxC;;AUlqDE;EAAsC,gBAAA;AVsqDxC;;AUtqDE;EAAsC,gBAAA;AV0qDxC;;AU1qDE;EAAsC,gBAAA;AV8qDxC;;AU9qDE;EAAsC,gBAAA;AVkrDxC;;AUlrDE;EAAsC,gBAAA;AVsrDxC;;AUtrDE;EAAsC,gBAAA;AV0rDxC;;AU1rDE;EAAsC,YAAA;AV8rDxC;;AU9rDE;EAAsC,gBAAA;AVksDxC;;AUlsDE;EAAsC,gBAAA;AVssDxC;;AUtsDE;EAAsC,gBAAA;AV0sDxC;;AU1sDE;EAAsC,gBAAA;AV8sDxC;;AU9sDE;EAAsC,gBAAA;AVktDxC;;AUltDE;EAAsC,gBAAA;AVstDxC;;AUttDE;EAAsC,gBAAA;AV0tDxC;;AU1tDE;EAAsC,gBAAA;AV8tDxC;;AU9tDE;EAAsC,gBAAA;AVkuDxC;;AUluDE;EAAsC,gBAAA;AVsuDxC;;AUtuDE;EAAsC,gBAAA;AV0uDxC;;AU1uDE;EAAsC,gBAAA;AV8uDxC;;AU9uDE;EAAsC,gBAAA;AVkvDxC;;AUlvDE;EAAsC,gBAAA;AVsvDxC;;AUtvDE;EAAsC,gBAAA;AV0vDxC;;AU1vDE;EAAsC,gBAAA;AV8vDxC;;AU9vDE;EAAsC,gBAAA;AVkwDxC;;AUlwDE;EAAsC,gBAAA;AVswDxC;;AUtwDE;EAAsC,YAAA;AV0wDxC;;AU1wDE;EAAsC,YAAA;AV8wDxC;;AU9wDE;EAAsC,gBAAA;AVkxDxC;;AUlxDE;EAAsC,gBAAA;AVsxDxC;;AUtxDE;EAAsC,gBAAA;AV0xDxC;;AU1xDE;EAAsC,gBAAA;AV8xDxC;;AU9xDE;EAAsC,gBAAA;AVkyDxC;;AUlyDE;EAAsC,gBAAA;AVsyDxC;;AUtyDE;EAAsC,gBAAA;AV0yDxC;;AU1yDE;EAAsC,gBAAA;AV8yDxC;;AU9yDE;EAAsC,gBAAA;AVkzDxC;;AUlzDE;EAAsC,gBAAA;AVszDxC;;AUtzDE;EAAsC,gBAAA;AV0zDxC;;AU1zDE;EAAsC,gBAAA;AV8zDxC;;AU9zDE;EAAsC,gBAAA;AVk0DxC;;AUl0DE;EAAsC,gBAAA;AVs0DxC;;AUt0DE;EAAsC,gBAAA;AV00DxC;;AU10DE;EAAsC,gBAAA;AV80DxC;;AU90DE;EAAsC,gBAAA;AVk1DxC;;AUl1DE;EAAsC,gBAAA;AVs1DxC;;AUt1DE;EAAsC,gBAAA;AV01DxC;;AU11DE;EAAsC,gBAAA;AV81DxC;;AU91DE;EAAsC,gBAAA;AVk2DxC;;AUl2DE;EAAsC,gBAAA;AVs2DxC;;AUt2DE;EAAsC,gBAAA;AV02DxC;;AU12DE;EAAsC,gBAAA;AV82DxC;;AU92DE;EAAsC,gBAAA;AVk3DxC;;AUl3DE;EAAsC,gBAAA;AVs3DxC;;AUt3DE;EAAsC,gBAAA;AV03DxC;;AU13DE;EAAsC,gBAAA;AV83DxC;;AU93DE;EAAsC,gBAAA;AVk4DxC;;AUl4DE;EAAsC,gBAAA;AVs4DxC;;AUt4DE;EAAsC,gBAAA;AV04DxC;;AU14DE;EAAsC,gBAAA;AV84DxC;;AU94DE;EAAsC,gBAAA;AVk5DxC;;AUl5DE;EAAsC,gBAAA;AVs5DxC;;AUt5DE;EAAsC,gBAAA;AV05DxC;;AU15DE;EAAsC,YAAA;AV85DxC;;AU95DE;EAAsC,gBAAA;AVk6DxC;;AUl6DE;EAAsC,gBAAA;AVs6DxC;;AUt6DE;EAAsC,gBAAA;AV06DxC;;AU16DE;EAAsC,gBAAA;AV86DxC;;AU96DE;EAAsC,gBAAA;AVk7DxC;;AUl7DE;EAAsC,gBAAA;AVs7DxC;;AUt7DE;EAAsC,gBAAA;AV07DxC;;AU17DE;EAAsC,gBAAA;AV87DxC;;AU97DE;EAAsC,gBAAA;AVk8DxC;;AUl8DE;EAAsC,gBAAA;AVs8DxC;;AUt8DE;EAAsC,gBAAA;AV08DxC;;AU18DE;EAAsC,gBAAA;AV88DxC;;AU98DE;EAAsC,gBAAA;AVk9DxC;;AUl9DE;EAAsC,gBAAA;AVs9DxC;;AUt9DE;EAAsC,gBAAA;AV09DxC;;AU19DE;EAAsC,gBAAA;AV89DxC;;AU99DE;EAAsC,gBAAA;AVk+DxC;;AUl+DE;EAAsC,gBAAA;AVs+DxC;;AUt+DE;EAAsC,gBAAA;AV0+DxC;;AU1+DE;EAAsC,YAAA;AV8+DxC;;AU9+DE;EAAsC,gBAAA;AVk/DxC;;AUl/DE;EAAsC,gBAAA;AVs/DxC;;AUt/DE;EAAsC,gBAAA;AV0/DxC;;AU1/DE;EAAsC,gBAAA;AV8/DxC;;AU9/DE;EAAsC,gBAAA;AVkgExC;;AUlgEE;EAAsC,gBAAA;AVsgExC;;AUtgEE;EAAsC,gBAAA;AV0gExC;;AU1gEE;EAAsC,gBAAA;AV8gExC;;AU9gEE;EAAsC,gBAAA;AVkhExC;;AUlhEE;EAAsC,gBAAA;AVshExC;;AUthEE;EAAsC,gBAAA;AV0hExC;;AU1hEE;EAAsC,gBAAA;AV8hExC;;AU9hEE;EAAsC,gBAAA;AVkiExC;;AUliEE;EAAsC,gBAAA;AVsiExC;;AUtiEE;EAAsC,gBAAA;AV0iExC;;AU1iEE;EAAsC,gBAAA;AV8iExC;;AU9iEE;EAAsC,gBAAA;AVkjExC;;AUljEE;EAAsC,gBAAA;AVsjExC;;AUtjEE;EAAsC,gBAAA;AV0jExC;;AU1jEE;EAAsC,gBAAA;AV8jExC;;AU9jEE;EAAsC,gBAAA;AVkkExC;;AUlkEE;EAAsC,gBAAA;AVskExC;;AUtkEE;EAAsC,gBAAA;AV0kExC;;AU1kEE;EAAsC,gBAAA;AV8kExC;;AU9kEE;EAAsC,gBAAA;AVklExC;;AUllEE;EAAsC,gBAAA;AVslExC;;AUtlEE;EAAsC,gBAAA;AV0lExC;;AU1lEE;EAAsC,gBAAA;AV8lExC;;AU9lEE;EAAsC,gBAAA;AVkmExC;;AUlmEE;EAAsC,gBAAA;AVsmExC;;AUtmEE;EAAsC,gBAAA;AV0mExC;;AU1mEE;EAAsC,gBAAA;AV8mExC;;AU9mEE;EAAsC,gBAAA;AVknExC;;AUlnEE;EAAsC,gBAAA;AVsnExC;;AUtnEE;EAAsC,gBAAA;AV0nExC;;AU1nEE;EAAsC,gBAAA;AV8nExC;;AU9nEE;EAAsC,gBAAA;AVkoExC;;AUloEE;EAAsC,gBAAA;AVsoExC;;AUtoEE;EAAsC,gBAAA;AV0oExC;;AU1oEE;EAAsC,gBAAA;AV8oExC;;AU9oEE;EAAsC,gBAAA;AVkpExC;;AUlpEE;EAAsC,gBAAA;AVspExC;;AUtpEE;EAAsC,gBAAA;AV0pExC;;AU1pEE;EAAsC,gBAAA;AV8pExC;;AU9pEE;EAAsC,gBAAA;AVkqExC;;AUlqEE;EAAsC,gBAAA;AVsqExC;;AUtqEE;EAAsC,gBAAA;AV0qExC;;AU1qEE;EAAsC,gBAAA;AV8qExC;;AU9qEE;EAAsC,gBAAA;AVkrExC;;AUlrEE;EAAsC,gBAAA;AVsrExC;;AUtrEE;EAAsC,gBAAA;AV0rExC;;AU1rEE;EAAsC,gBAAA;AV8rExC;;AU9rEE;EAAsC,gBAAA;AVksExC;;AUlsEE;EAAsC,gBAAA;AVssExC;;AUtsEE;EAAsC,gBAAA;AV0sExC;;AU1sEE;EAAsC,gBAAA;AV8sExC;;AU9sEE;EAAsC,gBAAA;AVktExC;;AUltEE;EAAsC,gBAAA;AVstExC;;AUttEE;EAAsC,gBAAA;AV0tExC;;AU1tEE;EAAsC,gBAAA;AV8tExC;;AU9tEE;EAAsC,gBAAA;AVkuExC;;AUluEE;EAAsC,gBAAA;AVsuExC;;AUtuEE;EAAsC,gBAAA;AV0uExC;;AU1uEE;EAAsC,gBAAA;AV8uExC;;AU9uEE;EAAsC,gBAAA;AVkvExC;;AUlvEE;EAAsC,gBAAA;AVsvExC;;AUtvEE;EAAsC,gBAAA;AV0vExC;;AU1vEE;EAAsC,gBAAA;AV8vExC;;AU9vEE;EAAsC,gBAAA;AVkwExC;;AUlwEE;EAAsC,gBAAA;AVswExC;;AUtwEE;EAAsC,gBAAA;AV0wExC;;AU1wEE;EAAsC,gBAAA;AV8wExC;;AU9wEE;EAAsC,gBAAA;AVkxExC;;AUlxEE;EAAsC,gBAAA;AVsxExC;;AUtxEE;EAAsC,gBAAA;AV0xExC;;AU1xEE;EAAsC,gBAAA;AV8xExC;;AU9xEE;EAAsC,gBAAA;AVkyExC;;AUlyEE;EAAsC,gBAAA;AVsyExC;;AUtyEE;EAAsC,gBAAA;AV0yExC;;AU1yEE;EAAsC,gBAAA;AV8yExC;;AU9yEE;EAAsC,gBAAA;AVkzExC;;AUlzEE;EAAsC,YAAA;AVszExC;;AUtzEE;EAAsC,gBAAA;AV0zExC;;AU1zEE;EAAsC,gBAAA;AV8zExC;;AU9zEE;EAAsC,gBAAA;AVk0ExC;;AUl0EE;EAAsC,gBAAA;AVs0ExC;;AUt0EE;EAAsC,gBAAA;AV00ExC;;AU10EE;EAAsC,gBAAA;AV80ExC;;AU90EE;EAAsC,gBAAA;AVk1ExC;;AUl1EE;EAAsC,gBAAA;AVs1ExC;;AUt1EE;EAAsC,gBAAA;AV01ExC;;AU11EE;EAAsC,gBAAA;AV81ExC;;AU91EE;EAAsC,gBAAA;AVk2ExC;;AUl2EE;EAAsC,gBAAA;AVs2ExC;;AUt2EE;EAAsC,gBAAA;AV02ExC;;AU12EE;EAAsC,gBAAA;AV82ExC;;AU92EE;EAAsC,gBAAA;AVk3ExC;;AUl3EE;EAAsC,gBAAA;AVs3ExC;;AUt3EE;EAAsC,gBAAA;AV03ExC;;AU13EE;EAAsC,gBAAA;AV83ExC;;AU93EE;EAAsC,gBAAA;AVk4ExC;;AUl4EE;EAAsC,gBAAA;AVs4ExC;;AUt4EE;EAAsC,gBAAA;AV04ExC;;AU14EE;EAAsC,gBAAA;AV84ExC;;AU94EE;EAAsC,gBAAA;AVk5ExC;;AUl5EE;EAAsC,gBAAA;AVs5ExC;;AUt5EE;EAAsC,gBAAA;AV05ExC;;AU15EE;EAAsC,gBAAA;AV85ExC;;AU95EE;EAAsC,gBAAA;AVk6ExC;;AUl6EE;EAAsC,gBAAA;AVs6ExC;;AUt6EE;EAAsC,gBAAA;AV06ExC;;AU16EE;EAAsC,gBAAA;AV86ExC;;AU96EE;EAAsC,gBAAA;AVk7ExC;;AUl7EE;EAAsC,gBAAA;AVs7ExC;;AUt7EE;EAAsC,gBAAA;AV07ExC;;AU17EE;EAAsC,gBAAA;AV87ExC;;AU97EE;EAAsC,gBAAA;AVk8ExC;;AUl8EE;EAAsC,gBAAA;AVs8ExC;;AUt8EE;EAAsC,gBAAA;AV08ExC;;AU18EE;EAAsC,gBAAA;AV88ExC;;AU98EE;EAAsC,gBAAA;AVk9ExC;;AUl9EE;EAAsC,gBAAA;AVs9ExC;;AUt9EE;EAAsC,gBAAA;AV09ExC;;AU19EE;EAAsC,gBAAA;AV89ExC;;AU99EE;EAAsC,gBAAA;AVk+ExC;;AUl+EE;EAAsC,gBAAA;AVs+ExC;;AUt+EE;EAAsC,gBAAA;AV0+ExC;;AU1+EE;EAAsC,gBAAA;AV8+ExC;;AU9+EE;EAAsC,gBAAA;AVk/ExC;;AUl/EE;EAAsC,gBAAA;AVs/ExC;;AUt/EE;EAAsC,gBAAA;AV0/ExC;;AU1/EE;EAAsC,gBAAA;AV8/ExC;;AU9/EE;EAAsC,gBAAA;AVkgFxC;;AUlgFE;EAAsC,gBAAA;AVsgFxC;;AUtgFE;EAAsC,gBAAA;AV0gFxC;;AU1gFE;EAAsC,gBAAA;AV8gFxC;;AU9gFE;EAAsC,gBAAA;AVkhFxC;;AUlhFE;EAAsC,gBAAA;AVshFxC;;AUthFE;EAAsC,gBAAA;AV0hFxC;;AU1hFE;EAAsC,gBAAA;AV8hFxC;;AU9hFE;EAAsC,gBAAA;AVkiFxC;;AUliFE;EAAsC,gBAAA;AVsiFxC;;AUtiFE;EAAsC,gBAAA;AV0iFxC;;AU1iFE;EAAsC,gBAAA;AV8iFxC;;AU9iFE;EAAsC,gBAAA;AVkjFxC;;AUljFE;EAAsC,gBAAA;AVsjFxC;;AUtjFE;EAAsC,gBAAA;AV0jFxC;;AU1jFE;EAAsC,gBAAA;AV8jFxC;;AU9jFE;EAAsC,gBAAA;AVkkFxC;;AUlkFE;EAAsC,gBAAA;AVskFxC;;AUtkFE;EAAsC,gBAAA;AV0kFxC;;AU1kFE;EAAsC,gBAAA;AV8kFxC;;AU9kFE;EAAsC,gBAAA;AVklFxC;;AUllFE;EAAsC,gBAAA;AVslFxC;;AUtlFE;EAAsC,gBAAA;AV0lFxC;;AU1lFE;EAAsC,gBAAA;AV8lFxC;;AU9lFE;EAAsC,gBAAA;AVkmFxC;;AUlmFE;EAAsC,gBAAA;AVsmFxC;;AUtmFE;EAAsC,gBAAA;AV0mFxC;;AU1mFE;EAAsC,gBAAA;AV8mFxC;;AU9mFE;EAAsC,gBAAA;AVknFxC;;AUlnFE;EAAsC,gBAAA;AVsnFxC;;AUtnFE;EAAsC,gBAAA;AV0nFxC;;AU1nFE;EAAsC,gBAAA;AV8nFxC;;AU9nFE;EAAsC,gBAAA;AVkoFxC;;AUloFE;EAAsC,gBAAA;AVsoFxC;;AUtoFE;EAAsC,gBAAA;AV0oFxC;;AU1oFE;EAAsC,gBAAA;AV8oFxC;;AU9oFE;EAAsC,gBAAA;AVkpFxC;;AUlpFE;EAAsC,gBAAA;AVspFxC;;AUtpFE;EAAsC,gBAAA;AV0pFxC;;AU1pFE;EAAsC,gBAAA;AV8pFxC;;AU9pFE;EAAsC,gBAAA;AVkqFxC;;AUlqFE;EAAsC,gBAAA;AVsqFxC;;AUtqFE;EAAsC,gBAAA;AV0qFxC;;AU1qFE;EAAsC,gBAAA;AV8qFxC;;AU9qFE;EAAsC,gBAAA;AVkrFxC;;AUlrFE;EAAsC,gBAAA;AVsrFxC;;AUtrFE;EAAsC,gBAAA;AV0rFxC;;AU1rFE;EAAsC,gBAAA;AV8rFxC;;AU9rFE;EAAsC,gBAAA;AVksFxC;;AUlsFE;EAAsC,gBAAA;AVssFxC;;AUtsFE;EAAsC,gBAAA;AV0sFxC;;AU1sFE;EAAsC,gBAAA;AV8sFxC;;AU9sFE;EAAsC,gBAAA;AVktFxC;;AUltFE;EAAsC,gBAAA;AVstFxC;;AUttFE;EAAsC,gBAAA;AV0tFxC;;AU1tFE;EAAsC,gBAAA;AV8tFxC;;AU9tFE;EAAsC,gBAAA;AVkuFxC;;AUluFE;EAAsC,gBAAA;AVsuFxC;;AUtuFE;EAAsC,gBAAA;AV0uFxC;;AU1uFE;EAAsC,gBAAA;AV8uFxC;;AU9uFE;EAAsC,gBAAA;AVkvFxC;;AUlvFE;EAAsC,gBAAA;AVsvFxC;;AUtvFE;EAAsC,gBAAA;AV0vFxC;;AU1vFE;EAAsC,gBAAA;AV8vFxC;;AU9vFE;EAAsC,gBAAA;AVkwFxC;;AUlwFE;EAAsC,gBAAA;AVswFxC;;AUtwFE;EAAsC,gBAAA;AV0wFxC;;AU1wFE;EAAsC,gBAAA;AV8wFxC;;AU9wFE;EAAsC,gBAAA;AVkxFxC;;AUlxFE;EAAsC,gBAAA;AVsxFxC;;AUtxFE;EAAsC,gBAAA;AV0xFxC;;AU1xFE;EAAsC,gBAAA;AV8xFxC;;AU9xFE;EAAsC,gBAAA;AVkyFxC;;AUlyFE;EAAsC,gBAAA;AVsyFxC;;AUtyFE;EAAsC,gBAAA;AV0yFxC;;AU1yFE;EAAsC,gBAAA;AV8yFxC;;AU9yFE;EAAsC,gBAAA;AVkzFxC;;AUlzFE;EAAsC,gBAAA;AVszFxC;;AUtzFE;EAAsC,gBAAA;AV0zFxC;;AU1zFE;EAAsC,gBAAA;AV8zFxC;;AU9zFE;EAAsC,gBAAA;AVk0FxC;;AUl0FE;EAAsC,gBAAA;AVs0FxC;;AUt0FE;EAAsC,gBAAA;AV00FxC;;AU10FE;EAAsC,gBAAA;AV80FxC;;AU90FE;EAAsC,gBAAA;AVk1FxC;;AUl1FE;EAAsC,gBAAA;AVs1FxC;;AUt1FE;EAAsC,gBAAA;AV01FxC;;AU11FE;EAAsC,gBAAA;AV81FxC;;AU91FE;EAAsC,gBAAA;AVk2FxC;;AUl2FE;EAAsC,gBAAA;AVs2FxC;;AUt2FE;EAAsC,gBAAA;AV02FxC;;AU12FE;EAAsC,gBAAA;AV82FxC;;AU92FE;EAAsC,gBAAA;AVk3FxC;;AUl3FE;EAAsC,gBAAA;AVs3FxC;;AUt3FE;EAAsC,gBAAA;AV03FxC;;AU13FE;EAAsC,gBAAA;AV83FxC;;AU93FE;EAAsC,gBAAA;AVk4FxC;;AUl4FE;EAAsC,gBAAA;AVs4FxC;;AUt4FE;EAAsC,gBAAA;AV04FxC;;AU14FE;EAAsC,gBAAA;AV84FxC;;AU94FE;EAAsC,gBAAA;AVk5FxC;;AUl5FE;EAAsC,gBAAA;AVs5FxC;;AUt5FE;EAAsC,gBAAA;AV05FxC;;AU15FE;EAAsC,gBAAA;AV85FxC;;AU95FE;EAAsC,gBAAA;AVk6FxC;;AUl6FE;EAAsC,gBAAA;AVs6FxC;;AUt6FE;EAAsC,gBAAA;AV06FxC;;AU16FE;EAAsC,gBAAA;AV86FxC;;AU96FE;EAAsC,gBAAA;AVk7FxC;;AUl7FE;EAAsC,gBAAA;AVs7FxC;;AUt7FE;EAAsC,gBAAA;AV07FxC;;AU17FE;EAAsC,gBAAA;AV87FxC;;AU97FE;EAAsC,gBAAA;AVk8FxC;;AUl8FE;EAAsC,gBAAA;AVs8FxC;;AUt8FE;EAAsC,gBAAA;AV08FxC;;AU18FE;EAAsC,gBAAA;AV88FxC;;AU98FE;EAAsC,gBAAA;AVk9FxC;;AUl9FE;EAAsC,gBAAA;AVs9FxC;;AUt9FE;EAAsC,gBAAA;AV09FxC;;AU19FE;EAAsC,gBAAA;AV89FxC;;AU99FE;EAAsC,gBAAA;AVk+FxC;;AUl+FE;EAAsC,gBAAA;AVs+FxC;;AUt+FE;EAAsC,gBAAA;AV0+FxC;;AU1+FE;EAAsC,gBAAA;AV8+FxC;;AU9+FE;EAAsC,gBAAA;AVk/FxC;;AUl/FE;EAAsC,gBAAA;AVs/FxC;;AUt/FE;EAAsC,gBAAA;AV0/FxC;;AU1/FE;EAAsC,gBAAA;AV8/FxC;;AU9/FE;EAAsC,gBAAA;AVkgGxC;;AUlgGE;EAAsC,gBAAA;AVsgGxC;;AUtgGE;EAAsC,gBAAA;AV0gGxC;;AU1gGE;EAAsC,gBAAA;AV8gGxC;;AU9gGE;EAAsC,gBAAA;AVkhGxC;;AUlhGE;EAAsC,gBAAA;AVshGxC;;AUthGE;EAAsC,gBAAA;AV0hGxC;;AU1hGE;EAAsC,gBAAA;AV8hGxC;;AU9hGE;EAAsC,gBAAA;AVkiGxC;;AUliGE;EAAsC,gBAAA;AVsiGxC;;AUtiGE;EAAsC,gBAAA;AV0iGxC;;AU1iGE;EAAsC,gBAAA;AV8iGxC;;AU9iGE;EAAsC,gBAAA;AVkjGxC;;AUljGE;EAAsC,gBAAA;AVsjGxC;;AUtjGE;EAAsC,gBAAA;AV0jGxC;;AU1jGE;EAAsC,gBAAA;AV8jGxC;;AU9jGE;EAAsC,gBAAA;AVkkGxC;;AUlkGE;EAAsC,gBAAA;AVskGxC;;AUtkGE;EAAsC,gBAAA;AV0kGxC;;AU1kGE;EAAsC,gBAAA;AV8kGxC;;AU9kGE;EAAsC,gBAAA;AVklGxC;;AUllGE;EAAsC,gBAAA;AVslGxC;;AUtlGE;EAAsC,gBAAA;AV0lGxC;;AU1lGE;EAAsC,gBAAA;AV8lGxC;;AU9lGE;EAAsC,gBAAA;AVkmGxC;;AUlmGE;EAAsC,gBAAA;AVsmGxC;;AUtmGE;EAAsC,gBAAA;AV0mGxC;;AU1mGE;EAAsC,gBAAA;AV8mGxC;;AU9mGE;EAAsC,gBAAA;AVknGxC;;AUlnGE;EAAsC,gBAAA;AVsnGxC;;AUtnGE;EAAsC,gBAAA;AV0nGxC;;AU1nGE;EAAsC,gBAAA;AV8nGxC;;AU9nGE;EAAsC,gBAAA;AVkoGxC;;AUloGE;EAAsC,gBAAA;AVsoGxC;;AUtoGE;EAAsC,gBAAA;AV0oGxC;;AU1oGE;EAAsC,gBAAA;AV8oGxC;;AU9oGE;EAAsC,gBAAA;AVkpGxC;;AUlpGE;EAAsC,gBAAA;AVspGxC;;AUtpGE;EAAsC,gBAAA;AV0pGxC;;AU1pGE;EAAsC,gBAAA;AV8pGxC;;AU9pGE;EAAsC,gBAAA;AVkqGxC;;AUlqGE;EAAsC,gBAAA;AVsqGxC;;AUtqGE;EAAsC,gBAAA;AV0qGxC;;AU1qGE;EAAsC,gBAAA;AV8qGxC;;AU9qGE;EAAsC,gBAAA;AVkrGxC;;AUlrGE;EAAsC,gBAAA;AVsrGxC;;AUtrGE;EAAsC,gBAAA;AV0rGxC;;AU1rGE;EAAsC,gBAAA;AV8rGxC;;AU9rGE;EAAsC,gBAAA;AVksGxC;;AUlsGE;EAAsC,gBAAA;AVssGxC;;AUtsGE;EAAsC,gBAAA;AV0sGxC;;AU1sGE;EAAsC,gBAAA;AV8sGxC;;AU9sGE;EAAsC,gBAAA;AVktGxC;;AUltGE;EAAsC,gBAAA;AVstGxC;;AUttGE;EAAsC,gBAAA;AV0tGxC;;AU1tGE;EAAsC,gBAAA;AV8tGxC;;AU9tGE;EAAsC,gBAAA;AVkuGxC;;AUluGE;EAAsC,gBAAA;AVsuGxC;;AUtuGE;EAAsC,gBAAA;AV0uGxC;;AU1uGE;EAAsC,gBAAA;AV8uGxC;;AU9uGE;EAAsC,gBAAA;AVkvGxC;;AUlvGE;EAAsC,gBAAA;AVsvGxC;;AUtvGE;EAAsC,gBAAA;AV0vGxC;;AU1vGE;EAAsC,gBAAA;AV8vGxC;;AU9vGE;EAAsC,gBAAA;AVkwGxC;;AUlwGE;EAAsC,gBAAA;AVswGxC;;AUtwGE;EAAsC,gBAAA;AV0wGxC;;AU1wGE;EAAsC,gBAAA;AV8wGxC;;AU9wGE;EAAsC,gBAAA;AVkxGxC;;AUlxGE;EAAsC,gBAAA;AVsxGxC;;AUtxGE;EAAsC,gBAAA;AV0xGxC;;AU1xGE;EAAsC,gBAAA;AV8xGxC;;AU9xGE;EAAsC,gBAAA;AVkyGxC;;AUlyGE;EAAsC,gBAAA;AVsyGxC;;AUtyGE;EAAsC,gBAAA;AV0yGxC;;AU1yGE;EAAsC,gBAAA;AV8yGxC;;AU9yGE;EAAsC,gBAAA;AVkzGxC;;AUlzGE;EAAsC,gBAAA;AVszGxC;;AUtzGE;EAAsC,gBAAA;AV0zGxC;;AU1zGE;EAAsC,gBAAA;AV8zGxC;;AU9zGE;EAAsC,gBAAA;AVk0GxC;;AUl0GE;EAAsC,gBAAA;AVs0GxC;;AUt0GE;EAAsC,gBAAA;AV00GxC;;AU10GE;EAAsC,gBAAA;AV80GxC;;AU90GE;EAAsC,gBAAA;AVk1GxC;;AUl1GE;EAAsC,gBAAA;AVs1GxC;;AUt1GE;EAAsC,gBAAA;AV01GxC;;AU11GE;EAAsC,gBAAA;AV81GxC;;AU91GE;EAAsC,gBAAA;AVk2GxC;;AUl2GE;EAAsC,gBAAA;AVs2GxC;;AUt2GE;EAAsC,gBAAA;AV02GxC;;AU12GE;EAAsC,gBAAA;AV82GxC;;AU92GE;EAAsC,YAAA;AVk3GxC;;AUl3GE;EAAsC,gBAAA;AVs3GxC;;AUt3GE;EAAsC,gBAAA;AV03GxC;;AU13GE;EAAsC,gBAAA;AV83GxC;;AU93GE;EAAsC,YAAA;AVk4GxC;;AUl4GE;EAAsC,gBAAA;AVs4GxC;;AUt4GE;EAAsC,gBAAA;AV04GxC;;AU14GE;EAAsC,gBAAA;AV84GxC;;AU94GE;EAAsC,gBAAA;AVk5GxC;;AUl5GE;EAAsC,YAAA;AVs5GxC;;AUt5GE;EAAsC,gBAAA;AV05GxC;;AU15GE;EAAsC,gBAAA;AV85GxC;;AU95GE;EAAsC,gBAAA;AVk6GxC;;AUl6GE;EAAsC,gBAAA;AVs6GxC;;AUt6GE;EAAsC,gBAAA;AV06GxC;;AU16GE;EAAsC,gBAAA;AV86GxC;;AU96GE;EAAsC,gBAAA;AVk7GxC;;AUl7GE;EAAsC,gBAAA;AVs7GxC;;AUt7GE;EAAsC,gBAAA;AV07GxC;;AU17GE;EAAsC,gBAAA;AV87GxC;;AU97GE;EAAsC,gBAAA;AVk8GxC;;AUl8GE;EAAsC,gBAAA;AVs8GxC;;AUt8GE;EAAsC,gBAAA;AV08GxC;;AU18GE;EAAsC,gBAAA;AV88GxC;;AU98GE;EAAsC,gBAAA;AVk9GxC;;AUl9GE;EAAsC,gBAAA;AVs9GxC;;AUt9GE;EAAsC,gBAAA;AV09GxC;;AU19GE;EAAsC,gBAAA;AV89GxC;;AU99GE;EAAsC,gBAAA;AVk+GxC;;AUl+GE;EAAsC,gBAAA;AVs+GxC;;AUt+GE;EAAsC,gBAAA;AV0+GxC;;AU1+GE;EAAsC,gBAAA;AV8+GxC;;AU9+GE;EAAsC,aAAA;AVk/GxC;;AUl/GE;EAAsC,gBAAA;AVs/GxC;;AUt/GE;EAAsC,gBAAA;AV0/GxC;;AU1/GE;EAAsC,gBAAA;AV8/GxC;;AU9/GE;EAAsC,gBAAA;AVkgHxC;;AUlgHE;EAAsC,gBAAA;AVsgHxC;;AUtgHE;EAAsC,gBAAA;AV0gHxC;;AU1gHE;EAAsC,gBAAA;AV8gHxC;;AU9gHE;EAAsC,gBAAA;AVkhHxC;;AUlhHE;EAAsC,gBAAA;AVshHxC;;AUthHE;EAAsC,gBAAA;AV0hHxC;;AU1hHE;EAAsC,gBAAA;AV8hHxC;;AU9hHE;EAAsC,gBAAA;AVkiHxC;;AUliHE;EAAsC,gBAAA;AVsiHxC;;AUtiHE;EAAsC,gBAAA;AV0iHxC;;AU1iHE;EAAsC,gBAAA;AV8iHxC;;AU9iHE;EAAsC,gBAAA;AVkjHxC;;AUljHE;EAAsC,gBAAA;AVsjHxC;;AUtjHE;EAAsC,gBAAA;AV0jHxC;;AU1jHE;EAAsC,gBAAA;AV8jHxC;;AU9jHE;EAAsC,gBAAA;AVkkHxC;;AUlkHE;EAAsC,gBAAA;AVskHxC;;AUtkHE;EAAsC,gBAAA;AV0kHxC;;AU1kHE;EAAsC,YAAA;AV8kHxC;;AU9kHE;EAAsC,gBAAA;AVklHxC;;AUllHE;EAAsC,gBAAA;AVslHxC;;AUtlHE;EAAsC,gBAAA;AV0lHxC;;AU1lHE;EAAsC,gBAAA;AV8lHxC;;AU9lHE;EAAsC,gBAAA;AVkmHxC;;AUlmHE;EAAsC,gBAAA;AVsmHxC;;AUtmHE;EAAsC,gBAAA;AV0mHxC;;AU1mHE;EAAsC,gBAAA;AV8mHxC;;AU9mHE;EAAsC,gBAAA;AVknHxC;;AUlnHE;EAAsC,gBAAA;AVsnHxC;;AUtnHE;EAAsC,gBAAA;AV0nHxC;;AU1nHE;EAAsC,gBAAA;AV8nHxC;;AU9nHE;EAAsC,gBAAA;AVkoHxC;;AUloHE;EAAsC,gBAAA;AVsoHxC;;AUtoHE;EAAsC,gBAAA;AV0oHxC;;AU1oHE;EAAsC,gBAAA;AV8oHxC;;AU9oHE;EAAsC,gBAAA;AVkpHxC;;AUlpHE;EAAsC,gBAAA;AVspHxC;;AUtpHE;EAAsC,gBAAA;AV0pHxC;;AU1pHE;EAAsC,gBAAA;AV8pHxC;;AU9pHE;EAAsC,gBAAA;AVkqHxC;;AUlqHE;EAAsC,gBAAA;AVsqHxC;;AUtqHE;EAAsC,gBAAA;AV0qHxC;;AU1qHE;EAAsC,gBAAA;AV8qHxC;;AU9qHE;EAAsC,gBAAA;AVkrHxC;;AUlrHE;EAAsC,gBAAA;AVsrHxC;;AUtrHE;EAAsC,gBAAA;AV0rHxC;;AU1rHE;EAAsC,gBAAA;AV8rHxC;;AU9rHE;EAAsC,gBAAA;AVksHxC;;AUlsHE;EAAsC,gBAAA;AVssHxC;;AUtsHE;EAAsC,gBAAA;AV0sHxC;;AU1sHE;EAAsC,gBAAA;AV8sHxC;;AU9sHE;EAAsC,gBAAA;AVktHxC;;AUltHE;EAAsC,gBAAA;AVstHxC;;AUttHE;EAAsC,gBAAA;AV0tHxC;;AU1tHE;EAAsC,gBAAA;AV8tHxC;;AU9tHE;EAAsC,gBAAA;AVkuHxC;;AUluHE;EAAsC,gBAAA;AVsuHxC;;AUtuHE;EAAsC,gBAAA;AV0uHxC;;AU1uHE;EAAsC,YAAA;AV8uHxC;;AU9uHE;EAAsC,gBAAA;AVkvHxC;;AUlvHE;EAAsC,gBAAA;AVsvHxC;;AUtvHE;EAAsC,gBAAA;AV0vHxC;;AU1vHE;EAAsC,gBAAA;AV8vHxC;;AU9vHE;EAAsC,gBAAA;AVkwHxC;;AUlwHE;EAAsC,gBAAA;AVswHxC;;AUtwHE;EAAsC,gBAAA;AV0wHxC;;AU1wHE;EAAsC,gBAAA;AV8wHxC;;AU9wHE;EAAsC,gBAAA;AVkxHxC;;AUlxHE;EAAsC,gBAAA;AVsxHxC;;AUtxHE;EAAsC,gBAAA;AV0xHxC;;AU1xHE;EAAsC,gBAAA;AV8xHxC;;AU9xHE;EAAsC,gBAAA;AVkyHxC;;AUlyHE;EAAsC,gBAAA;AVsyHxC;;AUtyHE;EAAsC,gBAAA;AV0yHxC;;AU1yHE;EAAsC,gBAAA;AV8yHxC;;AU9yHE;EAAsC,gBAAA;AVkzHxC;;AUlzHE;EAAsC,gBAAA;AVszHxC;;AUtzHE;EAAsC,gBAAA;AV0zHxC;;AU1zHE;EAAsC,gBAAA;AV8zHxC;;AU9zHE;EAAsC,gBAAA;AVk0HxC;;AUl0HE;EAAsC,gBAAA;AVs0HxC;;AUt0HE;EAAsC,YAAA;AV00HxC;;AU10HE;EAAsC,gBAAA;AV80HxC;;AU90HE;EAAsC,gBAAA;AVk1HxC;;AUl1HE;EAAsC,gBAAA;AVs1HxC;;AUt1HE;EAAsC,gBAAA;AV01HxC;;AU11HE;EAAsC,gBAAA;AV81HxC;;AU91HE;EAAsC,gBAAA;AVk2HxC;;AUl2HE;EAAsC,gBAAA;AVs2HxC;;AUt2HE;EAAsC,gBAAA;AV02HxC;;AU12HE;EAAsC,gBAAA;AV82HxC;;AU92HE;EAAsC,gBAAA;AVk3HxC;;AUl3HE;EAAsC,gBAAA;AVs3HxC;;AUt3HE;EAAsC,gBAAA;AV03HxC;;AU13HE;EAAsC,gBAAA;AV83HxC;;AU93HE;EAAsC,gBAAA;AVk4HxC;;AUl4HE;EAAsC,gBAAA;AVs4HxC;;AUt4HE;EAAsC,gBAAA;AV04HxC;;AU14HE;EAAsC,gBAAA;AV84HxC;;AU94HE;EAAsC,gBAAA;AVk5HxC;;AUl5HE;EAAsC,gBAAA;AVs5HxC;;AUt5HE;EAAsC,gBAAA;AV05HxC;;AU15HE;EAAsC,gBAAA;AV85HxC;;AU95HE;EAAsC,gBAAA;AVk6HxC;;AUl6HE;EAAsC,gBAAA;AVs6HxC;;AUt6HE;EAAsC,gBAAA;AV06HxC;;AU16HE;EAAsC,gBAAA;AV86HxC;;AU96HE;EAAsC,gBAAA;AVk7HxC;;AUl7HE;EAAsC,gBAAA;AVs7HxC;;AUt7HE;EAAsC,gBAAA;AV07HxC;;AU17HE;EAAsC,gBAAA;AV87HxC;;AU97HE;EAAsC,gBAAA;AVk8HxC;;AUl8HE;EAAsC,gBAAA;AVs8HxC;;AUt8HE;EAAsC,gBAAA;AV08HxC;;AU18HE;EAAsC,gBAAA;AV88HxC;;AU98HE;EAAsC,gBAAA;AVk9HxC;;AUl9HE;EAAsC,gBAAA;AVs9HxC;;AUt9HE;EAAsC,gBAAA;AV09HxC;;AU19HE;EAAsC,gBAAA;AV89HxC;;AU99HE;EAAsC,gBAAA;AVk+HxC;;AUl+HE;EAAsC,gBAAA;AVs+HxC;;AUt+HE;EAAsC,gBAAA;AV0+HxC;;AU1+HE;EAAsC,gBAAA;AV8+HxC;;AU9+HE;EAAsC,gBAAA;AVk/HxC;;AUl/HE;EAAsC,gBAAA;AVs/HxC;;AUt/HE;EAAsC,gBAAA;AV0/HxC;;AU1/HE;EAAsC,gBAAA;AV8/HxC;;AU9/HE;EAAsC,gBAAA;AVkgIxC;;AUlgIE;EAAsC,gBAAA;AVsgIxC;;AUtgIE;EAAsC,gBAAA;AV0gIxC;;AU1gIE;EAAsC,gBAAA;AV8gIxC;;AU9gIE;EAAsC,gBAAA;AVkhIxC;;AUlhIE;EAAsC,gBAAA;AVshIxC;;AUthIE;EAAsC,gBAAA;AV0hIxC;;AU1hIE;EAAsC,gBAAA;AV8hIxC;;AU9hIE;EAAsC,gBAAA;AVkiIxC;;AUliIE;EAAsC,gBAAA;AVsiIxC;;AUtiIE;EAAsC,gBAAA;AV0iIxC;;AU1iIE;EAAsC,gBAAA;AV8iIxC;;AU9iIE;EAAsC,gBAAA;AVkjIxC;;AUljIE;EAAsC,gBAAA;AVsjIxC;;AUtjIE;EAAsC,gBAAA;AV0jIxC;;AU1jIE;EAAsC,gBAAA;AV8jIxC;;AU9jIE;EAAsC,gBAAA;AVkkIxC;;AUlkIE;EAAsC,gBAAA;AVskIxC;;AUtkIE;EAAsC,gBAAA;AV0kIxC;;AU1kIE;EAAsC,gBAAA;AV8kIxC;;AU9kIE;EAAsC,gBAAA;AVklIxC;;AUllIE;EAAsC,gBAAA;AVslIxC;;AUtlIE;EAAsC,gBAAA;AV0lIxC;;AU1lIE;EAAsC,gBAAA;AV8lIxC;;AU9lIE;EAAsC,gBAAA;AVkmIxC;;AUlmIE;EAAsC,gBAAA;AVsmIxC;;AUtmIE;EAAsC,gBAAA;AV0mIxC;;AU1mIE;EAAsC,gBAAA;AV8mIxC;;AU9mIE;EAAsC,gBAAA;AVknIxC;;AUlnIE;EAAsC,gBAAA;AVsnIxC;;AUtnIE;EAAsC,gBAAA;AV0nIxC;;AU1nIE;EAAsC,gBAAA;AV8nIxC;;AU9nIE;EAAsC,gBAAA;AVkoIxC;;AUloIE;EAAsC,gBAAA;AVsoIxC;;AUtoIE;EAAsC,gBAAA;AV0oIxC;;AU1oIE;EAAsC,gBAAA;AV8oIxC;;AU9oIE;EAAsC,gBAAA;AVkpIxC;;AUlpIE;EAAsC,gBAAA;AVspIxC;;AUtpIE;EAAsC,gBAAA;AV0pIxC;;AU1pIE;EAAsC,gBAAA;AV8pIxC;;AU9pIE;EAAsC,gBAAA;AVkqIxC;;AUlqIE;EAAsC,gBAAA;AVsqIxC;;AUtqIE;EAAsC,gBAAA;AV0qIxC;;AU1qIE;EAAsC,gBAAA;AV8qIxC;;AU9qIE;EAAsC,gBAAA;AVkrIxC;;AUlrIE;EAAsC,gBAAA;AVsrIxC;;AUtrIE;EAAsC,gBAAA;AV0rIxC;;AU1rIE;EAAsC,gBAAA;AV8rIxC;;AU9rIE;EAAsC,gBAAA;AVksIxC;;AUlsIE;EAAsC,gBAAA;AVssIxC;;AUtsIE;EAAsC,gBAAA;AV0sIxC;;AU1sIE;EAAsC,gBAAA;AV8sIxC;;AU9sIE;EAAsC,gBAAA;AVktIxC;;AUltIE;EAAsC,gBAAA;AVstIxC;;AUttIE;EAAsC,gBAAA;AV0tIxC;;AU1tIE;EAAsC,gBAAA;AV8tIxC;;AU9tIE;EAAsC,gBAAA;AVkuIxC;;AUluIE;EAAsC,gBAAA;AVsuIxC;;AUtuIE;EAAsC,gBAAA;AV0uIxC;;AU1uIE;EAAsC,gBAAA;AV8uIxC;;AU9uIE;EAAsC,gBAAA;AVkvIxC;;AUlvIE;EAAsC,gBAAA;AVsvIxC;;AUtvIE;EAAsC,gBAAA;AV0vIxC;;AU1vIE;EAAsC,gBAAA;AV8vIxC;;AU9vIE;EAAsC,gBAAA;AVkwIxC;;AUlwIE;EAAsC,gBAAA;AVswIxC;;AUtwIE;EAAsC,gBAAA;AV0wIxC;;AU1wIE;EAAsC,gBAAA;AV8wIxC;;AU9wIE;EAAsC,gBAAA;AVkxIxC;;AUlxIE;EAAsC,gBAAA;AVsxIxC;;AUtxIE;EAAsC,gBAAA;AV0xIxC;;AU1xIE;EAAsC,gBAAA;AV8xIxC;;AU9xIE;EAAsC,gBAAA;AVkyIxC;;AUlyIE;EAAsC,gBAAA;AVsyIxC;;AUtyIE;EAAsC,gBAAA;AV0yIxC;;AU1yIE;EAAsC,gBAAA;AV8yIxC;;AU9yIE;EAAsC,gBAAA;AVkzIxC;;AUlzIE;EAAsC,gBAAA;AVszIxC;;AUtzIE;EAAsC,gBAAA;AV0zIxC;;AU1zIE;EAAsC,gBAAA;AV8zIxC;;AU9zIE;EAAsC,gBAAA;AVk0IxC;;AUl0IE;EAAsC,gBAAA;AVs0IxC;;AUt0IE;EAAsC,gBAAA;AV00IxC;;AU10IE;EAAsC,gBAAA;AV80IxC;;AU90IE;EAAsC,gBAAA;AVk1IxC;;AUl1IE;EAAsC,gBAAA;AVs1IxC;;AUt1IE;EAAsC,gBAAA;AV01IxC;;AU11IE;EAAsC,gBAAA;AV81IxC;;AU91IE;EAAsC,gBAAA;AVk2IxC;;AUl2IE;EAAsC,gBAAA;AVs2IxC;;AUt2IE;EAAsC,gBAAA;AV02IxC;;AU12IE;EAAsC,gBAAA;AV82IxC;;AU92IE;EAAsC,gBAAA;AVk3IxC;;AUl3IE;EAAsC,gBAAA;AVs3IxC;;AUt3IE;EAAsC,gBAAA;AV03IxC;;AU13IE;EAAsC,gBAAA;AV83IxC;;AU93IE;EAAsC,gBAAA;AVk4IxC;;AUl4IE;EAAsC,gBAAA;AVs4IxC;;AUt4IE;EAAsC,gBAAA;AV04IxC;;AU14IE;EAAsC,gBAAA;AV84IxC;;AU94IE;EAAsC,gBAAA;AVk5IxC;;AUl5IE;EAAsC,gBAAA;AVs5IxC;;AUt5IE;EAAsC,gBAAA;AV05IxC;;AU15IE;EAAsC,gBAAA;AV85IxC;;AU95IE;EAAsC,gBAAA;AVk6IxC;;AUl6IE;EAAsC,gBAAA;AVs6IxC;;AUt6IE;EAAsC,gBAAA;AV06IxC;;AU16IE;EAAsC,gBAAA;AV86IxC;;AU96IE;EAAsC,gBAAA;AVk7IxC;;AUl7IE;EAAsC,gBAAA;AVs7IxC;;AUt7IE;EAAsC,gBAAA;AV07IxC;;AU17IE;EAAsC,gBAAA;AV87IxC;;AU97IE;EAAsC,gBAAA;AVk8IxC;;AUl8IE;EAAsC,gBAAA;AVs8IxC;;AUt8IE;EAAsC,gBAAA;AV08IxC;;AU18IE;EAAsC,gBAAA;AV88IxC;;AU98IE;EAAsC,gBAAA;AVk9IxC;;AUl9IE;EAAsC,gBAAA;AVs9IxC;;AUt9IE;EAAsC,gBAAA;AV09IxC;;AU19IE;EAAsC,gBAAA;AV89IxC;;AU99IE;EAAsC,gBAAA;AVk+IxC;;AUl+IE;EAAsC,gBAAA;AVs+IxC;;AUt+IE;EAAsC,gBAAA;AV0+IxC;;AU1+IE;EAAsC,gBAAA;AV8+IxC;;AU9+IE;EAAsC,gBAAA;AVk/IxC;;AUl/IE;EAAsC,gBAAA;AVs/IxC;;AUt/IE;EAAsC,gBAAA;AV0/IxC;;AU1/IE;EAAsC,gBAAA;AV8/IxC;;AU9/IE;EAAsC,gBAAA;AVkgJxC;;AUlgJE;EAAsC,gBAAA;AVsgJxC;;AUtgJE;EAAsC,gBAAA;AV0gJxC;;AU1gJE;EAAsC,gBAAA;AV8gJxC;;AU9gJE;EAAsC,gBAAA;AVkhJxC;;AUlhJE;EAAsC,gBAAA;AVshJxC;;AUthJE;EAAsC,gBAAA;AV0hJxC;;AU1hJE;EAAsC,gBAAA;AV8hJxC;;AU9hJE;EAAsC,gBAAA;AVkiJxC;;AUliJE;EAAsC,gBAAA;AVsiJxC;;AUtiJE;EAAsC,gBAAA;AV0iJxC;;AU1iJE;EAAsC,gBAAA;AV8iJxC;;AU9iJE;EAAsC,gBAAA;AVkjJxC;;AUljJE;EAAsC,gBAAA;AVsjJxC;;AUtjJE;EAAsC,gBAAA;AV0jJxC;;AU1jJE;EAAsC,YAAA;AV8jJxC;;AU9jJE;EAAsC,gBAAA;AVkkJxC;;AUlkJE;EAAsC,gBAAA;AVskJxC;;AUtkJE;EAAsC,gBAAA;AV0kJxC;;AU1kJE;EAAsC,gBAAA;AV8kJxC;;AU9kJE;EAAsC,gBAAA;AVklJxC;;AUllJE;EAAsC,gBAAA;AVslJxC;;AUtlJE;EAAsC,gBAAA;AV0lJxC;;AU1lJE;EAAsC,gBAAA;AV8lJxC;;AU9lJE;EAAsC,gBAAA;AVkmJxC;;AUlmJE;EAAsC,YAAA;AVsmJxC;;AUtmJE;EAAsC,gBAAA;AV0mJxC;;AU1mJE;EAAsC,gBAAA;AV8mJxC;;AU9mJE;EAAsC,gBAAA;AVknJxC;;AUlnJE;EAAsC,gBAAA;AVsnJxC;;AUtnJE;EAAsC,gBAAA;AV0nJxC;;AU1nJE;EAAsC,gBAAA;AV8nJxC;;AU9nJE;EAAsC,gBAAA;AVkoJxC;;AUloJE;EAAsC,gBAAA;AVsoJxC;;AUtoJE;EAAsC,gBAAA;AV0oJxC;;AU1oJE;EAAsC,gBAAA;AV8oJxC;;AU9oJE;EAAsC,gBAAA;AVkpJxC;;AUlpJE;EAAsC,gBAAA;AVspJxC;;AUtpJE;EAAsC,gBAAA;AV0pJxC;;AU1pJE;EAAsC,gBAAA;AV8pJxC;;AU9pJE;EAAsC,gBAAA;AVkqJxC;;AUlqJE;EAAsC,gBAAA;AVsqJxC;;AUtqJE;EAAsC,gBAAA;AV0qJxC;;AU1qJE;EAAsC,gBAAA;AV8qJxC;;AU9qJE;EAAsC,gBAAA;AVkrJxC;;AUlrJE;EAAsC,gBAAA;AVsrJxC;;AUtrJE;EAAsC,gBAAA;AV0rJxC;;AU1rJE;EAAsC,gBAAA;AV8rJxC;;AU9rJE;EAAsC,gBAAA;AVksJxC;;AUlsJE;EAAsC,gBAAA;AVssJxC;;AUtsJE;EAAsC,gBAAA;AV0sJxC;;AU1sJE;EAAsC,gBAAA;AV8sJxC;;AU9sJE;EAAsC,gBAAA;AVktJxC;;AUltJE;EAAsC,gBAAA;AVstJxC;;AUttJE;EAAsC,gBAAA;AV0tJxC;;AU1tJE;EAAsC,gBAAA;AV8tJxC;;AU9tJE;EAAsC,gBAAA;AVkuJxC;;AUluJE;EAAsC,gBAAA;AVsuJxC;;AUtuJE;EAAsC,gBAAA;AV0uJxC;;AU1uJE;EAAsC,gBAAA;AV8uJxC;;AU9uJE;EAAsC,gBAAA;AVkvJxC;;AUlvJE;EAAsC,gBAAA;AVsvJxC;;AUtvJE;EAAsC,gBAAA;AV0vJxC;;AU1vJE;EAAsC,gBAAA;AV8vJxC;;AU9vJE;EAAsC,gBAAA;AVkwJxC;;AUlwJE;EAAsC,gBAAA;AVswJxC;;AUtwJE;EAAsC,gBAAA;AV0wJxC;;AU1wJE;EAAsC,gBAAA;AV8wJxC;;AU9wJE;EAAsC,gBAAA;AVkxJxC;;AUlxJE;EAAsC,gBAAA;AVsxJxC;;AUtxJE;EAAsC,gBAAA;AV0xJxC;;AU1xJE;EAAsC,gBAAA;AV8xJxC;;AU9xJE;EAAsC,gBAAA;AVkyJxC;;AUlyJE;EAAsC,gBAAA;AVsyJxC;;AUtyJE;EAAsC,gBAAA;AV0yJxC;;AU1yJE;EAAsC,gBAAA;AV8yJxC;;AU9yJE;EAAsC,gBAAA;AVkzJxC;;AUlzJE;EAAsC,gBAAA;AVszJxC;;AUtzJE;EAAsC,gBAAA;AV0zJxC;;AU1zJE;EAAsC,gBAAA;AV8zJxC;;AU9zJE;EAAsC,gBAAA;AVk0JxC;;AUl0JE;EAAsC,gBAAA;AVs0JxC;;AUt0JE;EAAsC,gBAAA;AV00JxC;;AU10JE;EAAsC,gBAAA;AV80JxC;;AU90JE;EAAsC,gBAAA;AVk1JxC;;AUl1JE;EAAsC,gBAAA;AVs1JxC;;AUt1JE;EAAsC,gBAAA;AV01JxC;;AU11JE;EAAsC,gBAAA;AV81JxC;;AU91JE;EAAsC,gBAAA;AVk2JxC;;AUl2JE;EAAsC,gBAAA;AVs2JxC;;AUt2JE;EAAsC,gBAAA;AV02JxC;;AU12JE;EAAsC,gBAAA;AV82JxC;;AU92JE;EAAsC,gBAAA;AVk3JxC;;AUl3JE;EAAsC,gBAAA;AVs3JxC;;AUt3JE;EAAsC,gBAAA;AV03JxC;;AU13JE;EAAsC,gBAAA;AV83JxC;;AU93JE;EAAsC,gBAAA;AVk4JxC;;AUl4JE;EAAsC,gBAAA;AVs4JxC;;AUt4JE;EAAsC,gBAAA;AV04JxC;;AU14JE;EAAsC,gBAAA;AV84JxC;;AU94JE;EAAsC,gBAAA;AVk5JxC;;AUl5JE;EAAsC,gBAAA;AVs5JxC;;AUt5JE;EAAsC,gBAAA;AV05JxC;;AU15JE;EAAsC,gBAAA;AV85JxC;;AU95JE;EAAsC,gBAAA;AVk6JxC;;AUl6JE;EAAsC,gBAAA;AVs6JxC;;AUt6JE;EAAsC,gBAAA;AV06JxC;;AU16JE;EAAsC,gBAAA;AV86JxC;;AU96JE;EAAsC,gBAAA;AVk7JxC;;AUl7JE;EAAsC,gBAAA;AVs7JxC;;AUt7JE;EAAsC,gBAAA;AV07JxC;;AU17JE;EAAsC,gBAAA;AV87JxC;;AU97JE;EAAsC,gBAAA;AVk8JxC;;AUl8JE;EAAsC,gBAAA;AVs8JxC;;AUt8JE;EAAsC,gBAAA;AV08JxC;;AU18JE;EAAsC,gBAAA;AV88JxC;;AU98JE;EAAsC,gBAAA;AVk9JxC;;AUl9JE;EAAsC,gBAAA;AVs9JxC;;AUt9JE;EAAsC,gBAAA;AV09JxC;;AU19JE;EAAsC,gBAAA;AV89JxC;;AU99JE;EAAsC,gBAAA;AVk+JxC;;AUl+JE;EAAsC,gBAAA;AVs+JxC;;AUt+JE;EAAsC,gBAAA;AV0+JxC;;AU1+JE;EAAsC,gBAAA;AV8+JxC;;AU9+JE;EAAsC,gBAAA;AVk/JxC;;AUl/JE;EAAsC,gBAAA;AVs/JxC;;AUt/JE;EAAsC,gBAAA;AV0/JxC;;AU1/JE;EAAsC,gBAAA;AV8/JxC;;AU9/JE;EAAsC,gBAAA;AVkgKxC;;AUlgKE;EAAsC,gBAAA;AVsgKxC;;AUtgKE;EAAsC,gBAAA;AV0gKxC;;AU1gKE;EAAsC,gBAAA;AV8gKxC;;AU9gKE;EAAsC,gBAAA;AVkhKxC;;AUlhKE;EAAsC,gBAAA;AVshKxC;;AUthKE;EAAsC,gBAAA;AV0hKxC;;AU1hKE;EAAsC,gBAAA;AV8hKxC;;AU9hKE;EAAsC,gBAAA;AVkiKxC;;AUliKE;EAAsC,gBAAA;AVsiKxC;;AUtiKE;EAAsC,gBAAA;AV0iKxC;;AU1iKE;EAAsC,gBAAA;AV8iKxC;;AU9iKE;EAAsC,gBAAA;AVkjKxC;;AUljKE;EAAsC,gBAAA;AVsjKxC;;AUtjKE;EAAsC,gBAAA;AV0jKxC;;AU1jKE;EAAsC,gBAAA;AV8jKxC;;AU9jKE;EAAsC,gBAAA;AVkkKxC;;AUlkKE;EAAsC,gBAAA;AVskKxC;;AUtkKE;EAAsC,gBAAA;AV0kKxC;;AU1kKE;EAAsC,gBAAA;AV8kKxC;;AU9kKE;EAAsC,gBAAA;AVklKxC;;AUllKE;EAAsC,gBAAA;AVslKxC;;AUtlKE;EAAsC,gBAAA;AV0lKxC;;AU1lKE;EAAsC,gBAAA;AV8lKxC;;AU9lKE;EAAsC,gBAAA;AVkmKxC;;AUlmKE;EAAsC,gBAAA;AVsmKxC;;AUtmKE;EAAsC,gBAAA;AV0mKxC;;AU1mKE;EAAsC,gBAAA;AV8mKxC;;AU9mKE;EAAsC,gBAAA;AVknKxC;;AUlnKE;EAAsC,gBAAA;AVsnKxC;;AUtnKE;EAAsC,gBAAA;AV0nKxC;;AU1nKE;EAAsC,gBAAA;AV8nKxC;;AU9nKE;EAAsC,gBAAA;AVkoKxC;;AUloKE;EAAsC,gBAAA;AVsoKxC;;AUtoKE;EAAsC,gBAAA;AV0oKxC;;AU1oKE;EAAsC,gBAAA;AV8oKxC;;AU9oKE;EAAsC,gBAAA;AVkpKxC;;AUlpKE;EAAsC,gBAAA;AVspKxC;;AUtpKE;EAAsC,YAAA;AV0pKxC;;AU1pKE;EAAsC,gBAAA;AV8pKxC;;AU9pKE;EAAsC,gBAAA;AVkqKxC;;AUlqKE;EAAsC,gBAAA;AVsqKxC;;AUtqKE;EAAsC,gBAAA;AV0qKxC;;AU1qKE;EAAsC,gBAAA;AV8qKxC;;AU9qKE;EAAsC,gBAAA;AVkrKxC;;AUlrKE;EAAsC,gBAAA;AVsrKxC;;AUtrKE;EAAsC,gBAAA;AV0rKxC;;AU1rKE;EAAsC,gBAAA;AV8rKxC;;AU9rKE;EAAsC,YAAA;AVksKxC;;AUlsKE;EAAsC,gBAAA;AVssKxC;;AUtsKE;EAAsC,gBAAA;AV0sKxC;;AU1sKE;EAAsC,gBAAA;AV8sKxC;;AU9sKE;EAAsC,gBAAA;AVktKxC;;AUltKE;EAAsC,gBAAA;AVstKxC;;AUttKE;EAAsC,gBAAA;AV0tKxC;;AU1tKE;EAAsC,gBAAA;AV8tKxC;;AU9tKE;EAAsC,gBAAA;AVkuKxC;;AUluKE;EAAsC,gBAAA;AVsuKxC;;AUtuKE;EAAsC,gBAAA;AV0uKxC;;AU1uKE;EAAsC,gBAAA;AV8uKxC;;AU9uKE;EAAsC,gBAAA;AVkvKxC;;AUlvKE;EAAsC,gBAAA;AVsvKxC;;AUtvKE;EAAsC,gBAAA;AV0vKxC;;AU1vKE;EAAsC,gBAAA;AV8vKxC;;AU9vKE;EAAsC,gBAAA;AVkwKxC;;AUlwKE;EAAsC,gBAAA;AVswKxC;;AUtwKE;EAAsC,gBAAA;AV0wKxC;;AU1wKE;EAAsC,gBAAA;AV8wKxC;;AU9wKE;EAAsC,gBAAA;AVkxKxC;;AUlxKE;EAAsC,gBAAA;AVsxKxC;;AUtxKE;EAAsC,gBAAA;AV0xKxC;;AU1xKE;EAAsC,gBAAA;AV8xKxC;;AU9xKE;EAAsC,gBAAA;AVkyKxC;;AUlyKE;EAAsC,gBAAA;AVsyKxC;;AUtyKE;EAAsC,gBAAA;AV0yKxC;;AU1yKE;EAAsC,gBAAA;AV8yKxC;;AU9yKE;EAAsC,gBAAA;AVkzKxC;;AUlzKE;EAAsC,gBAAA;AVszKxC;;AUtzKE;EAAsC,gBAAA;AV0zKxC;;AU1zKE;EAAsC,gBAAA;AV8zKxC;;AU9zKE;EAAsC,gBAAA;AVk0KxC;;AUl0KE;EAAsC,gBAAA;AVs0KxC;;AUt0KE;EAAsC,gBAAA;AV00KxC;;AU10KE;EAAsC,gBAAA;AV80KxC;;AU90KE;EAAsC,gBAAA;AVk1KxC;;AUl1KE;EAAsC,gBAAA;AVs1KxC;;AUt1KE;EAAsC,gBAAA;AV01KxC;;AU11KE;EAAsC,gBAAA;AV81KxC;;AU91KE;EAAsC,gBAAA;AVk2KxC;;AUl2KE;EAAsC,gBAAA;AVs2KxC;;AUt2KE;EAAsC,gBAAA;AV02KxC;;AU12KE;EAAsC,gBAAA;AV82KxC;;AU92KE;EAAsC,gBAAA;AVk3KxC;;AUl3KE;EAAsC,gBAAA;AVs3KxC;;AUt3KE;EAAsC,gBAAA;AV03KxC;;AU13KE;EAAsC,gBAAA;AV83KxC;;AU93KE;EAAsC,gBAAA;AVk4KxC;;AUl4KE;EAAsC,YAAA;AVs4KxC;;AUt4KE;EAAsC,gBAAA;AV04KxC;;AU14KE;EAAsC,gBAAA;AV84KxC;;AU94KE;EAAsC,gBAAA;AVk5KxC;;AUl5KE;EAAsC,gBAAA;AVs5KxC;;AUt5KE;EAAsC,gBAAA;AV05KxC;;AU15KE;EAAsC,gBAAA;AV85KxC;;AU95KE;EAAsC,gBAAA;AVk6KxC;;AUl6KE;EAAsC,gBAAA;AVs6KxC;;AUt6KE;EAAsC,gBAAA;AV06KxC;;AU16KE;EAAsC,gBAAA;AV86KxC;;AU96KE;EAAsC,gBAAA;AVk7KxC;;AUl7KE;EAAsC,gBAAA;AVs7KxC;;AUt7KE;EAAsC,gBAAA;AV07KxC;;AU17KE;EAAsC,gBAAA;AV87KxC;;AU97KE;EAAsC,gBAAA;AVk8KxC;;AUl8KE;EAAsC,gBAAA;AVs8KxC;;AUt8KE;EAAsC,gBAAA;AV08KxC;;AU18KE;EAAsC,gBAAA;AV88KxC;;AU98KE;EAAsC,gBAAA;AVk9KxC;;AUl9KE;EAAsC,gBAAA;AVs9KxC;;AUt9KE;EAAsC,gBAAA;AV09KxC;;AU19KE;EAAsC,gBAAA;AV89KxC;;AU99KE;EAAsC,gBAAA;AVk+KxC;;AUl+KE;EAAsC,gBAAA;AVs+KxC;;AUt+KE;EAAsC,gBAAA;AV0+KxC;;AU1+KE;EAAsC,gBAAA;AV8+KxC;;AU9+KE;EAAsC,gBAAA;AVk/KxC;;AUl/KE;EAAsC,gBAAA;AVs/KxC;;AUt/KE;EAAsC,gBAAA;AV0/KxC;;AU1/KE;EAAsC,gBAAA;AV8/KxC;;AU9/KE;EAAsC,gBAAA;AVkgLxC;;AUlgLE;EAAsC,gBAAA;AVsgLxC;;AUtgLE;EAAsC,gBAAA;AV0gLxC;;AU1gLE;EAAsC,gBAAA;AV8gLxC;;AU9gLE;EAAsC,gBAAA;AVkhLxC;;AUlhLE;EAAsC,YAAA;AVshLxC;;AUthLE;EAAsC,gBAAA;AV0hLxC;;AU1hLE;EAAsC,gBAAA;AV8hLxC;;AU9hLE;EAAsC,gBAAA;AVkiLxC;;AUliLE;EAAsC,gBAAA;AVsiLxC;;AUtiLE;EAAsC,gBAAA;AV0iLxC;;AU1iLE;EAAsC,gBAAA;AV8iLxC;;AU9iLE;EAAsC,gBAAA;AVkjLxC;;AUljLE;EAAsC,gBAAA;AVsjLxC;;AUtjLE;EAAsC,gBAAA;AV0jLxC;;AU1jLE;EAAsC,gBAAA;AV8jLxC;;AU9jLE;EAAsC,gBAAA;AVkkLxC;;AUlkLE;EAAsC,gBAAA;AVskLxC;;AUtkLE;EAAsC,gBAAA;AV0kLxC;;AU1kLE;EAAsC,gBAAA;AV8kLxC;;AU9kLE;EAAsC,gBAAA;AVklLxC;;AUllLE;EAAsC,gBAAA;AVslLxC;;AUtlLE;EAAsC,gBAAA;AV0lLxC;;AU1lLE;EAAsC,gBAAA;AV8lLxC;;AU9lLE;EAAsC,gBAAA;AVkmLxC;;AUlmLE;EAAsC,gBAAA;AVsmLxC;;AUtmLE;EAAsC,gBAAA;AV0mLxC;;AU1mLE;EAAsC,gBAAA;AV8mLxC;;AU9mLE;EAAsC,gBAAA;AVknLxC;;AUlnLE;EAAsC,gBAAA;AVsnLxC;;AUtnLE;EAAsC,gBAAA;AV0nLxC;;AU1nLE;EAAsC,gBAAA;AV8nLxC;;AU9nLE;EAAsC,gBAAA;AVkoLxC;;AUloLE;EAAsC,gBAAA;AVsoLxC;;AUtoLE;EAAsC,gBAAA;AV0oLxC;;AU1oLE;EAAsC,gBAAA;AV8oLxC;;AU9oLE;EAAsC,gBAAA;AVkpLxC;;AUlpLE;EAAsC,gBAAA;AVspLxC;;AUtpLE;EAAsC,gBAAA;AV0pLxC;;AU1pLE;EAAsC,gBAAA;AV8pLxC;;AU9pLE;EAAsC,gBAAA;AVkqLxC;;AUlqLE;EAAsC,gBAAA;AVsqLxC;;AUtqLE;EAAsC,gBAAA;AV0qLxC;;AU1qLE;EAAsC,gBAAA;AV8qLxC;;AU9qLE;EAAsC,gBAAA;AVkrLxC;;AUlrLE;EAAsC,gBAAA;AVsrLxC;;AUtrLE;EAAsC,gBAAA;AV0rLxC;;AU1rLE;EAAsC,gBAAA;AV8rLxC;;AU9rLE;EAAsC,gBAAA;AVksLxC;;AUlsLE;EAAsC,gBAAA;AVssLxC;;AUtsLE;EAAsC,gBAAA;AV0sLxC;;AU1sLE;EAAsC,gBAAA;AV8sLxC;;AU9sLE;EAAsC,gBAAA;AVktLxC;;AUltLE;EAAsC,gBAAA;AVstLxC;;AUttLE;EAAsC,gBAAA;AV0tLxC;;AU1tLE;EAAsC,gBAAA;AV8tLxC;;AU9tLE;EAAsC,gBAAA;AVkuLxC;;AUluLE;EAAsC,gBAAA;AVsuLxC;;AUtuLE;EAAsC,gBAAA;AV0uLxC;;AU1uLE;EAAsC,gBAAA;AV8uLxC;;AU9uLE;EAAsC,gBAAA;AVkvLxC;;AUlvLE;EAAsC,gBAAA;AVsvLxC;;AUtvLE;EAAsC,gBAAA;AV0vLxC;;AU1vLE;EAAsC,gBAAA;AV8vLxC;;AU9vLE;EAAsC,gBAAA;AVkwLxC;;AUlwLE;EAAsC,gBAAA;AVswLxC;;AUtwLE;EAAsC,gBAAA;AV0wLxC;;AU1wLE;EAAsC,gBAAA;AV8wLxC;;AU9wLE;EAAsC,aAAA;AVkxLxC;;AUlxLE;EAAsC,gBAAA;AVsxLxC;;AUtxLE;EAAsC,gBAAA;AV0xLxC;;AU1xLE;EAAsC,gBAAA;AV8xLxC;;AU9xLE;EAAsC,gBAAA;AVkyLxC;;AUlyLE;EAAsC,gBAAA;AVsyLxC;;AUtyLE;EAAsC,gBAAA;AV0yLxC;;AU1yLE;EAAsC,gBAAA;AV8yLxC;;AU9yLE;EAAsC,gBAAA;AVkzLxC;;AUlzLE;EAAsC,gBAAA;AVszLxC;;AUtzLE;EAAsC,gBAAA;AV0zLxC;;AU1zLE;EAAsC,gBAAA;AV8zLxC;;AU9zLE;EAAsC,gBAAA;AVk0LxC;;AUl0LE;EAAsC,gBAAA;AVs0LxC;;AUt0LE;EAAsC,gBAAA;AV00LxC;;AU10LE;EAAsC,gBAAA;AV80LxC;;AU90LE;EAAsC,gBAAA;AVk1LxC;;AUl1LE;EAAsC,gBAAA;AVs1LxC;;AUt1LE;EAAsC,gBAAA;AV01LxC;;AU11LE;EAAsC,gBAAA;AV81LxC;;AU91LE;EAAsC,gBAAA;AVk2LxC;;AUl2LE;EAAsC,gBAAA;AVs2LxC;;AUt2LE;EAAsC,gBAAA;AV02LxC;;AU12LE;EAAsC,gBAAA;AV82LxC;;AU92LE;EAAsC,gBAAA;AVk3LxC;;AUl3LE;EAAsC,gBAAA;AVs3LxC;;AUt3LE;EAAsC,gBAAA;AV03LxC;;AU13LE;EAAsC,gBAAA;AV83LxC;;AU93LE;EAAsC,gBAAA;AVk4LxC;;AUl4LE;EAAsC,gBAAA;AVs4LxC;;AUt4LE;EAAsC,gBAAA;AV04LxC;;AU14LE;EAAsC,gBAAA;AV84LxC;;AU94LE;EAAsC,gBAAA;AVk5LxC;;AUl5LE;EAAsC,gBAAA;AVs5LxC;;AUt5LE;EAAsC,gBAAA;AV05LxC;;AU15LE;EAAsC,gBAAA;AV85LxC;;AU95LE;EAAsC,gBAAA;AVk6LxC;;AUl6LE;EAAsC,gBAAA;AVs6LxC;;AUt6LE;EAAsC,gBAAA;AV06LxC;;AU16LE;EAAsC,gBAAA;AV86LxC;;AU96LE;EAAsC,gBAAA;AVk7LxC;;AUl7LE;EAAsC,gBAAA;AVs7LxC;;AUt7LE;EAAsC,gBAAA;AV07LxC;;AU17LE;EAAsC,gBAAA;AV87LxC;;AU97LE;EAAsC,gBAAA;AVk8LxC;;AUl8LE;EAAsC,gBAAA;AVs8LxC;;AUt8LE;EAAsC,gBAAA;AV08LxC;;AU18LE;EAAsC,gBAAA;AV88LxC;;AU98LE;EAAsC,gBAAA;AVk9LxC;;AUl9LE;EAAsC,gBAAA;AVs9LxC;;AUt9LE;EAAsC,gBAAA;AV09LxC;;AU19LE;EAAsC,gBAAA;AV89LxC;;AU99LE;EAAsC,gBAAA;AVk+LxC;;AUl+LE;EAAsC,aAAA;AVs+LxC;;AUt+LE;EAAsC,gBAAA;AV0+LxC;;AU1+LE;EAAsC,gBAAA;AV8+LxC;;AU9+LE;EAAsC,gBAAA;AVk/LxC;;AUl/LE;EAAsC,gBAAA;AVs/LxC;;AUt/LE;EAAsC,gBAAA;AV0/LxC;;AU1/LE;EAAsC,gBAAA;AV8/LxC;;AU9/LE;EAAsC,gBAAA;AVkgMxC;;AUlgME;EAAsC,gBAAA;AVsgMxC;;AUtgME;EAAsC,gBAAA;AV0gMxC;;AU1gME;EAAsC,gBAAA;AV8gMxC;;AU9gME;EAAsC,gBAAA;AVkhMxC;;AUlhME;EAAsC,gBAAA;AVshMxC;;AUthME;EAAsC,gBAAA;AV0hMxC;;AU1hME;EAAsC,gBAAA;AV8hMxC;;AU9hME;EAAsC,gBAAA;AVkiMxC;;AUliME;EAAsC,gBAAA;AVsiMxC;;AUtiME;EAAsC,gBAAA;AV0iMxC;;AU1iME;EAAsC,gBAAA;AV8iMxC;;AU9iME;EAAsC,gBAAA;AVkjMxC;;AUljME;EAAsC,gBAAA;AVsjMxC;;AUtjME;EAAsC,gBAAA;AV0jMxC;;AU1jME;EAAsC,gBAAA;AV8jMxC;;AU9jME;EAAsC,gBAAA;AVkkMxC;;AUlkME;EAAsC,gBAAA;AVskMxC;;AUtkME;EAAsC,gBAAA;AV0kMxC;;AU1kME;EAAsC,gBAAA;AV8kMxC;;AU9kME;EAAsC,gBAAA;AVklMxC;;AUllME;EAAsC,gBAAA;AVslMxC;;AUtlME;EAAsC,gBAAA;AV0lMxC;;AU1lME;EAAsC,gBAAA;AV8lMxC;;AU9lME;EAAsC,gBAAA;AVkmMxC;;AUlmME;EAAsC,gBAAA;AVsmMxC;;AUtmME;EAAsC,gBAAA;AV0mMxC;;AU1mME;EAAsC,gBAAA;AV8mMxC;;AU9mME;EAAsC,gBAAA;AVknMxC;;AUlnME;EAAsC,gBAAA;AVsnMxC;;AUtnME;EAAsC,gBAAA;AV0nMxC;;AU1nME;EAAsC,gBAAA;AV8nMxC;;AU9nME;EAAsC,gBAAA;AVkoMxC;;AUloME;EAAsC,gBAAA;AVsoMxC;;AUtoME;EAAsC,gBAAA;AV0oMxC;;AU1oME;EAAsC,gBAAA;AV8oMxC;;AU9oME;EAAsC,gBAAA;AVkpMxC;;AUlpME;EAAsC,gBAAA;AVspMxC;;AUtpME;EAAsC,gBAAA;AV0pMxC;;AU1pME;EAAsC,gBAAA;AV8pMxC;;AU9pME;EAAsC,gBAAA;AVkqMxC;;AUlqME;EAAsC,gBAAA;AVsqMxC;;AUtqME;EAAsC,gBAAA;AV0qMxC;;AU1qME;EAAsC,gBAAA;AV8qMxC;;AU9qME;EAAsC,gBAAA;AVkrMxC;;AUlrME;EAAsC,gBAAA;AVsrMxC;;AUtrME;EAAsC,gBAAA;AV0rMxC;;AU1rME;EAAsC,gBAAA;AV8rMxC;;AU9rME;EAAsC,gBAAA;AVksMxC;;AUlsME;EAAsC,gBAAA;AVssMxC;;AUtsME;EAAsC,gBAAA;AV0sMxC;;AU1sME;EAAsC,gBAAA;AV8sMxC;;AU9sME;EAAsC,gBAAA;AVktMxC;;AUltME;EAAsC,gBAAA;AVstMxC;;AUttME;EAAsC,gBAAA;AV0tMxC;;AU1tME;EAAsC,gBAAA;AV8tMxC;;AU9tME;EAAsC,gBAAA;AVkuMxC;;AUluME;EAAsC,gBAAA;AVsuMxC;;AUtuME;EAAsC,gBAAA;AV0uMxC;;AU1uME;EAAsC,gBAAA;AV8uMxC;;AU9uME;EAAsC,gBAAA;AVkvMxC;;AUlvME;EAAsC,gBAAA;AVsvMxC;;AUtvME;EAAsC,gBAAA;AV0vMxC;;AU1vME;EAAsC,gBAAA;AV8vMxC;;AU9vME;EAAsC,gBAAA;AVkwMxC;;AUlwME;EAAsC,gBAAA;AVswMxC;;AUtwME;EAAsC,gBAAA;AV0wMxC;;AU1wME;EAAsC,gBAAA;AV8wMxC;;AU9wME;EAAsC,gBAAA;AVkxMxC;;AUlxME;EAAsC,gBAAA;AVsxMxC;;AUtxME;EAAsC,gBAAA;AV0xMxC;;AU1xME;EAAsC,gBAAA;AV8xMxC;;AU9xME;EAAsC,gBAAA;AVkyMxC;;AUlyME;EAAsC,gBAAA;AVsyMxC;;AUtyME;EAAsC,gBAAA;AV0yMxC;;AU1yME;EAAsC,gBAAA;AV8yMxC;;AU9yME;EAAsC,gBAAA;AVkzMxC;;AUlzME;EAAsC,gBAAA;AVszMxC;;AUtzME;EAAsC,gBAAA;AV0zMxC;;AU1zME;EAAsC,gBAAA;AV8zMxC;;AU9zME;EAAsC,gBAAA;AVk0MxC;;AUl0ME;EAAsC,gBAAA;AVs0MxC;;AUt0ME;EAAsC,gBAAA;AV00MxC;;AU10ME;EAAsC,gBAAA;AV80MxC;;AU90ME;EAAsC,gBAAA;AVk1MxC;;AUl1ME;EAAsC,gBAAA;AVs1MxC;;AUt1ME;EAAsC,gBAAA;AV01MxC;;AU11ME;EAAsC,gBAAA;AV81MxC;;AU91ME;EAAsC,gBAAA;AVk2MxC;;AUl2ME;EAAsC,gBAAA;AVs2MxC;;AUt2ME;EAAsC,gBAAA;AV02MxC;;AU12ME;EAAsC,gBAAA;AV82MxC;;AU92ME;EAAsC,gBAAA;AVk3MxC;;AUl3ME;EAAsC,gBAAA;AVs3MxC;;AUt3ME;EAAsC,gBAAA;AV03MxC;;AU13ME;EAAsC,gBAAA;AV83MxC;;AU93ME;EAAsC,gBAAA;AVk4MxC;;AUl4ME;EAAsC,gBAAA;AVs4MxC;;AUt4ME;EAAsC,gBAAA;AV04MxC;;AU14ME;EAAsC,YAAA;AV84MxC;;AU94ME;EAAsC,gBAAA;AVk5MxC;;AUl5ME;EAAsC,gBAAA;AVs5MxC;;AUt5ME;EAAsC,gBAAA;AV05MxC;;AU15ME;EAAsC,gBAAA;AV85MxC;;AU95ME;EAAsC,gBAAA;AVk6MxC;;AUl6ME;EAAsC,gBAAA;AVs6MxC;;AUt6ME;EAAsC,gBAAA;AV06MxC;;AU16ME;EAAsC,gBAAA;AV86MxC;;AU96ME;EAAsC,gBAAA;AVk7MxC;;AUl7ME;EAAsC,gBAAA;AVs7MxC;;AUt7ME;EAAsC,gBAAA;AV07MxC;;AU17ME;EAAsC,gBAAA;AV87MxC;;AU97ME;EAAsC,gBAAA;AVk8MxC;;AUl8ME;EAAsC,gBAAA;AVs8MxC;;AUt8ME;EAAsC,gBAAA;AV08MxC;;AU18ME;EAAsC,gBAAA;AV88MxC;;AU98ME;EAAsC,gBAAA;AVk9MxC;;AUl9ME;EAAsC,gBAAA;AVs9MxC;;AUt9ME;EAAsC,gBAAA;AV09MxC;;AU19ME;EAAsC,gBAAA;AV89MxC;;AU99ME;EAAsC,gBAAA;AVk+MxC;;AUl+ME;EAAsC,gBAAA;AVs+MxC;;AUt+ME;EAAsC,gBAAA;AV0+MxC;;AU1+ME;EAAsC,gBAAA;AV8+MxC;;AU9+ME;EAAsC,gBAAA;AVk/MxC;;AUl/ME;EAAsC,gBAAA;AVs/MxC;;AUt/ME;EAAsC,gBAAA;AV0/MxC;;AU1/ME;EAAsC,gBAAA;AV8/MxC;;AU9/ME;EAAsC,gBAAA;AVkgNxC;;AUlgNE;EAAsC,gBAAA;AVsgNxC;;AUtgNE;EAAsC,aAAA;AV0gNxC;;AU1gNE;EAAsC,aAAA;AV8gNxC;;AU9gNE;EAAsC,gBAAA;AVkhNxC;;AUlhNE;EAAsC,gBAAA;AVshNxC;;AUthNE;EAAsC,gBAAA;AV0hNxC;;AU1hNE;EAAsC,gBAAA;AV8hNxC;;AU9hNE;EAAsC,gBAAA;AVkiNxC;;AUliNE;EAAsC,gBAAA;AVsiNxC;;AUtiNE;EAAsC,gBAAA;AV0iNxC;;AU1iNE;EAAsC,gBAAA;AV8iNxC;;AU9iNE;EAAsC,gBAAA;AVkjNxC;;AUljNE;EAAsC,gBAAA;AVsjNxC;;AUtjNE;EAAsC,gBAAA;AV0jNxC;;AU1jNE;EAAsC,gBAAA;AV8jNxC;;AU9jNE;EAAsC,gBAAA;AVkkNxC;;AUlkNE;EAAsC,gBAAA;AVskNxC;;AUtkNE;EAAsC,gBAAA;AV0kNxC;;AU1kNE;EAAsC,gBAAA;AV8kNxC;;AU9kNE;EAAsC,gBAAA;AVklNxC;;AUllNE;EAAsC,gBAAA;AVslNxC;;AUtlNE;EAAsC,gBAAA;AV0lNxC;;AU1lNE;EAAsC,gBAAA;AV8lNxC;;AU9lNE;EAAsC,gBAAA;AVkmNxC;;AUlmNE;EAAsC,gBAAA;AVsmNxC;;AUtmNE;EAAsC,gBAAA;AV0mNxC;;AU1mNE;EAAsC,gBAAA;AV8mNxC;;AU9mNE;EAAsC,aAAA;AVknNxC;;AUlnNE;EAAsC,gBAAA;AVsnNxC;;AUtnNE;EAAsC,gBAAA;AV0nNxC;;AU1nNE;EAAsC,gBAAA;AV8nNxC;;AU9nNE;EAAsC,gBAAA;AVkoNxC;;AUloNE;EAAsC,gBAAA;AVsoNxC;;AUtoNE;EAAsC,gBAAA;AV0oNxC;;AU1oNE;EAAsC,gBAAA;AV8oNxC;;AU9oNE;EAAsC,gBAAA;AVkpNxC;;AUlpNE;EAAsC,gBAAA;AVspNxC;;AUtpNE;EAAsC,gBAAA;AV0pNxC;;AU1pNE;EAAsC,gBAAA;AV8pNxC;;AU9pNE;EAAsC,gBAAA;AVkqNxC;;AUlqNE;EAAsC,gBAAA;AVsqNxC;;AUtqNE;EAAsC,gBAAA;AV0qNxC;;AU1qNE;EAAsC,gBAAA;AV8qNxC;;AU9qNE;EAAsC,gBAAA;AVkrNxC;;AUlrNE;EAAsC,gBAAA;AVsrNxC;;AUtrNE;EAAsC,gBAAA;AV0rNxC;;AU1rNE;EAAsC,gBAAA;AV8rNxC;;AU9rNE;EAAsC,gBAAA;AVksNxC;;AUlsNE;EAAsC,gBAAA;AVssNxC;;AUtsNE;EAAsC,gBAAA;AV0sNxC;;AU1sNE;EAAsC,gBAAA;AV8sNxC;;AU9sNE;EAAsC,gBAAA;AVktNxC;;AUltNE;EAAsC,gBAAA;AVstNxC;;AUttNE;EAAsC,gBAAA;AV0tNxC;;AU1tNE;EAAsC,gBAAA;AV8tNxC;;AU9tNE;EAAsC,gBAAA;AVkuNxC;;AUluNE;EAAsC,gBAAA;AVsuNxC;;AUtuNE;EAAsC,gBAAA;AV0uNxC;;AU1uNE;EAAsC,gBAAA;AV8uNxC;;AU9uNE;EAAsC,gBAAA;AVkvNxC;;AUlvNE;EAAsC,gBAAA;AVsvNxC;;AUtvNE;EAAsC,gBAAA;AV0vNxC;;AU1vNE;EAAsC,gBAAA;AV8vNxC;;AU9vNE;EAAsC,gBAAA;AVkwNxC;;AUlwNE;EAAsC,gBAAA;AVswNxC;;AUtwNE;EAAsC,gBAAA;AV0wNxC;;AU1wNE;EAAsC,gBAAA;AV8wNxC;;AU9wNE;EAAsC,gBAAA;AVkxNxC;;AUlxNE;EAAsC,gBAAA;AVsxNxC;;AUtxNE;EAAsC,gBAAA;AV0xNxC;;AU1xNE;EAAsC,gBAAA;AV8xNxC;;AU9xNE;EAAsC,gBAAA;AVkyNxC;;AUlyNE;EAAsC,gBAAA;AVsyNxC;;AUtyNE;EAAsC,gBAAA;AV0yNxC;;AU1yNE;EAAsC,gBAAA;AV8yNxC;;AU9yNE;EAAsC,gBAAA;AVkzNxC;;AUlzNE;EAAsC,aAAA;AVszNxC;;AUtzNE;EAAsC,aAAA;AV0zNxC;;AU1zNE;EAAsC,gBAAA;AV8zNxC;;AU9zNE;EAAsC,gBAAA;AVk0NxC;;AUl0NE;EAAsC,gBAAA;AVs0NxC;;AUt0NE;EAAsC,gBAAA;AV00NxC;;AU10NE;EAAsC,gBAAA;AV80NxC;;AU90NE;EAAsC,gBAAA;AVk1NxC;;AUl1NE;EAAsC,gBAAA;AVs1NxC;;AUt1NE;EAAsC,gBAAA;AV01NxC;;AU11NE;EAAsC,gBAAA;AV81NxC;;AU91NE;EAAsC,gBAAA;AVk2NxC;;AUl2NE;EAAsC,gBAAA;AVs2NxC;;AUt2NE;EAAsC,gBAAA;AV02NxC;;AU12NE;EAAsC,gBAAA;AV82NxC;;AU92NE;EAAsC,gBAAA;AVk3NxC;;AUl3NE;EAAsC,gBAAA;AVs3NxC;;AUt3NE;EAAsC,gBAAA;AV03NxC;;AU13NE;EAAsC,gBAAA;AV83NxC;;AU93NE;EAAsC,gBAAA;AVk4NxC;;AUl4NE;EAAsC,gBAAA;AVs4NxC;;AUt4NE;EAAsC,gBAAA;AV04NxC;;AU14NE;EAAsC,gBAAA;AV84NxC;;AU94NE;EAAsC,gBAAA;AVk5NxC;;AUl5NE;EAAsC,gBAAA;AVs5NxC;;AUt5NE;EAAsC,gBAAA;AV05NxC;;AU15NE;EAAsC,gBAAA;AV85NxC;;AU95NE;EAAsC,gBAAA;AVk6NxC;;AUl6NE;EAAsC,gBAAA;AVs6NxC;;AUt6NE;EAAsC,gBAAA;AV06NxC;;AU16NE;EAAsC,gBAAA;AV86NxC;;AU96NE;EAAsC,gBAAA;AVk7NxC;;AUl7NE;EAAsC,gBAAA;AVs7NxC;;AUt7NE;EAAsC,gBAAA;AV07NxC;;AU17NE;EAAsC,gBAAA;AV87NxC;;AU97NE;EAAsC,gBAAA;AVk8NxC;;AUl8NE;EAAsC,gBAAA;AVs8NxC;;AUt8NE;EAAsC,gBAAA;AV08NxC;;AU18NE;EAAsC,gBAAA;AV88NxC;;AU98NE;EAAsC,gBAAA;AVk9NxC;;AUl9NE;EAAsC,gBAAA;AVs9NxC;;AUt9NE;EAAsC,gBAAA;AV09NxC;;AU19NE;EAAsC,gBAAA;AV89NxC;;AU99NE;EAAsC,gBAAA;AVk+NxC;;AUl+NE;EAAsC,gBAAA;AVs+NxC;;AUt+NE;EAAsC,gBAAA;AV0+NxC;;AU1+NE;EAAsC,gBAAA;AV8+NxC;;AU9+NE;EAAsC,gBAAA;AVk/NxC;;AUl/NE;EAAsC,gBAAA;AVs/NxC;;AUt/NE;EAAsC,gBAAA;AV0/NxC;;AU1/NE;EAAsC,gBAAA;AV8/NxC;;AU9/NE;EAAsC,gBAAA;AVkgOxC;;AUlgOE;EAAsC,gBAAA;AVsgOxC;;AUtgOE;EAAsC,gBAAA;AV0gOxC;;AU1gOE;EAAsC,gBAAA;AV8gOxC;;AU9gOE;EAAsC,gBAAA;AVkhOxC;;AUlhOE;EAAsC,gBAAA;AVshOxC;;AUthOE;EAAsC,gBAAA;AV0hOxC;;AU1hOE;EAAsC,gBAAA;AV8hOxC;;AU9hOE;EAAsC,gBAAA;AVkiOxC;;AUliOE;EAAsC,gBAAA;AVsiOxC;;AUtiOE;EAAsC,gBAAA;AV0iOxC;;AU1iOE;EAAsC,gBAAA;AV8iOxC;;AU9iOE;EAAsC,gBAAA;AVkjOxC;;AUljOE;EAAsC,gBAAA;AVsjOxC;;AUtjOE;EAAsC,gBAAA;AV0jOxC;;AU1jOE;EAAsC,gBAAA;AV8jOxC;;AU9jOE;EAAsC,gBAAA;AVkkOxC;;AUlkOE;EAAsC,gBAAA;AVskOxC;;AUtkOE;EAAsC,gBAAA;AV0kOxC;;AU1kOE;EAAsC,gBAAA;AV8kOxC;;AU9kOE;EAAsC,gBAAA;AVklOxC;;AUllOE;EAAsC,gBAAA;AVslOxC;;AUtlOE;EAAsC,gBAAA;AV0lOxC;;AU1lOE;EAAsC,gBAAA;AV8lOxC;;AU9lOE;EAAsC,gBAAA;AVkmOxC;;AUlmOE;EAAsC,gBAAA;AVsmOxC;;AUtmOE;EAAsC,gBAAA;AV0mOxC;;AU1mOE;EAAsC,gBAAA;AV8mOxC;;AU9mOE;EAAsC,gBAAA;AVknOxC;;AUlnOE;EAAsC,gBAAA;AVsnOxC;;AUtnOE;EAAsC,gBAAA;AV0nOxC;;AU1nOE;EAAsC,aAAA;AV8nOxC;;AU9nOE;EAAsC,gBAAA;AVkoOxC;;AUloOE;EAAsC,gBAAA;AVsoOxC;;AUtoOE;EAAsC,gBAAA;AV0oOxC;;AU1oOE;EAAsC,YAAA;AV8oOxC;;AU9oOE;EAAsC,gBAAA;AVkpOxC;;AUlpOE;EAAsC,gBAAA;AVspOxC;;AUtpOE;EAAsC,gBAAA;AV0pOxC;;AU1pOE;EAAsC,gBAAA;AV8pOxC;;AU9pOE;EAAsC,gBAAA;AVkqOxC;;AUlqOE;EAAsC,gBAAA;AVsqOxC;;AUtqOE;EAAsC,gBAAA;AV0qOxC;;AU1qOE;EAAsC,gBAAA;AV8qOxC;;AU9qOE;EAAsC,gBAAA;AVkrOxC;;AUlrOE;EAAsC,gBAAA;AVsrOxC;;AUtrOE;EAAsC,gBAAA;AV0rOxC;;AU1rOE;EAAsC,gBAAA;AV8rOxC;;AU9rOE;EAAsC,gBAAA;AVksOxC;;AUlsOE;EAAsC,gBAAA;AVssOxC;;AUtsOE;EAAsC,gBAAA;AV0sOxC;;AU1sOE;EAAsC,gBAAA;AV8sOxC;;AU9sOE;EAAsC,gBAAA;AVktOxC;;AUltOE;EAAsC,gBAAA;AVstOxC;;AUttOE;EAAsC,gBAAA;AV0tOxC;;AU1tOE;EAAsC,gBAAA;AV8tOxC;;AU9tOE;EAAsC,gBAAA;AVkuOxC;;AUluOE;EAAsC,gBAAA;AVsuOxC;;AUtuOE;EAAsC,gBAAA;AV0uOxC;;AU1uOE;EAAsC,gBAAA;AV8uOxC;;AU9uOE;EAAsC,gBAAA;AVkvOxC;;AUlvOE;EAAsC,gBAAA;AVsvOxC;;AUtvOE;EAAsC,gBAAA;AV0vOxC;;AU1vOE;EAAsC,gBAAA;AV8vOxC;;AU9vOE;EAAsC,gBAAA;AVkwOxC;;AUlwOE;EAAsC,gBAAA;AVswOxC;;AUtwOE;EAAsC,gBAAA;AV0wOxC;;AU1wOE;EAAsC,gBAAA;AV8wOxC;;AU9wOE;EAAsC,gBAAA;AVkxOxC;;AUlxOE;EAAsC,gBAAA;AVsxOxC;;AUtxOE;EAAsC,gBAAA;AV0xOxC;;AU1xOE;EAAsC,gBAAA;AV8xOxC;;AU9xOE;EAAsC,gBAAA;AVkyOxC;;AUlyOE;EAAsC,gBAAA;AVsyOxC;;AUtyOE;EAAsC,gBAAA;AV0yOxC;;AU1yOE;EAAsC,gBAAA;AV8yOxC;;AU9yOE;EAAsC,gBAAA;AVkzOxC;;AUlzOE;EAAsC,gBAAA;AVszOxC;;AUtzOE;EAAsC,gBAAA;AV0zOxC;;AU1zOE;EAAsC,gBAAA;AV8zOxC;;AU9zOE;EAAsC,gBAAA;AVk0OxC;;AUl0OE;EAAsC,gBAAA;AVs0OxC;;AUt0OE;EAAsC,gBAAA;AV00OxC;;AU10OE;EAAsC,gBAAA;AV80OxC;;AU90OE;EAAsC,gBAAA;AVk1OxC;;AUl1OE;EAAsC,gBAAA;AVs1OxC;;AUt1OE;EAAsC,gBAAA;AV01OxC;;AU11OE;EAAsC,gBAAA;AV81OxC;;AU91OE;EAAsC,gBAAA;AVk2OxC;;AUl2OE;EAAsC,gBAAA;AVs2OxC;;AUt2OE;EAAsC,gBAAA;AV02OxC;;AU12OE;EAAsC,YAAA;AV82OxC;;AU92OE;EAAsC,gBAAA;AVk3OxC;;AUl3OE;EAAsC,gBAAA;AVs3OxC;;AUt3OE;EAAsC,gBAAA;AV03OxC;;AU13OE;EAAsC,gBAAA;AV83OxC;;AU93OE;EAAsC,gBAAA;AVk4OxC;;AUl4OE;EAAsC,gBAAA;AVs4OxC;;AUt4OE;EAAsC,gBAAA;AV04OxC;;AU14OE;EAAsC,gBAAA;AV84OxC;;AU94OE;EAAsC,gBAAA;AVk5OxC;;AUl5OE;EAAsC,gBAAA;AVs5OxC;;AUt5OE;EAAsC,gBAAA;AV05OxC;;AU15OE;EAAsC,gBAAA;AV85OxC;;AU95OE;EAAsC,gBAAA;AVk6OxC;;AUl6OE;EAAsC,gBAAA;AVs6OxC;;AUt6OE;EAAsC,gBAAA;AV06OxC;;AU16OE;EAAsC,gBAAA;AV86OxC;;AU96OE;EAAsC,gBAAA;AVk7OxC;;AUl7OE;EAAsC,gBAAA;AVs7OxC;;AUt7OE;EAAsC,gBAAA;AV07OxC;;AU17OE;EAAsC,gBAAA;AV87OxC;;AU97OE;EAAsC,gBAAA;AVk8OxC;;AUl8OE;EAAsC,gBAAA;AVs8OxC;;AUt8OE;EAAsC,gBAAA;AV08OxC;;AU18OE;EAAsC,gBAAA;AV88OxC;;AU98OE;EAAsC,gBAAA;AVk9OxC;;AUl9OE;EAAsC,gBAAA;AVs9OxC;;AUt9OE;EAAsC,gBAAA;AV09OxC;;AU19OE;EAAsC,gBAAA;AV89OxC;;AU99OE;EAAsC,gBAAA;AVk+OxC;;AUl+OE;EAAsC,gBAAA;AVs+OxC;;AUt+OE;EAAsC,gBAAA;AV0+OxC;;AU1+OE;EAAsC,gBAAA;AV8+OxC;;AU9+OE;EAAsC,gBAAA;AVk/OxC;;AUl/OE;EAAsC,gBAAA;AVs/OxC;;AUt/OE;EAAsC,gBAAA;AV0/OxC;;AU1/OE;EAAsC,gBAAA;AV8/OxC;;AU9/OE;EAAsC,gBAAA;AVkgPxC;;AUlgPE;EAAsC,gBAAA;AVsgPxC;;AUtgPE;EAAsC,gBAAA;AV0gPxC;;AU1gPE;EAAsC,gBAAA;AV8gPxC;;AU9gPE;EAAsC,gBAAA;AVkhPxC;;AUlhPE;EAAsC,gBAAA;AVshPxC;;AUthPE;EAAsC,gBAAA;AV0hPxC;;AU1hPE;EAAsC,gBAAA;AV8hPxC;;AU9hPE;EAAsC,gBAAA;AVkiPxC;;AUliPE;EAAsC,gBAAA;AVsiPxC;;AUtiPE;EAAsC,gBAAA;AV0iPxC;;AU1iPE;EAAsC,gBAAA;AV8iPxC;;AU9iPE;EAAsC,gBAAA;AVkjPxC;;AUljPE;EAAsC,gBAAA;AVsjPxC;;AUtjPE;EAAsC,gBAAA;AV0jPxC;;AU1jPE;EAAsC,gBAAA;AV8jPxC;;AU9jPE;EAAsC,gBAAA;AVkkPxC;;AUlkPE;EAAsC,gBAAA;AVskPxC;;AUtkPE;EAAsC,gBAAA;AV0kPxC;;AU1kPE;EAAsC,gBAAA;AV8kPxC;;AU9kPE;EAAsC,gBAAA;AVklPxC;;AUllPE;EAAsC,gBAAA;AVslPxC;;AUtlPE;EAAsC,gBAAA;AV0lPxC;;AU1lPE;EAAsC,gBAAA;AV8lPxC;;AU9lPE;EAAsC,gBAAA;AVkmPxC;;AUlmPE;EAAsC,gBAAA;AVsmPxC;;AUtmPE;EAAsC,gBAAA;AV0mPxC;;AU1mPE;EAAsC,gBAAA;AV8mPxC;;AU9mPE;EAAsC,gBAAA;AVknPxC;;AUlnPE;EAAsC,gBAAA;AVsnPxC;;AUtnPE;EAAsC,gBAAA;AV0nPxC;;AU1nPE;EAAsC,gBAAA;AV8nPxC;;AU9nPE;EAAsC,gBAAA;AVkoPxC;;AUloPE;EAAsC,gBAAA;AVsoPxC;;AUtoPE;EAAsC,gBAAA;AV0oPxC;;AU1oPE;EAAsC,gBAAA;AV8oPxC;;AU9oPE;EAAsC,gBAAA;AVkpPxC;;AUlpPE;EAAsC,gBAAA;AVspPxC;;AUtpPE;EAAsC,gBAAA;AV0pPxC;;AU1pPE;EAAsC,gBAAA;AV8pPxC;;AU9pPE;EAAsC,gBAAA;AVkqPxC;;AUlqPE;EAAsC,gBAAA;AVsqPxC;;AUtqPE;EAAsC,gBAAA;AV0qPxC;;AU1qPE;EAAsC,gBAAA;AV8qPxC;;AU9qPE;EAAsC,gBAAA;AVkrPxC;;AUlrPE;EAAsC,gBAAA;AVsrPxC;;AUtrPE;EAAsC,gBAAA;AV0rPxC;;AU1rPE;EAAsC,gBAAA;AV8rPxC;;AU9rPE;EAAsC,gBAAA;AVksPxC;;AUlsPE;EAAsC,gBAAA;AVssPxC;;AUtsPE;EAAsC,gBAAA;AV0sPxC;;AU1sPE;EAAsC,gBAAA;AV8sPxC;;AU9sPE;EAAsC,gBAAA;AVktPxC;;AUltPE;EAAsC,gBAAA;AVstPxC;;AUttPE;EAAsC,gBAAA;AV0tPxC;;AU1tPE;EAAsC,gBAAA;AV8tPxC;;AU9tPE;EAAsC,gBAAA;AVkuPxC;;AUluPE;EAAsC,gBAAA;AVsuPxC;;AUtuPE;EAAsC,gBAAA;AV0uPxC;;AU1uPE;EAAsC,gBAAA;AV8uPxC;;AU9uPE;EAAsC,gBAAA;AVkvPxC;;AUlvPE;EAAsC,gBAAA;AVsvPxC;;AUtvPE;EAAsC,gBAAA;AV0vPxC;;AU1vPE;EAAsC,gBAAA;AV8vPxC;;AU9vPE;EAAsC,gBAAA;AVkwPxC;;AUlwPE;EAAsC,gBAAA;AVswPxC;;AUtwPE;EAAsC,gBAAA;AV0wPxC;;AU1wPE;EAAsC,gBAAA;AV8wPxC;;AU9wPE;EAAsC,gBAAA;AVkxPxC;;AUlxPE;EAAsC,gBAAA;AVsxPxC;;AUtxPE;EAAsC,gBAAA;AV0xPxC;;AU1xPE;EAAsC,gBAAA;AV8xPxC;;AU9xPE;EAAsC,gBAAA;AVkyPxC;;AUlyPE;EAAsC,gBAAA;AVsyPxC;;AUtyPE;EAAsC,gBAAA;AV0yPxC;;AU1yPE;EAAsC,gBAAA;AV8yPxC;;AU9yPE;EAAsC,gBAAA;AVkzPxC;;AUlzPE;EAAsC,gBAAA;AVszPxC;;AUtzPE;EAAsC,gBAAA;AV0zPxC;;AU1zPE;EAAsC,gBAAA;AV8zPxC;;AU9zPE;EAAsC,gBAAA;AVk0PxC;;AUl0PE;EAAsC,gBAAA;AVs0PxC;;AUt0PE;EAAsC,gBAAA;AV00PxC;;AU10PE;EAAsC,gBAAA;AV80PxC;;AU90PE;EAAsC,gBAAA;AVk1PxC;;AUl1PE;EAAsC,gBAAA;AVs1PxC;;AUt1PE;EAAsC,aAAA;AV01PxC;;AU11PE;EAAsC,gBAAA;AV81PxC;;AU91PE;EAAsC,gBAAA;AVk2PxC;;AUl2PE;EAAsC,gBAAA;AVs2PxC;;AUt2PE;EAAsC,gBAAA;AV02PxC;;AU12PE;EAAsC,gBAAA;AV82PxC;;AU92PE;EAAsC,aAAA;AVk3PxC;;AUl3PE;EAAsC,aAAA;AVs3PxC;;AUt3PE;EAAsC,aAAA;AV03PxC;;AU13PE;EAAsC,YAAA;AV83PxC;;AU93PE;EAAsC,gBAAA;AVk4PxC;;AUl4PE;EAAsC,gBAAA;AVs4PxC;;AUt4PE;EAAsC,gBAAA;AV04PxC;;AU14PE;EAAsC,gBAAA;AV84PxC;;AU94PE;EAAsC,gBAAA;AVk5PxC;;AUl5PE;EAAsC,gBAAA;AVs5PxC;;AUt5PE;EAAsC,gBAAA;AV05PxC;;AU15PE;EAAsC,gBAAA;AV85PxC;;AU95PE;EAAsC,gBAAA;AVk6PxC;;AUl6PE;EAAsC,gBAAA;AVs6PxC;;AUt6PE;EAAsC,gBAAA;AV06PxC;;AU16PE;EAAsC,gBAAA;AV86PxC;;AU96PE;EAAsC,YAAA;AVk7PxC;;AUl7PE;EAAsC,gBAAA;AVs7PxC;;AUt7PE;EAAsC,gBAAA;AV07PxC;;AU17PE;EAAsC,gBAAA;AV87PxC;;AU97PE;EAAsC,gBAAA;AVk8PxC;;AUl8PE;EAAsC,gBAAA;AVs8PxC;;AUt8PE;EAAsC,gBAAA;AV08PxC;;AU18PE;EAAsC,gBAAA;AV88PxC;;AU98PE;EAAsC,gBAAA;AVk9PxC;;AUl9PE;EAAsC,gBAAA;AVs9PxC;;AUt9PE;EAAsC,gBAAA;AV09PxC;;AU19PE;EAAsC,gBAAA;AV89PxC;;AU99PE;EAAsC,gBAAA;AVk+PxC;;AUl+PE;EAAsC,gBAAA;AVs+PxC;;AUt+PE;EAAsC,gBAAA;AV0+PxC;;AU1+PE;EAAsC,gBAAA;AV8+PxC;;AU9+PE;EAAsC,gBAAA;AVk/PxC;;AUl/PE;EAAsC,gBAAA;AVs/PxC;;AUt/PE;EAAsC,gBAAA;AV0/PxC;;AU1/PE;EAAsC,gBAAA;AV8/PxC;;AU9/PE;EAAsC,gBAAA;AVkgQxC;;AUlgQE;EAAsC,gBAAA;AVsgQxC;;AWzgQA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AFy/PF;;AEp/PE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AFsgQF;;AYviQA;;;;EAAA;AAQA;EACE,iDAAA;EACA,0DAAA;AZuiQF;;AYpiQA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBR8BwB;EQ7BxB,wHAAA;AZuiQF;AYniQA;;EAEE,gBAAA;AZqiQF;;AYjiQE;EAAqC,gBAAA;AZqiQvC;;AYriQE;EAAqC,gBAAA;AZyiQvC;;AYziQE;EAAqC,gBAAA;AZ6iQvC;;AY7iQE;EAAqC,gBAAA;AZijQvC;;AYjjQE;EAAqC,gBAAA;AZqjQvC;;AYrjQE;EAAqC,gBAAA;AZyjQvC;;AYzjQE;EAAqC,gBAAA;AZ6jQvC;;AY7jQE;EAAqC,gBAAA;AZikQvC;;AYjkQE;EAAqC,gBAAA;AZqkQvC;;AYrkQE;EAAqC,gBAAA;AZykQvC;;AYzkQE;EAAqC,gBAAA;AZ6kQvC;;AY7kQE;EAAqC,gBAAA;AZilQvC;;AYjlQE;EAAqC,gBAAA;AZqlQvC;;AYrlQE;EAAqC,gBAAA;AZylQvC;;AYzlQE;EAAqC,gBAAA;AZ6lQvC;;AY7lQE;EAAqC,gBAAA;AZimQvC;;AYjmQE;EAAqC,gBAAA;AZqmQvC;;AYrmQE;EAAqC,gBAAA;AZymQvC;;AYzmQE;EAAqC,gBAAA;AZ6mQvC;;AY7mQE;EAAqC,gBAAA;AZinQvC;;AYjnQE;EAAqC,gBAAA;AZqnQvC;;AYrnQE;EAAqC,gBAAA;AZynQvC;;AYznQE;EAAqC,gBAAA;AZ6nQvC;;AY7nQE;EAAqC,gBAAA;AZioQvC;;AYjoQE;EAAqC,gBAAA;AZqoQvC;;AYroQE;EAAqC,gBAAA;AZyoQvC;;AYzoQE;EAAqC,gBAAA;AZ6oQvC;;AY7oQE;EAAqC,gBAAA;AZipQvC;;AYjpQE;EAAqC,gBAAA;AZqpQvC;;AYrpQE;EAAqC,gBAAA;AZypQvC;;AYzpQE;EAAqC,gBAAA;AZ6pQvC;;AY7pQE;EAAqC,gBAAA;AZiqQvC;;AYjqQE;EAAqC,gBAAA;AZqqQvC;;AYrqQE;EAAqC,gBAAA;AZyqQvC;;AYzqQE;EAAqC,gBAAA;AZ6qQvC;;AY7qQE;EAAqC,gBAAA;AZirQvC;;AYjrQE;EAAqC,gBAAA;AZqrQvC;;AYrrQE;EAAqC,gBAAA;AZyrQvC;;AYzrQE;EAAqC,gBAAA;AZ6rQvC;;AY7rQE;EAAqC,gBAAA;AZisQvC;;AYjsQE;EAAqC,gBAAA;AZqsQvC;;AYrsQE;EAAqC,gBAAA;AZysQvC;;AYzsQE;EAAqC,gBAAA;AZ6sQvC;;AY7sQE;EAAqC,gBAAA;AZitQvC;;AYjtQE;EAAqC,gBAAA;AZqtQvC;;AYrtQE;EAAqC,gBAAA;AZytQvC;;AYztQE;EAAqC,gBAAA;AZ6tQvC;;AY7tQE;EAAqC,gBAAA;AZiuQvC;;AYjuQE;EAAqC,gBAAA;AZquQvC;;AYruQE;EAAqC,gBAAA;AZyuQvC;;AYzuQE;EAAqC,gBAAA;AZ6uQvC;;AY7uQE;EAAqC,gBAAA;AZivQvC;;AYjvQE;EAAqC,gBAAA;AZqvQvC;;AYrvQE;EAAqC,gBAAA;AZyvQvC;;AYzvQE;EAAqC,gBAAA;AZ6vQvC;;AY7vQE;EAAqC,gBAAA;AZiwQvC;;AYjwQE;EAAqC,gBAAA;AZqwQvC;;AYrwQE;EAAqC,gBAAA;AZywQvC;;AYzwQE;EAAqC,gBAAA;AZ6wQvC;;AY7wQE;EAAqC,gBAAA;AZixQvC;;AYjxQE;EAAqC,gBAAA;AZqxQvC;;AYrxQE;EAAqC,gBAAA;AZyxQvC;;AYzxQE;EAAqC,gBAAA;AZ6xQvC;;AY7xQE;EAAqC,gBAAA;AZiyQvC;;AYjyQE;EAAqC,gBAAA;AZqyQvC;;AYryQE;EAAqC,gBAAA;AZyyQvC;;AYzyQE;EAAqC,gBAAA;AZ6yQvC;;AY7yQE;EAAqC,gBAAA;AZizQvC;;AYjzQE;EAAqC,gBAAA;AZqzQvC;;AYrzQE;EAAqC,gBAAA;AZyzQvC;;AYzzQE;EAAqC,gBAAA;AZ6zQvC;;AY7zQE;EAAqC,gBAAA;AZi0QvC;;AYj0QE;EAAqC,gBAAA;AZq0QvC;;AYr0QE;EAAqC,gBAAA;AZy0QvC;;AYz0QE;EAAqC,gBAAA;AZ60QvC;;AY70QE;EAAqC,gBAAA;AZi1QvC;;AYj1QE;EAAqC,gBAAA;AZq1QvC;;AYr1QE;EAAqC,gBAAA;AZy1QvC;;AYz1QE;EAAqC,gBAAA;AZ61QvC;;AY71QE;EAAqC,gBAAA;AZi2QvC;;AYj2QE;EAAqC,gBAAA;AZq2QvC;;AYr2QE;EAAqC,gBAAA;AZy2QvC;;AYz2QE;EAAqC,gBAAA;AZ62QvC;;AY72QE;EAAqC,gBAAA;AZi3QvC;;AYj3QE;EAAqC,gBAAA;AZq3QvC;;AYr3QE;EAAqC,gBAAA;AZy3QvC;;AYz3QE;EAAqC,gBAAA;AZ63QvC;;AY73QE;EAAqC,gBAAA;AZi4QvC;;AYj4QE;EAAqC,gBAAA;AZq4QvC;;AYr4QE;EAAqC,gBAAA;AZy4QvC;;AYz4QE;EAAqC,gBAAA;AZ64QvC;;AY74QE;EAAqC,gBAAA;AZi5QvC;;AYj5QE;EAAqC,gBAAA;AZq5QvC;;AYr5QE;EAAqC,gBAAA;AZy5QvC;;AYz5QE;EAAqC,gBAAA;AZ65QvC;;AY75QE;EAAqC,gBAAA;AZi6QvC;;AYj6QE;EAAqC,gBAAA;AZq6QvC;;AYr6QE;EAAqC,gBAAA;AZy6QvC;;AYz6QE;EAAqC,gBAAA;AZ66QvC;;AY76QE;EAAqC,gBAAA;AZi7QvC;;AYj7QE;EAAqC,gBAAA;AZq7QvC;;AYr7QE;EAAqC,gBAAA;AZy7QvC;;AYz7QE;EAAqC,gBAAA;AZ67QvC;;AY77QE;EAAqC,gBAAA;AZi8QvC;;AYj8QE;EAAqC,gBAAA;AZq8QvC;;AYr8QE;EAAqC,gBAAA;AZy8QvC;;AYz8QE;EAAqC,gBAAA;AZ68QvC;;AY78QE;EAAqC,gBAAA;AZi9QvC;;AYj9QE;EAAqC,gBAAA;AZq9QvC;;AYr9QE;EAAqC,gBAAA;AZy9QvC;;AYz9QE;EAAqC,gBAAA;AZ69QvC;;AY79QE;EAAqC,gBAAA;AZi+QvC;;AYj+QE;EAAqC,gBAAA;AZq+QvC;;AYr+QE;EAAqC,gBAAA;AZy+QvC;;AYz+QE;EAAqC,gBAAA;AZ6+QvC;;AY7+QE;EAAqC,gBAAA;AZi/QvC;;AYj/QE;EAAqC,gBAAA;AZq/QvC;;AYr/QE;EAAqC,gBAAA;AZy/QvC;;AYz/QE;EAAqC,gBAAA;AZ6/QvC;;AY7/QE;EAAqC,gBAAA;AZigRvC;;AYjgRE;EAAqC,gBAAA;AZqgRvC;;AYrgRE;EAAqC,gBAAA;AZygRvC;;AYzgRE;EAAqC,gBAAA;AZ6gRvC;;AY7gRE;EAAqC,gBAAA;AZihRvC;;AYjhRE;EAAqC,gBAAA;AZqhRvC;;AYrhRE;EAAqC,gBAAA;AZyhRvC;;AYzhRE;EAAqC,gBAAA;AZ6hRvC;;AY7hRE;EAAqC,gBAAA;AZiiRvC;;AYjiRE;EAAqC,gBAAA;AZqiRvC;;AYriRE;EAAqC,gBAAA;AZyiRvC;;AYziRE;EAAqC,gBAAA;AZ6iRvC;;AY7iRE;EAAqC,gBAAA;AZijRvC;;AYjjRE;EAAqC,gBAAA;AZqjRvC;;AYrjRE;EAAqC,gBAAA;AZyjRvC;;AYzjRE;EAAqC,gBAAA;AZ6jRvC;;AY7jRE;EAAqC,gBAAA;AZikRvC;;AYjkRE;EAAqC,gBAAA;AZqkRvC;;AYrkRE;EAAqC,gBAAA;AZykRvC;;AYzkRE;EAAqC,gBAAA;AZ6kRvC;;AY7kRE;EAAqC,gBAAA;AZilRvC;;AYjlRE;EAAqC,gBAAA;AZqlRvC;;AYrlRE;EAAqC,gBAAA;AZylRvC;;AYzlRE;EAAqC,gBAAA;AZ6lRvC;;AY7lRE;EAAqC,gBAAA;AZimRvC;;AYjmRE;EAAqC,gBAAA;AZqmRvC;;AYrmRE;EAAqC,gBAAA;AZymRvC;;AYzmRE;EAAqC,gBAAA;AZ6mRvC;;AY7mRE;EAAqC,gBAAA;AZinRvC;;AYjnRE;EAAqC,gBAAA;AZqnRvC;;AYrnRE;EAAqC,gBAAA;AZynRvC;;AYznRE;EAAqC,gBAAA;AZ6nRvC;;AY7nRE;EAAqC,gBAAA;AZioRvC;;AYjoRE;EAAqC,gBAAA;AZqoRvC;;AYroRE;EAAqC,gBAAA;AZyoRvC;;AYzoRE;EAAqC,gBAAA;AZ6oRvC;;AY7oRE;EAAqC,gBAAA;AZipRvC;;AYjpRE;EAAqC,gBAAA;AZqpRvC;;AYrpRE;EAAqC,gBAAA;AZypRvC;;AYzpRE;EAAqC,gBAAA;AZ6pRvC;;AY7pRE;EAAqC,gBAAA;AZiqRvC;;AYjqRE;EAAqC,gBAAA;AZqqRvC;;AYrqRE;EAAqC,gBAAA;AZyqRvC;;AYzqRE;EAAqC,gBAAA;AZ6qRvC;;AY7qRE;EAAqC,gBAAA;AZirRvC;;AYjrRE;EAAqC,gBAAA;AZqrRvC;;AYrrRE;EAAqC,gBAAA;AZyrRvC;;AYzrRE;EAAqC,gBAAA;AZ6rRvC;;AY7rRE;EAAqC,gBAAA;AZisRvC;;AYjsRE;EAAqC,gBAAA;AZqsRvC;;AYrsRE;EAAqC,gBAAA;AZysRvC;;AYzsRE;EAAqC,gBAAA;AZ6sRvC;;AY7sRE;EAAqC,gBAAA;AZitRvC;;AYjtRE;EAAqC,gBAAA;AZqtRvC;;AYrtRE;EAAqC,gBAAA;AZytRvC;;AYztRE;EAAqC,gBAAA;AZ6tRvC;;AY7tRE;EAAqC,gBAAA;AZiuRvC;;AYjuRE;EAAqC,gBAAA;AZquRvC;;AYruRE;EAAqC,gBAAA;AZyuRvC;;AYzuRE;EAAqC,gBAAA;AZ6uRvC;;AY7uRE;EAAqC,gBAAA;AZivRvC;;AYjvRE;EAAqC,gBAAA;AZqvRvC;;AYrvRE;EAAqC,gBAAA;AZyvRvC;;AYzvRE;EAAqC,gBAAA;AZ6vRvC;;AY7vRE;EAAqC,gBAAA;AZiwRvC;;AYjwRE;EAAqC,gBAAA;AZqwRvC;;AYrwRE;EAAqC,gBAAA;AZywRvC;;AYzwRE;EAAqC,gBAAA;AZ6wRvC;;AY7wRE;EAAqC,gBAAA;AZixRvC;;AYjxRE;EAAqC,gBAAA;AZqxRvC;;AYrxRE;EAAqC,gBAAA;AZyxRvC;;AYzxRE;EAAqC,gBAAA;AZ6xRvC;;AY7xRE;EAAqC,gBAAA;AZiyRvC;;AYjyRE;EAAqC,gBAAA;AZqyRvC;;AYryRE;EAAqC,gBAAA;AZyyRvC;;AYzyRE;EAAqC,gBAAA;AZ6yRvC;;AY7yRE;EAAqC,gBAAA;AZizRvC;;AYjzRE;EAAqC,gBAAA;AZqzRvC;;AYrzRE;EAAqC,gBAAA;AZyzRvC;;AYzzRE;EAAqC,gBAAA;AZ6zRvC;;AY7zRE;EAAqC,gBAAA;AZi0RvC;;AYj0RE;EAAqC,gBAAA;AZq0RvC;;AYr0RE;EAAqC,gBAAA;AZy0RvC;;AYz0RE;EAAqC,gBAAA;AZ60RvC;;AY70RE;EAAqC,gBAAA;AZi1RvC;;AYj1RE;EAAqC,gBAAA;AZq1RvC;;AYr1RE;EAAqC,gBAAA;AZy1RvC;;AYz1RE;EAAqC,gBAAA;AZ61RvC;;AY71RE;EAAqC,gBAAA;AZi2RvC;;AYj2RE;EAAqC,gBAAA;AZq2RvC;;AYr2RE;EAAqC,gBAAA;AZy2RvC;;AYz2RE;EAAqC,gBAAA;AZ62RvC;;AY72RE;EAAqC,gBAAA;AZi3RvC;;AYj3RE;EAAqC,gBAAA;AZq3RvC;;AYr3RE;EAAqC,gBAAA;AZy3RvC;;AYz3RE;EAAqC,gBAAA;AZ63RvC;;AY73RE;EAAqC,gBAAA;AZi4RvC;;AYj4RE;EAAqC,gBAAA;AZq4RvC;;AYr4RE;EAAqC,gBAAA;AZy4RvC;;AYz4RE;EAAqC,gBAAA;AZ64RvC;;AY74RE;EAAqC,gBAAA;AZi5RvC;;AYj5RE;EAAqC,gBAAA;AZq5RvC;;AYr5RE;EAAqC,gBAAA;AZy5RvC;;AYz5RE;EAAqC,gBAAA;AZ65RvC;;AY75RE;EAAqC,gBAAA;AZi6RvC;;AYj6RE;EAAqC,gBAAA;AZq6RvC;;AYr6RE;EAAqC,gBAAA;AZy6RvC;;AYz6RE;EAAqC,gBAAA;AZ66RvC;;AY76RE;EAAqC,gBAAA;AZi7RvC;;AYj7RE;EAAqC,gBAAA;AZq7RvC;;AYr7RE;EAAqC,gBAAA;AZy7RvC;;AYz7RE;EAAqC,gBAAA;AZ67RvC;;AY77RE;EAAqC,gBAAA;AZi8RvC;;AYj8RE;EAAqC,gBAAA;AZq8RvC;;AYr8RE;EAAqC,gBAAA;AZy8RvC;;AYz8RE;EAAqC,gBAAA;AZ68RvC;;AY78RE;EAAqC,gBAAA;AZi9RvC;;AYj9RE;EAAqC,gBAAA;AZq9RvC;;AYr9RE;EAAqC,gBAAA;AZy9RvC;;AYz9RE;EAAqC,gBAAA;AZ69RvC;;AY79RE;EAAqC,gBAAA;AZi+RvC;;AYj+RE;EAAqC,gBAAA;AZq+RvC;;AYr+RE;EAAqC,gBAAA;AZy+RvC;;AYz+RE;EAAqC,gBAAA;AZ6+RvC;;AY7+RE;EAAqC,gBAAA;AZi/RvC;;AYj/RE;EAAqC,gBAAA;AZq/RvC;;AYr/RE;EAAqC,gBAAA;AZy/RvC;;AYz/RE;EAAqC,gBAAA;AZ6/RvC;;AY7/RE;EAAqC,gBAAA;AZigSvC;;AYjgSE;EAAqC,gBAAA;AZqgSvC;;AYrgSE;EAAqC,gBAAA;AZygSvC;;AYzgSE;EAAqC,gBAAA;AZ6gSvC;;AY7gSE;EAAqC,gBAAA;AZihSvC;;AYjhSE;EAAqC,gBAAA;AZqhSvC;;AYrhSE;EAAqC,gBAAA;AZyhSvC;;AYzhSE;EAAqC,gBAAA;AZ6hSvC;;AY7hSE;EAAqC,gBAAA;AZiiSvC;;AYjiSE;EAAqC,gBAAA;AZqiSvC;;AYriSE;EAAqC,gBAAA;AZyiSvC;;AYziSE;EAAqC,gBAAA;AZ6iSvC;;AY7iSE;EAAqC,gBAAA;AZijSvC;;AYjjSE;EAAqC,gBAAA;AZqjSvC;;AYrjSE;EAAqC,gBAAA;AZyjSvC;;AYzjSE;EAAqC,gBAAA;AZ6jSvC;;AY7jSE;EAAqC,gBAAA;AZikSvC;;AYjkSE;EAAqC,gBAAA;AZqkSvC;;AYrkSE;EAAqC,gBAAA;AZykSvC;;AYzkSE;EAAqC,gBAAA;AZ6kSvC;;AY7kSE;EAAqC,gBAAA;AZilSvC;;AYjlSE;EAAqC,gBAAA;AZqlSvC;;AYrlSE;EAAqC,gBAAA;AZylSvC;;AYzlSE;EAAqC,gBAAA;AZ6lSvC;;AY7lSE;EAAqC,gBAAA;AZimSvC;;AYjmSE;EAAqC,gBAAA;AZqmSvC;;AYrmSE;EAAqC,gBAAA;AZymSvC;;AYzmSE;EAAqC,gBAAA;AZ6mSvC;;AY7mSE;EAAqC,gBAAA;AZinSvC;;AYjnSE;EAAqC,gBAAA;AZqnSvC;;AYrnSE;EAAqC,gBAAA;AZynSvC;;AYznSE;EAAqC,gBAAA;AZ6nSvC;;AY7nSE;EAAqC,gBAAA;AZioSvC;;AYjoSE;EAAqC,gBAAA;AZqoSvC;;AYroSE;EAAqC,gBAAA;AZyoSvC;;AYzoSE;EAAqC,gBAAA;AZ6oSvC;;AY7oSE;EAAqC,gBAAA;AZipSvC;;AYjpSE;EAAqC,gBAAA;AZqpSvC;;AYrpSE;EAAqC,gBAAA;AZypSvC;;AYzpSE;EAAqC,gBAAA;AZ6pSvC;;AY7pSE;EAAqC,gBAAA;AZiqSvC;;AYjqSE;EAAqC,gBAAA;AZqqSvC;;AYrqSE;EAAqC,gBAAA;AZyqSvC;;AYzqSE;EAAqC,gBAAA;AZ6qSvC;;AY7qSE;EAAqC,gBAAA;AZirSvC;;AYjrSE;EAAqC,gBAAA;AZqrSvC;;AYrrSE;EAAqC,gBAAA;AZyrSvC;;AYzrSE;EAAqC,gBAAA;AZ6rSvC;;AY7rSE;EAAqC,gBAAA;AZisSvC;;AYjsSE;EAAqC,gBAAA;AZqsSvC;;AYrsSE;EAAqC,gBAAA;AZysSvC;;AYzsSE;EAAqC,gBAAA;AZ6sSvC;;AY7sSE;EAAqC,gBAAA;AZitSvC;;AYjtSE;EAAqC,gBAAA;AZqtSvC;;AYrtSE;EAAqC,gBAAA;AZytSvC;;AYztSE;EAAqC,gBAAA;AZ6tSvC;;AY7tSE;EAAqC,gBAAA;AZiuSvC;;AYjuSE;EAAqC,gBAAA;AZquSvC;;AYruSE;EAAqC,gBAAA;AZyuSvC;;AYzuSE;EAAqC,gBAAA;AZ6uSvC;;AY7uSE;EAAqC,gBAAA;AZivSvC;;AYjvSE;EAAqC,gBAAA;AZqvSvC;;AYrvSE;EAAqC,gBAAA;AZyvSvC;;AYzvSE;EAAqC,gBAAA;AZ6vSvC;;AY7vSE;EAAqC,gBAAA;AZiwSvC;;AYjwSE;EAAqC,gBAAA;AZqwSvC;;AYrwSE;EAAqC,gBAAA;AZywSvC;;AYzwSE;EAAqC,gBAAA;AZ6wSvC;;AY7wSE;EAAqC,gBAAA;AZixSvC;;AYjxSE;EAAqC,gBAAA;AZqxSvC;;AYrxSE;EAAqC,gBAAA;AZyxSvC;;AYzxSE;EAAqC,gBAAA;AZ6xSvC;;AY7xSE;EAAqC,gBAAA;AZiySvC;;AYjySE;EAAqC,gBAAA;AZqySvC;;AYrySE;EAAqC,gBAAA;AZyySvC;;AYzySE;EAAqC,gBAAA;AZ6ySvC;;AY7ySE;EAAqC,gBAAA;AZizSvC;;AYjzSE;EAAqC,gBAAA;AZqzSvC;;AYrzSE;EAAqC,gBAAA;AZyzSvC;;AYzzSE;EAAqC,gBAAA;AZ6zSvC;;AY7zSE;EAAqC,gBAAA;AZi0SvC;;AYj0SE;EAAqC,gBAAA;AZq0SvC;;AYr0SE;EAAqC,gBAAA;AZy0SvC;;AYz0SE;EAAqC,gBAAA;AZ60SvC;;AY70SE;EAAqC,gBAAA;AZi1SvC;;AYj1SE;EAAqC,gBAAA;AZq1SvC;;AYr1SE;EAAqC,gBAAA;AZy1SvC;;AYz1SE;EAAqC,gBAAA;AZ61SvC;;AY71SE;EAAqC,gBAAA;AZi2SvC;;AYj2SE;EAAqC,gBAAA;AZq2SvC;;AYr2SE;EAAqC,gBAAA;AZy2SvC;;AYz2SE;EAAqC,gBAAA;AZ62SvC;;AY72SE;EAAqC,gBAAA;AZi3SvC;;AYj3SE;EAAqC,gBAAA;AZq3SvC;;AYr3SE;EAAqC,gBAAA;AZy3SvC;;AYz3SE;EAAqC,gBAAA;AZ63SvC;;AY73SE;EAAqC,gBAAA;AZi4SvC;;AYj4SE;EAAqC,gBAAA;AZq4SvC;;AYr4SE;EAAqC,gBAAA;AZy4SvC;;AYz4SE;EAAqC,gBAAA;AZ64SvC;;AY74SE;EAAqC,gBAAA;AZi5SvC;;AYj5SE;EAAqC,gBAAA;AZq5SvC;;AYr5SE;EAAqC,gBAAA;AZy5SvC;;AYz5SE;EAAqC,gBAAA;AZ65SvC;;AY75SE;EAAqC,gBAAA;AZi6SvC;;AYj6SE;EAAqC,gBAAA;AZq6SvC;;AYr6SE;EAAqC,gBAAA;AZy6SvC;;AYz6SE;EAAqC,gBAAA;AZ66SvC;;AY76SE;EAAqC,gBAAA;AZi7SvC;;AYj7SE;EAAqC,gBAAA;AZq7SvC;;AYr7SE;EAAqC,gBAAA;AZy7SvC;;AYz7SE;EAAqC,gBAAA;AZ67SvC;;AY77SE;EAAqC,gBAAA;AZi8SvC;;AYj8SE;EAAqC,gBAAA;AZq8SvC;;AYr8SE;EAAqC,gBAAA;AZy8SvC;;AYz8SE;EAAqC,gBAAA;AZ68SvC;;AY78SE;EAAqC,gBAAA;AZi9SvC;;AYj9SE;EAAqC,gBAAA;AZq9SvC;;AYr9SE;EAAqC,gBAAA;AZy9SvC;;AYz9SE;EAAqC,gBAAA;AZ69SvC;;AY79SE;EAAqC,gBAAA;AZi+SvC;;AYj+SE;EAAqC,gBAAA;AZq+SvC;;AYr+SE;EAAqC,gBAAA;AZy+SvC;;AYz+SE;EAAqC,gBAAA;AZ6+SvC;;AY7+SE;EAAqC,gBAAA;AZi/SvC;;AYj/SE;EAAqC,gBAAA;AZq/SvC;;AYr/SE;EAAqC,gBAAA;AZy/SvC;;AYz/SE;EAAqC,gBAAA;AZ6/SvC;;AY7/SE;EAAqC,gBAAA;AZigTvC;;AYjgTE;EAAqC,gBAAA;AZqgTvC;;AYrgTE;EAAqC,gBAAA;AZygTvC;;AYzgTE;EAAqC,gBAAA;AZ6gTvC;;AY7gTE;EAAqC,gBAAA;AZihTvC;;AYjhTE;EAAqC,gBAAA;AZqhTvC;;AYrhTE;EAAqC,gBAAA;AZyhTvC;;AYzhTE;EAAqC,gBAAA;AZ6hTvC;;AY7hTE;EAAqC,gBAAA;AZiiTvC;;AYjiTE;EAAqC,gBAAA;AZqiTvC;;AYriTE;EAAqC,gBAAA;AZyiTvC;;AYziTE;EAAqC,gBAAA;AZ6iTvC;;AY7iTE;EAAqC,gBAAA;AZijTvC;;AYjjTE;EAAqC,gBAAA;AZqjTvC;;AYrjTE;EAAqC,gBAAA;AZyjTvC;;AYzjTE;EAAqC,gBAAA;AZ6jTvC;;AY7jTE;EAAqC,gBAAA;AZikTvC;;AYjkTE;EAAqC,gBAAA;AZqkTvC;;AYrkTE;EAAqC,gBAAA;AZykTvC;;AYzkTE;EAAqC,gBAAA;AZ6kTvC;;AY7kTE;EAAqC,gBAAA;AZilTvC;;AYjlTE;EAAqC,gBAAA;AZqlTvC;;AYrlTE;EAAqC,gBAAA;AZylTvC;;AYzlTE;EAAqC,gBAAA;AZ6lTvC;;AY7lTE;EAAqC,gBAAA;AZimTvC;;AYjmTE;EAAqC,gBAAA;AZqmTvC;;AYrmTE;EAAqC,gBAAA;AZymTvC;;AYzmTE;EAAqC,gBAAA;AZ6mTvC;;AY7mTE;EAAqC,gBAAA;AZinTvC;;AYjnTE;EAAqC,gBAAA;AZqnTvC;;AYrnTE;EAAqC,gBAAA;AZynTvC;;AYznTE;EAAqC,gBAAA;AZ6nTvC;;AY7nTE;EAAqC,gBAAA;AZioTvC;;AYjoTE;EAAqC,gBAAA;AZqoTvC;;AYroTE;EAAqC,gBAAA;AZyoTvC;;AYzoTE;EAAqC,gBAAA;AZ6oTvC;;AY7oTE;EAAqC,gBAAA;AZipTvC;;AYjpTE;EAAqC,gBAAA;AZqpTvC;;AYrpTE;EAAqC,gBAAA;AZypTvC;;AYzpTE;EAAqC,gBAAA;AZ6pTvC;;AY7pTE;EAAqC,gBAAA;AZiqTvC;;AYjqTE;EAAqC,gBAAA;AZqqTvC;;AYrqTE;EAAqC,gBAAA;AZyqTvC;;AYzqTE;EAAqC,gBAAA;AZ6qTvC;;AY7qTE;EAAqC,gBAAA;AZirTvC;;AYjrTE;EAAqC,gBAAA;AZqrTvC;;AYrrTE;EAAqC,gBAAA;AZyrTvC;;AYzrTE;EAAqC,gBAAA;AZ6rTvC;;AY7rTE;EAAqC,gBAAA;AZisTvC;;AYjsTE;EAAqC,gBAAA;AZqsTvC;;AYrsTE;EAAqC,gBAAA;AZysTvC;;AYzsTE;EAAqC,gBAAA;AZ6sTvC;;AY7sTE;EAAqC,gBAAA;AZitTvC;;AYjtTE;EAAqC,gBAAA;AZqtTvC;;AYrtTE;EAAqC,gBAAA;AZytTvC;;AYztTE;EAAqC,gBAAA;AZ6tTvC;;AY7tTE;EAAqC,gBAAA;AZiuTvC;;AYjuTE;EAAqC,gBAAA;AZquTvC;;AYruTE;EAAqC,gBAAA;AZyuTvC;;AYzuTE;EAAqC,gBAAA;AZ6uTvC;;AY7uTE;EAAqC,gBAAA;AZivTvC;;AYjvTE;EAAqC,gBAAA;AZqvTvC;;AYrvTE;EAAqC,gBAAA;AZyvTvC;;AYzvTE;EAAqC,gBAAA;AZ6vTvC;;AY7vTE;EAAqC,gBAAA;AZiwTvC;;AYjwTE;EAAqC,gBAAA;AZqwTvC;;AYrwTE;EAAqC,gBAAA;AZywTvC;;AYzwTE;EAAqC,gBAAA;AZ6wTvC;;AY7wTE;EAAqC,gBAAA;AZixTvC;;AYjxTE;EAAqC,gBAAA;AZqxTvC;;AYrxTE;EAAqC,gBAAA;AZyxTvC;;AYzxTE;EAAqC,gBAAA;AZ6xTvC;;AY7xTE;EAAqC,gBAAA;AZiyTvC;;AYjyTE;EAAqC,gBAAA;AZqyTvC;;AYryTE;EAAqC,gBAAA;AZyyTvC;;AYzyTE;EAAqC,gBAAA;AZ6yTvC;;AY7yTE;EAAqC,gBAAA;AZizTvC;;AYjzTE;EAAqC,gBAAA;AZqzTvC;;AYrzTE;EAAqC,gBAAA;AZyzTvC;;AYzzTE;EAAqC,gBAAA;AZ6zTvC;;AY7zTE;EAAqC,gBAAA;AZi0TvC;;AYj0TE;EAAqC,gBAAA;AZq0TvC;;AYr0TE;EAAqC,gBAAA;AZy0TvC;;AYz0TE;EAAqC,gBAAA;AZ60TvC;;AY70TE;EAAqC,gBAAA;AZi1TvC;;AYj1TE;EAAqC,gBAAA;AZq1TvC;;AYr1TE;EAAqC,gBAAA;AZy1TvC;;AYz1TE;EAAqC,gBAAA;AZ61TvC;;AY71TE;EAAqC,gBAAA;AZi2TvC;;AYj2TE;EAAqC,gBAAA;AZq2TvC;;AYr2TE;EAAqC,gBAAA;AZy2TvC;;AYz2TE;EAAqC,gBAAA;AZ62TvC;;AY72TE;EAAqC,gBAAA;AZi3TvC;;AYj3TE;EAAqC,gBAAA;AZq3TvC;;AYr3TE;EAAqC,gBAAA;AZy3TvC;;AYz3TE;EAAqC,gBAAA;AZ63TvC;;AY73TE;EAAqC,gBAAA;AZi4TvC;;AYj4TE;EAAqC,gBAAA;AZq4TvC;;AYr4TE;EAAqC,gBAAA;AZy4TvC;;AYz4TE;EAAqC,gBAAA;AZ64TvC;;AY74TE;EAAqC,gBAAA;AZi5TvC;;AYj5TE;EAAqC,gBAAA;AZq5TvC;;AYr5TE;EAAqC,gBAAA;AZy5TvC;;AYz5TE;EAAqC,gBAAA;AZ65TvC;;AY75TE;EAAqC,gBAAA;AZi6TvC;;AYj6TE;EAAqC,gBAAA;AZq6TvC;;AYr6TE;EAAqC,gBAAA;AZy6TvC;;AYz6TE;EAAqC,gBAAA;AZ66TvC;;AY76TE;EAAqC,gBAAA;AZi7TvC;;AYj7TE;EAAqC,gBAAA;AZq7TvC;;AYr7TE;EAAqC,gBAAA;AZy7TvC;;AYz7TE;EAAqC,gBAAA;AZ67TvC;;AY77TE;EAAqC,gBAAA;AZi8TvC;;AYj8TE;EAAqC,gBAAA;AZq8TvC;;AYr8TE;EAAqC,gBAAA;AZy8TvC;;AYz8TE;EAAqC,gBAAA;AZ68TvC;;AY78TE;EAAqC,gBAAA;AZi9TvC;;AYj9TE;EAAqC,gBAAA;AZq9TvC;;AYr9TE;EAAqC,gBAAA;AZy9TvC;;AYz9TE;EAAqC,gBAAA;AZ69TvC;;AY79TE;EAAqC,gBAAA;AZi+TvC;;AYj+TE;EAAqC,gBAAA;AZq+TvC;;AYr+TE;EAAqC,gBAAA;AZy+TvC;;AYz+TE;EAAqC,gBAAA;AZ6+TvC;;AY7+TE;EAAqC,gBAAA;AZi/TvC;;AYj/TE;EAAqC,gBAAA;AZq/TvC;;AYr/TE;EAAqC,gBAAA;AZy/TvC;;AYz/TE;EAAqC,gBAAA;AZ6/TvC;;AY7/TE;EAAqC,gBAAA;AZigUvC;;AYjgUE;EAAqC,gBAAA;AZqgUvC;;AYrgUE;EAAqC,gBAAA;AZygUvC;;AYzgUE;EAAqC,gBAAA;AZ6gUvC;;AY7gUE;EAAqC,gBAAA;AZihUvC;;AYjhUE;EAAqC,gBAAA;AZqhUvC;;AYrhUE;EAAqC,gBAAA;AZyhUvC;;AYzhUE;EAAqC,gBAAA;AZ6hUvC;;AY7hUE;EAAqC,gBAAA;AZiiUvC;;AYjiUE;EAAqC,gBAAA;AZqiUvC;;AYriUE;EAAqC,gBAAA;AZyiUvC;;AYziUE;EAAqC,gBAAA;AZ6iUvC;;AY7iUE;EAAqC,gBAAA;AZijUvC;;AYjjUE;EAAqC,gBAAA;AZqjUvC;;AYrjUE;EAAqC,gBAAA;AZyjUvC;;AYzjUE;EAAqC,gBAAA;AZ6jUvC;;AY7jUE;EAAqC,gBAAA;AZikUvC;;AYjkUE;EAAqC,gBAAA;AZqkUvC;;AYrkUE;EAAqC,gBAAA;AZykUvC;;AYzkUE;EAAqC,gBAAA;AZ6kUvC;;AY7kUE;EAAqC,gBAAA;AZilUvC;;AYjlUE;EAAqC,gBAAA;AZqlUvC;;AajnUA;;;;EAAA;AAQA;EACE,gDAAA;EACA,uDAAA;AbinUF;;Aa9mUA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBT8BwB;ES7BxB,wHAAA;AbinUF;Aa7mUA;;EAEE,gBAAA;Ab+mUF","sourcesContent":["/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.#{$fa-css-prefix},\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-sharp,\n.fas,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular,\n.fab,\n.#{$fa-css-prefix}-brands {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n.fas,\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular {\n  font-family: 'Font Awesome 6 Free';\n}\n\n.fab,\n.#{$fa-css-prefix}-brands {\n  font-family: 'Font Awesome 6 Brands';\n}\n\n\n%fa-icon {\n  @include fa-icon;\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n.fa {\n  font-family: var(--fa-style-family, \"Font Awesome 6 Free\");\n  font-weight: var(--fa-style, 900);\n}\n\n.fa,\n.fa-classic,\n.fa-sharp,\n.fas,\n.fa-solid,\n.far,\n.fa-regular,\n.fab,\n.fa-brands {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--fa-display, inline-block);\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n.fas,\n.fa-classic,\n.fa-solid,\n.far,\n.fa-regular {\n  font-family: \"Font Awesome 6 Free\";\n}\n\n.fab,\n.fa-brands {\n  font-family: \"Font Awesome 6 Brands\";\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.fa-0::before {\n  content: \"\\30 \";\n}\n\n.fa-1::before {\n  content: \"\\31 \";\n}\n\n.fa-2::before {\n  content: \"\\32 \";\n}\n\n.fa-3::before {\n  content: \"\\33 \";\n}\n\n.fa-4::before {\n  content: \"\\34 \";\n}\n\n.fa-5::before {\n  content: \"\\35 \";\n}\n\n.fa-6::before {\n  content: \"\\36 \";\n}\n\n.fa-7::before {\n  content: \"\\37 \";\n}\n\n.fa-8::before {\n  content: \"\\38 \";\n}\n\n.fa-9::before {\n  content: \"\\39 \";\n}\n\n.fa-fill-drip::before {\n  content: \"\\f576\";\n}\n\n.fa-arrows-to-circle::before {\n  content: \"\\e4bd\";\n}\n\n.fa-circle-chevron-right::before {\n  content: \"\\f138\";\n}\n\n.fa-chevron-circle-right::before {\n  content: \"\\f138\";\n}\n\n.fa-at::before {\n  content: \"\\@\";\n}\n\n.fa-trash-can::before {\n  content: \"\\f2ed\";\n}\n\n.fa-trash-alt::before {\n  content: \"\\f2ed\";\n}\n\n.fa-text-height::before {\n  content: \"\\f034\";\n}\n\n.fa-user-xmark::before {\n  content: \"\\f235\";\n}\n\n.fa-user-times::before {\n  content: \"\\f235\";\n}\n\n.fa-stethoscope::before {\n  content: \"\\f0f1\";\n}\n\n.fa-message::before {\n  content: \"\\f27a\";\n}\n\n.fa-comment-alt::before {\n  content: \"\\f27a\";\n}\n\n.fa-info::before {\n  content: \"\\f129\";\n}\n\n.fa-down-left-and-up-right-to-center::before {\n  content: \"\\f422\";\n}\n\n.fa-compress-alt::before {\n  content: \"\\f422\";\n}\n\n.fa-explosion::before {\n  content: \"\\e4e9\";\n}\n\n.fa-file-lines::before {\n  content: \"\\f15c\";\n}\n\n.fa-file-alt::before {\n  content: \"\\f15c\";\n}\n\n.fa-file-text::before {\n  content: \"\\f15c\";\n}\n\n.fa-wave-square::before {\n  content: \"\\f83e\";\n}\n\n.fa-ring::before {\n  content: \"\\f70b\";\n}\n\n.fa-building-un::before {\n  content: \"\\e4d9\";\n}\n\n.fa-dice-three::before {\n  content: \"\\f527\";\n}\n\n.fa-calendar-days::before {\n  content: \"\\f073\";\n}\n\n.fa-calendar-alt::before {\n  content: \"\\f073\";\n}\n\n.fa-anchor-circle-check::before {\n  content: \"\\e4aa\";\n}\n\n.fa-building-circle-arrow-right::before {\n  content: \"\\e4d1\";\n}\n\n.fa-volleyball::before {\n  content: \"\\f45f\";\n}\n\n.fa-volleyball-ball::before {\n  content: \"\\f45f\";\n}\n\n.fa-arrows-up-to-line::before {\n  content: \"\\e4c2\";\n}\n\n.fa-sort-down::before {\n  content: \"\\f0dd\";\n}\n\n.fa-sort-desc::before {\n  content: \"\\f0dd\";\n}\n\n.fa-circle-minus::before {\n  content: \"\\f056\";\n}\n\n.fa-minus-circle::before {\n  content: \"\\f056\";\n}\n\n.fa-door-open::before {\n  content: \"\\f52b\";\n}\n\n.fa-right-from-bracket::before {\n  content: \"\\f2f5\";\n}\n\n.fa-sign-out-alt::before {\n  content: \"\\f2f5\";\n}\n\n.fa-atom::before {\n  content: \"\\f5d2\";\n}\n\n.fa-soap::before {\n  content: \"\\e06e\";\n}\n\n.fa-icons::before {\n  content: \"\\f86d\";\n}\n\n.fa-heart-music-camera-bolt::before {\n  content: \"\\f86d\";\n}\n\n.fa-microphone-lines-slash::before {\n  content: \"\\f539\";\n}\n\n.fa-microphone-alt-slash::before {\n  content: \"\\f539\";\n}\n\n.fa-bridge-circle-check::before {\n  content: \"\\e4c9\";\n}\n\n.fa-pump-medical::before {\n  content: \"\\e06a\";\n}\n\n.fa-fingerprint::before {\n  content: \"\\f577\";\n}\n\n.fa-hand-point-right::before {\n  content: \"\\f0a4\";\n}\n\n.fa-magnifying-glass-location::before {\n  content: \"\\f689\";\n}\n\n.fa-search-location::before {\n  content: \"\\f689\";\n}\n\n.fa-forward-step::before {\n  content: \"\\f051\";\n}\n\n.fa-step-forward::before {\n  content: \"\\f051\";\n}\n\n.fa-face-smile-beam::before {\n  content: \"\\f5b8\";\n}\n\n.fa-smile-beam::before {\n  content: \"\\f5b8\";\n}\n\n.fa-flag-checkered::before {\n  content: \"\\f11e\";\n}\n\n.fa-football::before {\n  content: \"\\f44e\";\n}\n\n.fa-football-ball::before {\n  content: \"\\f44e\";\n}\n\n.fa-school-circle-exclamation::before {\n  content: \"\\e56c\";\n}\n\n.fa-crop::before {\n  content: \"\\f125\";\n}\n\n.fa-angles-down::before {\n  content: \"\\f103\";\n}\n\n.fa-angle-double-down::before {\n  content: \"\\f103\";\n}\n\n.fa-users-rectangle::before {\n  content: \"\\e594\";\n}\n\n.fa-people-roof::before {\n  content: \"\\e537\";\n}\n\n.fa-people-line::before {\n  content: \"\\e534\";\n}\n\n.fa-beer-mug-empty::before {\n  content: \"\\f0fc\";\n}\n\n.fa-beer::before {\n  content: \"\\f0fc\";\n}\n\n.fa-diagram-predecessor::before {\n  content: \"\\e477\";\n}\n\n.fa-arrow-up-long::before {\n  content: \"\\f176\";\n}\n\n.fa-long-arrow-up::before {\n  content: \"\\f176\";\n}\n\n.fa-fire-flame-simple::before {\n  content: \"\\f46a\";\n}\n\n.fa-burn::before {\n  content: \"\\f46a\";\n}\n\n.fa-person::before {\n  content: \"\\f183\";\n}\n\n.fa-male::before {\n  content: \"\\f183\";\n}\n\n.fa-laptop::before {\n  content: \"\\f109\";\n}\n\n.fa-file-csv::before {\n  content: \"\\f6dd\";\n}\n\n.fa-menorah::before {\n  content: \"\\f676\";\n}\n\n.fa-truck-plane::before {\n  content: \"\\e58f\";\n}\n\n.fa-record-vinyl::before {\n  content: \"\\f8d9\";\n}\n\n.fa-face-grin-stars::before {\n  content: \"\\f587\";\n}\n\n.fa-grin-stars::before {\n  content: \"\\f587\";\n}\n\n.fa-bong::before {\n  content: \"\\f55c\";\n}\n\n.fa-spaghetti-monster-flying::before {\n  content: \"\\f67b\";\n}\n\n.fa-pastafarianism::before {\n  content: \"\\f67b\";\n}\n\n.fa-arrow-down-up-across-line::before {\n  content: \"\\e4af\";\n}\n\n.fa-spoon::before {\n  content: \"\\f2e5\";\n}\n\n.fa-utensil-spoon::before {\n  content: \"\\f2e5\";\n}\n\n.fa-jar-wheat::before {\n  content: \"\\e517\";\n}\n\n.fa-envelopes-bulk::before {\n  content: \"\\f674\";\n}\n\n.fa-mail-bulk::before {\n  content: \"\\f674\";\n}\n\n.fa-file-circle-exclamation::before {\n  content: \"\\e4eb\";\n}\n\n.fa-circle-h::before {\n  content: \"\\f47e\";\n}\n\n.fa-hospital-symbol::before {\n  content: \"\\f47e\";\n}\n\n.fa-pager::before {\n  content: \"\\f815\";\n}\n\n.fa-address-book::before {\n  content: \"\\f2b9\";\n}\n\n.fa-contact-book::before {\n  content: \"\\f2b9\";\n}\n\n.fa-strikethrough::before {\n  content: \"\\f0cc\";\n}\n\n.fa-k::before {\n  content: \"K\";\n}\n\n.fa-landmark-flag::before {\n  content: \"\\e51c\";\n}\n\n.fa-pencil::before {\n  content: \"\\f303\";\n}\n\n.fa-pencil-alt::before {\n  content: \"\\f303\";\n}\n\n.fa-backward::before {\n  content: \"\\f04a\";\n}\n\n.fa-caret-right::before {\n  content: \"\\f0da\";\n}\n\n.fa-comments::before {\n  content: \"\\f086\";\n}\n\n.fa-paste::before {\n  content: \"\\f0ea\";\n}\n\n.fa-file-clipboard::before {\n  content: \"\\f0ea\";\n}\n\n.fa-code-pull-request::before {\n  content: \"\\e13c\";\n}\n\n.fa-clipboard-list::before {\n  content: \"\\f46d\";\n}\n\n.fa-truck-ramp-box::before {\n  content: \"\\f4de\";\n}\n\n.fa-truck-loading::before {\n  content: \"\\f4de\";\n}\n\n.fa-user-check::before {\n  content: \"\\f4fc\";\n}\n\n.fa-vial-virus::before {\n  content: \"\\e597\";\n}\n\n.fa-sheet-plastic::before {\n  content: \"\\e571\";\n}\n\n.fa-blog::before {\n  content: \"\\f781\";\n}\n\n.fa-user-ninja::before {\n  content: \"\\f504\";\n}\n\n.fa-person-arrow-up-from-line::before {\n  content: \"\\e539\";\n}\n\n.fa-scroll-torah::before {\n  content: \"\\f6a0\";\n}\n\n.fa-torah::before {\n  content: \"\\f6a0\";\n}\n\n.fa-broom-ball::before {\n  content: \"\\f458\";\n}\n\n.fa-quidditch::before {\n  content: \"\\f458\";\n}\n\n.fa-quidditch-broom-ball::before {\n  content: \"\\f458\";\n}\n\n.fa-toggle-off::before {\n  content: \"\\f204\";\n}\n\n.fa-box-archive::before {\n  content: \"\\f187\";\n}\n\n.fa-archive::before {\n  content: \"\\f187\";\n}\n\n.fa-person-drowning::before {\n  content: \"\\e545\";\n}\n\n.fa-arrow-down-9-1::before {\n  content: \"\\f886\";\n}\n\n.fa-sort-numeric-desc::before {\n  content: \"\\f886\";\n}\n\n.fa-sort-numeric-down-alt::before {\n  content: \"\\f886\";\n}\n\n.fa-face-grin-tongue-squint::before {\n  content: \"\\f58a\";\n}\n\n.fa-grin-tongue-squint::before {\n  content: \"\\f58a\";\n}\n\n.fa-spray-can::before {\n  content: \"\\f5bd\";\n}\n\n.fa-truck-monster::before {\n  content: \"\\f63b\";\n}\n\n.fa-w::before {\n  content: \"W\";\n}\n\n.fa-earth-africa::before {\n  content: \"\\f57c\";\n}\n\n.fa-globe-africa::before {\n  content: \"\\f57c\";\n}\n\n.fa-rainbow::before {\n  content: \"\\f75b\";\n}\n\n.fa-circle-notch::before {\n  content: \"\\f1ce\";\n}\n\n.fa-tablet-screen-button::before {\n  content: \"\\f3fa\";\n}\n\n.fa-tablet-alt::before {\n  content: \"\\f3fa\";\n}\n\n.fa-paw::before {\n  content: \"\\f1b0\";\n}\n\n.fa-cloud::before {\n  content: \"\\f0c2\";\n}\n\n.fa-trowel-bricks::before {\n  content: \"\\e58a\";\n}\n\n.fa-face-flushed::before {\n  content: \"\\f579\";\n}\n\n.fa-flushed::before {\n  content: \"\\f579\";\n}\n\n.fa-hospital-user::before {\n  content: \"\\f80d\";\n}\n\n.fa-tent-arrow-left-right::before {\n  content: \"\\e57f\";\n}\n\n.fa-gavel::before {\n  content: \"\\f0e3\";\n}\n\n.fa-legal::before {\n  content: \"\\f0e3\";\n}\n\n.fa-binoculars::before {\n  content: \"\\f1e5\";\n}\n\n.fa-microphone-slash::before {\n  content: \"\\f131\";\n}\n\n.fa-box-tissue::before {\n  content: \"\\e05b\";\n}\n\n.fa-motorcycle::before {\n  content: \"\\f21c\";\n}\n\n.fa-bell-concierge::before {\n  content: \"\\f562\";\n}\n\n.fa-concierge-bell::before {\n  content: \"\\f562\";\n}\n\n.fa-pen-ruler::before {\n  content: \"\\f5ae\";\n}\n\n.fa-pencil-ruler::before {\n  content: \"\\f5ae\";\n}\n\n.fa-people-arrows::before {\n  content: \"\\e068\";\n}\n\n.fa-people-arrows-left-right::before {\n  content: \"\\e068\";\n}\n\n.fa-mars-and-venus-burst::before {\n  content: \"\\e523\";\n}\n\n.fa-square-caret-right::before {\n  content: \"\\f152\";\n}\n\n.fa-caret-square-right::before {\n  content: \"\\f152\";\n}\n\n.fa-scissors::before {\n  content: \"\\f0c4\";\n}\n\n.fa-cut::before {\n  content: \"\\f0c4\";\n}\n\n.fa-sun-plant-wilt::before {\n  content: \"\\e57a\";\n}\n\n.fa-toilets-portable::before {\n  content: \"\\e584\";\n}\n\n.fa-hockey-puck::before {\n  content: \"\\f453\";\n}\n\n.fa-table::before {\n  content: \"\\f0ce\";\n}\n\n.fa-magnifying-glass-arrow-right::before {\n  content: \"\\e521\";\n}\n\n.fa-tachograph-digital::before {\n  content: \"\\f566\";\n}\n\n.fa-digital-tachograph::before {\n  content: \"\\f566\";\n}\n\n.fa-users-slash::before {\n  content: \"\\e073\";\n}\n\n.fa-clover::before {\n  content: \"\\e139\";\n}\n\n.fa-reply::before {\n  content: \"\\f3e5\";\n}\n\n.fa-mail-reply::before {\n  content: \"\\f3e5\";\n}\n\n.fa-star-and-crescent::before {\n  content: \"\\f699\";\n}\n\n.fa-house-fire::before {\n  content: \"\\e50c\";\n}\n\n.fa-square-minus::before {\n  content: \"\\f146\";\n}\n\n.fa-minus-square::before {\n  content: \"\\f146\";\n}\n\n.fa-helicopter::before {\n  content: \"\\f533\";\n}\n\n.fa-compass::before {\n  content: \"\\f14e\";\n}\n\n.fa-square-caret-down::before {\n  content: \"\\f150\";\n}\n\n.fa-caret-square-down::before {\n  content: \"\\f150\";\n}\n\n.fa-file-circle-question::before {\n  content: \"\\e4ef\";\n}\n\n.fa-laptop-code::before {\n  content: \"\\f5fc\";\n}\n\n.fa-swatchbook::before {\n  content: \"\\f5c3\";\n}\n\n.fa-prescription-bottle::before {\n  content: \"\\f485\";\n}\n\n.fa-bars::before {\n  content: \"\\f0c9\";\n}\n\n.fa-navicon::before {\n  content: \"\\f0c9\";\n}\n\n.fa-people-group::before {\n  content: \"\\e533\";\n}\n\n.fa-hourglass-end::before {\n  content: \"\\f253\";\n}\n\n.fa-hourglass-3::before {\n  content: \"\\f253\";\n}\n\n.fa-heart-crack::before {\n  content: \"\\f7a9\";\n}\n\n.fa-heart-broken::before {\n  content: \"\\f7a9\";\n}\n\n.fa-square-up-right::before {\n  content: \"\\f360\";\n}\n\n.fa-external-link-square-alt::before {\n  content: \"\\f360\";\n}\n\n.fa-face-kiss-beam::before {\n  content: \"\\f597\";\n}\n\n.fa-kiss-beam::before {\n  content: \"\\f597\";\n}\n\n.fa-film::before {\n  content: \"\\f008\";\n}\n\n.fa-ruler-horizontal::before {\n  content: \"\\f547\";\n}\n\n.fa-people-robbery::before {\n  content: \"\\e536\";\n}\n\n.fa-lightbulb::before {\n  content: \"\\f0eb\";\n}\n\n.fa-caret-left::before {\n  content: \"\\f0d9\";\n}\n\n.fa-circle-exclamation::before {\n  content: \"\\f06a\";\n}\n\n.fa-exclamation-circle::before {\n  content: \"\\f06a\";\n}\n\n.fa-school-circle-xmark::before {\n  content: \"\\e56d\";\n}\n\n.fa-arrow-right-from-bracket::before {\n  content: \"\\f08b\";\n}\n\n.fa-sign-out::before {\n  content: \"\\f08b\";\n}\n\n.fa-circle-chevron-down::before {\n  content: \"\\f13a\";\n}\n\n.fa-chevron-circle-down::before {\n  content: \"\\f13a\";\n}\n\n.fa-unlock-keyhole::before {\n  content: \"\\f13e\";\n}\n\n.fa-unlock-alt::before {\n  content: \"\\f13e\";\n}\n\n.fa-cloud-showers-heavy::before {\n  content: \"\\f740\";\n}\n\n.fa-headphones-simple::before {\n  content: \"\\f58f\";\n}\n\n.fa-headphones-alt::before {\n  content: \"\\f58f\";\n}\n\n.fa-sitemap::before {\n  content: \"\\f0e8\";\n}\n\n.fa-circle-dollar-to-slot::before {\n  content: \"\\f4b9\";\n}\n\n.fa-donate::before {\n  content: \"\\f4b9\";\n}\n\n.fa-memory::before {\n  content: \"\\f538\";\n}\n\n.fa-road-spikes::before {\n  content: \"\\e568\";\n}\n\n.fa-fire-burner::before {\n  content: \"\\e4f1\";\n}\n\n.fa-flag::before {\n  content: \"\\f024\";\n}\n\n.fa-hanukiah::before {\n  content: \"\\f6e6\";\n}\n\n.fa-feather::before {\n  content: \"\\f52d\";\n}\n\n.fa-volume-low::before {\n  content: \"\\f027\";\n}\n\n.fa-volume-down::before {\n  content: \"\\f027\";\n}\n\n.fa-comment-slash::before {\n  content: \"\\f4b3\";\n}\n\n.fa-cloud-sun-rain::before {\n  content: \"\\f743\";\n}\n\n.fa-compress::before {\n  content: \"\\f066\";\n}\n\n.fa-wheat-awn::before {\n  content: \"\\e2cd\";\n}\n\n.fa-wheat-alt::before {\n  content: \"\\e2cd\";\n}\n\n.fa-ankh::before {\n  content: \"\\f644\";\n}\n\n.fa-hands-holding-child::before {\n  content: \"\\e4fa\";\n}\n\n.fa-asterisk::before {\n  content: \"\\*\";\n}\n\n.fa-square-check::before {\n  content: \"\\f14a\";\n}\n\n.fa-check-square::before {\n  content: \"\\f14a\";\n}\n\n.fa-peseta-sign::before {\n  content: \"\\e221\";\n}\n\n.fa-heading::before {\n  content: \"\\f1dc\";\n}\n\n.fa-header::before {\n  content: \"\\f1dc\";\n}\n\n.fa-ghost::before {\n  content: \"\\f6e2\";\n}\n\n.fa-list::before {\n  content: \"\\f03a\";\n}\n\n.fa-list-squares::before {\n  content: \"\\f03a\";\n}\n\n.fa-square-phone-flip::before {\n  content: \"\\f87b\";\n}\n\n.fa-phone-square-alt::before {\n  content: \"\\f87b\";\n}\n\n.fa-cart-plus::before {\n  content: \"\\f217\";\n}\n\n.fa-gamepad::before {\n  content: \"\\f11b\";\n}\n\n.fa-circle-dot::before {\n  content: \"\\f192\";\n}\n\n.fa-dot-circle::before {\n  content: \"\\f192\";\n}\n\n.fa-face-dizzy::before {\n  content: \"\\f567\";\n}\n\n.fa-dizzy::before {\n  content: \"\\f567\";\n}\n\n.fa-egg::before {\n  content: \"\\f7fb\";\n}\n\n.fa-house-medical-circle-xmark::before {\n  content: \"\\e513\";\n}\n\n.fa-campground::before {\n  content: \"\\f6bb\";\n}\n\n.fa-folder-plus::before {\n  content: \"\\f65e\";\n}\n\n.fa-futbol::before {\n  content: \"\\f1e3\";\n}\n\n.fa-futbol-ball::before {\n  content: \"\\f1e3\";\n}\n\n.fa-soccer-ball::before {\n  content: \"\\f1e3\";\n}\n\n.fa-paintbrush::before {\n  content: \"\\f1fc\";\n}\n\n.fa-paint-brush::before {\n  content: \"\\f1fc\";\n}\n\n.fa-lock::before {\n  content: \"\\f023\";\n}\n\n.fa-gas-pump::before {\n  content: \"\\f52f\";\n}\n\n.fa-hot-tub-person::before {\n  content: \"\\f593\";\n}\n\n.fa-hot-tub::before {\n  content: \"\\f593\";\n}\n\n.fa-map-location::before {\n  content: \"\\f59f\";\n}\n\n.fa-map-marked::before {\n  content: \"\\f59f\";\n}\n\n.fa-house-flood-water::before {\n  content: \"\\e50e\";\n}\n\n.fa-tree::before {\n  content: \"\\f1bb\";\n}\n\n.fa-bridge-lock::before {\n  content: \"\\e4cc\";\n}\n\n.fa-sack-dollar::before {\n  content: \"\\f81d\";\n}\n\n.fa-pen-to-square::before {\n  content: \"\\f044\";\n}\n\n.fa-edit::before {\n  content: \"\\f044\";\n}\n\n.fa-car-side::before {\n  content: \"\\f5e4\";\n}\n\n.fa-share-nodes::before {\n  content: \"\\f1e0\";\n}\n\n.fa-share-alt::before {\n  content: \"\\f1e0\";\n}\n\n.fa-heart-circle-minus::before {\n  content: \"\\e4ff\";\n}\n\n.fa-hourglass-half::before {\n  content: \"\\f252\";\n}\n\n.fa-hourglass-2::before {\n  content: \"\\f252\";\n}\n\n.fa-microscope::before {\n  content: \"\\f610\";\n}\n\n.fa-sink::before {\n  content: \"\\e06d\";\n}\n\n.fa-bag-shopping::before {\n  content: \"\\f290\";\n}\n\n.fa-shopping-bag::before {\n  content: \"\\f290\";\n}\n\n.fa-arrow-down-z-a::before {\n  content: \"\\f881\";\n}\n\n.fa-sort-alpha-desc::before {\n  content: \"\\f881\";\n}\n\n.fa-sort-alpha-down-alt::before {\n  content: \"\\f881\";\n}\n\n.fa-mitten::before {\n  content: \"\\f7b5\";\n}\n\n.fa-person-rays::before {\n  content: \"\\e54d\";\n}\n\n.fa-users::before {\n  content: \"\\f0c0\";\n}\n\n.fa-eye-slash::before {\n  content: \"\\f070\";\n}\n\n.fa-flask-vial::before {\n  content: \"\\e4f3\";\n}\n\n.fa-hand::before {\n  content: \"\\f256\";\n}\n\n.fa-hand-paper::before {\n  content: \"\\f256\";\n}\n\n.fa-om::before {\n  content: \"\\f679\";\n}\n\n.fa-worm::before {\n  content: \"\\e599\";\n}\n\n.fa-house-circle-xmark::before {\n  content: \"\\e50b\";\n}\n\n.fa-plug::before {\n  content: \"\\f1e6\";\n}\n\n.fa-chevron-up::before {\n  content: \"\\f077\";\n}\n\n.fa-hand-spock::before {\n  content: \"\\f259\";\n}\n\n.fa-stopwatch::before {\n  content: \"\\f2f2\";\n}\n\n.fa-face-kiss::before {\n  content: \"\\f596\";\n}\n\n.fa-kiss::before {\n  content: \"\\f596\";\n}\n\n.fa-bridge-circle-xmark::before {\n  content: \"\\e4cb\";\n}\n\n.fa-face-grin-tongue::before {\n  content: \"\\f589\";\n}\n\n.fa-grin-tongue::before {\n  content: \"\\f589\";\n}\n\n.fa-chess-bishop::before {\n  content: \"\\f43a\";\n}\n\n.fa-face-grin-wink::before {\n  content: \"\\f58c\";\n}\n\n.fa-grin-wink::before {\n  content: \"\\f58c\";\n}\n\n.fa-ear-deaf::before {\n  content: \"\\f2a4\";\n}\n\n.fa-deaf::before {\n  content: \"\\f2a4\";\n}\n\n.fa-deafness::before {\n  content: \"\\f2a4\";\n}\n\n.fa-hard-of-hearing::before {\n  content: \"\\f2a4\";\n}\n\n.fa-road-circle-check::before {\n  content: \"\\e564\";\n}\n\n.fa-dice-five::before {\n  content: \"\\f523\";\n}\n\n.fa-square-rss::before {\n  content: \"\\f143\";\n}\n\n.fa-rss-square::before {\n  content: \"\\f143\";\n}\n\n.fa-land-mine-on::before {\n  content: \"\\e51b\";\n}\n\n.fa-i-cursor::before {\n  content: \"\\f246\";\n}\n\n.fa-stamp::before {\n  content: \"\\f5bf\";\n}\n\n.fa-stairs::before {\n  content: \"\\e289\";\n}\n\n.fa-i::before {\n  content: \"I\";\n}\n\n.fa-hryvnia-sign::before {\n  content: \"\\f6f2\";\n}\n\n.fa-hryvnia::before {\n  content: \"\\f6f2\";\n}\n\n.fa-pills::before {\n  content: \"\\f484\";\n}\n\n.fa-face-grin-wide::before {\n  content: \"\\f581\";\n}\n\n.fa-grin-alt::before {\n  content: \"\\f581\";\n}\n\n.fa-tooth::before {\n  content: \"\\f5c9\";\n}\n\n.fa-v::before {\n  content: \"V\";\n}\n\n.fa-bangladeshi-taka-sign::before {\n  content: \"\\e2e6\";\n}\n\n.fa-bicycle::before {\n  content: \"\\f206\";\n}\n\n.fa-staff-snake::before {\n  content: \"\\e579\";\n}\n\n.fa-rod-asclepius::before {\n  content: \"\\e579\";\n}\n\n.fa-rod-snake::before {\n  content: \"\\e579\";\n}\n\n.fa-staff-aesculapius::before {\n  content: \"\\e579\";\n}\n\n.fa-head-side-cough-slash::before {\n  content: \"\\e062\";\n}\n\n.fa-truck-medical::before {\n  content: \"\\f0f9\";\n}\n\n.fa-ambulance::before {\n  content: \"\\f0f9\";\n}\n\n.fa-wheat-awn-circle-exclamation::before {\n  content: \"\\e598\";\n}\n\n.fa-snowman::before {\n  content: \"\\f7d0\";\n}\n\n.fa-mortar-pestle::before {\n  content: \"\\f5a7\";\n}\n\n.fa-road-barrier::before {\n  content: \"\\e562\";\n}\n\n.fa-school::before {\n  content: \"\\f549\";\n}\n\n.fa-igloo::before {\n  content: \"\\f7ae\";\n}\n\n.fa-joint::before {\n  content: \"\\f595\";\n}\n\n.fa-angle-right::before {\n  content: \"\\f105\";\n}\n\n.fa-horse::before {\n  content: \"\\f6f0\";\n}\n\n.fa-q::before {\n  content: \"Q\";\n}\n\n.fa-g::before {\n  content: \"G\";\n}\n\n.fa-notes-medical::before {\n  content: \"\\f481\";\n}\n\n.fa-temperature-half::before {\n  content: \"\\f2c9\";\n}\n\n.fa-temperature-2::before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-2::before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-half::before {\n  content: \"\\f2c9\";\n}\n\n.fa-dong-sign::before {\n  content: \"\\e169\";\n}\n\n.fa-capsules::before {\n  content: \"\\f46b\";\n}\n\n.fa-poo-storm::before {\n  content: \"\\f75a\";\n}\n\n.fa-poo-bolt::before {\n  content: \"\\f75a\";\n}\n\n.fa-face-frown-open::before {\n  content: \"\\f57a\";\n}\n\n.fa-frown-open::before {\n  content: \"\\f57a\";\n}\n\n.fa-hand-point-up::before {\n  content: \"\\f0a6\";\n}\n\n.fa-money-bill::before {\n  content: \"\\f0d6\";\n}\n\n.fa-bookmark::before {\n  content: \"\\f02e\";\n}\n\n.fa-align-justify::before {\n  content: \"\\f039\";\n}\n\n.fa-umbrella-beach::before {\n  content: \"\\f5ca\";\n}\n\n.fa-helmet-un::before {\n  content: \"\\e503\";\n}\n\n.fa-bullseye::before {\n  content: \"\\f140\";\n}\n\n.fa-bacon::before {\n  content: \"\\f7e5\";\n}\n\n.fa-hand-point-down::before {\n  content: \"\\f0a7\";\n}\n\n.fa-arrow-up-from-bracket::before {\n  content: \"\\e09a\";\n}\n\n.fa-folder::before {\n  content: \"\\f07b\";\n}\n\n.fa-folder-blank::before {\n  content: \"\\f07b\";\n}\n\n.fa-file-waveform::before {\n  content: \"\\f478\";\n}\n\n.fa-file-medical-alt::before {\n  content: \"\\f478\";\n}\n\n.fa-radiation::before {\n  content: \"\\f7b9\";\n}\n\n.fa-chart-simple::before {\n  content: \"\\e473\";\n}\n\n.fa-mars-stroke::before {\n  content: \"\\f229\";\n}\n\n.fa-vial::before {\n  content: \"\\f492\";\n}\n\n.fa-gauge::before {\n  content: \"\\f624\";\n}\n\n.fa-dashboard::before {\n  content: \"\\f624\";\n}\n\n.fa-gauge-med::before {\n  content: \"\\f624\";\n}\n\n.fa-tachometer-alt-average::before {\n  content: \"\\f624\";\n}\n\n.fa-wand-magic-sparkles::before {\n  content: \"\\e2ca\";\n}\n\n.fa-magic-wand-sparkles::before {\n  content: \"\\e2ca\";\n}\n\n.fa-e::before {\n  content: \"E\";\n}\n\n.fa-pen-clip::before {\n  content: \"\\f305\";\n}\n\n.fa-pen-alt::before {\n  content: \"\\f305\";\n}\n\n.fa-bridge-circle-exclamation::before {\n  content: \"\\e4ca\";\n}\n\n.fa-user::before {\n  content: \"\\f007\";\n}\n\n.fa-school-circle-check::before {\n  content: \"\\e56b\";\n}\n\n.fa-dumpster::before {\n  content: \"\\f793\";\n}\n\n.fa-van-shuttle::before {\n  content: \"\\f5b6\";\n}\n\n.fa-shuttle-van::before {\n  content: \"\\f5b6\";\n}\n\n.fa-building-user::before {\n  content: \"\\e4da\";\n}\n\n.fa-square-caret-left::before {\n  content: \"\\f191\";\n}\n\n.fa-caret-square-left::before {\n  content: \"\\f191\";\n}\n\n.fa-highlighter::before {\n  content: \"\\f591\";\n}\n\n.fa-key::before {\n  content: \"\\f084\";\n}\n\n.fa-bullhorn::before {\n  content: \"\\f0a1\";\n}\n\n.fa-globe::before {\n  content: \"\\f0ac\";\n}\n\n.fa-synagogue::before {\n  content: \"\\f69b\";\n}\n\n.fa-person-half-dress::before {\n  content: \"\\e548\";\n}\n\n.fa-road-bridge::before {\n  content: \"\\e563\";\n}\n\n.fa-location-arrow::before {\n  content: \"\\f124\";\n}\n\n.fa-c::before {\n  content: \"C\";\n}\n\n.fa-tablet-button::before {\n  content: \"\\f10a\";\n}\n\n.fa-building-lock::before {\n  content: \"\\e4d6\";\n}\n\n.fa-pizza-slice::before {\n  content: \"\\f818\";\n}\n\n.fa-money-bill-wave::before {\n  content: \"\\f53a\";\n}\n\n.fa-chart-area::before {\n  content: \"\\f1fe\";\n}\n\n.fa-area-chart::before {\n  content: \"\\f1fe\";\n}\n\n.fa-house-flag::before {\n  content: \"\\e50d\";\n}\n\n.fa-person-circle-minus::before {\n  content: \"\\e540\";\n}\n\n.fa-ban::before {\n  content: \"\\f05e\";\n}\n\n.fa-cancel::before {\n  content: \"\\f05e\";\n}\n\n.fa-camera-rotate::before {\n  content: \"\\e0d8\";\n}\n\n.fa-spray-can-sparkles::before {\n  content: \"\\f5d0\";\n}\n\n.fa-air-freshener::before {\n  content: \"\\f5d0\";\n}\n\n.fa-star::before {\n  content: \"\\f005\";\n}\n\n.fa-repeat::before {\n  content: \"\\f363\";\n}\n\n.fa-cross::before {\n  content: \"\\f654\";\n}\n\n.fa-box::before {\n  content: \"\\f466\";\n}\n\n.fa-venus-mars::before {\n  content: \"\\f228\";\n}\n\n.fa-arrow-pointer::before {\n  content: \"\\f245\";\n}\n\n.fa-mouse-pointer::before {\n  content: \"\\f245\";\n}\n\n.fa-maximize::before {\n  content: \"\\f31e\";\n}\n\n.fa-expand-arrows-alt::before {\n  content: \"\\f31e\";\n}\n\n.fa-charging-station::before {\n  content: \"\\f5e7\";\n}\n\n.fa-shapes::before {\n  content: \"\\f61f\";\n}\n\n.fa-triangle-circle-square::before {\n  content: \"\\f61f\";\n}\n\n.fa-shuffle::before {\n  content: \"\\f074\";\n}\n\n.fa-random::before {\n  content: \"\\f074\";\n}\n\n.fa-person-running::before {\n  content: \"\\f70c\";\n}\n\n.fa-running::before {\n  content: \"\\f70c\";\n}\n\n.fa-mobile-retro::before {\n  content: \"\\e527\";\n}\n\n.fa-grip-lines-vertical::before {\n  content: \"\\f7a5\";\n}\n\n.fa-spider::before {\n  content: \"\\f717\";\n}\n\n.fa-hands-bound::before {\n  content: \"\\e4f9\";\n}\n\n.fa-file-invoice-dollar::before {\n  content: \"\\f571\";\n}\n\n.fa-plane-circle-exclamation::before {\n  content: \"\\e556\";\n}\n\n.fa-x-ray::before {\n  content: \"\\f497\";\n}\n\n.fa-spell-check::before {\n  content: \"\\f891\";\n}\n\n.fa-slash::before {\n  content: \"\\f715\";\n}\n\n.fa-computer-mouse::before {\n  content: \"\\f8cc\";\n}\n\n.fa-mouse::before {\n  content: \"\\f8cc\";\n}\n\n.fa-arrow-right-to-bracket::before {\n  content: \"\\f090\";\n}\n\n.fa-sign-in::before {\n  content: \"\\f090\";\n}\n\n.fa-shop-slash::before {\n  content: \"\\e070\";\n}\n\n.fa-store-alt-slash::before {\n  content: \"\\e070\";\n}\n\n.fa-server::before {\n  content: \"\\f233\";\n}\n\n.fa-virus-covid-slash::before {\n  content: \"\\e4a9\";\n}\n\n.fa-shop-lock::before {\n  content: \"\\e4a5\";\n}\n\n.fa-hourglass-start::before {\n  content: \"\\f251\";\n}\n\n.fa-hourglass-1::before {\n  content: \"\\f251\";\n}\n\n.fa-blender-phone::before {\n  content: \"\\f6b6\";\n}\n\n.fa-building-wheat::before {\n  content: \"\\e4db\";\n}\n\n.fa-person-breastfeeding::before {\n  content: \"\\e53a\";\n}\n\n.fa-right-to-bracket::before {\n  content: \"\\f2f6\";\n}\n\n.fa-sign-in-alt::before {\n  content: \"\\f2f6\";\n}\n\n.fa-venus::before {\n  content: \"\\f221\";\n}\n\n.fa-passport::before {\n  content: \"\\f5ab\";\n}\n\n.fa-heart-pulse::before {\n  content: \"\\f21e\";\n}\n\n.fa-heartbeat::before {\n  content: \"\\f21e\";\n}\n\n.fa-people-carry-box::before {\n  content: \"\\f4ce\";\n}\n\n.fa-people-carry::before {\n  content: \"\\f4ce\";\n}\n\n.fa-temperature-high::before {\n  content: \"\\f769\";\n}\n\n.fa-microchip::before {\n  content: \"\\f2db\";\n}\n\n.fa-crown::before {\n  content: \"\\f521\";\n}\n\n.fa-weight-hanging::before {\n  content: \"\\f5cd\";\n}\n\n.fa-xmarks-lines::before {\n  content: \"\\e59a\";\n}\n\n.fa-file-prescription::before {\n  content: \"\\f572\";\n}\n\n.fa-weight-scale::before {\n  content: \"\\f496\";\n}\n\n.fa-weight::before {\n  content: \"\\f496\";\n}\n\n.fa-user-group::before {\n  content: \"\\f500\";\n}\n\n.fa-user-friends::before {\n  content: \"\\f500\";\n}\n\n.fa-arrow-up-a-z::before {\n  content: \"\\f15e\";\n}\n\n.fa-sort-alpha-up::before {\n  content: \"\\f15e\";\n}\n\n.fa-chess-knight::before {\n  content: \"\\f441\";\n}\n\n.fa-face-laugh-squint::before {\n  content: \"\\f59b\";\n}\n\n.fa-laugh-squint::before {\n  content: \"\\f59b\";\n}\n\n.fa-wheelchair::before {\n  content: \"\\f193\";\n}\n\n.fa-circle-arrow-up::before {\n  content: \"\\f0aa\";\n}\n\n.fa-arrow-circle-up::before {\n  content: \"\\f0aa\";\n}\n\n.fa-toggle-on::before {\n  content: \"\\f205\";\n}\n\n.fa-person-walking::before {\n  content: \"\\f554\";\n}\n\n.fa-walking::before {\n  content: \"\\f554\";\n}\n\n.fa-l::before {\n  content: \"L\";\n}\n\n.fa-fire::before {\n  content: \"\\f06d\";\n}\n\n.fa-bed-pulse::before {\n  content: \"\\f487\";\n}\n\n.fa-procedures::before {\n  content: \"\\f487\";\n}\n\n.fa-shuttle-space::before {\n  content: \"\\f197\";\n}\n\n.fa-space-shuttle::before {\n  content: \"\\f197\";\n}\n\n.fa-face-laugh::before {\n  content: \"\\f599\";\n}\n\n.fa-laugh::before {\n  content: \"\\f599\";\n}\n\n.fa-folder-open::before {\n  content: \"\\f07c\";\n}\n\n.fa-heart-circle-plus::before {\n  content: \"\\e500\";\n}\n\n.fa-code-fork::before {\n  content: \"\\e13b\";\n}\n\n.fa-city::before {\n  content: \"\\f64f\";\n}\n\n.fa-microphone-lines::before {\n  content: \"\\f3c9\";\n}\n\n.fa-microphone-alt::before {\n  content: \"\\f3c9\";\n}\n\n.fa-pepper-hot::before {\n  content: \"\\f816\";\n}\n\n.fa-unlock::before {\n  content: \"\\f09c\";\n}\n\n.fa-colon-sign::before {\n  content: \"\\e140\";\n}\n\n.fa-headset::before {\n  content: \"\\f590\";\n}\n\n.fa-store-slash::before {\n  content: \"\\e071\";\n}\n\n.fa-road-circle-xmark::before {\n  content: \"\\e566\";\n}\n\n.fa-user-minus::before {\n  content: \"\\f503\";\n}\n\n.fa-mars-stroke-up::before {\n  content: \"\\f22a\";\n}\n\n.fa-mars-stroke-v::before {\n  content: \"\\f22a\";\n}\n\n.fa-champagne-glasses::before {\n  content: \"\\f79f\";\n}\n\n.fa-glass-cheers::before {\n  content: \"\\f79f\";\n}\n\n.fa-clipboard::before {\n  content: \"\\f328\";\n}\n\n.fa-house-circle-exclamation::before {\n  content: \"\\e50a\";\n}\n\n.fa-file-arrow-up::before {\n  content: \"\\f574\";\n}\n\n.fa-file-upload::before {\n  content: \"\\f574\";\n}\n\n.fa-wifi::before {\n  content: \"\\f1eb\";\n}\n\n.fa-wifi-3::before {\n  content: \"\\f1eb\";\n}\n\n.fa-wifi-strong::before {\n  content: \"\\f1eb\";\n}\n\n.fa-bath::before {\n  content: \"\\f2cd\";\n}\n\n.fa-bathtub::before {\n  content: \"\\f2cd\";\n}\n\n.fa-underline::before {\n  content: \"\\f0cd\";\n}\n\n.fa-user-pen::before {\n  content: \"\\f4ff\";\n}\n\n.fa-user-edit::before {\n  content: \"\\f4ff\";\n}\n\n.fa-signature::before {\n  content: \"\\f5b7\";\n}\n\n.fa-stroopwafel::before {\n  content: \"\\f551\";\n}\n\n.fa-bold::before {\n  content: \"\\f032\";\n}\n\n.fa-anchor-lock::before {\n  content: \"\\e4ad\";\n}\n\n.fa-building-ngo::before {\n  content: \"\\e4d7\";\n}\n\n.fa-manat-sign::before {\n  content: \"\\e1d5\";\n}\n\n.fa-not-equal::before {\n  content: \"\\f53e\";\n}\n\n.fa-border-top-left::before {\n  content: \"\\f853\";\n}\n\n.fa-border-style::before {\n  content: \"\\f853\";\n}\n\n.fa-map-location-dot::before {\n  content: \"\\f5a0\";\n}\n\n.fa-map-marked-alt::before {\n  content: \"\\f5a0\";\n}\n\n.fa-jedi::before {\n  content: \"\\f669\";\n}\n\n.fa-square-poll-vertical::before {\n  content: \"\\f681\";\n}\n\n.fa-poll::before {\n  content: \"\\f681\";\n}\n\n.fa-mug-hot::before {\n  content: \"\\f7b6\";\n}\n\n.fa-car-battery::before {\n  content: \"\\f5df\";\n}\n\n.fa-battery-car::before {\n  content: \"\\f5df\";\n}\n\n.fa-gift::before {\n  content: \"\\f06b\";\n}\n\n.fa-dice-two::before {\n  content: \"\\f528\";\n}\n\n.fa-chess-queen::before {\n  content: \"\\f445\";\n}\n\n.fa-glasses::before {\n  content: \"\\f530\";\n}\n\n.fa-chess-board::before {\n  content: \"\\f43c\";\n}\n\n.fa-building-circle-check::before {\n  content: \"\\e4d2\";\n}\n\n.fa-person-chalkboard::before {\n  content: \"\\e53d\";\n}\n\n.fa-mars-stroke-right::before {\n  content: \"\\f22b\";\n}\n\n.fa-mars-stroke-h::before {\n  content: \"\\f22b\";\n}\n\n.fa-hand-back-fist::before {\n  content: \"\\f255\";\n}\n\n.fa-hand-rock::before {\n  content: \"\\f255\";\n}\n\n.fa-square-caret-up::before {\n  content: \"\\f151\";\n}\n\n.fa-caret-square-up::before {\n  content: \"\\f151\";\n}\n\n.fa-cloud-showers-water::before {\n  content: \"\\e4e4\";\n}\n\n.fa-chart-bar::before {\n  content: \"\\f080\";\n}\n\n.fa-bar-chart::before {\n  content: \"\\f080\";\n}\n\n.fa-hands-bubbles::before {\n  content: \"\\e05e\";\n}\n\n.fa-hands-wash::before {\n  content: \"\\e05e\";\n}\n\n.fa-less-than-equal::before {\n  content: \"\\f537\";\n}\n\n.fa-train::before {\n  content: \"\\f238\";\n}\n\n.fa-eye-low-vision::before {\n  content: \"\\f2a8\";\n}\n\n.fa-low-vision::before {\n  content: \"\\f2a8\";\n}\n\n.fa-crow::before {\n  content: \"\\f520\";\n}\n\n.fa-sailboat::before {\n  content: \"\\e445\";\n}\n\n.fa-window-restore::before {\n  content: \"\\f2d2\";\n}\n\n.fa-square-plus::before {\n  content: \"\\f0fe\";\n}\n\n.fa-plus-square::before {\n  content: \"\\f0fe\";\n}\n\n.fa-torii-gate::before {\n  content: \"\\f6a1\";\n}\n\n.fa-frog::before {\n  content: \"\\f52e\";\n}\n\n.fa-bucket::before {\n  content: \"\\e4cf\";\n}\n\n.fa-image::before {\n  content: \"\\f03e\";\n}\n\n.fa-microphone::before {\n  content: \"\\f130\";\n}\n\n.fa-cow::before {\n  content: \"\\f6c8\";\n}\n\n.fa-caret-up::before {\n  content: \"\\f0d8\";\n}\n\n.fa-screwdriver::before {\n  content: \"\\f54a\";\n}\n\n.fa-folder-closed::before {\n  content: \"\\e185\";\n}\n\n.fa-house-tsunami::before {\n  content: \"\\e515\";\n}\n\n.fa-square-nfi::before {\n  content: \"\\e576\";\n}\n\n.fa-arrow-up-from-ground-water::before {\n  content: \"\\e4b5\";\n}\n\n.fa-martini-glass::before {\n  content: \"\\f57b\";\n}\n\n.fa-glass-martini-alt::before {\n  content: \"\\f57b\";\n}\n\n.fa-rotate-left::before {\n  content: \"\\f2ea\";\n}\n\n.fa-rotate-back::before {\n  content: \"\\f2ea\";\n}\n\n.fa-rotate-backward::before {\n  content: \"\\f2ea\";\n}\n\n.fa-undo-alt::before {\n  content: \"\\f2ea\";\n}\n\n.fa-table-columns::before {\n  content: \"\\f0db\";\n}\n\n.fa-columns::before {\n  content: \"\\f0db\";\n}\n\n.fa-lemon::before {\n  content: \"\\f094\";\n}\n\n.fa-head-side-mask::before {\n  content: \"\\e063\";\n}\n\n.fa-handshake::before {\n  content: \"\\f2b5\";\n}\n\n.fa-gem::before {\n  content: \"\\f3a5\";\n}\n\n.fa-dolly::before {\n  content: \"\\f472\";\n}\n\n.fa-dolly-box::before {\n  content: \"\\f472\";\n}\n\n.fa-smoking::before {\n  content: \"\\f48d\";\n}\n\n.fa-minimize::before {\n  content: \"\\f78c\";\n}\n\n.fa-compress-arrows-alt::before {\n  content: \"\\f78c\";\n}\n\n.fa-monument::before {\n  content: \"\\f5a6\";\n}\n\n.fa-snowplow::before {\n  content: \"\\f7d2\";\n}\n\n.fa-angles-right::before {\n  content: \"\\f101\";\n}\n\n.fa-angle-double-right::before {\n  content: \"\\f101\";\n}\n\n.fa-cannabis::before {\n  content: \"\\f55f\";\n}\n\n.fa-circle-play::before {\n  content: \"\\f144\";\n}\n\n.fa-play-circle::before {\n  content: \"\\f144\";\n}\n\n.fa-tablets::before {\n  content: \"\\f490\";\n}\n\n.fa-ethernet::before {\n  content: \"\\f796\";\n}\n\n.fa-euro-sign::before {\n  content: \"\\f153\";\n}\n\n.fa-eur::before {\n  content: \"\\f153\";\n}\n\n.fa-euro::before {\n  content: \"\\f153\";\n}\n\n.fa-chair::before {\n  content: \"\\f6c0\";\n}\n\n.fa-circle-check::before {\n  content: \"\\f058\";\n}\n\n.fa-check-circle::before {\n  content: \"\\f058\";\n}\n\n.fa-circle-stop::before {\n  content: \"\\f28d\";\n}\n\n.fa-stop-circle::before {\n  content: \"\\f28d\";\n}\n\n.fa-compass-drafting::before {\n  content: \"\\f568\";\n}\n\n.fa-drafting-compass::before {\n  content: \"\\f568\";\n}\n\n.fa-plate-wheat::before {\n  content: \"\\e55a\";\n}\n\n.fa-icicles::before {\n  content: \"\\f7ad\";\n}\n\n.fa-person-shelter::before {\n  content: \"\\e54f\";\n}\n\n.fa-neuter::before {\n  content: \"\\f22c\";\n}\n\n.fa-id-badge::before {\n  content: \"\\f2c1\";\n}\n\n.fa-marker::before {\n  content: \"\\f5a1\";\n}\n\n.fa-face-laugh-beam::before {\n  content: \"\\f59a\";\n}\n\n.fa-laugh-beam::before {\n  content: \"\\f59a\";\n}\n\n.fa-helicopter-symbol::before {\n  content: \"\\e502\";\n}\n\n.fa-universal-access::before {\n  content: \"\\f29a\";\n}\n\n.fa-circle-chevron-up::before {\n  content: \"\\f139\";\n}\n\n.fa-chevron-circle-up::before {\n  content: \"\\f139\";\n}\n\n.fa-lari-sign::before {\n  content: \"\\e1c8\";\n}\n\n.fa-volcano::before {\n  content: \"\\f770\";\n}\n\n.fa-person-walking-dashed-line-arrow-right::before {\n  content: \"\\e553\";\n}\n\n.fa-sterling-sign::before {\n  content: \"\\f154\";\n}\n\n.fa-gbp::before {\n  content: \"\\f154\";\n}\n\n.fa-pound-sign::before {\n  content: \"\\f154\";\n}\n\n.fa-viruses::before {\n  content: \"\\e076\";\n}\n\n.fa-square-person-confined::before {\n  content: \"\\e577\";\n}\n\n.fa-user-tie::before {\n  content: \"\\f508\";\n}\n\n.fa-arrow-down-long::before {\n  content: \"\\f175\";\n}\n\n.fa-long-arrow-down::before {\n  content: \"\\f175\";\n}\n\n.fa-tent-arrow-down-to-line::before {\n  content: \"\\e57e\";\n}\n\n.fa-certificate::before {\n  content: \"\\f0a3\";\n}\n\n.fa-reply-all::before {\n  content: \"\\f122\";\n}\n\n.fa-mail-reply-all::before {\n  content: \"\\f122\";\n}\n\n.fa-suitcase::before {\n  content: \"\\f0f2\";\n}\n\n.fa-person-skating::before {\n  content: \"\\f7c5\";\n}\n\n.fa-skating::before {\n  content: \"\\f7c5\";\n}\n\n.fa-filter-circle-dollar::before {\n  content: \"\\f662\";\n}\n\n.fa-funnel-dollar::before {\n  content: \"\\f662\";\n}\n\n.fa-camera-retro::before {\n  content: \"\\f083\";\n}\n\n.fa-circle-arrow-down::before {\n  content: \"\\f0ab\";\n}\n\n.fa-arrow-circle-down::before {\n  content: \"\\f0ab\";\n}\n\n.fa-file-import::before {\n  content: \"\\f56f\";\n}\n\n.fa-arrow-right-to-file::before {\n  content: \"\\f56f\";\n}\n\n.fa-square-arrow-up-right::before {\n  content: \"\\f14c\";\n}\n\n.fa-external-link-square::before {\n  content: \"\\f14c\";\n}\n\n.fa-box-open::before {\n  content: \"\\f49e\";\n}\n\n.fa-scroll::before {\n  content: \"\\f70e\";\n}\n\n.fa-spa::before {\n  content: \"\\f5bb\";\n}\n\n.fa-location-pin-lock::before {\n  content: \"\\e51f\";\n}\n\n.fa-pause::before {\n  content: \"\\f04c\";\n}\n\n.fa-hill-avalanche::before {\n  content: \"\\e507\";\n}\n\n.fa-temperature-empty::before {\n  content: \"\\f2cb\";\n}\n\n.fa-temperature-0::before {\n  content: \"\\f2cb\";\n}\n\n.fa-thermometer-0::before {\n  content: \"\\f2cb\";\n}\n\n.fa-thermometer-empty::before {\n  content: \"\\f2cb\";\n}\n\n.fa-bomb::before {\n  content: \"\\f1e2\";\n}\n\n.fa-registered::before {\n  content: \"\\f25d\";\n}\n\n.fa-address-card::before {\n  content: \"\\f2bb\";\n}\n\n.fa-contact-card::before {\n  content: \"\\f2bb\";\n}\n\n.fa-vcard::before {\n  content: \"\\f2bb\";\n}\n\n.fa-scale-unbalanced-flip::before {\n  content: \"\\f516\";\n}\n\n.fa-balance-scale-right::before {\n  content: \"\\f516\";\n}\n\n.fa-subscript::before {\n  content: \"\\f12c\";\n}\n\n.fa-diamond-turn-right::before {\n  content: \"\\f5eb\";\n}\n\n.fa-directions::before {\n  content: \"\\f5eb\";\n}\n\n.fa-burst::before {\n  content: \"\\e4dc\";\n}\n\n.fa-house-laptop::before {\n  content: \"\\e066\";\n}\n\n.fa-laptop-house::before {\n  content: \"\\e066\";\n}\n\n.fa-face-tired::before {\n  content: \"\\f5c8\";\n}\n\n.fa-tired::before {\n  content: \"\\f5c8\";\n}\n\n.fa-money-bills::before {\n  content: \"\\e1f3\";\n}\n\n.fa-smog::before {\n  content: \"\\f75f\";\n}\n\n.fa-crutch::before {\n  content: \"\\f7f7\";\n}\n\n.fa-cloud-arrow-up::before {\n  content: \"\\f0ee\";\n}\n\n.fa-cloud-upload::before {\n  content: \"\\f0ee\";\n}\n\n.fa-cloud-upload-alt::before {\n  content: \"\\f0ee\";\n}\n\n.fa-palette::before {\n  content: \"\\f53f\";\n}\n\n.fa-arrows-turn-right::before {\n  content: \"\\e4c0\";\n}\n\n.fa-vest::before {\n  content: \"\\e085\";\n}\n\n.fa-ferry::before {\n  content: \"\\e4ea\";\n}\n\n.fa-arrows-down-to-people::before {\n  content: \"\\e4b9\";\n}\n\n.fa-seedling::before {\n  content: \"\\f4d8\";\n}\n\n.fa-sprout::before {\n  content: \"\\f4d8\";\n}\n\n.fa-left-right::before {\n  content: \"\\f337\";\n}\n\n.fa-arrows-alt-h::before {\n  content: \"\\f337\";\n}\n\n.fa-boxes-packing::before {\n  content: \"\\e4c7\";\n}\n\n.fa-circle-arrow-left::before {\n  content: \"\\f0a8\";\n}\n\n.fa-arrow-circle-left::before {\n  content: \"\\f0a8\";\n}\n\n.fa-group-arrows-rotate::before {\n  content: \"\\e4f6\";\n}\n\n.fa-bowl-food::before {\n  content: \"\\e4c6\";\n}\n\n.fa-candy-cane::before {\n  content: \"\\f786\";\n}\n\n.fa-arrow-down-wide-short::before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-asc::before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-down::before {\n  content: \"\\f160\";\n}\n\n.fa-cloud-bolt::before {\n  content: \"\\f76c\";\n}\n\n.fa-thunderstorm::before {\n  content: \"\\f76c\";\n}\n\n.fa-text-slash::before {\n  content: \"\\f87d\";\n}\n\n.fa-remove-format::before {\n  content: \"\\f87d\";\n}\n\n.fa-face-smile-wink::before {\n  content: \"\\f4da\";\n}\n\n.fa-smile-wink::before {\n  content: \"\\f4da\";\n}\n\n.fa-file-word::before {\n  content: \"\\f1c2\";\n}\n\n.fa-file-powerpoint::before {\n  content: \"\\f1c4\";\n}\n\n.fa-arrows-left-right::before {\n  content: \"\\f07e\";\n}\n\n.fa-arrows-h::before {\n  content: \"\\f07e\";\n}\n\n.fa-house-lock::before {\n  content: \"\\e510\";\n}\n\n.fa-cloud-arrow-down::before {\n  content: \"\\f0ed\";\n}\n\n.fa-cloud-download::before {\n  content: \"\\f0ed\";\n}\n\n.fa-cloud-download-alt::before {\n  content: \"\\f0ed\";\n}\n\n.fa-children::before {\n  content: \"\\e4e1\";\n}\n\n.fa-chalkboard::before {\n  content: \"\\f51b\";\n}\n\n.fa-blackboard::before {\n  content: \"\\f51b\";\n}\n\n.fa-user-large-slash::before {\n  content: \"\\f4fa\";\n}\n\n.fa-user-alt-slash::before {\n  content: \"\\f4fa\";\n}\n\n.fa-envelope-open::before {\n  content: \"\\f2b6\";\n}\n\n.fa-handshake-simple-slash::before {\n  content: \"\\e05f\";\n}\n\n.fa-handshake-alt-slash::before {\n  content: \"\\e05f\";\n}\n\n.fa-mattress-pillow::before {\n  content: \"\\e525\";\n}\n\n.fa-guarani-sign::before {\n  content: \"\\e19a\";\n}\n\n.fa-arrows-rotate::before {\n  content: \"\\f021\";\n}\n\n.fa-refresh::before {\n  content: \"\\f021\";\n}\n\n.fa-sync::before {\n  content: \"\\f021\";\n}\n\n.fa-fire-extinguisher::before {\n  content: \"\\f134\";\n}\n\n.fa-cruzeiro-sign::before {\n  content: \"\\e152\";\n}\n\n.fa-greater-than-equal::before {\n  content: \"\\f532\";\n}\n\n.fa-shield-halved::before {\n  content: \"\\f3ed\";\n}\n\n.fa-shield-alt::before {\n  content: \"\\f3ed\";\n}\n\n.fa-book-atlas::before {\n  content: \"\\f558\";\n}\n\n.fa-atlas::before {\n  content: \"\\f558\";\n}\n\n.fa-virus::before {\n  content: \"\\e074\";\n}\n\n.fa-envelope-circle-check::before {\n  content: \"\\e4e8\";\n}\n\n.fa-layer-group::before {\n  content: \"\\f5fd\";\n}\n\n.fa-arrows-to-dot::before {\n  content: \"\\e4be\";\n}\n\n.fa-archway::before {\n  content: \"\\f557\";\n}\n\n.fa-heart-circle-check::before {\n  content: \"\\e4fd\";\n}\n\n.fa-house-chimney-crack::before {\n  content: \"\\f6f1\";\n}\n\n.fa-house-damage::before {\n  content: \"\\f6f1\";\n}\n\n.fa-file-zipper::before {\n  content: \"\\f1c6\";\n}\n\n.fa-file-archive::before {\n  content: \"\\f1c6\";\n}\n\n.fa-square::before {\n  content: \"\\f0c8\";\n}\n\n.fa-martini-glass-empty::before {\n  content: \"\\f000\";\n}\n\n.fa-glass-martini::before {\n  content: \"\\f000\";\n}\n\n.fa-couch::before {\n  content: \"\\f4b8\";\n}\n\n.fa-cedi-sign::before {\n  content: \"\\e0df\";\n}\n\n.fa-italic::before {\n  content: \"\\f033\";\n}\n\n.fa-table-cells-column-lock::before {\n  content: \"\\e678\";\n}\n\n.fa-church::before {\n  content: \"\\f51d\";\n}\n\n.fa-comments-dollar::before {\n  content: \"\\f653\";\n}\n\n.fa-democrat::before {\n  content: \"\\f747\";\n}\n\n.fa-z::before {\n  content: \"Z\";\n}\n\n.fa-person-skiing::before {\n  content: \"\\f7c9\";\n}\n\n.fa-skiing::before {\n  content: \"\\f7c9\";\n}\n\n.fa-road-lock::before {\n  content: \"\\e567\";\n}\n\n.fa-a::before {\n  content: \"A\";\n}\n\n.fa-temperature-arrow-down::before {\n  content: \"\\e03f\";\n}\n\n.fa-temperature-down::before {\n  content: \"\\e03f\";\n}\n\n.fa-feather-pointed::before {\n  content: \"\\f56b\";\n}\n\n.fa-feather-alt::before {\n  content: \"\\f56b\";\n}\n\n.fa-p::before {\n  content: \"P\";\n}\n\n.fa-snowflake::before {\n  content: \"\\f2dc\";\n}\n\n.fa-newspaper::before {\n  content: \"\\f1ea\";\n}\n\n.fa-rectangle-ad::before {\n  content: \"\\f641\";\n}\n\n.fa-ad::before {\n  content: \"\\f641\";\n}\n\n.fa-circle-arrow-right::before {\n  content: \"\\f0a9\";\n}\n\n.fa-arrow-circle-right::before {\n  content: \"\\f0a9\";\n}\n\n.fa-filter-circle-xmark::before {\n  content: \"\\e17b\";\n}\n\n.fa-locust::before {\n  content: \"\\e520\";\n}\n\n.fa-sort::before {\n  content: \"\\f0dc\";\n}\n\n.fa-unsorted::before {\n  content: \"\\f0dc\";\n}\n\n.fa-list-ol::before {\n  content: \"\\f0cb\";\n}\n\n.fa-list-1-2::before {\n  content: \"\\f0cb\";\n}\n\n.fa-list-numeric::before {\n  content: \"\\f0cb\";\n}\n\n.fa-person-dress-burst::before {\n  content: \"\\e544\";\n}\n\n.fa-money-check-dollar::before {\n  content: \"\\f53d\";\n}\n\n.fa-money-check-alt::before {\n  content: \"\\f53d\";\n}\n\n.fa-vector-square::before {\n  content: \"\\f5cb\";\n}\n\n.fa-bread-slice::before {\n  content: \"\\f7ec\";\n}\n\n.fa-language::before {\n  content: \"\\f1ab\";\n}\n\n.fa-face-kiss-wink-heart::before {\n  content: \"\\f598\";\n}\n\n.fa-kiss-wink-heart::before {\n  content: \"\\f598\";\n}\n\n.fa-filter::before {\n  content: \"\\f0b0\";\n}\n\n.fa-question::before {\n  content: \"\\?\";\n}\n\n.fa-file-signature::before {\n  content: \"\\f573\";\n}\n\n.fa-up-down-left-right::before {\n  content: \"\\f0b2\";\n}\n\n.fa-arrows-alt::before {\n  content: \"\\f0b2\";\n}\n\n.fa-house-chimney-user::before {\n  content: \"\\e065\";\n}\n\n.fa-hand-holding-heart::before {\n  content: \"\\f4be\";\n}\n\n.fa-puzzle-piece::before {\n  content: \"\\f12e\";\n}\n\n.fa-money-check::before {\n  content: \"\\f53c\";\n}\n\n.fa-star-half-stroke::before {\n  content: \"\\f5c0\";\n}\n\n.fa-star-half-alt::before {\n  content: \"\\f5c0\";\n}\n\n.fa-code::before {\n  content: \"\\f121\";\n}\n\n.fa-whiskey-glass::before {\n  content: \"\\f7a0\";\n}\n\n.fa-glass-whiskey::before {\n  content: \"\\f7a0\";\n}\n\n.fa-building-circle-exclamation::before {\n  content: \"\\e4d3\";\n}\n\n.fa-magnifying-glass-chart::before {\n  content: \"\\e522\";\n}\n\n.fa-arrow-up-right-from-square::before {\n  content: \"\\f08e\";\n}\n\n.fa-external-link::before {\n  content: \"\\f08e\";\n}\n\n.fa-cubes-stacked::before {\n  content: \"\\e4e6\";\n}\n\n.fa-won-sign::before {\n  content: \"\\f159\";\n}\n\n.fa-krw::before {\n  content: \"\\f159\";\n}\n\n.fa-won::before {\n  content: \"\\f159\";\n}\n\n.fa-virus-covid::before {\n  content: \"\\e4a8\";\n}\n\n.fa-austral-sign::before {\n  content: \"\\e0a9\";\n}\n\n.fa-f::before {\n  content: \"F\";\n}\n\n.fa-leaf::before {\n  content: \"\\f06c\";\n}\n\n.fa-road::before {\n  content: \"\\f018\";\n}\n\n.fa-taxi::before {\n  content: \"\\f1ba\";\n}\n\n.fa-cab::before {\n  content: \"\\f1ba\";\n}\n\n.fa-person-circle-plus::before {\n  content: \"\\e541\";\n}\n\n.fa-chart-pie::before {\n  content: \"\\f200\";\n}\n\n.fa-pie-chart::before {\n  content: \"\\f200\";\n}\n\n.fa-bolt-lightning::before {\n  content: \"\\e0b7\";\n}\n\n.fa-sack-xmark::before {\n  content: \"\\e56a\";\n}\n\n.fa-file-excel::before {\n  content: \"\\f1c3\";\n}\n\n.fa-file-contract::before {\n  content: \"\\f56c\";\n}\n\n.fa-fish-fins::before {\n  content: \"\\e4f2\";\n}\n\n.fa-building-flag::before {\n  content: \"\\e4d5\";\n}\n\n.fa-face-grin-beam::before {\n  content: \"\\f582\";\n}\n\n.fa-grin-beam::before {\n  content: \"\\f582\";\n}\n\n.fa-object-ungroup::before {\n  content: \"\\f248\";\n}\n\n.fa-poop::before {\n  content: \"\\f619\";\n}\n\n.fa-location-pin::before {\n  content: \"\\f041\";\n}\n\n.fa-map-marker::before {\n  content: \"\\f041\";\n}\n\n.fa-kaaba::before {\n  content: \"\\f66b\";\n}\n\n.fa-toilet-paper::before {\n  content: \"\\f71e\";\n}\n\n.fa-helmet-safety::before {\n  content: \"\\f807\";\n}\n\n.fa-hard-hat::before {\n  content: \"\\f807\";\n}\n\n.fa-hat-hard::before {\n  content: \"\\f807\";\n}\n\n.fa-eject::before {\n  content: \"\\f052\";\n}\n\n.fa-circle-right::before {\n  content: \"\\f35a\";\n}\n\n.fa-arrow-alt-circle-right::before {\n  content: \"\\f35a\";\n}\n\n.fa-plane-circle-check::before {\n  content: \"\\e555\";\n}\n\n.fa-face-rolling-eyes::before {\n  content: \"\\f5a5\";\n}\n\n.fa-meh-rolling-eyes::before {\n  content: \"\\f5a5\";\n}\n\n.fa-object-group::before {\n  content: \"\\f247\";\n}\n\n.fa-chart-line::before {\n  content: \"\\f201\";\n}\n\n.fa-line-chart::before {\n  content: \"\\f201\";\n}\n\n.fa-mask-ventilator::before {\n  content: \"\\e524\";\n}\n\n.fa-arrow-right::before {\n  content: \"\\f061\";\n}\n\n.fa-signs-post::before {\n  content: \"\\f277\";\n}\n\n.fa-map-signs::before {\n  content: \"\\f277\";\n}\n\n.fa-cash-register::before {\n  content: \"\\f788\";\n}\n\n.fa-person-circle-question::before {\n  content: \"\\e542\";\n}\n\n.fa-h::before {\n  content: \"H\";\n}\n\n.fa-tarp::before {\n  content: \"\\e57b\";\n}\n\n.fa-screwdriver-wrench::before {\n  content: \"\\f7d9\";\n}\n\n.fa-tools::before {\n  content: \"\\f7d9\";\n}\n\n.fa-arrows-to-eye::before {\n  content: \"\\e4bf\";\n}\n\n.fa-plug-circle-bolt::before {\n  content: \"\\e55b\";\n}\n\n.fa-heart::before {\n  content: \"\\f004\";\n}\n\n.fa-mars-and-venus::before {\n  content: \"\\f224\";\n}\n\n.fa-house-user::before {\n  content: \"\\e1b0\";\n}\n\n.fa-home-user::before {\n  content: \"\\e1b0\";\n}\n\n.fa-dumpster-fire::before {\n  content: \"\\f794\";\n}\n\n.fa-house-crack::before {\n  content: \"\\e3b1\";\n}\n\n.fa-martini-glass-citrus::before {\n  content: \"\\f561\";\n}\n\n.fa-cocktail::before {\n  content: \"\\f561\";\n}\n\n.fa-face-surprise::before {\n  content: \"\\f5c2\";\n}\n\n.fa-surprise::before {\n  content: \"\\f5c2\";\n}\n\n.fa-bottle-water::before {\n  content: \"\\e4c5\";\n}\n\n.fa-circle-pause::before {\n  content: \"\\f28b\";\n}\n\n.fa-pause-circle::before {\n  content: \"\\f28b\";\n}\n\n.fa-toilet-paper-slash::before {\n  content: \"\\e072\";\n}\n\n.fa-apple-whole::before {\n  content: \"\\f5d1\";\n}\n\n.fa-apple-alt::before {\n  content: \"\\f5d1\";\n}\n\n.fa-kitchen-set::before {\n  content: \"\\e51a\";\n}\n\n.fa-r::before {\n  content: \"R\";\n}\n\n.fa-temperature-quarter::before {\n  content: \"\\f2ca\";\n}\n\n.fa-temperature-1::before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-1::before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-quarter::before {\n  content: \"\\f2ca\";\n}\n\n.fa-cube::before {\n  content: \"\\f1b2\";\n}\n\n.fa-bitcoin-sign::before {\n  content: \"\\e0b4\";\n}\n\n.fa-shield-dog::before {\n  content: \"\\e573\";\n}\n\n.fa-solar-panel::before {\n  content: \"\\f5ba\";\n}\n\n.fa-lock-open::before {\n  content: \"\\f3c1\";\n}\n\n.fa-elevator::before {\n  content: \"\\e16d\";\n}\n\n.fa-money-bill-transfer::before {\n  content: \"\\e528\";\n}\n\n.fa-money-bill-trend-up::before {\n  content: \"\\e529\";\n}\n\n.fa-house-flood-water-circle-arrow-right::before {\n  content: \"\\e50f\";\n}\n\n.fa-square-poll-horizontal::before {\n  content: \"\\f682\";\n}\n\n.fa-poll-h::before {\n  content: \"\\f682\";\n}\n\n.fa-circle::before {\n  content: \"\\f111\";\n}\n\n.fa-backward-fast::before {\n  content: \"\\f049\";\n}\n\n.fa-fast-backward::before {\n  content: \"\\f049\";\n}\n\n.fa-recycle::before {\n  content: \"\\f1b8\";\n}\n\n.fa-user-astronaut::before {\n  content: \"\\f4fb\";\n}\n\n.fa-plane-slash::before {\n  content: \"\\e069\";\n}\n\n.fa-trademark::before {\n  content: \"\\f25c\";\n}\n\n.fa-basketball::before {\n  content: \"\\f434\";\n}\n\n.fa-basketball-ball::before {\n  content: \"\\f434\";\n}\n\n.fa-satellite-dish::before {\n  content: \"\\f7c0\";\n}\n\n.fa-circle-up::before {\n  content: \"\\f35b\";\n}\n\n.fa-arrow-alt-circle-up::before {\n  content: \"\\f35b\";\n}\n\n.fa-mobile-screen-button::before {\n  content: \"\\f3cd\";\n}\n\n.fa-mobile-alt::before {\n  content: \"\\f3cd\";\n}\n\n.fa-volume-high::before {\n  content: \"\\f028\";\n}\n\n.fa-volume-up::before {\n  content: \"\\f028\";\n}\n\n.fa-users-rays::before {\n  content: \"\\e593\";\n}\n\n.fa-wallet::before {\n  content: \"\\f555\";\n}\n\n.fa-clipboard-check::before {\n  content: \"\\f46c\";\n}\n\n.fa-file-audio::before {\n  content: \"\\f1c7\";\n}\n\n.fa-burger::before {\n  content: \"\\f805\";\n}\n\n.fa-hamburger::before {\n  content: \"\\f805\";\n}\n\n.fa-wrench::before {\n  content: \"\\f0ad\";\n}\n\n.fa-bugs::before {\n  content: \"\\e4d0\";\n}\n\n.fa-rupee-sign::before {\n  content: \"\\f156\";\n}\n\n.fa-rupee::before {\n  content: \"\\f156\";\n}\n\n.fa-file-image::before {\n  content: \"\\f1c5\";\n}\n\n.fa-circle-question::before {\n  content: \"\\f059\";\n}\n\n.fa-question-circle::before {\n  content: \"\\f059\";\n}\n\n.fa-plane-departure::before {\n  content: \"\\f5b0\";\n}\n\n.fa-handshake-slash::before {\n  content: \"\\e060\";\n}\n\n.fa-book-bookmark::before {\n  content: \"\\e0bb\";\n}\n\n.fa-code-branch::before {\n  content: \"\\f126\";\n}\n\n.fa-hat-cowboy::before {\n  content: \"\\f8c0\";\n}\n\n.fa-bridge::before {\n  content: \"\\e4c8\";\n}\n\n.fa-phone-flip::before {\n  content: \"\\f879\";\n}\n\n.fa-phone-alt::before {\n  content: \"\\f879\";\n}\n\n.fa-truck-front::before {\n  content: \"\\e2b7\";\n}\n\n.fa-cat::before {\n  content: \"\\f6be\";\n}\n\n.fa-anchor-circle-exclamation::before {\n  content: \"\\e4ab\";\n}\n\n.fa-truck-field::before {\n  content: \"\\e58d\";\n}\n\n.fa-route::before {\n  content: \"\\f4d7\";\n}\n\n.fa-clipboard-question::before {\n  content: \"\\e4e3\";\n}\n\n.fa-panorama::before {\n  content: \"\\e209\";\n}\n\n.fa-comment-medical::before {\n  content: \"\\f7f5\";\n}\n\n.fa-teeth-open::before {\n  content: \"\\f62f\";\n}\n\n.fa-file-circle-minus::before {\n  content: \"\\e4ed\";\n}\n\n.fa-tags::before {\n  content: \"\\f02c\";\n}\n\n.fa-wine-glass::before {\n  content: \"\\f4e3\";\n}\n\n.fa-forward-fast::before {\n  content: \"\\f050\";\n}\n\n.fa-fast-forward::before {\n  content: \"\\f050\";\n}\n\n.fa-face-meh-blank::before {\n  content: \"\\f5a4\";\n}\n\n.fa-meh-blank::before {\n  content: \"\\f5a4\";\n}\n\n.fa-square-parking::before {\n  content: \"\\f540\";\n}\n\n.fa-parking::before {\n  content: \"\\f540\";\n}\n\n.fa-house-signal::before {\n  content: \"\\e012\";\n}\n\n.fa-bars-progress::before {\n  content: \"\\f828\";\n}\n\n.fa-tasks-alt::before {\n  content: \"\\f828\";\n}\n\n.fa-faucet-drip::before {\n  content: \"\\e006\";\n}\n\n.fa-cart-flatbed::before {\n  content: \"\\f474\";\n}\n\n.fa-dolly-flatbed::before {\n  content: \"\\f474\";\n}\n\n.fa-ban-smoking::before {\n  content: \"\\f54d\";\n}\n\n.fa-smoking-ban::before {\n  content: \"\\f54d\";\n}\n\n.fa-terminal::before {\n  content: \"\\f120\";\n}\n\n.fa-mobile-button::before {\n  content: \"\\f10b\";\n}\n\n.fa-house-medical-flag::before {\n  content: \"\\e514\";\n}\n\n.fa-basket-shopping::before {\n  content: \"\\f291\";\n}\n\n.fa-shopping-basket::before {\n  content: \"\\f291\";\n}\n\n.fa-tape::before {\n  content: \"\\f4db\";\n}\n\n.fa-bus-simple::before {\n  content: \"\\f55e\";\n}\n\n.fa-bus-alt::before {\n  content: \"\\f55e\";\n}\n\n.fa-eye::before {\n  content: \"\\f06e\";\n}\n\n.fa-face-sad-cry::before {\n  content: \"\\f5b3\";\n}\n\n.fa-sad-cry::before {\n  content: \"\\f5b3\";\n}\n\n.fa-audio-description::before {\n  content: \"\\f29e\";\n}\n\n.fa-person-military-to-person::before {\n  content: \"\\e54c\";\n}\n\n.fa-file-shield::before {\n  content: \"\\e4f0\";\n}\n\n.fa-user-slash::before {\n  content: \"\\f506\";\n}\n\n.fa-pen::before {\n  content: \"\\f304\";\n}\n\n.fa-tower-observation::before {\n  content: \"\\e586\";\n}\n\n.fa-file-code::before {\n  content: \"\\f1c9\";\n}\n\n.fa-signal::before {\n  content: \"\\f012\";\n}\n\n.fa-signal-5::before {\n  content: \"\\f012\";\n}\n\n.fa-signal-perfect::before {\n  content: \"\\f012\";\n}\n\n.fa-bus::before {\n  content: \"\\f207\";\n}\n\n.fa-heart-circle-xmark::before {\n  content: \"\\e501\";\n}\n\n.fa-house-chimney::before {\n  content: \"\\e3af\";\n}\n\n.fa-home-lg::before {\n  content: \"\\e3af\";\n}\n\n.fa-window-maximize::before {\n  content: \"\\f2d0\";\n}\n\n.fa-face-frown::before {\n  content: \"\\f119\";\n}\n\n.fa-frown::before {\n  content: \"\\f119\";\n}\n\n.fa-prescription::before {\n  content: \"\\f5b1\";\n}\n\n.fa-shop::before {\n  content: \"\\f54f\";\n}\n\n.fa-store-alt::before {\n  content: \"\\f54f\";\n}\n\n.fa-floppy-disk::before {\n  content: \"\\f0c7\";\n}\n\n.fa-save::before {\n  content: \"\\f0c7\";\n}\n\n.fa-vihara::before {\n  content: \"\\f6a7\";\n}\n\n.fa-scale-unbalanced::before {\n  content: \"\\f515\";\n}\n\n.fa-balance-scale-left::before {\n  content: \"\\f515\";\n}\n\n.fa-sort-up::before {\n  content: \"\\f0de\";\n}\n\n.fa-sort-asc::before {\n  content: \"\\f0de\";\n}\n\n.fa-comment-dots::before {\n  content: \"\\f4ad\";\n}\n\n.fa-commenting::before {\n  content: \"\\f4ad\";\n}\n\n.fa-plant-wilt::before {\n  content: \"\\e5aa\";\n}\n\n.fa-diamond::before {\n  content: \"\\f219\";\n}\n\n.fa-face-grin-squint::before {\n  content: \"\\f585\";\n}\n\n.fa-grin-squint::before {\n  content: \"\\f585\";\n}\n\n.fa-hand-holding-dollar::before {\n  content: \"\\f4c0\";\n}\n\n.fa-hand-holding-usd::before {\n  content: \"\\f4c0\";\n}\n\n.fa-bacterium::before {\n  content: \"\\e05a\";\n}\n\n.fa-hand-pointer::before {\n  content: \"\\f25a\";\n}\n\n.fa-drum-steelpan::before {\n  content: \"\\f56a\";\n}\n\n.fa-hand-scissors::before {\n  content: \"\\f257\";\n}\n\n.fa-hands-praying::before {\n  content: \"\\f684\";\n}\n\n.fa-praying-hands::before {\n  content: \"\\f684\";\n}\n\n.fa-arrow-rotate-right::before {\n  content: \"\\f01e\";\n}\n\n.fa-arrow-right-rotate::before {\n  content: \"\\f01e\";\n}\n\n.fa-arrow-rotate-forward::before {\n  content: \"\\f01e\";\n}\n\n.fa-redo::before {\n  content: \"\\f01e\";\n}\n\n.fa-biohazard::before {\n  content: \"\\f780\";\n}\n\n.fa-location-crosshairs::before {\n  content: \"\\f601\";\n}\n\n.fa-location::before {\n  content: \"\\f601\";\n}\n\n.fa-mars-double::before {\n  content: \"\\f227\";\n}\n\n.fa-child-dress::before {\n  content: \"\\e59c\";\n}\n\n.fa-users-between-lines::before {\n  content: \"\\e591\";\n}\n\n.fa-lungs-virus::before {\n  content: \"\\e067\";\n}\n\n.fa-face-grin-tears::before {\n  content: \"\\f588\";\n}\n\n.fa-grin-tears::before {\n  content: \"\\f588\";\n}\n\n.fa-phone::before {\n  content: \"\\f095\";\n}\n\n.fa-calendar-xmark::before {\n  content: \"\\f273\";\n}\n\n.fa-calendar-times::before {\n  content: \"\\f273\";\n}\n\n.fa-child-reaching::before {\n  content: \"\\e59d\";\n}\n\n.fa-head-side-virus::before {\n  content: \"\\e064\";\n}\n\n.fa-user-gear::before {\n  content: \"\\f4fe\";\n}\n\n.fa-user-cog::before {\n  content: \"\\f4fe\";\n}\n\n.fa-arrow-up-1-9::before {\n  content: \"\\f163\";\n}\n\n.fa-sort-numeric-up::before {\n  content: \"\\f163\";\n}\n\n.fa-door-closed::before {\n  content: \"\\f52a\";\n}\n\n.fa-shield-virus::before {\n  content: \"\\e06c\";\n}\n\n.fa-dice-six::before {\n  content: \"\\f526\";\n}\n\n.fa-mosquito-net::before {\n  content: \"\\e52c\";\n}\n\n.fa-bridge-water::before {\n  content: \"\\e4ce\";\n}\n\n.fa-person-booth::before {\n  content: \"\\f756\";\n}\n\n.fa-text-width::before {\n  content: \"\\f035\";\n}\n\n.fa-hat-wizard::before {\n  content: \"\\f6e8\";\n}\n\n.fa-pen-fancy::before {\n  content: \"\\f5ac\";\n}\n\n.fa-person-digging::before {\n  content: \"\\f85e\";\n}\n\n.fa-digging::before {\n  content: \"\\f85e\";\n}\n\n.fa-trash::before {\n  content: \"\\f1f8\";\n}\n\n.fa-gauge-simple::before {\n  content: \"\\f629\";\n}\n\n.fa-gauge-simple-med::before {\n  content: \"\\f629\";\n}\n\n.fa-tachometer-average::before {\n  content: \"\\f629\";\n}\n\n.fa-book-medical::before {\n  content: \"\\f7e6\";\n}\n\n.fa-poo::before {\n  content: \"\\f2fe\";\n}\n\n.fa-quote-right::before {\n  content: \"\\f10e\";\n}\n\n.fa-quote-right-alt::before {\n  content: \"\\f10e\";\n}\n\n.fa-shirt::before {\n  content: \"\\f553\";\n}\n\n.fa-t-shirt::before {\n  content: \"\\f553\";\n}\n\n.fa-tshirt::before {\n  content: \"\\f553\";\n}\n\n.fa-cubes::before {\n  content: \"\\f1b3\";\n}\n\n.fa-divide::before {\n  content: \"\\f529\";\n}\n\n.fa-tenge-sign::before {\n  content: \"\\f7d7\";\n}\n\n.fa-tenge::before {\n  content: \"\\f7d7\";\n}\n\n.fa-headphones::before {\n  content: \"\\f025\";\n}\n\n.fa-hands-holding::before {\n  content: \"\\f4c2\";\n}\n\n.fa-hands-clapping::before {\n  content: \"\\e1a8\";\n}\n\n.fa-republican::before {\n  content: \"\\f75e\";\n}\n\n.fa-arrow-left::before {\n  content: \"\\f060\";\n}\n\n.fa-person-circle-xmark::before {\n  content: \"\\e543\";\n}\n\n.fa-ruler::before {\n  content: \"\\f545\";\n}\n\n.fa-align-left::before {\n  content: \"\\f036\";\n}\n\n.fa-dice-d6::before {\n  content: \"\\f6d1\";\n}\n\n.fa-restroom::before {\n  content: \"\\f7bd\";\n}\n\n.fa-j::before {\n  content: \"J\";\n}\n\n.fa-users-viewfinder::before {\n  content: \"\\e595\";\n}\n\n.fa-file-video::before {\n  content: \"\\f1c8\";\n}\n\n.fa-up-right-from-square::before {\n  content: \"\\f35d\";\n}\n\n.fa-external-link-alt::before {\n  content: \"\\f35d\";\n}\n\n.fa-table-cells::before {\n  content: \"\\f00a\";\n}\n\n.fa-th::before {\n  content: \"\\f00a\";\n}\n\n.fa-file-pdf::before {\n  content: \"\\f1c1\";\n}\n\n.fa-book-bible::before {\n  content: \"\\f647\";\n}\n\n.fa-bible::before {\n  content: \"\\f647\";\n}\n\n.fa-o::before {\n  content: \"O\";\n}\n\n.fa-suitcase-medical::before {\n  content: \"\\f0fa\";\n}\n\n.fa-medkit::before {\n  content: \"\\f0fa\";\n}\n\n.fa-user-secret::before {\n  content: \"\\f21b\";\n}\n\n.fa-otter::before {\n  content: \"\\f700\";\n}\n\n.fa-person-dress::before {\n  content: \"\\f182\";\n}\n\n.fa-female::before {\n  content: \"\\f182\";\n}\n\n.fa-comment-dollar::before {\n  content: \"\\f651\";\n}\n\n.fa-business-time::before {\n  content: \"\\f64a\";\n}\n\n.fa-briefcase-clock::before {\n  content: \"\\f64a\";\n}\n\n.fa-table-cells-large::before {\n  content: \"\\f009\";\n}\n\n.fa-th-large::before {\n  content: \"\\f009\";\n}\n\n.fa-book-tanakh::before {\n  content: \"\\f827\";\n}\n\n.fa-tanakh::before {\n  content: \"\\f827\";\n}\n\n.fa-phone-volume::before {\n  content: \"\\f2a0\";\n}\n\n.fa-volume-control-phone::before {\n  content: \"\\f2a0\";\n}\n\n.fa-hat-cowboy-side::before {\n  content: \"\\f8c1\";\n}\n\n.fa-clipboard-user::before {\n  content: \"\\f7f3\";\n}\n\n.fa-child::before {\n  content: \"\\f1ae\";\n}\n\n.fa-lira-sign::before {\n  content: \"\\f195\";\n}\n\n.fa-satellite::before {\n  content: \"\\f7bf\";\n}\n\n.fa-plane-lock::before {\n  content: \"\\e558\";\n}\n\n.fa-tag::before {\n  content: \"\\f02b\";\n}\n\n.fa-comment::before {\n  content: \"\\f075\";\n}\n\n.fa-cake-candles::before {\n  content: \"\\f1fd\";\n}\n\n.fa-birthday-cake::before {\n  content: \"\\f1fd\";\n}\n\n.fa-cake::before {\n  content: \"\\f1fd\";\n}\n\n.fa-envelope::before {\n  content: \"\\f0e0\";\n}\n\n.fa-angles-up::before {\n  content: \"\\f102\";\n}\n\n.fa-angle-double-up::before {\n  content: \"\\f102\";\n}\n\n.fa-paperclip::before {\n  content: \"\\f0c6\";\n}\n\n.fa-arrow-right-to-city::before {\n  content: \"\\e4b3\";\n}\n\n.fa-ribbon::before {\n  content: \"\\f4d6\";\n}\n\n.fa-lungs::before {\n  content: \"\\f604\";\n}\n\n.fa-arrow-up-9-1::before {\n  content: \"\\f887\";\n}\n\n.fa-sort-numeric-up-alt::before {\n  content: \"\\f887\";\n}\n\n.fa-litecoin-sign::before {\n  content: \"\\e1d3\";\n}\n\n.fa-border-none::before {\n  content: \"\\f850\";\n}\n\n.fa-circle-nodes::before {\n  content: \"\\e4e2\";\n}\n\n.fa-parachute-box::before {\n  content: \"\\f4cd\";\n}\n\n.fa-indent::before {\n  content: \"\\f03c\";\n}\n\n.fa-truck-field-un::before {\n  content: \"\\e58e\";\n}\n\n.fa-hourglass::before {\n  content: \"\\f254\";\n}\n\n.fa-hourglass-empty::before {\n  content: \"\\f254\";\n}\n\n.fa-mountain::before {\n  content: \"\\f6fc\";\n}\n\n.fa-user-doctor::before {\n  content: \"\\f0f0\";\n}\n\n.fa-user-md::before {\n  content: \"\\f0f0\";\n}\n\n.fa-circle-info::before {\n  content: \"\\f05a\";\n}\n\n.fa-info-circle::before {\n  content: \"\\f05a\";\n}\n\n.fa-cloud-meatball::before {\n  content: \"\\f73b\";\n}\n\n.fa-camera::before {\n  content: \"\\f030\";\n}\n\n.fa-camera-alt::before {\n  content: \"\\f030\";\n}\n\n.fa-square-virus::before {\n  content: \"\\e578\";\n}\n\n.fa-meteor::before {\n  content: \"\\f753\";\n}\n\n.fa-car-on::before {\n  content: \"\\e4dd\";\n}\n\n.fa-sleigh::before {\n  content: \"\\f7cc\";\n}\n\n.fa-arrow-down-1-9::before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-asc::before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-down::before {\n  content: \"\\f162\";\n}\n\n.fa-hand-holding-droplet::before {\n  content: \"\\f4c1\";\n}\n\n.fa-hand-holding-water::before {\n  content: \"\\f4c1\";\n}\n\n.fa-water::before {\n  content: \"\\f773\";\n}\n\n.fa-calendar-check::before {\n  content: \"\\f274\";\n}\n\n.fa-braille::before {\n  content: \"\\f2a1\";\n}\n\n.fa-prescription-bottle-medical::before {\n  content: \"\\f486\";\n}\n\n.fa-prescription-bottle-alt::before {\n  content: \"\\f486\";\n}\n\n.fa-landmark::before {\n  content: \"\\f66f\";\n}\n\n.fa-truck::before {\n  content: \"\\f0d1\";\n}\n\n.fa-crosshairs::before {\n  content: \"\\f05b\";\n}\n\n.fa-person-cane::before {\n  content: \"\\e53c\";\n}\n\n.fa-tent::before {\n  content: \"\\e57d\";\n}\n\n.fa-vest-patches::before {\n  content: \"\\e086\";\n}\n\n.fa-check-double::before {\n  content: \"\\f560\";\n}\n\n.fa-arrow-down-a-z::before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-asc::before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-down::before {\n  content: \"\\f15d\";\n}\n\n.fa-money-bill-wheat::before {\n  content: \"\\e52a\";\n}\n\n.fa-cookie::before {\n  content: \"\\f563\";\n}\n\n.fa-arrow-rotate-left::before {\n  content: \"\\f0e2\";\n}\n\n.fa-arrow-left-rotate::before {\n  content: \"\\f0e2\";\n}\n\n.fa-arrow-rotate-back::before {\n  content: \"\\f0e2\";\n}\n\n.fa-arrow-rotate-backward::before {\n  content: \"\\f0e2\";\n}\n\n.fa-undo::before {\n  content: \"\\f0e2\";\n}\n\n.fa-hard-drive::before {\n  content: \"\\f0a0\";\n}\n\n.fa-hdd::before {\n  content: \"\\f0a0\";\n}\n\n.fa-face-grin-squint-tears::before {\n  content: \"\\f586\";\n}\n\n.fa-grin-squint-tears::before {\n  content: \"\\f586\";\n}\n\n.fa-dumbbell::before {\n  content: \"\\f44b\";\n}\n\n.fa-rectangle-list::before {\n  content: \"\\f022\";\n}\n\n.fa-list-alt::before {\n  content: \"\\f022\";\n}\n\n.fa-tarp-droplet::before {\n  content: \"\\e57c\";\n}\n\n.fa-house-medical-circle-check::before {\n  content: \"\\e511\";\n}\n\n.fa-person-skiing-nordic::before {\n  content: \"\\f7ca\";\n}\n\n.fa-skiing-nordic::before {\n  content: \"\\f7ca\";\n}\n\n.fa-calendar-plus::before {\n  content: \"\\f271\";\n}\n\n.fa-plane-arrival::before {\n  content: \"\\f5af\";\n}\n\n.fa-circle-left::before {\n  content: \"\\f359\";\n}\n\n.fa-arrow-alt-circle-left::before {\n  content: \"\\f359\";\n}\n\n.fa-train-subway::before {\n  content: \"\\f239\";\n}\n\n.fa-subway::before {\n  content: \"\\f239\";\n}\n\n.fa-chart-gantt::before {\n  content: \"\\e0e4\";\n}\n\n.fa-indian-rupee-sign::before {\n  content: \"\\e1bc\";\n}\n\n.fa-indian-rupee::before {\n  content: \"\\e1bc\";\n}\n\n.fa-inr::before {\n  content: \"\\e1bc\";\n}\n\n.fa-crop-simple::before {\n  content: \"\\f565\";\n}\n\n.fa-crop-alt::before {\n  content: \"\\f565\";\n}\n\n.fa-money-bill-1::before {\n  content: \"\\f3d1\";\n}\n\n.fa-money-bill-alt::before {\n  content: \"\\f3d1\";\n}\n\n.fa-left-long::before {\n  content: \"\\f30a\";\n}\n\n.fa-long-arrow-alt-left::before {\n  content: \"\\f30a\";\n}\n\n.fa-dna::before {\n  content: \"\\f471\";\n}\n\n.fa-virus-slash::before {\n  content: \"\\e075\";\n}\n\n.fa-minus::before {\n  content: \"\\f068\";\n}\n\n.fa-subtract::before {\n  content: \"\\f068\";\n}\n\n.fa-chess::before {\n  content: \"\\f439\";\n}\n\n.fa-arrow-left-long::before {\n  content: \"\\f177\";\n}\n\n.fa-long-arrow-left::before {\n  content: \"\\f177\";\n}\n\n.fa-plug-circle-check::before {\n  content: \"\\e55c\";\n}\n\n.fa-street-view::before {\n  content: \"\\f21d\";\n}\n\n.fa-franc-sign::before {\n  content: \"\\e18f\";\n}\n\n.fa-volume-off::before {\n  content: \"\\f026\";\n}\n\n.fa-hands-asl-interpreting::before {\n  content: \"\\f2a3\";\n}\n\n.fa-american-sign-language-interpreting::before {\n  content: \"\\f2a3\";\n}\n\n.fa-asl-interpreting::before {\n  content: \"\\f2a3\";\n}\n\n.fa-hands-american-sign-language-interpreting::before {\n  content: \"\\f2a3\";\n}\n\n.fa-gear::before {\n  content: \"\\f013\";\n}\n\n.fa-cog::before {\n  content: \"\\f013\";\n}\n\n.fa-droplet-slash::before {\n  content: \"\\f5c7\";\n}\n\n.fa-tint-slash::before {\n  content: \"\\f5c7\";\n}\n\n.fa-mosque::before {\n  content: \"\\f678\";\n}\n\n.fa-mosquito::before {\n  content: \"\\e52b\";\n}\n\n.fa-star-of-david::before {\n  content: \"\\f69a\";\n}\n\n.fa-person-military-rifle::before {\n  content: \"\\e54b\";\n}\n\n.fa-cart-shopping::before {\n  content: \"\\f07a\";\n}\n\n.fa-shopping-cart::before {\n  content: \"\\f07a\";\n}\n\n.fa-vials::before {\n  content: \"\\f493\";\n}\n\n.fa-plug-circle-plus::before {\n  content: \"\\e55f\";\n}\n\n.fa-place-of-worship::before {\n  content: \"\\f67f\";\n}\n\n.fa-grip-vertical::before {\n  content: \"\\f58e\";\n}\n\n.fa-arrow-turn-up::before {\n  content: \"\\f148\";\n}\n\n.fa-level-up::before {\n  content: \"\\f148\";\n}\n\n.fa-u::before {\n  content: \"U\";\n}\n\n.fa-square-root-variable::before {\n  content: \"\\f698\";\n}\n\n.fa-square-root-alt::before {\n  content: \"\\f698\";\n}\n\n.fa-clock::before {\n  content: \"\\f017\";\n}\n\n.fa-clock-four::before {\n  content: \"\\f017\";\n}\n\n.fa-backward-step::before {\n  content: \"\\f048\";\n}\n\n.fa-step-backward::before {\n  content: \"\\f048\";\n}\n\n.fa-pallet::before {\n  content: \"\\f482\";\n}\n\n.fa-faucet::before {\n  content: \"\\e005\";\n}\n\n.fa-baseball-bat-ball::before {\n  content: \"\\f432\";\n}\n\n.fa-s::before {\n  content: \"S\";\n}\n\n.fa-timeline::before {\n  content: \"\\e29c\";\n}\n\n.fa-keyboard::before {\n  content: \"\\f11c\";\n}\n\n.fa-caret-down::before {\n  content: \"\\f0d7\";\n}\n\n.fa-house-chimney-medical::before {\n  content: \"\\f7f2\";\n}\n\n.fa-clinic-medical::before {\n  content: \"\\f7f2\";\n}\n\n.fa-temperature-three-quarters::before {\n  content: \"\\f2c8\";\n}\n\n.fa-temperature-3::before {\n  content: \"\\f2c8\";\n}\n\n.fa-thermometer-3::before {\n  content: \"\\f2c8\";\n}\n\n.fa-thermometer-three-quarters::before {\n  content: \"\\f2c8\";\n}\n\n.fa-mobile-screen::before {\n  content: \"\\f3cf\";\n}\n\n.fa-mobile-android-alt::before {\n  content: \"\\f3cf\";\n}\n\n.fa-plane-up::before {\n  content: \"\\e22d\";\n}\n\n.fa-piggy-bank::before {\n  content: \"\\f4d3\";\n}\n\n.fa-battery-half::before {\n  content: \"\\f242\";\n}\n\n.fa-battery-3::before {\n  content: \"\\f242\";\n}\n\n.fa-mountain-city::before {\n  content: \"\\e52e\";\n}\n\n.fa-coins::before {\n  content: \"\\f51e\";\n}\n\n.fa-khanda::before {\n  content: \"\\f66d\";\n}\n\n.fa-sliders::before {\n  content: \"\\f1de\";\n}\n\n.fa-sliders-h::before {\n  content: \"\\f1de\";\n}\n\n.fa-folder-tree::before {\n  content: \"\\f802\";\n}\n\n.fa-network-wired::before {\n  content: \"\\f6ff\";\n}\n\n.fa-map-pin::before {\n  content: \"\\f276\";\n}\n\n.fa-hamsa::before {\n  content: \"\\f665\";\n}\n\n.fa-cent-sign::before {\n  content: \"\\e3f5\";\n}\n\n.fa-flask::before {\n  content: \"\\f0c3\";\n}\n\n.fa-person-pregnant::before {\n  content: \"\\e31e\";\n}\n\n.fa-wand-sparkles::before {\n  content: \"\\f72b\";\n}\n\n.fa-ellipsis-vertical::before {\n  content: \"\\f142\";\n}\n\n.fa-ellipsis-v::before {\n  content: \"\\f142\";\n}\n\n.fa-ticket::before {\n  content: \"\\f145\";\n}\n\n.fa-power-off::before {\n  content: \"\\f011\";\n}\n\n.fa-right-long::before {\n  content: \"\\f30b\";\n}\n\n.fa-long-arrow-alt-right::before {\n  content: \"\\f30b\";\n}\n\n.fa-flag-usa::before {\n  content: \"\\f74d\";\n}\n\n.fa-laptop-file::before {\n  content: \"\\e51d\";\n}\n\n.fa-tty::before {\n  content: \"\\f1e4\";\n}\n\n.fa-teletype::before {\n  content: \"\\f1e4\";\n}\n\n.fa-diagram-next::before {\n  content: \"\\e476\";\n}\n\n.fa-person-rifle::before {\n  content: \"\\e54e\";\n}\n\n.fa-house-medical-circle-exclamation::before {\n  content: \"\\e512\";\n}\n\n.fa-closed-captioning::before {\n  content: \"\\f20a\";\n}\n\n.fa-person-hiking::before {\n  content: \"\\f6ec\";\n}\n\n.fa-hiking::before {\n  content: \"\\f6ec\";\n}\n\n.fa-venus-double::before {\n  content: \"\\f226\";\n}\n\n.fa-images::before {\n  content: \"\\f302\";\n}\n\n.fa-calculator::before {\n  content: \"\\f1ec\";\n}\n\n.fa-people-pulling::before {\n  content: \"\\e535\";\n}\n\n.fa-n::before {\n  content: \"N\";\n}\n\n.fa-cable-car::before {\n  content: \"\\f7da\";\n}\n\n.fa-tram::before {\n  content: \"\\f7da\";\n}\n\n.fa-cloud-rain::before {\n  content: \"\\f73d\";\n}\n\n.fa-building-circle-xmark::before {\n  content: \"\\e4d4\";\n}\n\n.fa-ship::before {\n  content: \"\\f21a\";\n}\n\n.fa-arrows-down-to-line::before {\n  content: \"\\e4b8\";\n}\n\n.fa-download::before {\n  content: \"\\f019\";\n}\n\n.fa-face-grin::before {\n  content: \"\\f580\";\n}\n\n.fa-grin::before {\n  content: \"\\f580\";\n}\n\n.fa-delete-left::before {\n  content: \"\\f55a\";\n}\n\n.fa-backspace::before {\n  content: \"\\f55a\";\n}\n\n.fa-eye-dropper::before {\n  content: \"\\f1fb\";\n}\n\n.fa-eye-dropper-empty::before {\n  content: \"\\f1fb\";\n}\n\n.fa-eyedropper::before {\n  content: \"\\f1fb\";\n}\n\n.fa-file-circle-check::before {\n  content: \"\\e5a0\";\n}\n\n.fa-forward::before {\n  content: \"\\f04e\";\n}\n\n.fa-mobile::before {\n  content: \"\\f3ce\";\n}\n\n.fa-mobile-android::before {\n  content: \"\\f3ce\";\n}\n\n.fa-mobile-phone::before {\n  content: \"\\f3ce\";\n}\n\n.fa-face-meh::before {\n  content: \"\\f11a\";\n}\n\n.fa-meh::before {\n  content: \"\\f11a\";\n}\n\n.fa-align-center::before {\n  content: \"\\f037\";\n}\n\n.fa-book-skull::before {\n  content: \"\\f6b7\";\n}\n\n.fa-book-dead::before {\n  content: \"\\f6b7\";\n}\n\n.fa-id-card::before {\n  content: \"\\f2c2\";\n}\n\n.fa-drivers-license::before {\n  content: \"\\f2c2\";\n}\n\n.fa-outdent::before {\n  content: \"\\f03b\";\n}\n\n.fa-dedent::before {\n  content: \"\\f03b\";\n}\n\n.fa-heart-circle-exclamation::before {\n  content: \"\\e4fe\";\n}\n\n.fa-house::before {\n  content: \"\\f015\";\n}\n\n.fa-home::before {\n  content: \"\\f015\";\n}\n\n.fa-home-alt::before {\n  content: \"\\f015\";\n}\n\n.fa-home-lg-alt::before {\n  content: \"\\f015\";\n}\n\n.fa-calendar-week::before {\n  content: \"\\f784\";\n}\n\n.fa-laptop-medical::before {\n  content: \"\\f812\";\n}\n\n.fa-b::before {\n  content: \"B\";\n}\n\n.fa-file-medical::before {\n  content: \"\\f477\";\n}\n\n.fa-dice-one::before {\n  content: \"\\f525\";\n}\n\n.fa-kiwi-bird::before {\n  content: \"\\f535\";\n}\n\n.fa-arrow-right-arrow-left::before {\n  content: \"\\f0ec\";\n}\n\n.fa-exchange::before {\n  content: \"\\f0ec\";\n}\n\n.fa-rotate-right::before {\n  content: \"\\f2f9\";\n}\n\n.fa-redo-alt::before {\n  content: \"\\f2f9\";\n}\n\n.fa-rotate-forward::before {\n  content: \"\\f2f9\";\n}\n\n.fa-utensils::before {\n  content: \"\\f2e7\";\n}\n\n.fa-cutlery::before {\n  content: \"\\f2e7\";\n}\n\n.fa-arrow-up-wide-short::before {\n  content: \"\\f161\";\n}\n\n.fa-sort-amount-up::before {\n  content: \"\\f161\";\n}\n\n.fa-mill-sign::before {\n  content: \"\\e1ed\";\n}\n\n.fa-bowl-rice::before {\n  content: \"\\e2eb\";\n}\n\n.fa-skull::before {\n  content: \"\\f54c\";\n}\n\n.fa-tower-broadcast::before {\n  content: \"\\f519\";\n}\n\n.fa-broadcast-tower::before {\n  content: \"\\f519\";\n}\n\n.fa-truck-pickup::before {\n  content: \"\\f63c\";\n}\n\n.fa-up-long::before {\n  content: \"\\f30c\";\n}\n\n.fa-long-arrow-alt-up::before {\n  content: \"\\f30c\";\n}\n\n.fa-stop::before {\n  content: \"\\f04d\";\n}\n\n.fa-code-merge::before {\n  content: \"\\f387\";\n}\n\n.fa-upload::before {\n  content: \"\\f093\";\n}\n\n.fa-hurricane::before {\n  content: \"\\f751\";\n}\n\n.fa-mound::before {\n  content: \"\\e52d\";\n}\n\n.fa-toilet-portable::before {\n  content: \"\\e583\";\n}\n\n.fa-compact-disc::before {\n  content: \"\\f51f\";\n}\n\n.fa-file-arrow-down::before {\n  content: \"\\f56d\";\n}\n\n.fa-file-download::before {\n  content: \"\\f56d\";\n}\n\n.fa-caravan::before {\n  content: \"\\f8ff\";\n}\n\n.fa-shield-cat::before {\n  content: \"\\e572\";\n}\n\n.fa-bolt::before {\n  content: \"\\f0e7\";\n}\n\n.fa-zap::before {\n  content: \"\\f0e7\";\n}\n\n.fa-glass-water::before {\n  content: \"\\e4f4\";\n}\n\n.fa-oil-well::before {\n  content: \"\\e532\";\n}\n\n.fa-vault::before {\n  content: \"\\e2c5\";\n}\n\n.fa-mars::before {\n  content: \"\\f222\";\n}\n\n.fa-toilet::before {\n  content: \"\\f7d8\";\n}\n\n.fa-plane-circle-xmark::before {\n  content: \"\\e557\";\n}\n\n.fa-yen-sign::before {\n  content: \"\\f157\";\n}\n\n.fa-cny::before {\n  content: \"\\f157\";\n}\n\n.fa-jpy::before {\n  content: \"\\f157\";\n}\n\n.fa-rmb::before {\n  content: \"\\f157\";\n}\n\n.fa-yen::before {\n  content: \"\\f157\";\n}\n\n.fa-ruble-sign::before {\n  content: \"\\f158\";\n}\n\n.fa-rouble::before {\n  content: \"\\f158\";\n}\n\n.fa-rub::before {\n  content: \"\\f158\";\n}\n\n.fa-ruble::before {\n  content: \"\\f158\";\n}\n\n.fa-sun::before {\n  content: \"\\f185\";\n}\n\n.fa-guitar::before {\n  content: \"\\f7a6\";\n}\n\n.fa-face-laugh-wink::before {\n  content: \"\\f59c\";\n}\n\n.fa-laugh-wink::before {\n  content: \"\\f59c\";\n}\n\n.fa-horse-head::before {\n  content: \"\\f7ab\";\n}\n\n.fa-bore-hole::before {\n  content: \"\\e4c3\";\n}\n\n.fa-industry::before {\n  content: \"\\f275\";\n}\n\n.fa-circle-down::before {\n  content: \"\\f358\";\n}\n\n.fa-arrow-alt-circle-down::before {\n  content: \"\\f358\";\n}\n\n.fa-arrows-turn-to-dots::before {\n  content: \"\\e4c1\";\n}\n\n.fa-florin-sign::before {\n  content: \"\\e184\";\n}\n\n.fa-arrow-down-short-wide::before {\n  content: \"\\f884\";\n}\n\n.fa-sort-amount-desc::before {\n  content: \"\\f884\";\n}\n\n.fa-sort-amount-down-alt::before {\n  content: \"\\f884\";\n}\n\n.fa-less-than::before {\n  content: \"\\<\";\n}\n\n.fa-angle-down::before {\n  content: \"\\f107\";\n}\n\n.fa-car-tunnel::before {\n  content: \"\\e4de\";\n}\n\n.fa-head-side-cough::before {\n  content: \"\\e061\";\n}\n\n.fa-grip-lines::before {\n  content: \"\\f7a4\";\n}\n\n.fa-thumbs-down::before {\n  content: \"\\f165\";\n}\n\n.fa-user-lock::before {\n  content: \"\\f502\";\n}\n\n.fa-arrow-right-long::before {\n  content: \"\\f178\";\n}\n\n.fa-long-arrow-right::before {\n  content: \"\\f178\";\n}\n\n.fa-anchor-circle-xmark::before {\n  content: \"\\e4ac\";\n}\n\n.fa-ellipsis::before {\n  content: \"\\f141\";\n}\n\n.fa-ellipsis-h::before {\n  content: \"\\f141\";\n}\n\n.fa-chess-pawn::before {\n  content: \"\\f443\";\n}\n\n.fa-kit-medical::before {\n  content: \"\\f479\";\n}\n\n.fa-first-aid::before {\n  content: \"\\f479\";\n}\n\n.fa-person-through-window::before {\n  content: \"\\e5a9\";\n}\n\n.fa-toolbox::before {\n  content: \"\\f552\";\n}\n\n.fa-hands-holding-circle::before {\n  content: \"\\e4fb\";\n}\n\n.fa-bug::before {\n  content: \"\\f188\";\n}\n\n.fa-credit-card::before {\n  content: \"\\f09d\";\n}\n\n.fa-credit-card-alt::before {\n  content: \"\\f09d\";\n}\n\n.fa-car::before {\n  content: \"\\f1b9\";\n}\n\n.fa-automobile::before {\n  content: \"\\f1b9\";\n}\n\n.fa-hand-holding-hand::before {\n  content: \"\\e4f7\";\n}\n\n.fa-book-open-reader::before {\n  content: \"\\f5da\";\n}\n\n.fa-book-reader::before {\n  content: \"\\f5da\";\n}\n\n.fa-mountain-sun::before {\n  content: \"\\e52f\";\n}\n\n.fa-arrows-left-right-to-line::before {\n  content: \"\\e4ba\";\n}\n\n.fa-dice-d20::before {\n  content: \"\\f6cf\";\n}\n\n.fa-truck-droplet::before {\n  content: \"\\e58c\";\n}\n\n.fa-file-circle-xmark::before {\n  content: \"\\e5a1\";\n}\n\n.fa-temperature-arrow-up::before {\n  content: \"\\e040\";\n}\n\n.fa-temperature-up::before {\n  content: \"\\e040\";\n}\n\n.fa-medal::before {\n  content: \"\\f5a2\";\n}\n\n.fa-bed::before {\n  content: \"\\f236\";\n}\n\n.fa-square-h::before {\n  content: \"\\f0fd\";\n}\n\n.fa-h-square::before {\n  content: \"\\f0fd\";\n}\n\n.fa-podcast::before {\n  content: \"\\f2ce\";\n}\n\n.fa-temperature-full::before {\n  content: \"\\f2c7\";\n}\n\n.fa-temperature-4::before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-4::before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-full::before {\n  content: \"\\f2c7\";\n}\n\n.fa-bell::before {\n  content: \"\\f0f3\";\n}\n\n.fa-superscript::before {\n  content: \"\\f12b\";\n}\n\n.fa-plug-circle-xmark::before {\n  content: \"\\e560\";\n}\n\n.fa-star-of-life::before {\n  content: \"\\f621\";\n}\n\n.fa-phone-slash::before {\n  content: \"\\f3dd\";\n}\n\n.fa-paint-roller::before {\n  content: \"\\f5aa\";\n}\n\n.fa-handshake-angle::before {\n  content: \"\\f4c4\";\n}\n\n.fa-hands-helping::before {\n  content: \"\\f4c4\";\n}\n\n.fa-location-dot::before {\n  content: \"\\f3c5\";\n}\n\n.fa-map-marker-alt::before {\n  content: \"\\f3c5\";\n}\n\n.fa-file::before {\n  content: \"\\f15b\";\n}\n\n.fa-greater-than::before {\n  content: \"\\>\";\n}\n\n.fa-person-swimming::before {\n  content: \"\\f5c4\";\n}\n\n.fa-swimmer::before {\n  content: \"\\f5c4\";\n}\n\n.fa-arrow-down::before {\n  content: \"\\f063\";\n}\n\n.fa-droplet::before {\n  content: \"\\f043\";\n}\n\n.fa-tint::before {\n  content: \"\\f043\";\n}\n\n.fa-eraser::before {\n  content: \"\\f12d\";\n}\n\n.fa-earth-americas::before {\n  content: \"\\f57d\";\n}\n\n.fa-earth::before {\n  content: \"\\f57d\";\n}\n\n.fa-earth-america::before {\n  content: \"\\f57d\";\n}\n\n.fa-globe-americas::before {\n  content: \"\\f57d\";\n}\n\n.fa-person-burst::before {\n  content: \"\\e53b\";\n}\n\n.fa-dove::before {\n  content: \"\\f4ba\";\n}\n\n.fa-battery-empty::before {\n  content: \"\\f244\";\n}\n\n.fa-battery-0::before {\n  content: \"\\f244\";\n}\n\n.fa-socks::before {\n  content: \"\\f696\";\n}\n\n.fa-inbox::before {\n  content: \"\\f01c\";\n}\n\n.fa-section::before {\n  content: \"\\e447\";\n}\n\n.fa-gauge-high::before {\n  content: \"\\f625\";\n}\n\n.fa-tachometer-alt::before {\n  content: \"\\f625\";\n}\n\n.fa-tachometer-alt-fast::before {\n  content: \"\\f625\";\n}\n\n.fa-envelope-open-text::before {\n  content: \"\\f658\";\n}\n\n.fa-hospital::before {\n  content: \"\\f0f8\";\n}\n\n.fa-hospital-alt::before {\n  content: \"\\f0f8\";\n}\n\n.fa-hospital-wide::before {\n  content: \"\\f0f8\";\n}\n\n.fa-wine-bottle::before {\n  content: \"\\f72f\";\n}\n\n.fa-chess-rook::before {\n  content: \"\\f447\";\n}\n\n.fa-bars-staggered::before {\n  content: \"\\f550\";\n}\n\n.fa-reorder::before {\n  content: \"\\f550\";\n}\n\n.fa-stream::before {\n  content: \"\\f550\";\n}\n\n.fa-dharmachakra::before {\n  content: \"\\f655\";\n}\n\n.fa-hotdog::before {\n  content: \"\\f80f\";\n}\n\n.fa-person-walking-with-cane::before {\n  content: \"\\f29d\";\n}\n\n.fa-blind::before {\n  content: \"\\f29d\";\n}\n\n.fa-drum::before {\n  content: \"\\f569\";\n}\n\n.fa-ice-cream::before {\n  content: \"\\f810\";\n}\n\n.fa-heart-circle-bolt::before {\n  content: \"\\e4fc\";\n}\n\n.fa-fax::before {\n  content: \"\\f1ac\";\n}\n\n.fa-paragraph::before {\n  content: \"\\f1dd\";\n}\n\n.fa-check-to-slot::before {\n  content: \"\\f772\";\n}\n\n.fa-vote-yea::before {\n  content: \"\\f772\";\n}\n\n.fa-star-half::before {\n  content: \"\\f089\";\n}\n\n.fa-boxes-stacked::before {\n  content: \"\\f468\";\n}\n\n.fa-boxes::before {\n  content: \"\\f468\";\n}\n\n.fa-boxes-alt::before {\n  content: \"\\f468\";\n}\n\n.fa-link::before {\n  content: \"\\f0c1\";\n}\n\n.fa-chain::before {\n  content: \"\\f0c1\";\n}\n\n.fa-ear-listen::before {\n  content: \"\\f2a2\";\n}\n\n.fa-assistive-listening-systems::before {\n  content: \"\\f2a2\";\n}\n\n.fa-tree-city::before {\n  content: \"\\e587\";\n}\n\n.fa-play::before {\n  content: \"\\f04b\";\n}\n\n.fa-font::before {\n  content: \"\\f031\";\n}\n\n.fa-table-cells-row-lock::before {\n  content: \"\\e67a\";\n}\n\n.fa-rupiah-sign::before {\n  content: \"\\e23d\";\n}\n\n.fa-magnifying-glass::before {\n  content: \"\\f002\";\n}\n\n.fa-search::before {\n  content: \"\\f002\";\n}\n\n.fa-table-tennis-paddle-ball::before {\n  content: \"\\f45d\";\n}\n\n.fa-ping-pong-paddle-ball::before {\n  content: \"\\f45d\";\n}\n\n.fa-table-tennis::before {\n  content: \"\\f45d\";\n}\n\n.fa-person-dots-from-line::before {\n  content: \"\\f470\";\n}\n\n.fa-diagnoses::before {\n  content: \"\\f470\";\n}\n\n.fa-trash-can-arrow-up::before {\n  content: \"\\f82a\";\n}\n\n.fa-trash-restore-alt::before {\n  content: \"\\f82a\";\n}\n\n.fa-naira-sign::before {\n  content: \"\\e1f6\";\n}\n\n.fa-cart-arrow-down::before {\n  content: \"\\f218\";\n}\n\n.fa-walkie-talkie::before {\n  content: \"\\f8ef\";\n}\n\n.fa-file-pen::before {\n  content: \"\\f31c\";\n}\n\n.fa-file-edit::before {\n  content: \"\\f31c\";\n}\n\n.fa-receipt::before {\n  content: \"\\f543\";\n}\n\n.fa-square-pen::before {\n  content: \"\\f14b\";\n}\n\n.fa-pen-square::before {\n  content: \"\\f14b\";\n}\n\n.fa-pencil-square::before {\n  content: \"\\f14b\";\n}\n\n.fa-suitcase-rolling::before {\n  content: \"\\f5c1\";\n}\n\n.fa-person-circle-exclamation::before {\n  content: \"\\e53f\";\n}\n\n.fa-chevron-down::before {\n  content: \"\\f078\";\n}\n\n.fa-battery-full::before {\n  content: \"\\f240\";\n}\n\n.fa-battery::before {\n  content: \"\\f240\";\n}\n\n.fa-battery-5::before {\n  content: \"\\f240\";\n}\n\n.fa-skull-crossbones::before {\n  content: \"\\f714\";\n}\n\n.fa-code-compare::before {\n  content: \"\\e13a\";\n}\n\n.fa-list-ul::before {\n  content: \"\\f0ca\";\n}\n\n.fa-list-dots::before {\n  content: \"\\f0ca\";\n}\n\n.fa-school-lock::before {\n  content: \"\\e56f\";\n}\n\n.fa-tower-cell::before {\n  content: \"\\e585\";\n}\n\n.fa-down-long::before {\n  content: \"\\f309\";\n}\n\n.fa-long-arrow-alt-down::before {\n  content: \"\\f309\";\n}\n\n.fa-ranking-star::before {\n  content: \"\\e561\";\n}\n\n.fa-chess-king::before {\n  content: \"\\f43f\";\n}\n\n.fa-person-harassing::before {\n  content: \"\\e549\";\n}\n\n.fa-brazilian-real-sign::before {\n  content: \"\\e46c\";\n}\n\n.fa-landmark-dome::before {\n  content: \"\\f752\";\n}\n\n.fa-landmark-alt::before {\n  content: \"\\f752\";\n}\n\n.fa-arrow-up::before {\n  content: \"\\f062\";\n}\n\n.fa-tv::before {\n  content: \"\\f26c\";\n}\n\n.fa-television::before {\n  content: \"\\f26c\";\n}\n\n.fa-tv-alt::before {\n  content: \"\\f26c\";\n}\n\n.fa-shrimp::before {\n  content: \"\\e448\";\n}\n\n.fa-list-check::before {\n  content: \"\\f0ae\";\n}\n\n.fa-tasks::before {\n  content: \"\\f0ae\";\n}\n\n.fa-jug-detergent::before {\n  content: \"\\e519\";\n}\n\n.fa-circle-user::before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-circle::before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-shield::before {\n  content: \"\\f505\";\n}\n\n.fa-wind::before {\n  content: \"\\f72e\";\n}\n\n.fa-car-burst::before {\n  content: \"\\f5e1\";\n}\n\n.fa-car-crash::before {\n  content: \"\\f5e1\";\n}\n\n.fa-y::before {\n  content: \"Y\";\n}\n\n.fa-person-snowboarding::before {\n  content: \"\\f7ce\";\n}\n\n.fa-snowboarding::before {\n  content: \"\\f7ce\";\n}\n\n.fa-truck-fast::before {\n  content: \"\\f48b\";\n}\n\n.fa-shipping-fast::before {\n  content: \"\\f48b\";\n}\n\n.fa-fish::before {\n  content: \"\\f578\";\n}\n\n.fa-user-graduate::before {\n  content: \"\\f501\";\n}\n\n.fa-circle-half-stroke::before {\n  content: \"\\f042\";\n}\n\n.fa-adjust::before {\n  content: \"\\f042\";\n}\n\n.fa-clapperboard::before {\n  content: \"\\e131\";\n}\n\n.fa-circle-radiation::before {\n  content: \"\\f7ba\";\n}\n\n.fa-radiation-alt::before {\n  content: \"\\f7ba\";\n}\n\n.fa-baseball::before {\n  content: \"\\f433\";\n}\n\n.fa-baseball-ball::before {\n  content: \"\\f433\";\n}\n\n.fa-jet-fighter-up::before {\n  content: \"\\e518\";\n}\n\n.fa-diagram-project::before {\n  content: \"\\f542\";\n}\n\n.fa-project-diagram::before {\n  content: \"\\f542\";\n}\n\n.fa-copy::before {\n  content: \"\\f0c5\";\n}\n\n.fa-volume-xmark::before {\n  content: \"\\f6a9\";\n}\n\n.fa-volume-mute::before {\n  content: \"\\f6a9\";\n}\n\n.fa-volume-times::before {\n  content: \"\\f6a9\";\n}\n\n.fa-hand-sparkles::before {\n  content: \"\\e05d\";\n}\n\n.fa-grip::before {\n  content: \"\\f58d\";\n}\n\n.fa-grip-horizontal::before {\n  content: \"\\f58d\";\n}\n\n.fa-share-from-square::before {\n  content: \"\\f14d\";\n}\n\n.fa-share-square::before {\n  content: \"\\f14d\";\n}\n\n.fa-child-combatant::before {\n  content: \"\\e4e0\";\n}\n\n.fa-child-rifle::before {\n  content: \"\\e4e0\";\n}\n\n.fa-gun::before {\n  content: \"\\e19b\";\n}\n\n.fa-square-phone::before {\n  content: \"\\f098\";\n}\n\n.fa-phone-square::before {\n  content: \"\\f098\";\n}\n\n.fa-plus::before {\n  content: \"\\+\";\n}\n\n.fa-add::before {\n  content: \"\\+\";\n}\n\n.fa-expand::before {\n  content: \"\\f065\";\n}\n\n.fa-computer::before {\n  content: \"\\e4e5\";\n}\n\n.fa-xmark::before {\n  content: \"\\f00d\";\n}\n\n.fa-close::before {\n  content: \"\\f00d\";\n}\n\n.fa-multiply::before {\n  content: \"\\f00d\";\n}\n\n.fa-remove::before {\n  content: \"\\f00d\";\n}\n\n.fa-times::before {\n  content: \"\\f00d\";\n}\n\n.fa-arrows-up-down-left-right::before {\n  content: \"\\f047\";\n}\n\n.fa-arrows::before {\n  content: \"\\f047\";\n}\n\n.fa-chalkboard-user::before {\n  content: \"\\f51c\";\n}\n\n.fa-chalkboard-teacher::before {\n  content: \"\\f51c\";\n}\n\n.fa-peso-sign::before {\n  content: \"\\e222\";\n}\n\n.fa-building-shield::before {\n  content: \"\\e4d8\";\n}\n\n.fa-baby::before {\n  content: \"\\f77c\";\n}\n\n.fa-users-line::before {\n  content: \"\\e592\";\n}\n\n.fa-quote-left::before {\n  content: \"\\f10d\";\n}\n\n.fa-quote-left-alt::before {\n  content: \"\\f10d\";\n}\n\n.fa-tractor::before {\n  content: \"\\f722\";\n}\n\n.fa-trash-arrow-up::before {\n  content: \"\\f829\";\n}\n\n.fa-trash-restore::before {\n  content: \"\\f829\";\n}\n\n.fa-arrow-down-up-lock::before {\n  content: \"\\e4b0\";\n}\n\n.fa-lines-leaning::before {\n  content: \"\\e51e\";\n}\n\n.fa-ruler-combined::before {\n  content: \"\\f546\";\n}\n\n.fa-copyright::before {\n  content: \"\\f1f9\";\n}\n\n.fa-equals::before {\n  content: \"\\=\";\n}\n\n.fa-blender::before {\n  content: \"\\f517\";\n}\n\n.fa-teeth::before {\n  content: \"\\f62e\";\n}\n\n.fa-shekel-sign::before {\n  content: \"\\f20b\";\n}\n\n.fa-ils::before {\n  content: \"\\f20b\";\n}\n\n.fa-shekel::before {\n  content: \"\\f20b\";\n}\n\n.fa-sheqel::before {\n  content: \"\\f20b\";\n}\n\n.fa-sheqel-sign::before {\n  content: \"\\f20b\";\n}\n\n.fa-map::before {\n  content: \"\\f279\";\n}\n\n.fa-rocket::before {\n  content: \"\\f135\";\n}\n\n.fa-photo-film::before {\n  content: \"\\f87c\";\n}\n\n.fa-photo-video::before {\n  content: \"\\f87c\";\n}\n\n.fa-folder-minus::before {\n  content: \"\\f65d\";\n}\n\n.fa-store::before {\n  content: \"\\f54e\";\n}\n\n.fa-arrow-trend-up::before {\n  content: \"\\e098\";\n}\n\n.fa-plug-circle-minus::before {\n  content: \"\\e55e\";\n}\n\n.fa-sign-hanging::before {\n  content: \"\\f4d9\";\n}\n\n.fa-sign::before {\n  content: \"\\f4d9\";\n}\n\n.fa-bezier-curve::before {\n  content: \"\\f55b\";\n}\n\n.fa-bell-slash::before {\n  content: \"\\f1f6\";\n}\n\n.fa-tablet::before {\n  content: \"\\f3fb\";\n}\n\n.fa-tablet-android::before {\n  content: \"\\f3fb\";\n}\n\n.fa-school-flag::before {\n  content: \"\\e56e\";\n}\n\n.fa-fill::before {\n  content: \"\\f575\";\n}\n\n.fa-angle-up::before {\n  content: \"\\f106\";\n}\n\n.fa-drumstick-bite::before {\n  content: \"\\f6d7\";\n}\n\n.fa-holly-berry::before {\n  content: \"\\f7aa\";\n}\n\n.fa-chevron-left::before {\n  content: \"\\f053\";\n}\n\n.fa-bacteria::before {\n  content: \"\\e059\";\n}\n\n.fa-hand-lizard::before {\n  content: \"\\f258\";\n}\n\n.fa-notdef::before {\n  content: \"\\e1fe\";\n}\n\n.fa-disease::before {\n  content: \"\\f7fa\";\n}\n\n.fa-briefcase-medical::before {\n  content: \"\\f469\";\n}\n\n.fa-genderless::before {\n  content: \"\\f22d\";\n}\n\n.fa-chevron-right::before {\n  content: \"\\f054\";\n}\n\n.fa-retweet::before {\n  content: \"\\f079\";\n}\n\n.fa-car-rear::before {\n  content: \"\\f5de\";\n}\n\n.fa-car-alt::before {\n  content: \"\\f5de\";\n}\n\n.fa-pump-soap::before {\n  content: \"\\e06b\";\n}\n\n.fa-video-slash::before {\n  content: \"\\f4e2\";\n}\n\n.fa-battery-quarter::before {\n  content: \"\\f243\";\n}\n\n.fa-battery-2::before {\n  content: \"\\f243\";\n}\n\n.fa-radio::before {\n  content: \"\\f8d7\";\n}\n\n.fa-baby-carriage::before {\n  content: \"\\f77d\";\n}\n\n.fa-carriage-baby::before {\n  content: \"\\f77d\";\n}\n\n.fa-traffic-light::before {\n  content: \"\\f637\";\n}\n\n.fa-thermometer::before {\n  content: \"\\f491\";\n}\n\n.fa-vr-cardboard::before {\n  content: \"\\f729\";\n}\n\n.fa-hand-middle-finger::before {\n  content: \"\\f806\";\n}\n\n.fa-percent::before {\n  content: \"\\%\";\n}\n\n.fa-percentage::before {\n  content: \"\\%\";\n}\n\n.fa-truck-moving::before {\n  content: \"\\f4df\";\n}\n\n.fa-glass-water-droplet::before {\n  content: \"\\e4f5\";\n}\n\n.fa-display::before {\n  content: \"\\e163\";\n}\n\n.fa-face-smile::before {\n  content: \"\\f118\";\n}\n\n.fa-smile::before {\n  content: \"\\f118\";\n}\n\n.fa-thumbtack::before {\n  content: \"\\f08d\";\n}\n\n.fa-thumb-tack::before {\n  content: \"\\f08d\";\n}\n\n.fa-trophy::before {\n  content: \"\\f091\";\n}\n\n.fa-person-praying::before {\n  content: \"\\f683\";\n}\n\n.fa-pray::before {\n  content: \"\\f683\";\n}\n\n.fa-hammer::before {\n  content: \"\\f6e3\";\n}\n\n.fa-hand-peace::before {\n  content: \"\\f25b\";\n}\n\n.fa-rotate::before {\n  content: \"\\f2f1\";\n}\n\n.fa-sync-alt::before {\n  content: \"\\f2f1\";\n}\n\n.fa-spinner::before {\n  content: \"\\f110\";\n}\n\n.fa-robot::before {\n  content: \"\\f544\";\n}\n\n.fa-peace::before {\n  content: \"\\f67c\";\n}\n\n.fa-gears::before {\n  content: \"\\f085\";\n}\n\n.fa-cogs::before {\n  content: \"\\f085\";\n}\n\n.fa-warehouse::before {\n  content: \"\\f494\";\n}\n\n.fa-arrow-up-right-dots::before {\n  content: \"\\e4b7\";\n}\n\n.fa-splotch::before {\n  content: \"\\f5bc\";\n}\n\n.fa-face-grin-hearts::before {\n  content: \"\\f584\";\n}\n\n.fa-grin-hearts::before {\n  content: \"\\f584\";\n}\n\n.fa-dice-four::before {\n  content: \"\\f524\";\n}\n\n.fa-sim-card::before {\n  content: \"\\f7c4\";\n}\n\n.fa-transgender::before {\n  content: \"\\f225\";\n}\n\n.fa-transgender-alt::before {\n  content: \"\\f225\";\n}\n\n.fa-mercury::before {\n  content: \"\\f223\";\n}\n\n.fa-arrow-turn-down::before {\n  content: \"\\f149\";\n}\n\n.fa-level-down::before {\n  content: \"\\f149\";\n}\n\n.fa-person-falling-burst::before {\n  content: \"\\e547\";\n}\n\n.fa-award::before {\n  content: \"\\f559\";\n}\n\n.fa-ticket-simple::before {\n  content: \"\\f3ff\";\n}\n\n.fa-ticket-alt::before {\n  content: \"\\f3ff\";\n}\n\n.fa-building::before {\n  content: \"\\f1ad\";\n}\n\n.fa-angles-left::before {\n  content: \"\\f100\";\n}\n\n.fa-angle-double-left::before {\n  content: \"\\f100\";\n}\n\n.fa-qrcode::before {\n  content: \"\\f029\";\n}\n\n.fa-clock-rotate-left::before {\n  content: \"\\f1da\";\n}\n\n.fa-history::before {\n  content: \"\\f1da\";\n}\n\n.fa-face-grin-beam-sweat::before {\n  content: \"\\f583\";\n}\n\n.fa-grin-beam-sweat::before {\n  content: \"\\f583\";\n}\n\n.fa-file-export::before {\n  content: \"\\f56e\";\n}\n\n.fa-arrow-right-from-file::before {\n  content: \"\\f56e\";\n}\n\n.fa-shield::before {\n  content: \"\\f132\";\n}\n\n.fa-shield-blank::before {\n  content: \"\\f132\";\n}\n\n.fa-arrow-up-short-wide::before {\n  content: \"\\f885\";\n}\n\n.fa-sort-amount-up-alt::before {\n  content: \"\\f885\";\n}\n\n.fa-house-medical::before {\n  content: \"\\e3b2\";\n}\n\n.fa-golf-ball-tee::before {\n  content: \"\\f450\";\n}\n\n.fa-golf-ball::before {\n  content: \"\\f450\";\n}\n\n.fa-circle-chevron-left::before {\n  content: \"\\f137\";\n}\n\n.fa-chevron-circle-left::before {\n  content: \"\\f137\";\n}\n\n.fa-house-chimney-window::before {\n  content: \"\\e00d\";\n}\n\n.fa-pen-nib::before {\n  content: \"\\f5ad\";\n}\n\n.fa-tent-arrow-turn-left::before {\n  content: \"\\e580\";\n}\n\n.fa-tents::before {\n  content: \"\\e582\";\n}\n\n.fa-wand-magic::before {\n  content: \"\\f0d0\";\n}\n\n.fa-magic::before {\n  content: \"\\f0d0\";\n}\n\n.fa-dog::before {\n  content: \"\\f6d3\";\n}\n\n.fa-carrot::before {\n  content: \"\\f787\";\n}\n\n.fa-moon::before {\n  content: \"\\f186\";\n}\n\n.fa-wine-glass-empty::before {\n  content: \"\\f5ce\";\n}\n\n.fa-wine-glass-alt::before {\n  content: \"\\f5ce\";\n}\n\n.fa-cheese::before {\n  content: \"\\f7ef\";\n}\n\n.fa-yin-yang::before {\n  content: \"\\f6ad\";\n}\n\n.fa-music::before {\n  content: \"\\f001\";\n}\n\n.fa-code-commit::before {\n  content: \"\\f386\";\n}\n\n.fa-temperature-low::before {\n  content: \"\\f76b\";\n}\n\n.fa-person-biking::before {\n  content: \"\\f84a\";\n}\n\n.fa-biking::before {\n  content: \"\\f84a\";\n}\n\n.fa-broom::before {\n  content: \"\\f51a\";\n}\n\n.fa-shield-heart::before {\n  content: \"\\e574\";\n}\n\n.fa-gopuram::before {\n  content: \"\\f664\";\n}\n\n.fa-earth-oceania::before {\n  content: \"\\e47b\";\n}\n\n.fa-globe-oceania::before {\n  content: \"\\e47b\";\n}\n\n.fa-square-xmark::before {\n  content: \"\\f2d3\";\n}\n\n.fa-times-square::before {\n  content: \"\\f2d3\";\n}\n\n.fa-xmark-square::before {\n  content: \"\\f2d3\";\n}\n\n.fa-hashtag::before {\n  content: \"\\#\";\n}\n\n.fa-up-right-and-down-left-from-center::before {\n  content: \"\\f424\";\n}\n\n.fa-expand-alt::before {\n  content: \"\\f424\";\n}\n\n.fa-oil-can::before {\n  content: \"\\f613\";\n}\n\n.fa-t::before {\n  content: \"T\";\n}\n\n.fa-hippo::before {\n  content: \"\\f6ed\";\n}\n\n.fa-chart-column::before {\n  content: \"\\e0e3\";\n}\n\n.fa-infinity::before {\n  content: \"\\f534\";\n}\n\n.fa-vial-circle-check::before {\n  content: \"\\e596\";\n}\n\n.fa-person-arrow-down-to-line::before {\n  content: \"\\e538\";\n}\n\n.fa-voicemail::before {\n  content: \"\\f897\";\n}\n\n.fa-fan::before {\n  content: \"\\f863\";\n}\n\n.fa-person-walking-luggage::before {\n  content: \"\\e554\";\n}\n\n.fa-up-down::before {\n  content: \"\\f338\";\n}\n\n.fa-arrows-alt-v::before {\n  content: \"\\f338\";\n}\n\n.fa-cloud-moon-rain::before {\n  content: \"\\f73c\";\n}\n\n.fa-calendar::before {\n  content: \"\\f133\";\n}\n\n.fa-trailer::before {\n  content: \"\\e041\";\n}\n\n.fa-bahai::before {\n  content: \"\\f666\";\n}\n\n.fa-haykal::before {\n  content: \"\\f666\";\n}\n\n.fa-sd-card::before {\n  content: \"\\f7c2\";\n}\n\n.fa-dragon::before {\n  content: \"\\f6d5\";\n}\n\n.fa-shoe-prints::before {\n  content: \"\\f54b\";\n}\n\n.fa-circle-plus::before {\n  content: \"\\f055\";\n}\n\n.fa-plus-circle::before {\n  content: \"\\f055\";\n}\n\n.fa-face-grin-tongue-wink::before {\n  content: \"\\f58b\";\n}\n\n.fa-grin-tongue-wink::before {\n  content: \"\\f58b\";\n}\n\n.fa-hand-holding::before {\n  content: \"\\f4bd\";\n}\n\n.fa-plug-circle-exclamation::before {\n  content: \"\\e55d\";\n}\n\n.fa-link-slash::before {\n  content: \"\\f127\";\n}\n\n.fa-chain-broken::before {\n  content: \"\\f127\";\n}\n\n.fa-chain-slash::before {\n  content: \"\\f127\";\n}\n\n.fa-unlink::before {\n  content: \"\\f127\";\n}\n\n.fa-clone::before {\n  content: \"\\f24d\";\n}\n\n.fa-person-walking-arrow-loop-left::before {\n  content: \"\\e551\";\n}\n\n.fa-arrow-up-z-a::before {\n  content: \"\\f882\";\n}\n\n.fa-sort-alpha-up-alt::before {\n  content: \"\\f882\";\n}\n\n.fa-fire-flame-curved::before {\n  content: \"\\f7e4\";\n}\n\n.fa-fire-alt::before {\n  content: \"\\f7e4\";\n}\n\n.fa-tornado::before {\n  content: \"\\f76f\";\n}\n\n.fa-file-circle-plus::before {\n  content: \"\\e494\";\n}\n\n.fa-book-quran::before {\n  content: \"\\f687\";\n}\n\n.fa-quran::before {\n  content: \"\\f687\";\n}\n\n.fa-anchor::before {\n  content: \"\\f13d\";\n}\n\n.fa-border-all::before {\n  content: \"\\f84c\";\n}\n\n.fa-face-angry::before {\n  content: \"\\f556\";\n}\n\n.fa-angry::before {\n  content: \"\\f556\";\n}\n\n.fa-cookie-bite::before {\n  content: \"\\f564\";\n}\n\n.fa-arrow-trend-down::before {\n  content: \"\\e097\";\n}\n\n.fa-rss::before {\n  content: \"\\f09e\";\n}\n\n.fa-feed::before {\n  content: \"\\f09e\";\n}\n\n.fa-draw-polygon::before {\n  content: \"\\f5ee\";\n}\n\n.fa-scale-balanced::before {\n  content: \"\\f24e\";\n}\n\n.fa-balance-scale::before {\n  content: \"\\f24e\";\n}\n\n.fa-gauge-simple-high::before {\n  content: \"\\f62a\";\n}\n\n.fa-tachometer::before {\n  content: \"\\f62a\";\n}\n\n.fa-tachometer-fast::before {\n  content: \"\\f62a\";\n}\n\n.fa-shower::before {\n  content: \"\\f2cc\";\n}\n\n.fa-desktop::before {\n  content: \"\\f390\";\n}\n\n.fa-desktop-alt::before {\n  content: \"\\f390\";\n}\n\n.fa-m::before {\n  content: \"M\";\n}\n\n.fa-table-list::before {\n  content: \"\\f00b\";\n}\n\n.fa-th-list::before {\n  content: \"\\f00b\";\n}\n\n.fa-comment-sms::before {\n  content: \"\\f7cd\";\n}\n\n.fa-sms::before {\n  content: \"\\f7cd\";\n}\n\n.fa-book::before {\n  content: \"\\f02d\";\n}\n\n.fa-user-plus::before {\n  content: \"\\f234\";\n}\n\n.fa-check::before {\n  content: \"\\f00c\";\n}\n\n.fa-battery-three-quarters::before {\n  content: \"\\f241\";\n}\n\n.fa-battery-4::before {\n  content: \"\\f241\";\n}\n\n.fa-house-circle-check::before {\n  content: \"\\e509\";\n}\n\n.fa-angle-left::before {\n  content: \"\\f104\";\n}\n\n.fa-diagram-successor::before {\n  content: \"\\e47a\";\n}\n\n.fa-truck-arrow-right::before {\n  content: \"\\e58b\";\n}\n\n.fa-arrows-split-up-and-left::before {\n  content: \"\\e4bc\";\n}\n\n.fa-hand-fist::before {\n  content: \"\\f6de\";\n}\n\n.fa-fist-raised::before {\n  content: \"\\f6de\";\n}\n\n.fa-cloud-moon::before {\n  content: \"\\f6c3\";\n}\n\n.fa-briefcase::before {\n  content: \"\\f0b1\";\n}\n\n.fa-person-falling::before {\n  content: \"\\e546\";\n}\n\n.fa-image-portrait::before {\n  content: \"\\f3e0\";\n}\n\n.fa-portrait::before {\n  content: \"\\f3e0\";\n}\n\n.fa-user-tag::before {\n  content: \"\\f507\";\n}\n\n.fa-rug::before {\n  content: \"\\e569\";\n}\n\n.fa-earth-europe::before {\n  content: \"\\f7a2\";\n}\n\n.fa-globe-europe::before {\n  content: \"\\f7a2\";\n}\n\n.fa-cart-flatbed-suitcase::before {\n  content: \"\\f59d\";\n}\n\n.fa-luggage-cart::before {\n  content: \"\\f59d\";\n}\n\n.fa-rectangle-xmark::before {\n  content: \"\\f410\";\n}\n\n.fa-rectangle-times::before {\n  content: \"\\f410\";\n}\n\n.fa-times-rectangle::before {\n  content: \"\\f410\";\n}\n\n.fa-window-close::before {\n  content: \"\\f410\";\n}\n\n.fa-baht-sign::before {\n  content: \"\\e0ac\";\n}\n\n.fa-book-open::before {\n  content: \"\\f518\";\n}\n\n.fa-book-journal-whills::before {\n  content: \"\\f66a\";\n}\n\n.fa-journal-whills::before {\n  content: \"\\f66a\";\n}\n\n.fa-handcuffs::before {\n  content: \"\\e4f8\";\n}\n\n.fa-triangle-exclamation::before {\n  content: \"\\f071\";\n}\n\n.fa-exclamation-triangle::before {\n  content: \"\\f071\";\n}\n\n.fa-warning::before {\n  content: \"\\f071\";\n}\n\n.fa-database::before {\n  content: \"\\f1c0\";\n}\n\n.fa-share::before {\n  content: \"\\f064\";\n}\n\n.fa-mail-forward::before {\n  content: \"\\f064\";\n}\n\n.fa-bottle-droplet::before {\n  content: \"\\e4c4\";\n}\n\n.fa-mask-face::before {\n  content: \"\\e1d7\";\n}\n\n.fa-hill-rockslide::before {\n  content: \"\\e508\";\n}\n\n.fa-right-left::before {\n  content: \"\\f362\";\n}\n\n.fa-exchange-alt::before {\n  content: \"\\f362\";\n}\n\n.fa-paper-plane::before {\n  content: \"\\f1d8\";\n}\n\n.fa-road-circle-exclamation::before {\n  content: \"\\e565\";\n}\n\n.fa-dungeon::before {\n  content: \"\\f6d9\";\n}\n\n.fa-align-right::before {\n  content: \"\\f038\";\n}\n\n.fa-money-bill-1-wave::before {\n  content: \"\\f53b\";\n}\n\n.fa-money-bill-wave-alt::before {\n  content: \"\\f53b\";\n}\n\n.fa-life-ring::before {\n  content: \"\\f1cd\";\n}\n\n.fa-hands::before {\n  content: \"\\f2a7\";\n}\n\n.fa-sign-language::before {\n  content: \"\\f2a7\";\n}\n\n.fa-signing::before {\n  content: \"\\f2a7\";\n}\n\n.fa-calendar-day::before {\n  content: \"\\f783\";\n}\n\n.fa-water-ladder::before {\n  content: \"\\f5c5\";\n}\n\n.fa-ladder-water::before {\n  content: \"\\f5c5\";\n}\n\n.fa-swimming-pool::before {\n  content: \"\\f5c5\";\n}\n\n.fa-arrows-up-down::before {\n  content: \"\\f07d\";\n}\n\n.fa-arrows-v::before {\n  content: \"\\f07d\";\n}\n\n.fa-face-grimace::before {\n  content: \"\\f57f\";\n}\n\n.fa-grimace::before {\n  content: \"\\f57f\";\n}\n\n.fa-wheelchair-move::before {\n  content: \"\\e2ce\";\n}\n\n.fa-wheelchair-alt::before {\n  content: \"\\e2ce\";\n}\n\n.fa-turn-down::before {\n  content: \"\\f3be\";\n}\n\n.fa-level-down-alt::before {\n  content: \"\\f3be\";\n}\n\n.fa-person-walking-arrow-right::before {\n  content: \"\\e552\";\n}\n\n.fa-square-envelope::before {\n  content: \"\\f199\";\n}\n\n.fa-envelope-square::before {\n  content: \"\\f199\";\n}\n\n.fa-dice::before {\n  content: \"\\f522\";\n}\n\n.fa-bowling-ball::before {\n  content: \"\\f436\";\n}\n\n.fa-brain::before {\n  content: \"\\f5dc\";\n}\n\n.fa-bandage::before {\n  content: \"\\f462\";\n}\n\n.fa-band-aid::before {\n  content: \"\\f462\";\n}\n\n.fa-calendar-minus::before {\n  content: \"\\f272\";\n}\n\n.fa-circle-xmark::before {\n  content: \"\\f057\";\n}\n\n.fa-times-circle::before {\n  content: \"\\f057\";\n}\n\n.fa-xmark-circle::before {\n  content: \"\\f057\";\n}\n\n.fa-gifts::before {\n  content: \"\\f79c\";\n}\n\n.fa-hotel::before {\n  content: \"\\f594\";\n}\n\n.fa-earth-asia::before {\n  content: \"\\f57e\";\n}\n\n.fa-globe-asia::before {\n  content: \"\\f57e\";\n}\n\n.fa-id-card-clip::before {\n  content: \"\\f47f\";\n}\n\n.fa-id-card-alt::before {\n  content: \"\\f47f\";\n}\n\n.fa-magnifying-glass-plus::before {\n  content: \"\\f00e\";\n}\n\n.fa-search-plus::before {\n  content: \"\\f00e\";\n}\n\n.fa-thumbs-up::before {\n  content: \"\\f164\";\n}\n\n.fa-user-clock::before {\n  content: \"\\f4fd\";\n}\n\n.fa-hand-dots::before {\n  content: \"\\f461\";\n}\n\n.fa-allergies::before {\n  content: \"\\f461\";\n}\n\n.fa-file-invoice::before {\n  content: \"\\f570\";\n}\n\n.fa-window-minimize::before {\n  content: \"\\f2d1\";\n}\n\n.fa-mug-saucer::before {\n  content: \"\\f0f4\";\n}\n\n.fa-coffee::before {\n  content: \"\\f0f4\";\n}\n\n.fa-brush::before {\n  content: \"\\f55d\";\n}\n\n.fa-mask::before {\n  content: \"\\f6fa\";\n}\n\n.fa-magnifying-glass-minus::before {\n  content: \"\\f010\";\n}\n\n.fa-search-minus::before {\n  content: \"\\f010\";\n}\n\n.fa-ruler-vertical::before {\n  content: \"\\f548\";\n}\n\n.fa-user-large::before {\n  content: \"\\f406\";\n}\n\n.fa-user-alt::before {\n  content: \"\\f406\";\n}\n\n.fa-train-tram::before {\n  content: \"\\e5b4\";\n}\n\n.fa-user-nurse::before {\n  content: \"\\f82f\";\n}\n\n.fa-syringe::before {\n  content: \"\\f48e\";\n}\n\n.fa-cloud-sun::before {\n  content: \"\\f6c4\";\n}\n\n.fa-stopwatch-20::before {\n  content: \"\\e06f\";\n}\n\n.fa-square-full::before {\n  content: \"\\f45c\";\n}\n\n.fa-magnet::before {\n  content: \"\\f076\";\n}\n\n.fa-jar::before {\n  content: \"\\e516\";\n}\n\n.fa-note-sticky::before {\n  content: \"\\f249\";\n}\n\n.fa-sticky-note::before {\n  content: \"\\f249\";\n}\n\n.fa-bug-slash::before {\n  content: \"\\e490\";\n}\n\n.fa-arrow-up-from-water-pump::before {\n  content: \"\\e4b6\";\n}\n\n.fa-bone::before {\n  content: \"\\f5d7\";\n}\n\n.fa-user-injured::before {\n  content: \"\\f728\";\n}\n\n.fa-face-sad-tear::before {\n  content: \"\\f5b4\";\n}\n\n.fa-sad-tear::before {\n  content: \"\\f5b4\";\n}\n\n.fa-plane::before {\n  content: \"\\f072\";\n}\n\n.fa-tent-arrows-down::before {\n  content: \"\\e581\";\n}\n\n.fa-exclamation::before {\n  content: \"\\!\";\n}\n\n.fa-arrows-spin::before {\n  content: \"\\e4bb\";\n}\n\n.fa-print::before {\n  content: \"\\f02f\";\n}\n\n.fa-turkish-lira-sign::before {\n  content: \"\\e2bb\";\n}\n\n.fa-try::before {\n  content: \"\\e2bb\";\n}\n\n.fa-turkish-lira::before {\n  content: \"\\e2bb\";\n}\n\n.fa-dollar-sign::before {\n  content: \"\\$\";\n}\n\n.fa-dollar::before {\n  content: \"\\$\";\n}\n\n.fa-usd::before {\n  content: \"\\$\";\n}\n\n.fa-x::before {\n  content: \"X\";\n}\n\n.fa-magnifying-glass-dollar::before {\n  content: \"\\f688\";\n}\n\n.fa-search-dollar::before {\n  content: \"\\f688\";\n}\n\n.fa-users-gear::before {\n  content: \"\\f509\";\n}\n\n.fa-users-cog::before {\n  content: \"\\f509\";\n}\n\n.fa-person-military-pointing::before {\n  content: \"\\e54a\";\n}\n\n.fa-building-columns::before {\n  content: \"\\f19c\";\n}\n\n.fa-bank::before {\n  content: \"\\f19c\";\n}\n\n.fa-institution::before {\n  content: \"\\f19c\";\n}\n\n.fa-museum::before {\n  content: \"\\f19c\";\n}\n\n.fa-university::before {\n  content: \"\\f19c\";\n}\n\n.fa-umbrella::before {\n  content: \"\\f0e9\";\n}\n\n.fa-trowel::before {\n  content: \"\\e589\";\n}\n\n.fa-d::before {\n  content: \"D\";\n}\n\n.fa-stapler::before {\n  content: \"\\e5af\";\n}\n\n.fa-masks-theater::before {\n  content: \"\\f630\";\n}\n\n.fa-theater-masks::before {\n  content: \"\\f630\";\n}\n\n.fa-kip-sign::before {\n  content: \"\\e1c4\";\n}\n\n.fa-hand-point-left::before {\n  content: \"\\f0a5\";\n}\n\n.fa-handshake-simple::before {\n  content: \"\\f4c6\";\n}\n\n.fa-handshake-alt::before {\n  content: \"\\f4c6\";\n}\n\n.fa-jet-fighter::before {\n  content: \"\\f0fb\";\n}\n\n.fa-fighter-jet::before {\n  content: \"\\f0fb\";\n}\n\n.fa-square-share-nodes::before {\n  content: \"\\f1e1\";\n}\n\n.fa-share-alt-square::before {\n  content: \"\\f1e1\";\n}\n\n.fa-barcode::before {\n  content: \"\\f02a\";\n}\n\n.fa-plus-minus::before {\n  content: \"\\e43c\";\n}\n\n.fa-video::before {\n  content: \"\\f03d\";\n}\n\n.fa-video-camera::before {\n  content: \"\\f03d\";\n}\n\n.fa-graduation-cap::before {\n  content: \"\\f19d\";\n}\n\n.fa-mortar-board::before {\n  content: \"\\f19d\";\n}\n\n.fa-hand-holding-medical::before {\n  content: \"\\e05c\";\n}\n\n.fa-person-circle-check::before {\n  content: \"\\e53e\";\n}\n\n.fa-turn-up::before {\n  content: \"\\f3bf\";\n}\n\n.fa-level-up-alt::before {\n  content: \"\\f3bf\";\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n:root, :host {\n  --fa-style-family-brands: \"Font Awesome 6 Brands\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\n@font-face {\n  font-family: \"Font Awesome 6 Brands\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\");\n}\n.fab,\n.fa-brands {\n  font-weight: 400;\n}\n\n.fa-monero:before {\n  content: \"\\f3d0\";\n}\n\n.fa-hooli:before {\n  content: \"\\f427\";\n}\n\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n\n.fa-shopware:before {\n  content: \"\\f5b5\";\n}\n\n.fa-creative-commons-nc:before {\n  content: \"\\f4e8\";\n}\n\n.fa-aws:before {\n  content: \"\\f375\";\n}\n\n.fa-redhat:before {\n  content: \"\\f7bc\";\n}\n\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n\n.fa-cloudflare:before {\n  content: \"\\e07d\";\n}\n\n.fa-ups:before {\n  content: \"\\f7e0\";\n}\n\n.fa-pixiv:before {\n  content: \"\\e640\";\n}\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n\n.fa-dyalog:before {\n  content: \"\\f399\";\n}\n\n.fa-bity:before {\n  content: \"\\f37a\";\n}\n\n.fa-stackpath:before {\n  content: \"\\f842\";\n}\n\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n\n.fa-modx:before {\n  content: \"\\f285\";\n}\n\n.fa-guilded:before {\n  content: \"\\e07e\";\n}\n\n.fa-vnv:before {\n  content: \"\\f40b\";\n}\n\n.fa-square-js:before {\n  content: \"\\f3b9\";\n}\n\n.fa-js-square:before {\n  content: \"\\f3b9\";\n}\n\n.fa-microsoft:before {\n  content: \"\\f3ca\";\n}\n\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n\n.fa-orcid:before {\n  content: \"\\f8d2\";\n}\n\n.fa-java:before {\n  content: \"\\f4e4\";\n}\n\n.fa-invision:before {\n  content: \"\\f7b0\";\n}\n\n.fa-creative-commons-pd-alt:before {\n  content: \"\\f4ed\";\n}\n\n.fa-centercode:before {\n  content: \"\\f380\";\n}\n\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n\n.fa-jxl:before {\n  content: \"\\e67b\";\n}\n\n.fa-hire-a-helper:before {\n  content: \"\\f3b0\";\n}\n\n.fa-creative-commons-by:before {\n  content: \"\\f4e7\";\n}\n\n.fa-unity:before {\n  content: \"\\e049\";\n}\n\n.fa-whmcs:before {\n  content: \"\\f40d\";\n}\n\n.fa-rocketchat:before {\n  content: \"\\f3e8\";\n}\n\n.fa-vk:before {\n  content: \"\\f189\";\n}\n\n.fa-untappd:before {\n  content: \"\\f405\";\n}\n\n.fa-mailchimp:before {\n  content: \"\\f59e\";\n}\n\n.fa-css3-alt:before {\n  content: \"\\f38b\";\n}\n\n.fa-square-reddit:before {\n  content: \"\\f1a2\";\n}\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n\n.fa-vimeo-v:before {\n  content: \"\\f27d\";\n}\n\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n\n.fa-square-font-awesome:before {\n  content: \"\\e5ad\";\n}\n\n.fa-deskpro:before {\n  content: \"\\f38f\";\n}\n\n.fa-brave:before {\n  content: \"\\e63c\";\n}\n\n.fa-sistrix:before {\n  content: \"\\f3ee\";\n}\n\n.fa-square-instagram:before {\n  content: \"\\e055\";\n}\n\n.fa-instagram-square:before {\n  content: \"\\e055\";\n}\n\n.fa-battle-net:before {\n  content: \"\\f835\";\n}\n\n.fa-the-red-yeti:before {\n  content: \"\\f69d\";\n}\n\n.fa-square-hacker-news:before {\n  content: \"\\f3af\";\n}\n\n.fa-hacker-news-square:before {\n  content: \"\\f3af\";\n}\n\n.fa-edge:before {\n  content: \"\\f282\";\n}\n\n.fa-threads:before {\n  content: \"\\e618\";\n}\n\n.fa-napster:before {\n  content: \"\\f3d2\";\n}\n\n.fa-square-snapchat:before {\n  content: \"\\f2ad\";\n}\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n\n.fa-google-plus-g:before {\n  content: \"\\f0d5\";\n}\n\n.fa-artstation:before {\n  content: \"\\f77a\";\n}\n\n.fa-markdown:before {\n  content: \"\\f60f\";\n}\n\n.fa-sourcetree:before {\n  content: \"\\f7d3\";\n}\n\n.fa-google-plus:before {\n  content: \"\\f2b3\";\n}\n\n.fa-diaspora:before {\n  content: \"\\f791\";\n}\n\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n\n.fa-phoenix-squadron:before {\n  content: \"\\f511\";\n}\n\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n\n.fa-algolia:before {\n  content: \"\\f36c\";\n}\n\n.fa-red-river:before {\n  content: \"\\f3e3\";\n}\n\n.fa-creative-commons-sa:before {\n  content: \"\\f4ef\";\n}\n\n.fa-safari:before {\n  content: \"\\f267\";\n}\n\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n\n.fa-square-font-awesome-stroke:before {\n  content: \"\\f35c\";\n}\n\n.fa-font-awesome-alt:before {\n  content: \"\\f35c\";\n}\n\n.fa-atlassian:before {\n  content: \"\\f77b\";\n}\n\n.fa-linkedin-in:before {\n  content: \"\\f0e1\";\n}\n\n.fa-digital-ocean:before {\n  content: \"\\f391\";\n}\n\n.fa-nimblr:before {\n  content: \"\\f5a8\";\n}\n\n.fa-chromecast:before {\n  content: \"\\f838\";\n}\n\n.fa-evernote:before {\n  content: \"\\f839\";\n}\n\n.fa-hacker-news:before {\n  content: \"\\f1d4\";\n}\n\n.fa-creative-commons-sampling:before {\n  content: \"\\f4f0\";\n}\n\n.fa-adversal:before {\n  content: \"\\f36a\";\n}\n\n.fa-creative-commons:before {\n  content: \"\\f25e\";\n}\n\n.fa-watchman-monitoring:before {\n  content: \"\\e087\";\n}\n\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n\n.fa-git-alt:before {\n  content: \"\\f841\";\n}\n\n.fa-lyft:before {\n  content: \"\\f3c3\";\n}\n\n.fa-rev:before {\n  content: \"\\f5b2\";\n}\n\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n\n.fa-wizards-of-the-coast:before {\n  content: \"\\f730\";\n}\n\n.fa-square-viadeo:before {\n  content: \"\\f2aa\";\n}\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n\n.fa-centos:before {\n  content: \"\\f789\";\n}\n\n.fa-adn:before {\n  content: \"\\f170\";\n}\n\n.fa-cloudsmith:before {\n  content: \"\\f384\";\n}\n\n.fa-opensuse:before {\n  content: \"\\e62b\";\n}\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n\n.fa-square-dribbble:before {\n  content: \"\\f397\";\n}\n\n.fa-dribbble-square:before {\n  content: \"\\f397\";\n}\n\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n\n.fa-node:before {\n  content: \"\\f419\";\n}\n\n.fa-mix:before {\n  content: \"\\f3cb\";\n}\n\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n\n.fa-cc-apple-pay:before {\n  content: \"\\f416\";\n}\n\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n\n.fa-debian:before {\n  content: \"\\e60b\";\n}\n\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n\n.fa-instalod:before {\n  content: \"\\e081\";\n}\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n\n.fa-sellcast:before {\n  content: \"\\f2da\";\n}\n\n.fa-square-twitter:before {\n  content: \"\\f081\";\n}\n\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n\n.fa-r-project:before {\n  content: \"\\f4f7\";\n}\n\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n\n.fa-freebsd:before {\n  content: \"\\f3a4\";\n}\n\n.fa-vuejs:before {\n  content: \"\\f41f\";\n}\n\n.fa-accusoft:before {\n  content: \"\\f369\";\n}\n\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n\n.fa-fonticons-fi:before {\n  content: \"\\f3a2\";\n}\n\n.fa-app-store:before {\n  content: \"\\f36f\";\n}\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n\n.fa-itunes-note:before {\n  content: \"\\f3b5\";\n}\n\n.fa-golang:before {\n  content: \"\\e40f\";\n}\n\n.fa-kickstarter:before {\n  content: \"\\f3bb\";\n}\n\n.fa-square-kickstarter:before {\n  content: \"\\f3bb\";\n}\n\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n\n.fa-uncharted:before {\n  content: \"\\e084\";\n}\n\n.fa-firstdraft:before {\n  content: \"\\f3a1\";\n}\n\n.fa-square-youtube:before {\n  content: \"\\f431\";\n}\n\n.fa-youtube-square:before {\n  content: \"\\f431\";\n}\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n\n.fa-wpressr:before {\n  content: \"\\f3e4\";\n}\n\n.fa-rendact:before {\n  content: \"\\f3e4\";\n}\n\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n\n.fa-galactic-republic:before {\n  content: \"\\f50c\";\n}\n\n.fa-nfc-directional:before {\n  content: \"\\e530\";\n}\n\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n\n.fa-joget:before {\n  content: \"\\f3b7\";\n}\n\n.fa-fedora:before {\n  content: \"\\f798\";\n}\n\n.fa-stripe-s:before {\n  content: \"\\f42a\";\n}\n\n.fa-meta:before {\n  content: \"\\e49b\";\n}\n\n.fa-laravel:before {\n  content: \"\\f3bd\";\n}\n\n.fa-hotjar:before {\n  content: \"\\f3b1\";\n}\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n\n.fa-square-letterboxd:before {\n  content: \"\\e62e\";\n}\n\n.fa-sticker-mule:before {\n  content: \"\\f3f7\";\n}\n\n.fa-creative-commons-zero:before {\n  content: \"\\f4f3\";\n}\n\n.fa-hips:before {\n  content: \"\\f452\";\n}\n\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n\n.fa-discord:before {\n  content: \"\\f392\";\n}\n\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n\n.fa-app-store-ios:before {\n  content: \"\\f370\";\n}\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n\n.fa-confluence:before {\n  content: \"\\f78d\";\n}\n\n.fa-shoelace:before {\n  content: \"\\e60c\";\n}\n\n.fa-mdb:before {\n  content: \"\\f8ca\";\n}\n\n.fa-dochub:before {\n  content: \"\\f394\";\n}\n\n.fa-accessible-icon:before {\n  content: \"\\f368\";\n}\n\n.fa-ebay:before {\n  content: \"\\f4f4\";\n}\n\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n\n.fa-unsplash:before {\n  content: \"\\e07c\";\n}\n\n.fa-yarn:before {\n  content: \"\\f7e3\";\n}\n\n.fa-square-steam:before {\n  content: \"\\f1b7\";\n}\n\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n\n.fa-square-vimeo:before {\n  content: \"\\f194\";\n}\n\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n\n.fa-asymmetrik:before {\n  content: \"\\f372\";\n}\n\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n\n.fa-font-awesome-flag:before {\n  content: \"\\f2b4\";\n}\n\n.fa-font-awesome-logo-full:before {\n  content: \"\\f2b4\";\n}\n\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n\n.fa-apple:before {\n  content: \"\\f179\";\n}\n\n.fa-hive:before {\n  content: \"\\e07f\";\n}\n\n.fa-gitkraken:before {\n  content: \"\\f3a6\";\n}\n\n.fa-keybase:before {\n  content: \"\\f4f5\";\n}\n\n.fa-apple-pay:before {\n  content: \"\\f415\";\n}\n\n.fa-padlet:before {\n  content: \"\\e4a0\";\n}\n\n.fa-amazon-pay:before {\n  content: \"\\f42c\";\n}\n\n.fa-square-github:before {\n  content: \"\\f092\";\n}\n\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n\n.fa-fedex:before {\n  content: \"\\f797\";\n}\n\n.fa-phoenix-framework:before {\n  content: \"\\f3dc\";\n}\n\n.fa-shopify:before {\n  content: \"\\e057\";\n}\n\n.fa-neos:before {\n  content: \"\\f612\";\n}\n\n.fa-square-threads:before {\n  content: \"\\e619\";\n}\n\n.fa-hackerrank:before {\n  content: \"\\f5f7\";\n}\n\n.fa-researchgate:before {\n  content: \"\\f4f8\";\n}\n\n.fa-swift:before {\n  content: \"\\f8e1\";\n}\n\n.fa-angular:before {\n  content: \"\\f420\";\n}\n\n.fa-speakap:before {\n  content: \"\\f3f3\";\n}\n\n.fa-angrycreative:before {\n  content: \"\\f36e\";\n}\n\n.fa-y-combinator:before {\n  content: \"\\f23b\";\n}\n\n.fa-empire:before {\n  content: \"\\f1d1\";\n}\n\n.fa-envira:before {\n  content: \"\\f299\";\n}\n\n.fa-google-scholar:before {\n  content: \"\\e63b\";\n}\n\n.fa-square-gitlab:before {\n  content: \"\\e5ae\";\n}\n\n.fa-gitlab-square:before {\n  content: \"\\e5ae\";\n}\n\n.fa-studiovinari:before {\n  content: \"\\f3f8\";\n}\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n\n.fa-goodreads:before {\n  content: \"\\f3a8\";\n}\n\n.fa-square-odnoklassniki:before {\n  content: \"\\f264\";\n}\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n\n.fa-sith:before {\n  content: \"\\f512\";\n}\n\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n\n.fa-page4:before {\n  content: \"\\f3d7\";\n}\n\n.fa-hashnode:before {\n  content: \"\\e499\";\n}\n\n.fa-react:before {\n  content: \"\\f41b\";\n}\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n\n.fa-squarespace:before {\n  content: \"\\f5be\";\n}\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n\n.fa-creative-commons-share:before {\n  content: \"\\f4f2\";\n}\n\n.fa-bitcoin:before {\n  content: \"\\f379\";\n}\n\n.fa-keycdn:before {\n  content: \"\\f3ba\";\n}\n\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n\n.fa-itch-io:before {\n  content: \"\\f83a\";\n}\n\n.fa-umbraco:before {\n  content: \"\\f8e8\";\n}\n\n.fa-galactic-senate:before {\n  content: \"\\f50d\";\n}\n\n.fa-ubuntu:before {\n  content: \"\\f7df\";\n}\n\n.fa-draft2digital:before {\n  content: \"\\f396\";\n}\n\n.fa-stripe:before {\n  content: \"\\f429\";\n}\n\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n\n.fa-gg:before {\n  content: \"\\f260\";\n}\n\n.fa-dhl:before {\n  content: \"\\f790\";\n}\n\n.fa-square-pinterest:before {\n  content: \"\\f0d3\";\n}\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n\n.fa-xing:before {\n  content: \"\\f168\";\n}\n\n.fa-blackberry:before {\n  content: \"\\f37b\";\n}\n\n.fa-creative-commons-pd:before {\n  content: \"\\f4ec\";\n}\n\n.fa-playstation:before {\n  content: \"\\f3df\";\n}\n\n.fa-quinscape:before {\n  content: \"\\f459\";\n}\n\n.fa-less:before {\n  content: \"\\f41d\";\n}\n\n.fa-blogger-b:before {\n  content: \"\\f37d\";\n}\n\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n\n.fa-signal-messenger:before {\n  content: \"\\e663\";\n}\n\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n\n.fa-typo3:before {\n  content: \"\\f42b\";\n}\n\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n\n.fa-dailymotion:before {\n  content: \"\\e052\";\n}\n\n.fa-affiliatetheme:before {\n  content: \"\\f36b\";\n}\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n\n.fa-bootstrap:before {\n  content: \"\\f836\";\n}\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n\n.fa-nfc-symbol:before {\n  content: \"\\e531\";\n}\n\n.fa-mintbit:before {\n  content: \"\\e62f\";\n}\n\n.fa-ethereum:before {\n  content: \"\\f42e\";\n}\n\n.fa-speaker-deck:before {\n  content: \"\\f83c\";\n}\n\n.fa-creative-commons-nc-eu:before {\n  content: \"\\f4e9\";\n}\n\n.fa-patreon:before {\n  content: \"\\f3d9\";\n}\n\n.fa-avianex:before {\n  content: \"\\f374\";\n}\n\n.fa-ello:before {\n  content: \"\\f5f1\";\n}\n\n.fa-gofore:before {\n  content: \"\\f3a7\";\n}\n\n.fa-bimobject:before {\n  content: \"\\f378\";\n}\n\n.fa-brave-reverse:before {\n  content: \"\\e63d\";\n}\n\n.fa-facebook-f:before {\n  content: \"\\f39e\";\n}\n\n.fa-square-google-plus:before {\n  content: \"\\f0d4\";\n}\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n\n.fa-web-awesome:before {\n  content: \"\\e682\";\n}\n\n.fa-mandalorian:before {\n  content: \"\\f50f\";\n}\n\n.fa-first-order-alt:before {\n  content: \"\\f50a\";\n}\n\n.fa-osi:before {\n  content: \"\\f41a\";\n}\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n\n.fa-d-and-d-beyond:before {\n  content: \"\\f6ca\";\n}\n\n.fa-periscope:before {\n  content: \"\\f3da\";\n}\n\n.fa-fulcrum:before {\n  content: \"\\f50b\";\n}\n\n.fa-cloudscale:before {\n  content: \"\\f383\";\n}\n\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n\n.fa-mizuni:before {\n  content: \"\\f3cc\";\n}\n\n.fa-schlix:before {\n  content: \"\\f3ea\";\n}\n\n.fa-square-xing:before {\n  content: \"\\f169\";\n}\n\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n\n.fa-cloudversify:before {\n  content: \"\\f385\";\n}\n\n.fa-usps:before {\n  content: \"\\f7e1\";\n}\n\n.fa-megaport:before {\n  content: \"\\f5a3\";\n}\n\n.fa-magento:before {\n  content: \"\\f3c4\";\n}\n\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n\n.fa-fly:before {\n  content: \"\\f417\";\n}\n\n.fa-aviato:before {\n  content: \"\\f421\";\n}\n\n.fa-itunes:before {\n  content: \"\\f3b4\";\n}\n\n.fa-cuttlefish:before {\n  content: \"\\f38c\";\n}\n\n.fa-blogger:before {\n  content: \"\\f37c\";\n}\n\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n\n.fa-viber:before {\n  content: \"\\f409\";\n}\n\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n\n.fa-letterboxd:before {\n  content: \"\\e62d\";\n}\n\n.fa-symfony:before {\n  content: \"\\f83d\";\n}\n\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n\n.fa-facebook-messenger:before {\n  content: \"\\f39f\";\n}\n\n.fa-audible:before {\n  content: \"\\f373\";\n}\n\n.fa-think-peaks:before {\n  content: \"\\f731\";\n}\n\n.fa-bilibili:before {\n  content: \"\\e3d9\";\n}\n\n.fa-erlang:before {\n  content: \"\\f39d\";\n}\n\n.fa-x-twitter:before {\n  content: \"\\e61b\";\n}\n\n.fa-cotton-bureau:before {\n  content: \"\\f89e\";\n}\n\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n\n.fa-42-group:before {\n  content: \"\\e080\";\n}\n\n.fa-innosoft:before {\n  content: \"\\e080\";\n}\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n\n.fa-elementor:before {\n  content: \"\\f430\";\n}\n\n.fa-square-pied-piper:before {\n  content: \"\\e01e\";\n}\n\n.fa-pied-piper-square:before {\n  content: \"\\e01e\";\n}\n\n.fa-creative-commons-nd:before {\n  content: \"\\f4eb\";\n}\n\n.fa-palfed:before {\n  content: \"\\f3d8\";\n}\n\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n\n.fa-resolving:before {\n  content: \"\\f3e7\";\n}\n\n.fa-xbox:before {\n  content: \"\\f412\";\n}\n\n.fa-square-web-awesome-stroke:before {\n  content: \"\\e684\";\n}\n\n.fa-searchengin:before {\n  content: \"\\f3eb\";\n}\n\n.fa-tiktok:before {\n  content: \"\\e07b\";\n}\n\n.fa-square-facebook:before {\n  content: \"\\f082\";\n}\n\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n\n.fa-linkedin:before {\n  content: \"\\f08c\";\n}\n\n.fa-hubspot:before {\n  content: \"\\f3b2\";\n}\n\n.fa-deploydog:before {\n  content: \"\\f38e\";\n}\n\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n\n.fa-mixer:before {\n  content: \"\\e056\";\n}\n\n.fa-square-lastfm:before {\n  content: \"\\f203\";\n}\n\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n\n.fa-vimeo:before {\n  content: \"\\f40a\";\n}\n\n.fa-mendeley:before {\n  content: \"\\f7b3\";\n}\n\n.fa-uniregistry:before {\n  content: \"\\f404\";\n}\n\n.fa-figma:before {\n  content: \"\\f799\";\n}\n\n.fa-creative-commons-remix:before {\n  content: \"\\f4ee\";\n}\n\n.fa-cc-amazon-pay:before {\n  content: \"\\f42d\";\n}\n\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n\n.fa-cmplid:before {\n  content: \"\\e360\";\n}\n\n.fa-upwork:before {\n  content: \"\\e641\";\n}\n\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n\n.fa-gripfire:before {\n  content: \"\\f3ac\";\n}\n\n.fa-jedi-order:before {\n  content: \"\\f50e\";\n}\n\n.fa-uikit:before {\n  content: \"\\f403\";\n}\n\n.fa-fort-awesome-alt:before {\n  content: \"\\f3a3\";\n}\n\n.fa-phabricator:before {\n  content: \"\\f3db\";\n}\n\n.fa-ussunnah:before {\n  content: \"\\f407\";\n}\n\n.fa-earlybirds:before {\n  content: \"\\f39a\";\n}\n\n.fa-trade-federation:before {\n  content: \"\\f513\";\n}\n\n.fa-autoprefixer:before {\n  content: \"\\f41c\";\n}\n\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n\n.fa-square-upwork:before {\n  content: \"\\e67c\";\n}\n\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n\n.fa-google-play:before {\n  content: \"\\f3ab\";\n}\n\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n\n.fa-line:before {\n  content: \"\\f3c0\";\n}\n\n.fa-google-drive:before {\n  content: \"\\f3aa\";\n}\n\n.fa-servicestack:before {\n  content: \"\\f3ec\";\n}\n\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n\n.fa-deezer:before {\n  content: \"\\e077\";\n}\n\n.fa-raspberry-pi:before {\n  content: \"\\f7bb\";\n}\n\n.fa-jira:before {\n  content: \"\\f7b1\";\n}\n\n.fa-docker:before {\n  content: \"\\f395\";\n}\n\n.fa-screenpal:before {\n  content: \"\\e570\";\n}\n\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n\n.fa-gitter:before {\n  content: \"\\f426\";\n}\n\n.fa-d-and-d:before {\n  content: \"\\f38d\";\n}\n\n.fa-microblog:before {\n  content: \"\\e01a\";\n}\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n\n.fa-pied-piper-hat:before {\n  content: \"\\f4e5\";\n}\n\n.fa-kickstarter-k:before {\n  content: \"\\f3bc\";\n}\n\n.fa-yandex:before {\n  content: \"\\f413\";\n}\n\n.fa-readme:before {\n  content: \"\\f4d5\";\n}\n\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n\n.fa-square-web-awesome:before {\n  content: \"\\e683\";\n}\n\n.fa-sass:before {\n  content: \"\\f41e\";\n}\n\n.fa-wirsindhandwerk:before {\n  content: \"\\e2d0\";\n}\n\n.fa-wsh:before {\n  content: \"\\e2d0\";\n}\n\n.fa-buromobelexperte:before {\n  content: \"\\f37f\";\n}\n\n.fa-salesforce:before {\n  content: \"\\f83b\";\n}\n\n.fa-octopus-deploy:before {\n  content: \"\\e082\";\n}\n\n.fa-medapps:before {\n  content: \"\\f3c6\";\n}\n\n.fa-ns8:before {\n  content: \"\\f3d5\";\n}\n\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n\n.fa-apper:before {\n  content: \"\\f371\";\n}\n\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n\n.fa-waze:before {\n  content: \"\\f83f\";\n}\n\n.fa-bluesky:before {\n  content: \"\\e671\";\n}\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ab\";\n}\n\n.fa-fantasy-flight-games:before {\n  content: \"\\f6dc\";\n}\n\n.fa-rust:before {\n  content: \"\\e07a\";\n}\n\n.fa-wix:before {\n  content: \"\\f5cf\";\n}\n\n.fa-square-behance:before {\n  content: \"\\f1b5\";\n}\n\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n\n.fa-supple:before {\n  content: \"\\f3f9\";\n}\n\n.fa-webflow:before {\n  content: \"\\e65c\";\n}\n\n.fa-rebel:before {\n  content: \"\\f1d0\";\n}\n\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n\n.fa-staylinked:before {\n  content: \"\\f3f5\";\n}\n\n.fa-kaggle:before {\n  content: \"\\f5fa\";\n}\n\n.fa-space-awesome:before {\n  content: \"\\e5ac\";\n}\n\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n\n.fa-cpanel:before {\n  content: \"\\f388\";\n}\n\n.fa-goodreads-g:before {\n  content: \"\\f3a9\";\n}\n\n.fa-square-git:before {\n  content: \"\\f1d2\";\n}\n\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n\n.fa-square-tumblr:before {\n  content: \"\\f174\";\n}\n\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n\n.fa-trello:before {\n  content: \"\\f181\";\n}\n\n.fa-creative-commons-nc-jp:before {\n  content: \"\\f4ea\";\n}\n\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n\n.fa-perbyte:before {\n  content: \"\\e083\";\n}\n\n.fa-grunt:before {\n  content: \"\\f3ad\";\n}\n\n.fa-weebly:before {\n  content: \"\\f5cc\";\n}\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n\n.fa-themeco:before {\n  content: \"\\f5c6\";\n}\n\n.fa-python:before {\n  content: \"\\f3e2\";\n}\n\n.fa-android:before {\n  content: \"\\f17b\";\n}\n\n.fa-bots:before {\n  content: \"\\e340\";\n}\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n\n.fa-hornbill:before {\n  content: \"\\f592\";\n}\n\n.fa-js:before {\n  content: \"\\f3b8\";\n}\n\n.fa-ideal:before {\n  content: \"\\e013\";\n}\n\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n\n.fa-dev:before {\n  content: \"\\f6cc\";\n}\n\n.fa-sketch:before {\n  content: \"\\f7c6\";\n}\n\n.fa-yandex-international:before {\n  content: \"\\f414\";\n}\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n\n.fa-uber:before {\n  content: \"\\f402\";\n}\n\n.fa-github:before {\n  content: \"\\f09b\";\n}\n\n.fa-php:before {\n  content: \"\\f457\";\n}\n\n.fa-alipay:before {\n  content: \"\\f642\";\n}\n\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n\n.fa-firefox-browser:before {\n  content: \"\\e007\";\n}\n\n.fa-replyd:before {\n  content: \"\\f3e6\";\n}\n\n.fa-suse:before {\n  content: \"\\f7d6\";\n}\n\n.fa-jenkins:before {\n  content: \"\\f3b6\";\n}\n\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n\n.fa-rockrms:before {\n  content: \"\\f3e9\";\n}\n\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n\n.fa-buffer:before {\n  content: \"\\f837\";\n}\n\n.fa-npm:before {\n  content: \"\\f3d4\";\n}\n\n.fa-yammer:before {\n  content: \"\\f840\";\n}\n\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n\n.fa-stubber:before {\n  content: \"\\e5c7\";\n}\n\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n\n.fa-telegram-plane:before {\n  content: \"\\f2c6\";\n}\n\n.fa-old-republic:before {\n  content: \"\\f510\";\n}\n\n.fa-odysee:before {\n  content: \"\\e5c6\";\n}\n\n.fa-square-whatsapp:before {\n  content: \"\\f40c\";\n}\n\n.fa-whatsapp-square:before {\n  content: \"\\f40c\";\n}\n\n.fa-node-js:before {\n  content: \"\\f3d3\";\n}\n\n.fa-edge-legacy:before {\n  content: \"\\e078\";\n}\n\n.fa-slack:before {\n  content: \"\\f198\";\n}\n\n.fa-slack-hash:before {\n  content: \"\\f198\";\n}\n\n.fa-medrt:before {\n  content: \"\\f3c8\";\n}\n\n.fa-usb:before {\n  content: \"\\f287\";\n}\n\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n\n.fa-vaadin:before {\n  content: \"\\f408\";\n}\n\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n\n.fa-square-x-twitter:before {\n  content: \"\\e61a\";\n}\n\n.fa-reacteurope:before {\n  content: \"\\f75d\";\n}\n\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n\n.fa-medium-m:before {\n  content: \"\\f23a\";\n}\n\n.fa-amilia:before {\n  content: \"\\f36d\";\n}\n\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n\n.fa-flipboard:before {\n  content: \"\\f44d\";\n}\n\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n\n.fa-critical-role:before {\n  content: \"\\f6c9\";\n}\n\n.fa-sitrox:before {\n  content: \"\\e44a\";\n}\n\n.fa-discourse:before {\n  content: \"\\f393\";\n}\n\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n\n.fa-mastodon:before {\n  content: \"\\f4f6\";\n}\n\n.fa-airbnb:before {\n  content: \"\\f834\";\n}\n\n.fa-wolf-pack-battalion:before {\n  content: \"\\f514\";\n}\n\n.fa-buy-n-large:before {\n  content: \"\\f8a6\";\n}\n\n.fa-gulp:before {\n  content: \"\\f3ae\";\n}\n\n.fa-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\";\n}\n\n.fa-strava:before {\n  content: \"\\f428\";\n}\n\n.fa-ember:before {\n  content: \"\\f423\";\n}\n\n.fa-canadian-maple-leaf:before {\n  content: \"\\f785\";\n}\n\n.fa-teamspeak:before {\n  content: \"\\f4f9\";\n}\n\n.fa-pushed:before {\n  content: \"\\f3e1\";\n}\n\n.fa-wordpress-simple:before {\n  content: \"\\f411\";\n}\n\n.fa-nutritionix:before {\n  content: \"\\f3d6\";\n}\n\n.fa-wodu:before {\n  content: \"\\e088\";\n}\n\n.fa-google-pay:before {\n  content: \"\\e079\";\n}\n\n.fa-intercom:before {\n  content: \"\\f7af\";\n}\n\n.fa-zhihu:before {\n  content: \"\\f63f\";\n}\n\n.fa-korvue:before {\n  content: \"\\f42f\";\n}\n\n.fa-pix:before {\n  content: \"\\e43a\";\n}\n\n.fa-steam-symbol:before {\n  content: \"\\f3f6\";\n}\n\n/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n:root, :host {\n  --fa-style-family-classic: \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n}\n\n@font-face {\n  font-family: \"Font Awesome 6 Free\";\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\");\n}\n.fas,\n.fa-solid {\n  font-weight: 900;\n}","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: fa-divide($font-size, $fa-size-scale-base) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: fa-divide(1, $font-size) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: (fa-divide(6, $font-size) - fa-divide(3, 8)) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n\n// sets a specific icon family to use alongside style + icon mixins\n\n// convenience mixins for declaring pseudo-elements by CSS variable,\n// including all style-specific font properties, and both the ::before\n// and ::after elements in the duotone case.\n@mixin fa-icon-solid($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-solid;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-regular($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-regular;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-brands($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-brands;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix          : fa !default;\n$fa-style               : 900 !default;\n$fa-style-family        : \"Font Awesome 6 Free\" !default;\n\n$fa-display             : inline-block !default;\n\n$fa-fw-width            : fa-divide(20em, 16) !default;\n$fa-inverse             : #fff !default;\n\n$fa-border-color        : #eee !default;\n$fa-border-padding      : .2em .25em .15em !default;\n$fa-border-radius       : .1em !default;\n$fa-border-style        : solid !default;\n$fa-border-width        : .08em !default;\n\n$fa-size-scale-2xs      : 10 !default;\n$fa-size-scale-xs       : 12 !default;\n$fa-size-scale-sm       : 14 !default;\n$fa-size-scale-base     : 16 !default;\n$fa-size-scale-lg       : 20 !default;\n$fa-size-scale-xl       : 24 !default;\n$fa-size-scale-2xl      : 32 !default;\n\n$fa-sizes: (\n  \"2xs\"                 : $fa-size-scale-2xs,\n  \"xs\"                  : $fa-size-scale-xs,\n  \"sm\"                  : $fa-size-scale-sm,\n  \"lg\"                  : $fa-size-scale-lg,\n  \"xl\"                  : $fa-size-scale-xl,\n  \"2xl\"                 : $fa-size-scale-2xl\n) !default;\n\n$fa-li-width            : 2em !default;\n$fa-li-margin           : $fa-li-width * fa-divide(5, 4) !default;\n\n$fa-pull-margin         : .3em !default;\n\n$fa-primary-opacity     : 1 !default;\n$fa-secondary-opacity   : .4 !default;\n\n$fa-stack-vertical-align: middle !default;\n$fa-stack-width         : ($fa-fw-width * 2) !default;\n$fa-stack-z-index       : auto !default;\n\n$fa-font-display        : block !default;\n$fa-font-path           : \"../webfonts\" !default;\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-fill-drip: \\f576;\n$fa-var-arrows-to-circle: \\e4bd;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-at: \\40;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-text-height: \\f034;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-info: \\f129;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-explosion: \\e4e9;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-wave-square: \\f83e;\n$fa-var-ring: \\f70b;\n$fa-var-building-un: \\e4d9;\n$fa-var-dice-three: \\f527;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-anchor-circle-check: \\e4aa;\n$fa-var-building-circle-arrow-right: \\e4d1;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-arrows-up-to-line: \\e4c2;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-door-open: \\f52b;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-atom: \\f5d2;\n$fa-var-soap: \\e06e;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-bridge-circle-check: \\e4c9;\n$fa-var-pump-medical: \\e06a;\n$fa-var-fingerprint: \\f577;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-school-circle-exclamation: \\e56c;\n$fa-var-crop: \\f125;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-users-rectangle: \\e594;\n$fa-var-people-roof: \\e537;\n$fa-var-people-line: \\e534;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-diagram-predecessor: \\e477;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-laptop: \\f109;\n$fa-var-file-csv: \\f6dd;\n$fa-var-menorah: \\f676;\n$fa-var-truck-plane: \\e58f;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-bong: \\f55c;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-arrow-down-up-across-line: \\e4af;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-jar-wheat: \\e517;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-file-circle-exclamation: \\e4eb;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-pager: \\f815;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-k: \\4b;\n$fa-var-landmark-flag: \\e51c;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-backward: \\f04a;\n$fa-var-caret-right: \\f0da;\n$fa-var-comments: \\f086;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-user-check: \\f4fc;\n$fa-var-vial-virus: \\e597;\n$fa-var-sheet-plastic: \\e571;\n$fa-var-blog: \\f781;\n$fa-var-user-ninja: \\f504;\n$fa-var-person-arrow-up-from-line: \\e539;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-toggle-off: \\f204;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-person-drowning: \\e545;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-spray-can: \\f5bd;\n$fa-var-truck-monster: \\f63b;\n$fa-var-w: \\57;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-rainbow: \\f75b;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-paw: \\f1b0;\n$fa-var-cloud: \\f0c2;\n$fa-var-trowel-bricks: \\e58a;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-hospital-user: \\f80d;\n$fa-var-tent-arrow-left-right: \\e57f;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-binoculars: \\f1e5;\n$fa-var-microphone-slash: \\f131;\n$fa-var-box-tissue: \\e05b;\n$fa-var-motorcycle: \\f21c;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-mars-and-venus-burst: \\e523;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-sun-plant-wilt: \\e57a;\n$fa-var-toilets-portable: \\e584;\n$fa-var-hockey-puck: \\f453;\n$fa-var-table: \\f0ce;\n$fa-var-magnifying-glass-arrow-right: \\e521;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-users-slash: \\e073;\n$fa-var-clover: \\e139;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-house-fire: \\e50c;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-helicopter: \\f533;\n$fa-var-compass: \\f14e;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-file-circle-question: \\e4ef;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-people-group: \\e533;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-film: \\f008;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-people-robbery: \\e536;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-caret-left: \\f0d9;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-school-circle-xmark: \\e56d;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-sitemap: \\f0e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-memory: \\f538;\n$fa-var-road-spikes: \\e568;\n$fa-var-fire-burner: \\e4f1;\n$fa-var-flag: \\f024;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-feather: \\f52d;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-compress: \\f066;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-ankh: \\f644;\n$fa-var-hands-holding-child: \\e4fa;\n$fa-var-asterisk: \\2a;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-peseta-sign: \\e221;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-ghost: \\f6e2;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-cart-plus: \\f217;\n$fa-var-gamepad: \\f11b;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-egg: \\f7fb;\n$fa-var-house-medical-circle-xmark: \\e513;\n$fa-var-campground: \\f6bb;\n$fa-var-folder-plus: \\f65e;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-paintbrush: \\f1fc;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-lock: \\f023;\n$fa-var-gas-pump: \\f52f;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-house-flood-water: \\e50e;\n$fa-var-tree: \\f1bb;\n$fa-var-bridge-lock: \\e4cc;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-car-side: \\f5e4;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-heart-circle-minus: \\e4ff;\n$fa-var-hourglass-half: \\f252;\n$fa-var-hourglass-2: \\f252;\n$fa-var-microscope: \\f610;\n$fa-var-sink: \\e06d;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-mitten: \\f7b5;\n$fa-var-person-rays: \\e54d;\n$fa-var-users: \\f0c0;\n$fa-var-eye-slash: \\f070;\n$fa-var-flask-vial: \\e4f3;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-om: \\f679;\n$fa-var-worm: \\e599;\n$fa-var-house-circle-xmark: \\e50b;\n$fa-var-plug: \\f1e6;\n$fa-var-chevron-up: \\f077;\n$fa-var-hand-spock: \\f259;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-bridge-circle-xmark: \\e4cb;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-road-circle-check: \\e564;\n$fa-var-dice-five: \\f523;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-land-mine-on: \\e51b;\n$fa-var-i-cursor: \\f246;\n$fa-var-stamp: \\f5bf;\n$fa-var-stairs: \\e289;\n$fa-var-i: \\49;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-pills: \\f484;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-tooth: \\f5c9;\n$fa-var-v: \\56;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-bicycle: \\f206;\n$fa-var-staff-snake: \\e579;\n$fa-var-rod-asclepius: \\e579;\n$fa-var-rod-snake: \\e579;\n$fa-var-staff-aesculapius: \\e579;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-wheat-awn-circle-exclamation: \\e598;\n$fa-var-snowman: \\f7d0;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-road-barrier: \\e562;\n$fa-var-school: \\f549;\n$fa-var-igloo: \\f7ae;\n$fa-var-joint: \\f595;\n$fa-var-angle-right: \\f105;\n$fa-var-horse: \\f6f0;\n$fa-var-q: \\51;\n$fa-var-g: \\47;\n$fa-var-notes-medical: \\f481;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-dong-sign: \\e169;\n$fa-var-capsules: \\f46b;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-money-bill: \\f0d6;\n$fa-var-bookmark: \\f02e;\n$fa-var-align-justify: \\f039;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-helmet-un: \\e503;\n$fa-var-bullseye: \\f140;\n$fa-var-bacon: \\f7e5;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-folder: \\f07b;\n$fa-var-folder-blank: \\f07b;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-radiation: \\f7b9;\n$fa-var-chart-simple: \\e473;\n$fa-var-mars-stroke: \\f229;\n$fa-var-vial: \\f492;\n$fa-var-gauge: \\f624;\n$fa-var-dashboard: \\f624;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-e: \\45;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-bridge-circle-exclamation: \\e4ca;\n$fa-var-user: \\f007;\n$fa-var-school-circle-check: \\e56b;\n$fa-var-dumpster: \\f793;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-building-user: \\e4da;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-highlighter: \\f591;\n$fa-var-key: \\f084;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-globe: \\f0ac;\n$fa-var-synagogue: \\f69b;\n$fa-var-person-half-dress: \\e548;\n$fa-var-road-bridge: \\e563;\n$fa-var-location-arrow: \\f124;\n$fa-var-c: \\43;\n$fa-var-tablet-button: \\f10a;\n$fa-var-building-lock: \\e4d6;\n$fa-var-pizza-slice: \\f818;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-house-flag: \\e50d;\n$fa-var-person-circle-minus: \\e540;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-star: \\f005;\n$fa-var-repeat: \\f363;\n$fa-var-cross: \\f654;\n$fa-var-box: \\f466;\n$fa-var-venus-mars: \\f228;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-charging-station: \\f5e7;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-mobile-retro: \\e527;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-spider: \\f717;\n$fa-var-hands-bound: \\e4f9;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-plane-circle-exclamation: \\e556;\n$fa-var-x-ray: \\f497;\n$fa-var-spell-check: \\f891;\n$fa-var-slash: \\f715;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-server: \\f233;\n$fa-var-virus-covid-slash: \\e4a9;\n$fa-var-shop-lock: \\e4a5;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-building-wheat: \\e4db;\n$fa-var-person-breastfeeding: \\e53a;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-venus: \\f221;\n$fa-var-passport: \\f5ab;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-temperature-high: \\f769;\n$fa-var-microchip: \\f2db;\n$fa-var-crown: \\f521;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-xmarks-lines: \\e59a;\n$fa-var-file-prescription: \\f572;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-chess-knight: \\f441;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-wheelchair: \\f193;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-toggle-on: \\f205;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-l: \\4c;\n$fa-var-fire: \\f06d;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-folder-open: \\f07c;\n$fa-var-heart-circle-plus: \\e500;\n$fa-var-code-fork: \\e13b;\n$fa-var-city: \\f64f;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-pepper-hot: \\f816;\n$fa-var-unlock: \\f09c;\n$fa-var-colon-sign: \\e140;\n$fa-var-headset: \\f590;\n$fa-var-store-slash: \\e071;\n$fa-var-road-circle-xmark: \\e566;\n$fa-var-user-minus: \\f503;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-clipboard: \\f328;\n$fa-var-house-circle-exclamation: \\e50a;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-underline: \\f0cd;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-signature: \\f5b7;\n$fa-var-stroopwafel: \\f551;\n$fa-var-bold: \\f032;\n$fa-var-anchor-lock: \\e4ad;\n$fa-var-building-ngo: \\e4d7;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-not-equal: \\f53e;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-jedi: \\f669;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-gift: \\f06b;\n$fa-var-dice-two: \\f528;\n$fa-var-chess-queen: \\f445;\n$fa-var-glasses: \\f530;\n$fa-var-chess-board: \\f43c;\n$fa-var-building-circle-check: \\e4d2;\n$fa-var-person-chalkboard: \\e53d;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-cloud-showers-water: \\e4e4;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-less-than-equal: \\f537;\n$fa-var-train: \\f238;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-crow: \\f520;\n$fa-var-sailboat: \\e445;\n$fa-var-window-restore: \\f2d2;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-frog: \\f52e;\n$fa-var-bucket: \\e4cf;\n$fa-var-image: \\f03e;\n$fa-var-microphone: \\f130;\n$fa-var-cow: \\f6c8;\n$fa-var-caret-up: \\f0d8;\n$fa-var-screwdriver: \\f54a;\n$fa-var-folder-closed: \\e185;\n$fa-var-house-tsunami: \\e515;\n$fa-var-square-nfi: \\e576;\n$fa-var-arrow-up-from-ground-water: \\e4b5;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-lemon: \\f094;\n$fa-var-head-side-mask: \\e063;\n$fa-var-handshake: \\f2b5;\n$fa-var-gem: \\f3a5;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-smoking: \\f48d;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-monument: \\f5a6;\n$fa-var-snowplow: \\f7d2;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-cannabis: \\f55f;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-tablets: \\f490;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-chair: \\f6c0;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-plate-wheat: \\e55a;\n$fa-var-icicles: \\f7ad;\n$fa-var-person-shelter: \\e54f;\n$fa-var-neuter: \\f22c;\n$fa-var-id-badge: \\f2c1;\n$fa-var-marker: \\f5a1;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-helicopter-symbol: \\e502;\n$fa-var-universal-access: \\f29a;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-volcano: \\f770;\n$fa-var-person-walking-dashed-line-arrow-right: \\e553;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-viruses: \\e076;\n$fa-var-square-person-confined: \\e577;\n$fa-var-user-tie: \\f508;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-tent-arrow-down-to-line: \\e57e;\n$fa-var-certificate: \\f0a3;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-suitcase: \\f0f2;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-camera-retro: \\f083;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-box-open: \\f49e;\n$fa-var-scroll: \\f70e;\n$fa-var-spa: \\f5bb;\n$fa-var-location-pin-lock: \\e51f;\n$fa-var-pause: \\f04c;\n$fa-var-hill-avalanche: \\e507;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-bomb: \\f1e2;\n$fa-var-registered: \\f25d;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-subscript: \\f12c;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-burst: \\e4dc;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-money-bills: \\e1f3;\n$fa-var-smog: \\f75f;\n$fa-var-crutch: \\f7f7;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-palette: \\f53f;\n$fa-var-arrows-turn-right: \\e4c0;\n$fa-var-vest: \\e085;\n$fa-var-ferry: \\e4ea;\n$fa-var-arrows-down-to-people: \\e4b9;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-boxes-packing: \\e4c7;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-group-arrows-rotate: \\e4f6;\n$fa-var-bowl-food: \\e4c6;\n$fa-var-candy-cane: \\f786;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-house-lock: \\e510;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-children: \\e4e1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-mattress-pillow: \\e525;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-shield-halved: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-virus: \\e074;\n$fa-var-envelope-circle-check: \\e4e8;\n$fa-var-layer-group: \\f5fd;\n$fa-var-arrows-to-dot: \\e4be;\n$fa-var-archway: \\f557;\n$fa-var-heart-circle-check: \\e4fd;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-square: \\f0c8;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-couch: \\f4b8;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-italic: \\f033;\n$fa-var-table-cells-column-lock: \\e678;\n$fa-var-church: \\f51d;\n$fa-var-comments-dollar: \\f653;\n$fa-var-democrat: \\f747;\n$fa-var-z: \\5a;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-road-lock: \\e567;\n$fa-var-a: \\41;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-p: \\50;\n$fa-var-snowflake: \\f2dc;\n$fa-var-newspaper: \\f1ea;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-locust: \\e520;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-person-dress-burst: \\e544;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-vector-square: \\f5cb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-language: \\f1ab;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-filter: \\f0b0;\n$fa-var-question: \\3f;\n$fa-var-file-signature: \\f573;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-money-check: \\f53c;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-code: \\f121;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-building-circle-exclamation: \\e4d3;\n$fa-var-magnifying-glass-chart: \\e522;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-cubes-stacked: \\e4e6;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-virus-covid: \\e4a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-f: \\46;\n$fa-var-leaf: \\f06c;\n$fa-var-road: \\f018;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-person-circle-plus: \\e541;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-sack-xmark: \\e56a;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-contract: \\f56c;\n$fa-var-fish-fins: \\e4f2;\n$fa-var-building-flag: \\e4d5;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-object-ungroup: \\f248;\n$fa-var-poop: \\f619;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-kaaba: \\f66b;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-eject: \\f052;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-plane-circle-check: \\e555;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-object-group: \\f247;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-mask-ventilator: \\e524;\n$fa-var-arrow-right: \\f061;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-cash-register: \\f788;\n$fa-var-person-circle-question: \\e542;\n$fa-var-h: \\48;\n$fa-var-tarp: \\e57b;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-arrows-to-eye: \\e4bf;\n$fa-var-plug-circle-bolt: \\e55b;\n$fa-var-heart: \\f004;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-house-crack: \\e3b1;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-bottle-water: \\e4c5;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-kitchen-set: \\e51a;\n$fa-var-r: \\52;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-cube: \\f1b2;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-shield-dog: \\e573;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-lock-open: \\f3c1;\n$fa-var-elevator: \\e16d;\n$fa-var-money-bill-transfer: \\e528;\n$fa-var-money-bill-trend-up: \\e529;\n$fa-var-house-flood-water-circle-arrow-right: \\e50f;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-circle: \\f111;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-recycle: \\f1b8;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-plane-slash: \\e069;\n$fa-var-trademark: \\f25c;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-users-rays: \\e593;\n$fa-var-wallet: \\f555;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-file-audio: \\f1c7;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-wrench: \\f0ad;\n$fa-var-bugs: \\e4d0;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-file-image: \\f1c5;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-handshake-slash: \\e060;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-code-branch: \\f126;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-bridge: \\e4c8;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-truck-front: \\e2b7;\n$fa-var-cat: \\f6be;\n$fa-var-anchor-circle-exclamation: \\e4ab;\n$fa-var-truck-field: \\e58d;\n$fa-var-route: \\f4d7;\n$fa-var-clipboard-question: \\e4e3;\n$fa-var-panorama: \\e209;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-teeth-open: \\f62f;\n$fa-var-file-circle-minus: \\e4ed;\n$fa-var-tags: \\f02c;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-house-signal: \\e012;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-faucet-drip: \\e006;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-terminal: \\f120;\n$fa-var-mobile-button: \\f10b;\n$fa-var-house-medical-flag: \\e514;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-tape: \\f4db;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-eye: \\f06e;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-audio-description: \\f29e;\n$fa-var-person-military-to-person: \\e54c;\n$fa-var-file-shield: \\e4f0;\n$fa-var-user-slash: \\f506;\n$fa-var-pen: \\f304;\n$fa-var-tower-observation: \\e586;\n$fa-var-file-code: \\f1c9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-bus: \\f207;\n$fa-var-heart-circle-xmark: \\e501;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-prescription: \\f5b1;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-vihara: \\f6a7;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-plant-wilt: \\e5aa;\n$fa-var-diamond: \\f219;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-bacterium: \\e05a;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-biohazard: \\f780;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-mars-double: \\f227;\n$fa-var-child-dress: \\e59c;\n$fa-var-users-between-lines: \\e591;\n$fa-var-lungs-virus: \\e067;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-phone: \\f095;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-child-reaching: \\e59d;\n$fa-var-head-side-virus: \\e064;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-door-closed: \\f52a;\n$fa-var-shield-virus: \\e06c;\n$fa-var-dice-six: \\f526;\n$fa-var-mosquito-net: \\e52c;\n$fa-var-bridge-water: \\e4ce;\n$fa-var-person-booth: \\f756;\n$fa-var-text-width: \\f035;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-trash: \\f1f8;\n$fa-var-gauge-simple: \\f629;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-book-medical: \\f7e6;\n$fa-var-poo: \\f2fe;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-cubes: \\f1b3;\n$fa-var-divide: \\f529;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-headphones: \\f025;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-republican: \\f75e;\n$fa-var-arrow-left: \\f060;\n$fa-var-person-circle-xmark: \\e543;\n$fa-var-ruler: \\f545;\n$fa-var-align-left: \\f036;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-restroom: \\f7bd;\n$fa-var-j: \\4a;\n$fa-var-users-viewfinder: \\e595;\n$fa-var-file-video: \\f1c8;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-o: \\4f;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-user-secret: \\f21b;\n$fa-var-otter: \\f700;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-comment-dollar: \\f651;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-child: \\f1ae;\n$fa-var-lira-sign: \\f195;\n$fa-var-satellite: \\f7bf;\n$fa-var-plane-lock: \\e558;\n$fa-var-tag: \\f02b;\n$fa-var-comment: \\f075;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake: \\f1fd;\n$fa-var-envelope: \\f0e0;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-paperclip: \\f0c6;\n$fa-var-arrow-right-to-city: \\e4b3;\n$fa-var-ribbon: \\f4d6;\n$fa-var-lungs: \\f604;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-border-none: \\f850;\n$fa-var-circle-nodes: \\e4e2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-indent: \\f03c;\n$fa-var-truck-field-un: \\e58e;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-empty: \\f254;\n$fa-var-mountain: \\f6fc;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-square-virus: \\e578;\n$fa-var-meteor: \\f753;\n$fa-var-car-on: \\e4dd;\n$fa-var-sleigh: \\f7cc;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-water: \\f773;\n$fa-var-calendar-check: \\f274;\n$fa-var-braille: \\f2a1;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-landmark: \\f66f;\n$fa-var-truck: \\f0d1;\n$fa-var-crosshairs: \\f05b;\n$fa-var-person-cane: \\e53c;\n$fa-var-tent: \\e57d;\n$fa-var-vest-patches: \\e086;\n$fa-var-check-double: \\f560;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-money-bill-wheat: \\e52a;\n$fa-var-cookie: \\f563;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-dumbbell: \\f44b;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-tarp-droplet: \\e57c;\n$fa-var-house-medical-circle-check: \\e511;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-calendar-plus: \\f271;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-dna: \\f471;\n$fa-var-virus-slash: \\e075;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-chess: \\f439;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-plug-circle-check: \\e55c;\n$fa-var-street-view: \\f21d;\n$fa-var-franc-sign: \\e18f;\n$fa-var-volume-off: \\f026;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-mosque: \\f678;\n$fa-var-mosquito: \\e52b;\n$fa-var-star-of-david: \\f69a;\n$fa-var-person-military-rifle: \\e54b;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-vials: \\f493;\n$fa-var-plug-circle-plus: \\e55f;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-u: \\55;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-pallet: \\f482;\n$fa-var-faucet: \\e005;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-s: \\53;\n$fa-var-timeline: \\e29c;\n$fa-var-keyboard: \\f11c;\n$fa-var-caret-down: \\f0d7;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-plane-up: \\e22d;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-mountain-city: \\e52e;\n$fa-var-coins: \\f51e;\n$fa-var-khanda: \\f66d;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-folder-tree: \\f802;\n$fa-var-network-wired: \\f6ff;\n$fa-var-map-pin: \\f276;\n$fa-var-hamsa: \\f665;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-flask: \\f0c3;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-ticket: \\f145;\n$fa-var-power-off: \\f011;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-flag-usa: \\f74d;\n$fa-var-laptop-file: \\e51d;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-diagram-next: \\e476;\n$fa-var-person-rifle: \\e54e;\n$fa-var-house-medical-circle-exclamation: \\e512;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-venus-double: \\f226;\n$fa-var-images: \\f302;\n$fa-var-calculator: \\f1ec;\n$fa-var-people-pulling: \\e535;\n$fa-var-n: \\4e;\n$fa-var-cable-car: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-building-circle-xmark: \\e4d4;\n$fa-var-ship: \\f21a;\n$fa-var-arrows-down-to-line: \\e4b8;\n$fa-var-download: \\f019;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-file-circle-check: \\e5a0;\n$fa-var-forward: \\f04e;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-align-center: \\f037;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-heart-circle-exclamation: \\e4fe;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-home-alt: \\f015;\n$fa-var-home-lg-alt: \\f015;\n$fa-var-calendar-week: \\f784;\n$fa-var-laptop-medical: \\f812;\n$fa-var-b: \\42;\n$fa-var-file-medical: \\f477;\n$fa-var-dice-one: \\f525;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-skull: \\f54c;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-stop: \\f04d;\n$fa-var-code-merge: \\f387;\n$fa-var-upload: \\f093;\n$fa-var-hurricane: \\f751;\n$fa-var-mound: \\e52d;\n$fa-var-toilet-portable: \\e583;\n$fa-var-compact-disc: \\f51f;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-caravan: \\f8ff;\n$fa-var-shield-cat: \\e572;\n$fa-var-bolt: \\f0e7;\n$fa-var-zap: \\f0e7;\n$fa-var-glass-water: \\e4f4;\n$fa-var-oil-well: \\e532;\n$fa-var-vault: \\e2c5;\n$fa-var-mars: \\f222;\n$fa-var-toilet: \\f7d8;\n$fa-var-plane-circle-xmark: \\e557;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-sun: \\f185;\n$fa-var-guitar: \\f7a6;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-horse-head: \\f7ab;\n$fa-var-bore-hole: \\e4c3;\n$fa-var-industry: \\f275;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-arrows-turn-to-dots: \\e4c1;\n$fa-var-florin-sign: \\e184;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-less-than: \\3c;\n$fa-var-angle-down: \\f107;\n$fa-var-car-tunnel: \\e4de;\n$fa-var-head-side-cough: \\e061;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-thumbs-down: \\f165;\n$fa-var-user-lock: \\f502;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-anchor-circle-xmark: \\e4ac;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-chess-pawn: \\f443;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-person-through-window: \\e5a9;\n$fa-var-toolbox: \\f552;\n$fa-var-hands-holding-circle: \\e4fb;\n$fa-var-bug: \\f188;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-hand-holding-hand: \\e4f7;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-mountain-sun: \\e52f;\n$fa-var-arrows-left-right-to-line: \\e4ba;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-truck-droplet: \\e58c;\n$fa-var-file-circle-xmark: \\e5a1;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-medal: \\f5a2;\n$fa-var-bed: \\f236;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-podcast: \\f2ce;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-bell: \\f0f3;\n$fa-var-superscript: \\f12b;\n$fa-var-plug-circle-xmark: \\e560;\n$fa-var-star-of-life: \\f621;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-file: \\f15b;\n$fa-var-greater-than: \\3e;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-arrow-down: \\f063;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-eraser: \\f12d;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-earth-america: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-person-burst: \\e53b;\n$fa-var-dove: \\f4ba;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-socks: \\f696;\n$fa-var-inbox: \\f01c;\n$fa-var-section: \\e447;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-alt: \\f0f8;\n$fa-var-hospital-wide: \\f0f8;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-chess-rook: \\f447;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-dharmachakra: \\f655;\n$fa-var-hotdog: \\f80f;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-drum: \\f569;\n$fa-var-ice-cream: \\f810;\n$fa-var-heart-circle-bolt: \\e4fc;\n$fa-var-fax: \\f1ac;\n$fa-var-paragraph: \\f1dd;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-star-half: \\f089;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-tree-city: \\e587;\n$fa-var-play: \\f04b;\n$fa-var-font: \\f031;\n$fa-var-table-cells-row-lock: \\e67a;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-receipt: \\f543;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-person-circle-exclamation: \\e53f;\n$fa-var-chevron-down: \\f078;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-code-compare: \\e13a;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-school-lock: \\e56f;\n$fa-var-tower-cell: \\e585;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-ranking-star: \\e561;\n$fa-var-chess-king: \\f43f;\n$fa-var-person-harassing: \\e549;\n$fa-var-brazilian-real-sign: \\e46c;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-arrow-up: \\f062;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-shrimp: \\e448;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-jug-detergent: \\e519;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-user-shield: \\f505;\n$fa-var-wind: \\f72e;\n$fa-var-car-burst: \\f5e1;\n$fa-var-car-crash: \\f5e1;\n$fa-var-y: \\59;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-fish: \\f578;\n$fa-var-user-graduate: \\f501;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-clapperboard: \\e131;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-jet-fighter-up: \\e518;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-copy: \\f0c5;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-child-combatant: \\e4e0;\n$fa-var-child-rifle: \\e4e0;\n$fa-var-gun: \\e19b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-expand: \\f065;\n$fa-var-computer: \\e4e5;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-peso-sign: \\e222;\n$fa-var-building-shield: \\e4d8;\n$fa-var-baby: \\f77c;\n$fa-var-users-line: \\e592;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-tractor: \\f722;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-arrow-down-up-lock: \\e4b0;\n$fa-var-lines-leaning: \\e51e;\n$fa-var-ruler-combined: \\f546;\n$fa-var-copyright: \\f1f9;\n$fa-var-equals: \\3d;\n$fa-var-blender: \\f517;\n$fa-var-teeth: \\f62e;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-map: \\f279;\n$fa-var-rocket: \\f135;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-store: \\f54e;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-plug-circle-minus: \\e55e;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-school-flag: \\e56e;\n$fa-var-fill: \\f575;\n$fa-var-angle-up: \\f106;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-chevron-left: \\f053;\n$fa-var-bacteria: \\e059;\n$fa-var-hand-lizard: \\f258;\n$fa-var-notdef: \\e1fe;\n$fa-var-disease: \\f7fa;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-genderless: \\f22d;\n$fa-var-chevron-right: \\f054;\n$fa-var-retweet: \\f079;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-pump-soap: \\e06b;\n$fa-var-video-slash: \\f4e2;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-radio: \\f8d7;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-traffic-light: \\f637;\n$fa-var-thermometer: \\f491;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-truck-moving: \\f4df;\n$fa-var-glass-water-droplet: \\e4f5;\n$fa-var-display: \\e163;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-trophy: \\f091;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-hammer: \\f6e3;\n$fa-var-hand-peace: \\f25b;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-spinner: \\f110;\n$fa-var-robot: \\f544;\n$fa-var-peace: \\f67c;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-warehouse: \\f494;\n$fa-var-arrow-up-right-dots: \\e4b7;\n$fa-var-splotch: \\f5bc;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-dice-four: \\f524;\n$fa-var-sim-card: \\f7c4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-mercury: \\f223;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-person-falling-burst: \\e547;\n$fa-var-award: \\f559;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-building: \\f1ad;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-qrcode: \\f029;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f132;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-house-medical: \\e3b2;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-tent-arrow-turn-left: \\e580;\n$fa-var-tents: \\e582;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-dog: \\f6d3;\n$fa-var-carrot: \\f787;\n$fa-var-moon: \\f186;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-cheese: \\f7ef;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-music: \\f001;\n$fa-var-code-commit: \\f386;\n$fa-var-temperature-low: \\f76b;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-broom: \\f51a;\n$fa-var-shield-heart: \\e574;\n$fa-var-gopuram: \\f664;\n$fa-var-earth-oceania: \\e47b;\n$fa-var-globe-oceania: \\e47b;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-hashtag: \\23;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-oil-can: \\f613;\n$fa-var-t: \\54;\n$fa-var-hippo: \\f6ed;\n$fa-var-chart-column: \\e0e3;\n$fa-var-infinity: \\f534;\n$fa-var-vial-circle-check: \\e596;\n$fa-var-person-arrow-down-to-line: \\e538;\n$fa-var-voicemail: \\f897;\n$fa-var-fan: \\f863;\n$fa-var-person-walking-luggage: \\e554;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-calendar: \\f133;\n$fa-var-trailer: \\e041;\n$fa-var-bahai: \\f666;\n$fa-var-haykal: \\f666;\n$fa-var-sd-card: \\f7c2;\n$fa-var-dragon: \\f6d5;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-plug-circle-exclamation: \\e55d;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-clone: \\f24d;\n$fa-var-person-walking-arrow-loop-left: \\e551;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-tornado: \\f76f;\n$fa-var-file-circle-plus: \\e494;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-anchor: \\f13d;\n$fa-var-border-all: \\f84c;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-cookie-bite: \\f564;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-tachometer-fast: \\f62a;\n$fa-var-shower: \\f2cc;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-m: \\4d;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-book: \\f02d;\n$fa-var-user-plus: \\f234;\n$fa-var-check: \\f00c;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-house-circle-check: \\e509;\n$fa-var-angle-left: \\f104;\n$fa-var-diagram-successor: \\e47a;\n$fa-var-truck-arrow-right: \\e58b;\n$fa-var-arrows-split-up-and-left: \\e4bc;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-briefcase: \\f0b1;\n$fa-var-person-falling: \\e546;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-user-tag: \\f507;\n$fa-var-rug: \\e569;\n$fa-var-earth-europe: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-book-open: \\f518;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-handcuffs: \\e4f8;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-database: \\f1c0;\n$fa-var-share: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-bottle-droplet: \\e4c4;\n$fa-var-mask-face: \\e1d7;\n$fa-var-hill-rockslide: \\e508;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-road-circle-exclamation: \\e565;\n$fa-var-dungeon: \\f6d9;\n$fa-var-align-right: \\f038;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-life-ring: \\f1cd;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-calendar-day: \\f783;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-person-walking-arrow-right: \\e552;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-dice: \\f522;\n$fa-var-bowling-ball: \\f436;\n$fa-var-brain: \\f5dc;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-calendar-minus: \\f272;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-gifts: \\f79c;\n$fa-var-hotel: \\f594;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-thumbs-up: \\f164;\n$fa-var-user-clock: \\f4fd;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-file-invoice: \\f570;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-brush: \\f55d;\n$fa-var-mask: \\f6fa;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-train-tram: \\e5b4;\n$fa-var-user-nurse: \\f82f;\n$fa-var-syringe: \\f48e;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-square-full: \\f45c;\n$fa-var-magnet: \\f076;\n$fa-var-jar: \\e516;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-bug-slash: \\e490;\n$fa-var-arrow-up-from-water-pump: \\e4b6;\n$fa-var-bone: \\f5d7;\n$fa-var-user-injured: \\f728;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-plane: \\f072;\n$fa-var-tent-arrows-down: \\e581;\n$fa-var-exclamation: \\21;\n$fa-var-arrows-spin: \\e4bb;\n$fa-var-print: \\f02f;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-x: \\58;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-person-military-pointing: \\e54a;\n$fa-var-building-columns: \\f19c;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-museum: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-umbrella: \\f0e9;\n$fa-var-trowel: \\e589;\n$fa-var-d: \\44;\n$fa-var-stapler: \\e5af;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-barcode: \\f02a;\n$fa-var-plus-minus: \\e43c;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-person-circle-check: \\e53e;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n\n$fa-var-monero: \\f3d0;\n$fa-var-hooli: \\f427;\n$fa-var-yelp: \\f1e9;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-lastfm: \\f202;\n$fa-var-shopware: \\f5b5;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-aws: \\f375;\n$fa-var-redhat: \\f7bc;\n$fa-var-yoast: \\f2b1;\n$fa-var-cloudflare: \\e07d;\n$fa-var-ups: \\f7e0;\n$fa-var-pixiv: \\e640;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-dyalog: \\f399;\n$fa-var-bity: \\f37a;\n$fa-var-stackpath: \\f842;\n$fa-var-buysellads: \\f20d;\n$fa-var-first-order: \\f2b0;\n$fa-var-modx: \\f285;\n$fa-var-guilded: \\e07e;\n$fa-var-vnv: \\f40b;\n$fa-var-square-js: \\f3b9;\n$fa-var-js-square: \\f3b9;\n$fa-var-microsoft: \\f3ca;\n$fa-var-qq: \\f1d6;\n$fa-var-orcid: \\f8d2;\n$fa-var-java: \\f4e4;\n$fa-var-invision: \\f7b0;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-centercode: \\f380;\n$fa-var-glide-g: \\f2a6;\n$fa-var-drupal: \\f1a9;\n$fa-var-jxl: \\e67b;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-unity: \\e049;\n$fa-var-whmcs: \\f40d;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-vk: \\f189;\n$fa-var-untappd: \\f405;\n$fa-var-mailchimp: \\f59e;\n$fa-var-css3-alt: \\f38b;\n$fa-var-square-reddit: \\f1a2;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-contao: \\f26d;\n$fa-var-square-font-awesome: \\e5ad;\n$fa-var-deskpro: \\f38f;\n$fa-var-brave: \\e63c;\n$fa-var-sistrix: \\f3ee;\n$fa-var-square-instagram: \\e055;\n$fa-var-instagram-square: \\e055;\n$fa-var-battle-net: \\f835;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-square-hacker-news: \\f3af;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-edge: \\f282;\n$fa-var-threads: \\e618;\n$fa-var-napster: \\f3d2;\n$fa-var-square-snapchat: \\f2ad;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-artstation: \\f77a;\n$fa-var-markdown: \\f60f;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-google-plus: \\f2b3;\n$fa-var-diaspora: \\f791;\n$fa-var-foursquare: \\f180;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-github-alt: \\f113;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-pagelines: \\f18c;\n$fa-var-algolia: \\f36c;\n$fa-var-red-river: \\f3e3;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-safari: \\f267;\n$fa-var-google: \\f1a0;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-atlassian: \\f77b;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-digital-ocean: \\f391;\n$fa-var-nimblr: \\f5a8;\n$fa-var-chromecast: \\f838;\n$fa-var-evernote: \\f839;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-adversal: \\f36a;\n$fa-var-creative-commons: \\f25e;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-fonticons: \\f280;\n$fa-var-weixin: \\f1d7;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-codepen: \\f1cb;\n$fa-var-git-alt: \\f841;\n$fa-var-lyft: \\f3c3;\n$fa-var-rev: \\f5b2;\n$fa-var-windows: \\f17a;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-square-viadeo: \\f2aa;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-meetup: \\f2e0;\n$fa-var-centos: \\f789;\n$fa-var-adn: \\f170;\n$fa-var-cloudsmith: \\f384;\n$fa-var-opensuse: \\e62b;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-square-dribbble: \\f397;\n$fa-var-dribbble-square: \\f397;\n$fa-var-codiepie: \\f284;\n$fa-var-node: \\f419;\n$fa-var-mix: \\f3cb;\n$fa-var-steam: \\f1b6;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-scribd: \\f28a;\n$fa-var-debian: \\e60b;\n$fa-var-openid: \\f19b;\n$fa-var-instalod: \\e081;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-sellcast: \\f2da;\n$fa-var-square-twitter: \\f081;\n$fa-var-twitter-square: \\f081;\n$fa-var-r-project: \\f4f7;\n$fa-var-delicious: \\f1a5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-vuejs: \\f41f;\n$fa-var-accusoft: \\f369;\n$fa-var-ioxhost: \\f208;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-app-store: \\f36f;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-golang: \\e40f;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-square-kickstarter: \\f3bb;\n$fa-var-grav: \\f2d6;\n$fa-var-weibo: \\f18a;\n$fa-var-uncharted: \\e084;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-square-youtube: \\f431;\n$fa-var-youtube-square: \\f431;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-wpressr: \\f3e4;\n$fa-var-rendact: \\f3e4;\n$fa-var-angellist: \\f209;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-nfc-directional: \\e530;\n$fa-var-skype: \\f17e;\n$fa-var-joget: \\f3b7;\n$fa-var-fedora: \\f798;\n$fa-var-stripe-s: \\f42a;\n$fa-var-meta: \\e49b;\n$fa-var-laravel: \\f3bd;\n$fa-var-hotjar: \\f3b1;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-square-letterboxd: \\e62e;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-hips: \\f452;\n$fa-var-behance: \\f1b4;\n$fa-var-reddit: \\f1a1;\n$fa-var-discord: \\f392;\n$fa-var-chrome: \\f268;\n$fa-var-app-store-ios: \\f370;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-wpbeginner: \\f297;\n$fa-var-confluence: \\f78d;\n$fa-var-shoelace: \\e60c;\n$fa-var-mdb: \\f8ca;\n$fa-var-dochub: \\f394;\n$fa-var-accessible-icon: \\f368;\n$fa-var-ebay: \\f4f4;\n$fa-var-amazon: \\f270;\n$fa-var-unsplash: \\e07c;\n$fa-var-yarn: \\f7e3;\n$fa-var-square-steam: \\f1b7;\n$fa-var-steam-square: \\f1b7;\n$fa-var-500px: \\f26e;\n$fa-var-square-vimeo: \\f194;\n$fa-var-vimeo-square: \\f194;\n$fa-var-asymmetrik: \\f372;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-gratipay: \\f184;\n$fa-var-apple: \\f179;\n$fa-var-hive: \\e07f;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-keybase: \\f4f5;\n$fa-var-apple-pay: \\f415;\n$fa-var-padlet: \\e4a0;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-square-github: \\f092;\n$fa-var-github-square: \\f092;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-fedex: \\f797;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-shopify: \\e057;\n$fa-var-neos: \\f612;\n$fa-var-square-threads: \\e619;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-researchgate: \\f4f8;\n$fa-var-swift: \\f8e1;\n$fa-var-angular: \\f420;\n$fa-var-speakap: \\f3f3;\n$fa-var-angrycreative: \\f36e;\n$fa-var-y-combinator: \\f23b;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-google-scholar: \\e63b;\n$fa-var-square-gitlab: \\e5ae;\n$fa-var-gitlab-square: \\e5ae;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-wordpress: \\f19a;\n$fa-var-product-hunt: \\f288;\n$fa-var-firefox: \\f269;\n$fa-var-linode: \\f2b8;\n$fa-var-goodreads: \\f3a8;\n$fa-var-square-odnoklassniki: \\f264;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-sith: \\f512;\n$fa-var-themeisle: \\f2b2;\n$fa-var-page4: \\f3d7;\n$fa-var-hashnode: \\e499;\n$fa-var-react: \\f41b;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-squarespace: \\f5be;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-bitcoin: \\f379;\n$fa-var-keycdn: \\f3ba;\n$fa-var-opera: \\f26a;\n$fa-var-itch-io: \\f83a;\n$fa-var-umbraco: \\f8e8;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-ubuntu: \\f7df;\n$fa-var-draft2digital: \\f396;\n$fa-var-stripe: \\f429;\n$fa-var-houzz: \\f27c;\n$fa-var-gg: \\f260;\n$fa-var-dhl: \\f790;\n$fa-var-square-pinterest: \\f0d3;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-xing: \\f168;\n$fa-var-blackberry: \\f37b;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-playstation: \\f3df;\n$fa-var-quinscape: \\f459;\n$fa-var-less: \\f41d;\n$fa-var-blogger-b: \\f37d;\n$fa-var-opencart: \\f23d;\n$fa-var-vine: \\f1ca;\n$fa-var-signal-messenger: \\e663;\n$fa-var-paypal: \\f1ed;\n$fa-var-gitlab: \\f296;\n$fa-var-typo3: \\f42b;\n$fa-var-reddit-alien: \\f281;\n$fa-var-yahoo: \\f19e;\n$fa-var-dailymotion: \\e052;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-bootstrap: \\f836;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-nfc-symbol: \\e531;\n$fa-var-mintbit: \\e62f;\n$fa-var-ethereum: \\f42e;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-patreon: \\f3d9;\n$fa-var-avianex: \\f374;\n$fa-var-ello: \\f5f1;\n$fa-var-gofore: \\f3a7;\n$fa-var-bimobject: \\f378;\n$fa-var-brave-reverse: \\e63d;\n$fa-var-facebook-f: \\f39e;\n$fa-var-square-google-plus: \\f0d4;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-web-awesome: \\e682;\n$fa-var-mandalorian: \\f50f;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-osi: \\f41a;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-periscope: \\f3da;\n$fa-var-fulcrum: \\f50b;\n$fa-var-cloudscale: \\f383;\n$fa-var-forumbee: \\f211;\n$fa-var-mizuni: \\f3cc;\n$fa-var-schlix: \\f3ea;\n$fa-var-square-xing: \\f169;\n$fa-var-xing-square: \\f169;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-wpforms: \\f298;\n$fa-var-cloudversify: \\f385;\n$fa-var-usps: \\f7e1;\n$fa-var-megaport: \\f5a3;\n$fa-var-magento: \\f3c4;\n$fa-var-spotify: \\f1bc;\n$fa-var-optin-monster: \\f23c;\n$fa-var-fly: \\f417;\n$fa-var-aviato: \\f421;\n$fa-var-itunes: \\f3b4;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-blogger: \\f37c;\n$fa-var-flickr: \\f16e;\n$fa-var-viber: \\f409;\n$fa-var-soundcloud: \\f1be;\n$fa-var-digg: \\f1a6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-letterboxd: \\e62d;\n$fa-var-symfony: \\f83d;\n$fa-var-maxcdn: \\f136;\n$fa-var-etsy: \\f2d7;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-audible: \\f373;\n$fa-var-think-peaks: \\f731;\n$fa-var-bilibili: \\e3d9;\n$fa-var-erlang: \\f39d;\n$fa-var-x-twitter: \\e61b;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-dashcube: \\f210;\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-elementor: \\f430;\n$fa-var-square-pied-piper: \\e01e;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-palfed: \\f3d8;\n$fa-var-superpowers: \\f2dd;\n$fa-var-resolving: \\f3e7;\n$fa-var-xbox: \\f412;\n$fa-var-square-web-awesome-stroke: \\e684;\n$fa-var-searchengin: \\f3eb;\n$fa-var-tiktok: \\e07b;\n$fa-var-square-facebook: \\f082;\n$fa-var-facebook-square: \\f082;\n$fa-var-renren: \\f18b;\n$fa-var-linux: \\f17c;\n$fa-var-glide: \\f2a5;\n$fa-var-linkedin: \\f08c;\n$fa-var-hubspot: \\f3b2;\n$fa-var-deploydog: \\f38e;\n$fa-var-twitch: \\f1e8;\n$fa-var-ravelry: \\f2d9;\n$fa-var-mixer: \\e056;\n$fa-var-square-lastfm: \\f203;\n$fa-var-lastfm-square: \\f203;\n$fa-var-vimeo: \\f40a;\n$fa-var-mendeley: \\f7b3;\n$fa-var-uniregistry: \\f404;\n$fa-var-figma: \\f799;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-dropbox: \\f16b;\n$fa-var-instagram: \\f16d;\n$fa-var-cmplid: \\e360;\n$fa-var-upwork: \\e641;\n$fa-var-facebook: \\f09a;\n$fa-var-gripfire: \\f3ac;\n$fa-var-jedi-order: \\f50e;\n$fa-var-uikit: \\f403;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-phabricator: \\f3db;\n$fa-var-ussunnah: \\f407;\n$fa-var-earlybirds: \\f39a;\n$fa-var-trade-federation: \\f513;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-whatsapp: \\f232;\n$fa-var-square-upwork: \\e67c;\n$fa-var-slideshare: \\f1e7;\n$fa-var-google-play: \\f3ab;\n$fa-var-viadeo: \\f2a9;\n$fa-var-line: \\f3c0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-servicestack: \\f3ec;\n$fa-var-simplybuilt: \\f215;\n$fa-var-bitbucket: \\f171;\n$fa-var-imdb: \\f2d8;\n$fa-var-deezer: \\e077;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-jira: \\f7b1;\n$fa-var-docker: \\f395;\n$fa-var-screenpal: \\e570;\n$fa-var-bluetooth: \\f293;\n$fa-var-gitter: \\f426;\n$fa-var-d-and-d: \\f38d;\n$fa-var-microblog: \\e01a;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-gg-circle: \\f261;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-yandex: \\f413;\n$fa-var-readme: \\f4d5;\n$fa-var-html5: \\f13b;\n$fa-var-sellsy: \\f213;\n$fa-var-square-web-awesome: \\e683;\n$fa-var-sass: \\f41e;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-salesforce: \\f83b;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-medapps: \\f3c6;\n$fa-var-ns8: \\f3d5;\n$fa-var-pinterest-p: \\f231;\n$fa-var-apper: \\f371;\n$fa-var-fort-awesome: \\f286;\n$fa-var-waze: \\f83f;\n$fa-var-bluesky: \\e671;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-rust: \\e07a;\n$fa-var-wix: \\f5cf;\n$fa-var-square-behance: \\f1b5;\n$fa-var-behance-square: \\f1b5;\n$fa-var-supple: \\f3f9;\n$fa-var-webflow: \\e65c;\n$fa-var-rebel: \\f1d0;\n$fa-var-css3: \\f13c;\n$fa-var-staylinked: \\f3f5;\n$fa-var-kaggle: \\f5fa;\n$fa-var-space-awesome: \\e5ac;\n$fa-var-deviantart: \\f1bd;\n$fa-var-cpanel: \\f388;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-square-git: \\f1d2;\n$fa-var-git-square: \\f1d2;\n$fa-var-square-tumblr: \\f174;\n$fa-var-tumblr-square: \\f174;\n$fa-var-trello: \\f181;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-get-pocket: \\f265;\n$fa-var-perbyte: \\e083;\n$fa-var-grunt: \\f3ad;\n$fa-var-weebly: \\f5cc;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-leanpub: \\f212;\n$fa-var-black-tie: \\f27e;\n$fa-var-themeco: \\f5c6;\n$fa-var-python: \\f3e2;\n$fa-var-android: \\f17b;\n$fa-var-bots: \\e340;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-hornbill: \\f592;\n$fa-var-js: \\f3b8;\n$fa-var-ideal: \\e013;\n$fa-var-git: \\f1d3;\n$fa-var-dev: \\f6cc;\n$fa-var-sketch: \\f7c6;\n$fa-var-yandex-international: \\f414;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-uber: \\f402;\n$fa-var-github: \\f09b;\n$fa-var-php: \\f457;\n$fa-var-alipay: \\f642;\n$fa-var-youtube: \\f167;\n$fa-var-skyatlas: \\f216;\n$fa-var-firefox-browser: \\e007;\n$fa-var-replyd: \\f3e6;\n$fa-var-suse: \\f7d6;\n$fa-var-jenkins: \\f3b6;\n$fa-var-twitter: \\f099;\n$fa-var-rockrms: \\f3e9;\n$fa-var-pinterest: \\f0d2;\n$fa-var-buffer: \\f837;\n$fa-var-npm: \\f3d4;\n$fa-var-yammer: \\f840;\n$fa-var-btc: \\f15a;\n$fa-var-dribbble: \\f17d;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-stubber: \\e5c7;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-old-republic: \\f510;\n$fa-var-odysee: \\e5c6;\n$fa-var-square-whatsapp: \\f40c;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-node-js: \\f3d3;\n$fa-var-edge-legacy: \\e078;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-medrt: \\f3c8;\n$fa-var-usb: \\f287;\n$fa-var-tumblr: \\f173;\n$fa-var-vaadin: \\f408;\n$fa-var-quora: \\f2c4;\n$fa-var-square-x-twitter: \\e61a;\n$fa-var-reacteurope: \\f75d;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-amilia: \\f36d;\n$fa-var-mixcloud: \\f289;\n$fa-var-flipboard: \\f44d;\n$fa-var-viacoin: \\f237;\n$fa-var-critical-role: \\f6c9;\n$fa-var-sitrox: \\e44a;\n$fa-var-discourse: \\f393;\n$fa-var-joomla: \\f1aa;\n$fa-var-mastodon: \\f4f6;\n$fa-var-airbnb: \\f834;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-gulp: \\f3ae;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-strava: \\f428;\n$fa-var-ember: \\f423;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-pushed: \\f3e1;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-wodu: \\e088;\n$fa-var-google-pay: \\e079;\n$fa-var-intercom: \\f7af;\n$fa-var-zhihu: \\f63f;\n$fa-var-korvue: \\f42f;\n$fa-var-pix: \\e43a;\n$fa-var-steam-symbol: \\f3f6;\n\n$fa-icons: (\n  \"0\": $fa-var-0,\n  \"1\": $fa-var-1,\n  \"2\": $fa-var-2,\n  \"3\": $fa-var-3,\n  \"4\": $fa-var-4,\n  \"5\": $fa-var-5,\n  \"6\": $fa-var-6,\n  \"7\": $fa-var-7,\n  \"8\": $fa-var-8,\n  \"9\": $fa-var-9,\n  \"fill-drip\": $fa-var-fill-drip,\n  \"arrows-to-circle\": $fa-var-arrows-to-circle,\n  \"circle-chevron-right\": $fa-var-circle-chevron-right,\n  \"chevron-circle-right\": $fa-var-chevron-circle-right,\n  \"at\": $fa-var-at,\n  \"trash-can\": $fa-var-trash-can,\n  \"trash-alt\": $fa-var-trash-alt,\n  \"text-height\": $fa-var-text-height,\n  \"user-xmark\": $fa-var-user-xmark,\n  \"user-times\": $fa-var-user-times,\n  \"stethoscope\": $fa-var-stethoscope,\n  \"message\": $fa-var-message,\n  \"comment-alt\": $fa-var-comment-alt,\n  \"info\": $fa-var-info,\n  \"down-left-and-up-right-to-center\": $fa-var-down-left-and-up-right-to-center,\n  \"compress-alt\": $fa-var-compress-alt,\n  \"explosion\": $fa-var-explosion,\n  \"file-lines\": $fa-var-file-lines,\n  \"file-alt\": $fa-var-file-alt,\n  \"file-text\": $fa-var-file-text,\n  \"wave-square\": $fa-var-wave-square,\n  \"ring\": $fa-var-ring,\n  \"building-un\": $fa-var-building-un,\n  \"dice-three\": $fa-var-dice-three,\n  \"calendar-days\": $fa-var-calendar-days,\n  \"calendar-alt\": $fa-var-calendar-alt,\n  \"anchor-circle-check\": $fa-var-anchor-circle-check,\n  \"building-circle-arrow-right\": $fa-var-building-circle-arrow-right,\n  \"volleyball\": $fa-var-volleyball,\n  \"volleyball-ball\": $fa-var-volleyball-ball,\n  \"arrows-up-to-line\": $fa-var-arrows-up-to-line,\n  \"sort-down\": $fa-var-sort-down,\n  \"sort-desc\": $fa-var-sort-desc,\n  \"circle-minus\": $fa-var-circle-minus,\n  \"minus-circle\": $fa-var-minus-circle,\n  \"door-open\": $fa-var-door-open,\n  \"right-from-bracket\": $fa-var-right-from-bracket,\n  \"sign-out-alt\": $fa-var-sign-out-alt,\n  \"atom\": $fa-var-atom,\n  \"soap\": $fa-var-soap,\n  \"icons\": $fa-var-icons,\n  \"heart-music-camera-bolt\": $fa-var-heart-music-camera-bolt,\n  \"microphone-lines-slash\": $fa-var-microphone-lines-slash,\n  \"microphone-alt-slash\": $fa-var-microphone-alt-slash,\n  \"bridge-circle-check\": $fa-var-bridge-circle-check,\n  \"pump-medical\": $fa-var-pump-medical,\n  \"fingerprint\": $fa-var-fingerprint,\n  \"hand-point-right\": $fa-var-hand-point-right,\n  \"magnifying-glass-location\": $fa-var-magnifying-glass-location,\n  \"search-location\": $fa-var-search-location,\n  \"forward-step\": $fa-var-forward-step,\n  \"step-forward\": $fa-var-step-forward,\n  \"face-smile-beam\": $fa-var-face-smile-beam,\n  \"smile-beam\": $fa-var-smile-beam,\n  \"flag-checkered\": $fa-var-flag-checkered,\n  \"football\": $fa-var-football,\n  \"football-ball\": $fa-var-football-ball,\n  \"school-circle-exclamation\": $fa-var-school-circle-exclamation,\n  \"crop\": $fa-var-crop,\n  \"angles-down\": $fa-var-angles-down,\n  \"angle-double-down\": $fa-var-angle-double-down,\n  \"users-rectangle\": $fa-var-users-rectangle,\n  \"people-roof\": $fa-var-people-roof,\n  \"people-line\": $fa-var-people-line,\n  \"beer-mug-empty\": $fa-var-beer-mug-empty,\n  \"beer\": $fa-var-beer,\n  \"diagram-predecessor\": $fa-var-diagram-predecessor,\n  \"arrow-up-long\": $fa-var-arrow-up-long,\n  \"long-arrow-up\": $fa-var-long-arrow-up,\n  \"fire-flame-simple\": $fa-var-fire-flame-simple,\n  \"burn\": $fa-var-burn,\n  \"person\": $fa-var-person,\n  \"male\": $fa-var-male,\n  \"laptop\": $fa-var-laptop,\n  \"file-csv\": $fa-var-file-csv,\n  \"menorah\": $fa-var-menorah,\n  \"truck-plane\": $fa-var-truck-plane,\n  \"record-vinyl\": $fa-var-record-vinyl,\n  \"face-grin-stars\": $fa-var-face-grin-stars,\n  \"grin-stars\": $fa-var-grin-stars,\n  \"bong\": $fa-var-bong,\n  \"spaghetti-monster-flying\": $fa-var-spaghetti-monster-flying,\n  \"pastafarianism\": $fa-var-pastafarianism,\n  \"arrow-down-up-across-line\": $fa-var-arrow-down-up-across-line,\n  \"spoon\": $fa-var-spoon,\n  \"utensil-spoon\": $fa-var-utensil-spoon,\n  \"jar-wheat\": $fa-var-jar-wheat,\n  \"envelopes-bulk\": $fa-var-envelopes-bulk,\n  \"mail-bulk\": $fa-var-mail-bulk,\n  \"file-circle-exclamation\": $fa-var-file-circle-exclamation,\n  \"circle-h\": $fa-var-circle-h,\n  \"hospital-symbol\": $fa-var-hospital-symbol,\n  \"pager\": $fa-var-pager,\n  \"address-book\": $fa-var-address-book,\n  \"contact-book\": $fa-var-contact-book,\n  \"strikethrough\": $fa-var-strikethrough,\n  \"k\": $fa-var-k,\n  \"landmark-flag\": $fa-var-landmark-flag,\n  \"pencil\": $fa-var-pencil,\n  \"pencil-alt\": $fa-var-pencil-alt,\n  \"backward\": $fa-var-backward,\n  \"caret-right\": $fa-var-caret-right,\n  \"comments\": $fa-var-comments,\n  \"paste\": $fa-var-paste,\n  \"file-clipboard\": $fa-var-file-clipboard,\n  \"code-pull-request\": $fa-var-code-pull-request,\n  \"clipboard-list\": $fa-var-clipboard-list,\n  \"truck-ramp-box\": $fa-var-truck-ramp-box,\n  \"truck-loading\": $fa-var-truck-loading,\n  \"user-check\": $fa-var-user-check,\n  \"vial-virus\": $fa-var-vial-virus,\n  \"sheet-plastic\": $fa-var-sheet-plastic,\n  \"blog\": $fa-var-blog,\n  \"user-ninja\": $fa-var-user-ninja,\n  \"person-arrow-up-from-line\": $fa-var-person-arrow-up-from-line,\n  \"scroll-torah\": $fa-var-scroll-torah,\n  \"torah\": $fa-var-torah,\n  \"broom-ball\": $fa-var-broom-ball,\n  \"quidditch\": $fa-var-quidditch,\n  \"quidditch-broom-ball\": $fa-var-quidditch-broom-ball,\n  \"toggle-off\": $fa-var-toggle-off,\n  \"box-archive\": $fa-var-box-archive,\n  \"archive\": $fa-var-archive,\n  \"person-drowning\": $fa-var-person-drowning,\n  \"arrow-down-9-1\": $fa-var-arrow-down-9-1,\n  \"sort-numeric-desc\": $fa-var-sort-numeric-desc,\n  \"sort-numeric-down-alt\": $fa-var-sort-numeric-down-alt,\n  \"face-grin-tongue-squint\": $fa-var-face-grin-tongue-squint,\n  \"grin-tongue-squint\": $fa-var-grin-tongue-squint,\n  \"spray-can\": $fa-var-spray-can,\n  \"truck-monster\": $fa-var-truck-monster,\n  \"w\": $fa-var-w,\n  \"earth-africa\": $fa-var-earth-africa,\n  \"globe-africa\": $fa-var-globe-africa,\n  \"rainbow\": $fa-var-rainbow,\n  \"circle-notch\": $fa-var-circle-notch,\n  \"tablet-screen-button\": $fa-var-tablet-screen-button,\n  \"tablet-alt\": $fa-var-tablet-alt,\n  \"paw\": $fa-var-paw,\n  \"cloud\": $fa-var-cloud,\n  \"trowel-bricks\": $fa-var-trowel-bricks,\n  \"face-flushed\": $fa-var-face-flushed,\n  \"flushed\": $fa-var-flushed,\n  \"hospital-user\": $fa-var-hospital-user,\n  \"tent-arrow-left-right\": $fa-var-tent-arrow-left-right,\n  \"gavel\": $fa-var-gavel,\n  \"legal\": $fa-var-legal,\n  \"binoculars\": $fa-var-binoculars,\n  \"microphone-slash\": $fa-var-microphone-slash,\n  \"box-tissue\": $fa-var-box-tissue,\n  \"motorcycle\": $fa-var-motorcycle,\n  \"bell-concierge\": $fa-var-bell-concierge,\n  \"concierge-bell\": $fa-var-concierge-bell,\n  \"pen-ruler\": $fa-var-pen-ruler,\n  \"pencil-ruler\": $fa-var-pencil-ruler,\n  \"people-arrows\": $fa-var-people-arrows,\n  \"people-arrows-left-right\": $fa-var-people-arrows-left-right,\n  \"mars-and-venus-burst\": $fa-var-mars-and-venus-burst,\n  \"square-caret-right\": $fa-var-square-caret-right,\n  \"caret-square-right\": $fa-var-caret-square-right,\n  \"scissors\": $fa-var-scissors,\n  \"cut\": $fa-var-cut,\n  \"sun-plant-wilt\": $fa-var-sun-plant-wilt,\n  \"toilets-portable\": $fa-var-toilets-portable,\n  \"hockey-puck\": $fa-var-hockey-puck,\n  \"table\": $fa-var-table,\n  \"magnifying-glass-arrow-right\": $fa-var-magnifying-glass-arrow-right,\n  \"tachograph-digital\": $fa-var-tachograph-digital,\n  \"digital-tachograph\": $fa-var-digital-tachograph,\n  \"users-slash\": $fa-var-users-slash,\n  \"clover\": $fa-var-clover,\n  \"reply\": $fa-var-reply,\n  \"mail-reply\": $fa-var-mail-reply,\n  \"star-and-crescent\": $fa-var-star-and-crescent,\n  \"house-fire\": $fa-var-house-fire,\n  \"square-minus\": $fa-var-square-minus,\n  \"minus-square\": $fa-var-minus-square,\n  \"helicopter\": $fa-var-helicopter,\n  \"compass\": $fa-var-compass,\n  \"square-caret-down\": $fa-var-square-caret-down,\n  \"caret-square-down\": $fa-var-caret-square-down,\n  \"file-circle-question\": $fa-var-file-circle-question,\n  \"laptop-code\": $fa-var-laptop-code,\n  \"swatchbook\": $fa-var-swatchbook,\n  \"prescription-bottle\": $fa-var-prescription-bottle,\n  \"bars\": $fa-var-bars,\n  \"navicon\": $fa-var-navicon,\n  \"people-group\": $fa-var-people-group,\n  \"hourglass-end\": $fa-var-hourglass-end,\n  \"hourglass-3\": $fa-var-hourglass-3,\n  \"heart-crack\": $fa-var-heart-crack,\n  \"heart-broken\": $fa-var-heart-broken,\n  \"square-up-right\": $fa-var-square-up-right,\n  \"external-link-square-alt\": $fa-var-external-link-square-alt,\n  \"face-kiss-beam\": $fa-var-face-kiss-beam,\n  \"kiss-beam\": $fa-var-kiss-beam,\n  \"film\": $fa-var-film,\n  \"ruler-horizontal\": $fa-var-ruler-horizontal,\n  \"people-robbery\": $fa-var-people-robbery,\n  \"lightbulb\": $fa-var-lightbulb,\n  \"caret-left\": $fa-var-caret-left,\n  \"circle-exclamation\": $fa-var-circle-exclamation,\n  \"exclamation-circle\": $fa-var-exclamation-circle,\n  \"school-circle-xmark\": $fa-var-school-circle-xmark,\n  \"arrow-right-from-bracket\": $fa-var-arrow-right-from-bracket,\n  \"sign-out\": $fa-var-sign-out,\n  \"circle-chevron-down\": $fa-var-circle-chevron-down,\n  \"chevron-circle-down\": $fa-var-chevron-circle-down,\n  \"unlock-keyhole\": $fa-var-unlock-keyhole,\n  \"unlock-alt\": $fa-var-unlock-alt,\n  \"cloud-showers-heavy\": $fa-var-cloud-showers-heavy,\n  \"headphones-simple\": $fa-var-headphones-simple,\n  \"headphones-alt\": $fa-var-headphones-alt,\n  \"sitemap\": $fa-var-sitemap,\n  \"circle-dollar-to-slot\": $fa-var-circle-dollar-to-slot,\n  \"donate\": $fa-var-donate,\n  \"memory\": $fa-var-memory,\n  \"road-spikes\": $fa-var-road-spikes,\n  \"fire-burner\": $fa-var-fire-burner,\n  \"flag\": $fa-var-flag,\n  \"hanukiah\": $fa-var-hanukiah,\n  \"feather\": $fa-var-feather,\n  \"volume-low\": $fa-var-volume-low,\n  \"volume-down\": $fa-var-volume-down,\n  \"comment-slash\": $fa-var-comment-slash,\n  \"cloud-sun-rain\": $fa-var-cloud-sun-rain,\n  \"compress\": $fa-var-compress,\n  \"wheat-awn\": $fa-var-wheat-awn,\n  \"wheat-alt\": $fa-var-wheat-alt,\n  \"ankh\": $fa-var-ankh,\n  \"hands-holding-child\": $fa-var-hands-holding-child,\n  \"asterisk\": $fa-var-asterisk,\n  \"square-check\": $fa-var-square-check,\n  \"check-square\": $fa-var-check-square,\n  \"peseta-sign\": $fa-var-peseta-sign,\n  \"heading\": $fa-var-heading,\n  \"header\": $fa-var-header,\n  \"ghost\": $fa-var-ghost,\n  \"list\": $fa-var-list,\n  \"list-squares\": $fa-var-list-squares,\n  \"square-phone-flip\": $fa-var-square-phone-flip,\n  \"phone-square-alt\": $fa-var-phone-square-alt,\n  \"cart-plus\": $fa-var-cart-plus,\n  \"gamepad\": $fa-var-gamepad,\n  \"circle-dot\": $fa-var-circle-dot,\n  \"dot-circle\": $fa-var-dot-circle,\n  \"face-dizzy\": $fa-var-face-dizzy,\n  \"dizzy\": $fa-var-dizzy,\n  \"egg\": $fa-var-egg,\n  \"house-medical-circle-xmark\": $fa-var-house-medical-circle-xmark,\n  \"campground\": $fa-var-campground,\n  \"folder-plus\": $fa-var-folder-plus,\n  \"futbol\": $fa-var-futbol,\n  \"futbol-ball\": $fa-var-futbol-ball,\n  \"soccer-ball\": $fa-var-soccer-ball,\n  \"paintbrush\": $fa-var-paintbrush,\n  \"paint-brush\": $fa-var-paint-brush,\n  \"lock\": $fa-var-lock,\n  \"gas-pump\": $fa-var-gas-pump,\n  \"hot-tub-person\": $fa-var-hot-tub-person,\n  \"hot-tub\": $fa-var-hot-tub,\n  \"map-location\": $fa-var-map-location,\n  \"map-marked\": $fa-var-map-marked,\n  \"house-flood-water\": $fa-var-house-flood-water,\n  \"tree\": $fa-var-tree,\n  \"bridge-lock\": $fa-var-bridge-lock,\n  \"sack-dollar\": $fa-var-sack-dollar,\n  \"pen-to-square\": $fa-var-pen-to-square,\n  \"edit\": $fa-var-edit,\n  \"car-side\": $fa-var-car-side,\n  \"share-nodes\": $fa-var-share-nodes,\n  \"share-alt\": $fa-var-share-alt,\n  \"heart-circle-minus\": $fa-var-heart-circle-minus,\n  \"hourglass-half\": $fa-var-hourglass-half,\n  \"hourglass-2\": $fa-var-hourglass-2,\n  \"microscope\": $fa-var-microscope,\n  \"sink\": $fa-var-sink,\n  \"bag-shopping\": $fa-var-bag-shopping,\n  \"shopping-bag\": $fa-var-shopping-bag,\n  \"arrow-down-z-a\": $fa-var-arrow-down-z-a,\n  \"sort-alpha-desc\": $fa-var-sort-alpha-desc,\n  \"sort-alpha-down-alt\": $fa-var-sort-alpha-down-alt,\n  \"mitten\": $fa-var-mitten,\n  \"person-rays\": $fa-var-person-rays,\n  \"users\": $fa-var-users,\n  \"eye-slash\": $fa-var-eye-slash,\n  \"flask-vial\": $fa-var-flask-vial,\n  \"hand\": $fa-var-hand,\n  \"hand-paper\": $fa-var-hand-paper,\n  \"om\": $fa-var-om,\n  \"worm\": $fa-var-worm,\n  \"house-circle-xmark\": $fa-var-house-circle-xmark,\n  \"plug\": $fa-var-plug,\n  \"chevron-up\": $fa-var-chevron-up,\n  \"hand-spock\": $fa-var-hand-spock,\n  \"stopwatch\": $fa-var-stopwatch,\n  \"face-kiss\": $fa-var-face-kiss,\n  \"kiss\": $fa-var-kiss,\n  \"bridge-circle-xmark\": $fa-var-bridge-circle-xmark,\n  \"face-grin-tongue\": $fa-var-face-grin-tongue,\n  \"grin-tongue\": $fa-var-grin-tongue,\n  \"chess-bishop\": $fa-var-chess-bishop,\n  \"face-grin-wink\": $fa-var-face-grin-wink,\n  \"grin-wink\": $fa-var-grin-wink,\n  \"ear-deaf\": $fa-var-ear-deaf,\n  \"deaf\": $fa-var-deaf,\n  \"deafness\": $fa-var-deafness,\n  \"hard-of-hearing\": $fa-var-hard-of-hearing,\n  \"road-circle-check\": $fa-var-road-circle-check,\n  \"dice-five\": $fa-var-dice-five,\n  \"square-rss\": $fa-var-square-rss,\n  \"rss-square\": $fa-var-rss-square,\n  \"land-mine-on\": $fa-var-land-mine-on,\n  \"i-cursor\": $fa-var-i-cursor,\n  \"stamp\": $fa-var-stamp,\n  \"stairs\": $fa-var-stairs,\n  \"i\": $fa-var-i,\n  \"hryvnia-sign\": $fa-var-hryvnia-sign,\n  \"hryvnia\": $fa-var-hryvnia,\n  \"pills\": $fa-var-pills,\n  \"face-grin-wide\": $fa-var-face-grin-wide,\n  \"grin-alt\": $fa-var-grin-alt,\n  \"tooth\": $fa-var-tooth,\n  \"v\": $fa-var-v,\n  \"bangladeshi-taka-sign\": $fa-var-bangladeshi-taka-sign,\n  \"bicycle\": $fa-var-bicycle,\n  \"staff-snake\": $fa-var-staff-snake,\n  \"rod-asclepius\": $fa-var-rod-asclepius,\n  \"rod-snake\": $fa-var-rod-snake,\n  \"staff-aesculapius\": $fa-var-staff-aesculapius,\n  \"head-side-cough-slash\": $fa-var-head-side-cough-slash,\n  \"truck-medical\": $fa-var-truck-medical,\n  \"ambulance\": $fa-var-ambulance,\n  \"wheat-awn-circle-exclamation\": $fa-var-wheat-awn-circle-exclamation,\n  \"snowman\": $fa-var-snowman,\n  \"mortar-pestle\": $fa-var-mortar-pestle,\n  \"road-barrier\": $fa-var-road-barrier,\n  \"school\": $fa-var-school,\n  \"igloo\": $fa-var-igloo,\n  \"joint\": $fa-var-joint,\n  \"angle-right\": $fa-var-angle-right,\n  \"horse\": $fa-var-horse,\n  \"q\": $fa-var-q,\n  \"g\": $fa-var-g,\n  \"notes-medical\": $fa-var-notes-medical,\n  \"temperature-half\": $fa-var-temperature-half,\n  \"temperature-2\": $fa-var-temperature-2,\n  \"thermometer-2\": $fa-var-thermometer-2,\n  \"thermometer-half\": $fa-var-thermometer-half,\n  \"dong-sign\": $fa-var-dong-sign,\n  \"capsules\": $fa-var-capsules,\n  \"poo-storm\": $fa-var-poo-storm,\n  \"poo-bolt\": $fa-var-poo-bolt,\n  \"face-frown-open\": $fa-var-face-frown-open,\n  \"frown-open\": $fa-var-frown-open,\n  \"hand-point-up\": $fa-var-hand-point-up,\n  \"money-bill\": $fa-var-money-bill,\n  \"bookmark\": $fa-var-bookmark,\n  \"align-justify\": $fa-var-align-justify,\n  \"umbrella-beach\": $fa-var-umbrella-beach,\n  \"helmet-un\": $fa-var-helmet-un,\n  \"bullseye\": $fa-var-bullseye,\n  \"bacon\": $fa-var-bacon,\n  \"hand-point-down\": $fa-var-hand-point-down,\n  \"arrow-up-from-bracket\": $fa-var-arrow-up-from-bracket,\n  \"folder\": $fa-var-folder,\n  \"folder-blank\": $fa-var-folder-blank,\n  \"file-waveform\": $fa-var-file-waveform,\n  \"file-medical-alt\": $fa-var-file-medical-alt,\n  \"radiation\": $fa-var-radiation,\n  \"chart-simple\": $fa-var-chart-simple,\n  \"mars-stroke\": $fa-var-mars-stroke,\n  \"vial\": $fa-var-vial,\n  \"gauge\": $fa-var-gauge,\n  \"dashboard\": $fa-var-dashboard,\n  \"gauge-med\": $fa-var-gauge-med,\n  \"tachometer-alt-average\": $fa-var-tachometer-alt-average,\n  \"wand-magic-sparkles\": $fa-var-wand-magic-sparkles,\n  \"magic-wand-sparkles\": $fa-var-magic-wand-sparkles,\n  \"e\": $fa-var-e,\n  \"pen-clip\": $fa-var-pen-clip,\n  \"pen-alt\": $fa-var-pen-alt,\n  \"bridge-circle-exclamation\": $fa-var-bridge-circle-exclamation,\n  \"user\": $fa-var-user,\n  \"school-circle-check\": $fa-var-school-circle-check,\n  \"dumpster\": $fa-var-dumpster,\n  \"van-shuttle\": $fa-var-van-shuttle,\n  \"shuttle-van\": $fa-var-shuttle-van,\n  \"building-user\": $fa-var-building-user,\n  \"square-caret-left\": $fa-var-square-caret-left,\n  \"caret-square-left\": $fa-var-caret-square-left,\n  \"highlighter\": $fa-var-highlighter,\n  \"key\": $fa-var-key,\n  \"bullhorn\": $fa-var-bullhorn,\n  \"globe\": $fa-var-globe,\n  \"synagogue\": $fa-var-synagogue,\n  \"person-half-dress\": $fa-var-person-half-dress,\n  \"road-bridge\": $fa-var-road-bridge,\n  \"location-arrow\": $fa-var-location-arrow,\n  \"c\": $fa-var-c,\n  \"tablet-button\": $fa-var-tablet-button,\n  \"building-lock\": $fa-var-building-lock,\n  \"pizza-slice\": $fa-var-pizza-slice,\n  \"money-bill-wave\": $fa-var-money-bill-wave,\n  \"chart-area\": $fa-var-chart-area,\n  \"area-chart\": $fa-var-area-chart,\n  \"house-flag\": $fa-var-house-flag,\n  \"person-circle-minus\": $fa-var-person-circle-minus,\n  \"ban\": $fa-var-ban,\n  \"cancel\": $fa-var-cancel,\n  \"camera-rotate\": $fa-var-camera-rotate,\n  \"spray-can-sparkles\": $fa-var-spray-can-sparkles,\n  \"air-freshener\": $fa-var-air-freshener,\n  \"star\": $fa-var-star,\n  \"repeat\": $fa-var-repeat,\n  \"cross\": $fa-var-cross,\n  \"box\": $fa-var-box,\n  \"venus-mars\": $fa-var-venus-mars,\n  \"arrow-pointer\": $fa-var-arrow-pointer,\n  \"mouse-pointer\": $fa-var-mouse-pointer,\n  \"maximize\": $fa-var-maximize,\n  \"expand-arrows-alt\": $fa-var-expand-arrows-alt,\n  \"charging-station\": $fa-var-charging-station,\n  \"shapes\": $fa-var-shapes,\n  \"triangle-circle-square\": $fa-var-triangle-circle-square,\n  \"shuffle\": $fa-var-shuffle,\n  \"random\": $fa-var-random,\n  \"person-running\": $fa-var-person-running,\n  \"running\": $fa-var-running,\n  \"mobile-retro\": $fa-var-mobile-retro,\n  \"grip-lines-vertical\": $fa-var-grip-lines-vertical,\n  \"spider\": $fa-var-spider,\n  \"hands-bound\": $fa-var-hands-bound,\n  \"file-invoice-dollar\": $fa-var-file-invoice-dollar,\n  \"plane-circle-exclamation\": $fa-var-plane-circle-exclamation,\n  \"x-ray\": $fa-var-x-ray,\n  \"spell-check\": $fa-var-spell-check,\n  \"slash\": $fa-var-slash,\n  \"computer-mouse\": $fa-var-computer-mouse,\n  \"mouse\": $fa-var-mouse,\n  \"arrow-right-to-bracket\": $fa-var-arrow-right-to-bracket,\n  \"sign-in\": $fa-var-sign-in,\n  \"shop-slash\": $fa-var-shop-slash,\n  \"store-alt-slash\": $fa-var-store-alt-slash,\n  \"server\": $fa-var-server,\n  \"virus-covid-slash\": $fa-var-virus-covid-slash,\n  \"shop-lock\": $fa-var-shop-lock,\n  \"hourglass-start\": $fa-var-hourglass-start,\n  \"hourglass-1\": $fa-var-hourglass-1,\n  \"blender-phone\": $fa-var-blender-phone,\n  \"building-wheat\": $fa-var-building-wheat,\n  \"person-breastfeeding\": $fa-var-person-breastfeeding,\n  \"right-to-bracket\": $fa-var-right-to-bracket,\n  \"sign-in-alt\": $fa-var-sign-in-alt,\n  \"venus\": $fa-var-venus,\n  \"passport\": $fa-var-passport,\n  \"heart-pulse\": $fa-var-heart-pulse,\n  \"heartbeat\": $fa-var-heartbeat,\n  \"people-carry-box\": $fa-var-people-carry-box,\n  \"people-carry\": $fa-var-people-carry,\n  \"temperature-high\": $fa-var-temperature-high,\n  \"microchip\": $fa-var-microchip,\n  \"crown\": $fa-var-crown,\n  \"weight-hanging\": $fa-var-weight-hanging,\n  \"xmarks-lines\": $fa-var-xmarks-lines,\n  \"file-prescription\": $fa-var-file-prescription,\n  \"weight-scale\": $fa-var-weight-scale,\n  \"weight\": $fa-var-weight,\n  \"user-group\": $fa-var-user-group,\n  \"user-friends\": $fa-var-user-friends,\n  \"arrow-up-a-z\": $fa-var-arrow-up-a-z,\n  \"sort-alpha-up\": $fa-var-sort-alpha-up,\n  \"chess-knight\": $fa-var-chess-knight,\n  \"face-laugh-squint\": $fa-var-face-laugh-squint,\n  \"laugh-squint\": $fa-var-laugh-squint,\n  \"wheelchair\": $fa-var-wheelchair,\n  \"circle-arrow-up\": $fa-var-circle-arrow-up,\n  \"arrow-circle-up\": $fa-var-arrow-circle-up,\n  \"toggle-on\": $fa-var-toggle-on,\n  \"person-walking\": $fa-var-person-walking,\n  \"walking\": $fa-var-walking,\n  \"l\": $fa-var-l,\n  \"fire\": $fa-var-fire,\n  \"bed-pulse\": $fa-var-bed-pulse,\n  \"procedures\": $fa-var-procedures,\n  \"shuttle-space\": $fa-var-shuttle-space,\n  \"space-shuttle\": $fa-var-space-shuttle,\n  \"face-laugh\": $fa-var-face-laugh,\n  \"laugh\": $fa-var-laugh,\n  \"folder-open\": $fa-var-folder-open,\n  \"heart-circle-plus\": $fa-var-heart-circle-plus,\n  \"code-fork\": $fa-var-code-fork,\n  \"city\": $fa-var-city,\n  \"microphone-lines\": $fa-var-microphone-lines,\n  \"microphone-alt\": $fa-var-microphone-alt,\n  \"pepper-hot\": $fa-var-pepper-hot,\n  \"unlock\": $fa-var-unlock,\n  \"colon-sign\": $fa-var-colon-sign,\n  \"headset\": $fa-var-headset,\n  \"store-slash\": $fa-var-store-slash,\n  \"road-circle-xmark\": $fa-var-road-circle-xmark,\n  \"user-minus\": $fa-var-user-minus,\n  \"mars-stroke-up\": $fa-var-mars-stroke-up,\n  \"mars-stroke-v\": $fa-var-mars-stroke-v,\n  \"champagne-glasses\": $fa-var-champagne-glasses,\n  \"glass-cheers\": $fa-var-glass-cheers,\n  \"clipboard\": $fa-var-clipboard,\n  \"house-circle-exclamation\": $fa-var-house-circle-exclamation,\n  \"file-arrow-up\": $fa-var-file-arrow-up,\n  \"file-upload\": $fa-var-file-upload,\n  \"wifi\": $fa-var-wifi,\n  \"wifi-3\": $fa-var-wifi-3,\n  \"wifi-strong\": $fa-var-wifi-strong,\n  \"bath\": $fa-var-bath,\n  \"bathtub\": $fa-var-bathtub,\n  \"underline\": $fa-var-underline,\n  \"user-pen\": $fa-var-user-pen,\n  \"user-edit\": $fa-var-user-edit,\n  \"signature\": $fa-var-signature,\n  \"stroopwafel\": $fa-var-stroopwafel,\n  \"bold\": $fa-var-bold,\n  \"anchor-lock\": $fa-var-anchor-lock,\n  \"building-ngo\": $fa-var-building-ngo,\n  \"manat-sign\": $fa-var-manat-sign,\n  \"not-equal\": $fa-var-not-equal,\n  \"border-top-left\": $fa-var-border-top-left,\n  \"border-style\": $fa-var-border-style,\n  \"map-location-dot\": $fa-var-map-location-dot,\n  \"map-marked-alt\": $fa-var-map-marked-alt,\n  \"jedi\": $fa-var-jedi,\n  \"square-poll-vertical\": $fa-var-square-poll-vertical,\n  \"poll\": $fa-var-poll,\n  \"mug-hot\": $fa-var-mug-hot,\n  \"car-battery\": $fa-var-car-battery,\n  \"battery-car\": $fa-var-battery-car,\n  \"gift\": $fa-var-gift,\n  \"dice-two\": $fa-var-dice-two,\n  \"chess-queen\": $fa-var-chess-queen,\n  \"glasses\": $fa-var-glasses,\n  \"chess-board\": $fa-var-chess-board,\n  \"building-circle-check\": $fa-var-building-circle-check,\n  \"person-chalkboard\": $fa-var-person-chalkboard,\n  \"mars-stroke-right\": $fa-var-mars-stroke-right,\n  \"mars-stroke-h\": $fa-var-mars-stroke-h,\n  \"hand-back-fist\": $fa-var-hand-back-fist,\n  \"hand-rock\": $fa-var-hand-rock,\n  \"square-caret-up\": $fa-var-square-caret-up,\n  \"caret-square-up\": $fa-var-caret-square-up,\n  \"cloud-showers-water\": $fa-var-cloud-showers-water,\n  \"chart-bar\": $fa-var-chart-bar,\n  \"bar-chart\": $fa-var-bar-chart,\n  \"hands-bubbles\": $fa-var-hands-bubbles,\n  \"hands-wash\": $fa-var-hands-wash,\n  \"less-than-equal\": $fa-var-less-than-equal,\n  \"train\": $fa-var-train,\n  \"eye-low-vision\": $fa-var-eye-low-vision,\n  \"low-vision\": $fa-var-low-vision,\n  \"crow\": $fa-var-crow,\n  \"sailboat\": $fa-var-sailboat,\n  \"window-restore\": $fa-var-window-restore,\n  \"square-plus\": $fa-var-square-plus,\n  \"plus-square\": $fa-var-plus-square,\n  \"torii-gate\": $fa-var-torii-gate,\n  \"frog\": $fa-var-frog,\n  \"bucket\": $fa-var-bucket,\n  \"image\": $fa-var-image,\n  \"microphone\": $fa-var-microphone,\n  \"cow\": $fa-var-cow,\n  \"caret-up\": $fa-var-caret-up,\n  \"screwdriver\": $fa-var-screwdriver,\n  \"folder-closed\": $fa-var-folder-closed,\n  \"house-tsunami\": $fa-var-house-tsunami,\n  \"square-nfi\": $fa-var-square-nfi,\n  \"arrow-up-from-ground-water\": $fa-var-arrow-up-from-ground-water,\n  \"martini-glass\": $fa-var-martini-glass,\n  \"glass-martini-alt\": $fa-var-glass-martini-alt,\n  \"rotate-left\": $fa-var-rotate-left,\n  \"rotate-back\": $fa-var-rotate-back,\n  \"rotate-backward\": $fa-var-rotate-backward,\n  \"undo-alt\": $fa-var-undo-alt,\n  \"table-columns\": $fa-var-table-columns,\n  \"columns\": $fa-var-columns,\n  \"lemon\": $fa-var-lemon,\n  \"head-side-mask\": $fa-var-head-side-mask,\n  \"handshake\": $fa-var-handshake,\n  \"gem\": $fa-var-gem,\n  \"dolly\": $fa-var-dolly,\n  \"dolly-box\": $fa-var-dolly-box,\n  \"smoking\": $fa-var-smoking,\n  \"minimize\": $fa-var-minimize,\n  \"compress-arrows-alt\": $fa-var-compress-arrows-alt,\n  \"monument\": $fa-var-monument,\n  \"snowplow\": $fa-var-snowplow,\n  \"angles-right\": $fa-var-angles-right,\n  \"angle-double-right\": $fa-var-angle-double-right,\n  \"cannabis\": $fa-var-cannabis,\n  \"circle-play\": $fa-var-circle-play,\n  \"play-circle\": $fa-var-play-circle,\n  \"tablets\": $fa-var-tablets,\n  \"ethernet\": $fa-var-ethernet,\n  \"euro-sign\": $fa-var-euro-sign,\n  \"eur\": $fa-var-eur,\n  \"euro\": $fa-var-euro,\n  \"chair\": $fa-var-chair,\n  \"circle-check\": $fa-var-circle-check,\n  \"check-circle\": $fa-var-check-circle,\n  \"circle-stop\": $fa-var-circle-stop,\n  \"stop-circle\": $fa-var-stop-circle,\n  \"compass-drafting\": $fa-var-compass-drafting,\n  \"drafting-compass\": $fa-var-drafting-compass,\n  \"plate-wheat\": $fa-var-plate-wheat,\n  \"icicles\": $fa-var-icicles,\n  \"person-shelter\": $fa-var-person-shelter,\n  \"neuter\": $fa-var-neuter,\n  \"id-badge\": $fa-var-id-badge,\n  \"marker\": $fa-var-marker,\n  \"face-laugh-beam\": $fa-var-face-laugh-beam,\n  \"laugh-beam\": $fa-var-laugh-beam,\n  \"helicopter-symbol\": $fa-var-helicopter-symbol,\n  \"universal-access\": $fa-var-universal-access,\n  \"circle-chevron-up\": $fa-var-circle-chevron-up,\n  \"chevron-circle-up\": $fa-var-chevron-circle-up,\n  \"lari-sign\": $fa-var-lari-sign,\n  \"volcano\": $fa-var-volcano,\n  \"person-walking-dashed-line-arrow-right\": $fa-var-person-walking-dashed-line-arrow-right,\n  \"sterling-sign\": $fa-var-sterling-sign,\n  \"gbp\": $fa-var-gbp,\n  \"pound-sign\": $fa-var-pound-sign,\n  \"viruses\": $fa-var-viruses,\n  \"square-person-confined\": $fa-var-square-person-confined,\n  \"user-tie\": $fa-var-user-tie,\n  \"arrow-down-long\": $fa-var-arrow-down-long,\n  \"long-arrow-down\": $fa-var-long-arrow-down,\n  \"tent-arrow-down-to-line\": $fa-var-tent-arrow-down-to-line,\n  \"certificate\": $fa-var-certificate,\n  \"reply-all\": $fa-var-reply-all,\n  \"mail-reply-all\": $fa-var-mail-reply-all,\n  \"suitcase\": $fa-var-suitcase,\n  \"person-skating\": $fa-var-person-skating,\n  \"skating\": $fa-var-skating,\n  \"filter-circle-dollar\": $fa-var-filter-circle-dollar,\n  \"funnel-dollar\": $fa-var-funnel-dollar,\n  \"camera-retro\": $fa-var-camera-retro,\n  \"circle-arrow-down\": $fa-var-circle-arrow-down,\n  \"arrow-circle-down\": $fa-var-arrow-circle-down,\n  \"file-import\": $fa-var-file-import,\n  \"arrow-right-to-file\": $fa-var-arrow-right-to-file,\n  \"square-arrow-up-right\": $fa-var-square-arrow-up-right,\n  \"external-link-square\": $fa-var-external-link-square,\n  \"box-open\": $fa-var-box-open,\n  \"scroll\": $fa-var-scroll,\n  \"spa\": $fa-var-spa,\n  \"location-pin-lock\": $fa-var-location-pin-lock,\n  \"pause\": $fa-var-pause,\n  \"hill-avalanche\": $fa-var-hill-avalanche,\n  \"temperature-empty\": $fa-var-temperature-empty,\n  \"temperature-0\": $fa-var-temperature-0,\n  \"thermometer-0\": $fa-var-thermometer-0,\n  \"thermometer-empty\": $fa-var-thermometer-empty,\n  \"bomb\": $fa-var-bomb,\n  \"registered\": $fa-var-registered,\n  \"address-card\": $fa-var-address-card,\n  \"contact-card\": $fa-var-contact-card,\n  \"vcard\": $fa-var-vcard,\n  \"scale-unbalanced-flip\": $fa-var-scale-unbalanced-flip,\n  \"balance-scale-right\": $fa-var-balance-scale-right,\n  \"subscript\": $fa-var-subscript,\n  \"diamond-turn-right\": $fa-var-diamond-turn-right,\n  \"directions\": $fa-var-directions,\n  \"burst\": $fa-var-burst,\n  \"house-laptop\": $fa-var-house-laptop,\n  \"laptop-house\": $fa-var-laptop-house,\n  \"face-tired\": $fa-var-face-tired,\n  \"tired\": $fa-var-tired,\n  \"money-bills\": $fa-var-money-bills,\n  \"smog\": $fa-var-smog,\n  \"crutch\": $fa-var-crutch,\n  \"cloud-arrow-up\": $fa-var-cloud-arrow-up,\n  \"cloud-upload\": $fa-var-cloud-upload,\n  \"cloud-upload-alt\": $fa-var-cloud-upload-alt,\n  \"palette\": $fa-var-palette,\n  \"arrows-turn-right\": $fa-var-arrows-turn-right,\n  \"vest\": $fa-var-vest,\n  \"ferry\": $fa-var-ferry,\n  \"arrows-down-to-people\": $fa-var-arrows-down-to-people,\n  \"seedling\": $fa-var-seedling,\n  \"sprout\": $fa-var-sprout,\n  \"left-right\": $fa-var-left-right,\n  \"arrows-alt-h\": $fa-var-arrows-alt-h,\n  \"boxes-packing\": $fa-var-boxes-packing,\n  \"circle-arrow-left\": $fa-var-circle-arrow-left,\n  \"arrow-circle-left\": $fa-var-arrow-circle-left,\n  \"group-arrows-rotate\": $fa-var-group-arrows-rotate,\n  \"bowl-food\": $fa-var-bowl-food,\n  \"candy-cane\": $fa-var-candy-cane,\n  \"arrow-down-wide-short\": $fa-var-arrow-down-wide-short,\n  \"sort-amount-asc\": $fa-var-sort-amount-asc,\n  \"sort-amount-down\": $fa-var-sort-amount-down,\n  \"cloud-bolt\": $fa-var-cloud-bolt,\n  \"thunderstorm\": $fa-var-thunderstorm,\n  \"text-slash\": $fa-var-text-slash,\n  \"remove-format\": $fa-var-remove-format,\n  \"face-smile-wink\": $fa-var-face-smile-wink,\n  \"smile-wink\": $fa-var-smile-wink,\n  \"file-word\": $fa-var-file-word,\n  \"file-powerpoint\": $fa-var-file-powerpoint,\n  \"arrows-left-right\": $fa-var-arrows-left-right,\n  \"arrows-h\": $fa-var-arrows-h,\n  \"house-lock\": $fa-var-house-lock,\n  \"cloud-arrow-down\": $fa-var-cloud-arrow-down,\n  \"cloud-download\": $fa-var-cloud-download,\n  \"cloud-download-alt\": $fa-var-cloud-download-alt,\n  \"children\": $fa-var-children,\n  \"chalkboard\": $fa-var-chalkboard,\n  \"blackboard\": $fa-var-blackboard,\n  \"user-large-slash\": $fa-var-user-large-slash,\n  \"user-alt-slash\": $fa-var-user-alt-slash,\n  \"envelope-open\": $fa-var-envelope-open,\n  \"handshake-simple-slash\": $fa-var-handshake-simple-slash,\n  \"handshake-alt-slash\": $fa-var-handshake-alt-slash,\n  \"mattress-pillow\": $fa-var-mattress-pillow,\n  \"guarani-sign\": $fa-var-guarani-sign,\n  \"arrows-rotate\": $fa-var-arrows-rotate,\n  \"refresh\": $fa-var-refresh,\n  \"sync\": $fa-var-sync,\n  \"fire-extinguisher\": $fa-var-fire-extinguisher,\n  \"cruzeiro-sign\": $fa-var-cruzeiro-sign,\n  \"greater-than-equal\": $fa-var-greater-than-equal,\n  \"shield-halved\": $fa-var-shield-halved,\n  \"shield-alt\": $fa-var-shield-alt,\n  \"book-atlas\": $fa-var-book-atlas,\n  \"atlas\": $fa-var-atlas,\n  \"virus\": $fa-var-virus,\n  \"envelope-circle-check\": $fa-var-envelope-circle-check,\n  \"layer-group\": $fa-var-layer-group,\n  \"arrows-to-dot\": $fa-var-arrows-to-dot,\n  \"archway\": $fa-var-archway,\n  \"heart-circle-check\": $fa-var-heart-circle-check,\n  \"house-chimney-crack\": $fa-var-house-chimney-crack,\n  \"house-damage\": $fa-var-house-damage,\n  \"file-zipper\": $fa-var-file-zipper,\n  \"file-archive\": $fa-var-file-archive,\n  \"square\": $fa-var-square,\n  \"martini-glass-empty\": $fa-var-martini-glass-empty,\n  \"glass-martini\": $fa-var-glass-martini,\n  \"couch\": $fa-var-couch,\n  \"cedi-sign\": $fa-var-cedi-sign,\n  \"italic\": $fa-var-italic,\n  \"table-cells-column-lock\": $fa-var-table-cells-column-lock,\n  \"church\": $fa-var-church,\n  \"comments-dollar\": $fa-var-comments-dollar,\n  \"democrat\": $fa-var-democrat,\n  \"z\": $fa-var-z,\n  \"person-skiing\": $fa-var-person-skiing,\n  \"skiing\": $fa-var-skiing,\n  \"road-lock\": $fa-var-road-lock,\n  \"a\": $fa-var-a,\n  \"temperature-arrow-down\": $fa-var-temperature-arrow-down,\n  \"temperature-down\": $fa-var-temperature-down,\n  \"feather-pointed\": $fa-var-feather-pointed,\n  \"feather-alt\": $fa-var-feather-alt,\n  \"p\": $fa-var-p,\n  \"snowflake\": $fa-var-snowflake,\n  \"newspaper\": $fa-var-newspaper,\n  \"rectangle-ad\": $fa-var-rectangle-ad,\n  \"ad\": $fa-var-ad,\n  \"circle-arrow-right\": $fa-var-circle-arrow-right,\n  \"arrow-circle-right\": $fa-var-arrow-circle-right,\n  \"filter-circle-xmark\": $fa-var-filter-circle-xmark,\n  \"locust\": $fa-var-locust,\n  \"sort\": $fa-var-sort,\n  \"unsorted\": $fa-var-unsorted,\n  \"list-ol\": $fa-var-list-ol,\n  \"list-1-2\": $fa-var-list-1-2,\n  \"list-numeric\": $fa-var-list-numeric,\n  \"person-dress-burst\": $fa-var-person-dress-burst,\n  \"money-check-dollar\": $fa-var-money-check-dollar,\n  \"money-check-alt\": $fa-var-money-check-alt,\n  \"vector-square\": $fa-var-vector-square,\n  \"bread-slice\": $fa-var-bread-slice,\n  \"language\": $fa-var-language,\n  \"face-kiss-wink-heart\": $fa-var-face-kiss-wink-heart,\n  \"kiss-wink-heart\": $fa-var-kiss-wink-heart,\n  \"filter\": $fa-var-filter,\n  \"question\": $fa-var-question,\n  \"file-signature\": $fa-var-file-signature,\n  \"up-down-left-right\": $fa-var-up-down-left-right,\n  \"arrows-alt\": $fa-var-arrows-alt,\n  \"house-chimney-user\": $fa-var-house-chimney-user,\n  \"hand-holding-heart\": $fa-var-hand-holding-heart,\n  \"puzzle-piece\": $fa-var-puzzle-piece,\n  \"money-check\": $fa-var-money-check,\n  \"star-half-stroke\": $fa-var-star-half-stroke,\n  \"star-half-alt\": $fa-var-star-half-alt,\n  \"code\": $fa-var-code,\n  \"whiskey-glass\": $fa-var-whiskey-glass,\n  \"glass-whiskey\": $fa-var-glass-whiskey,\n  \"building-circle-exclamation\": $fa-var-building-circle-exclamation,\n  \"magnifying-glass-chart\": $fa-var-magnifying-glass-chart,\n  \"arrow-up-right-from-square\": $fa-var-arrow-up-right-from-square,\n  \"external-link\": $fa-var-external-link,\n  \"cubes-stacked\": $fa-var-cubes-stacked,\n  \"won-sign\": $fa-var-won-sign,\n  \"krw\": $fa-var-krw,\n  \"won\": $fa-var-won,\n  \"virus-covid\": $fa-var-virus-covid,\n  \"austral-sign\": $fa-var-austral-sign,\n  \"f\": $fa-var-f,\n  \"leaf\": $fa-var-leaf,\n  \"road\": $fa-var-road,\n  \"taxi\": $fa-var-taxi,\n  \"cab\": $fa-var-cab,\n  \"person-circle-plus\": $fa-var-person-circle-plus,\n  \"chart-pie\": $fa-var-chart-pie,\n  \"pie-chart\": $fa-var-pie-chart,\n  \"bolt-lightning\": $fa-var-bolt-lightning,\n  \"sack-xmark\": $fa-var-sack-xmark,\n  \"file-excel\": $fa-var-file-excel,\n  \"file-contract\": $fa-var-file-contract,\n  \"fish-fins\": $fa-var-fish-fins,\n  \"building-flag\": $fa-var-building-flag,\n  \"face-grin-beam\": $fa-var-face-grin-beam,\n  \"grin-beam\": $fa-var-grin-beam,\n  \"object-ungroup\": $fa-var-object-ungroup,\n  \"poop\": $fa-var-poop,\n  \"location-pin\": $fa-var-location-pin,\n  \"map-marker\": $fa-var-map-marker,\n  \"kaaba\": $fa-var-kaaba,\n  \"toilet-paper\": $fa-var-toilet-paper,\n  \"helmet-safety\": $fa-var-helmet-safety,\n  \"hard-hat\": $fa-var-hard-hat,\n  \"hat-hard\": $fa-var-hat-hard,\n  \"eject\": $fa-var-eject,\n  \"circle-right\": $fa-var-circle-right,\n  \"arrow-alt-circle-right\": $fa-var-arrow-alt-circle-right,\n  \"plane-circle-check\": $fa-var-plane-circle-check,\n  \"face-rolling-eyes\": $fa-var-face-rolling-eyes,\n  \"meh-rolling-eyes\": $fa-var-meh-rolling-eyes,\n  \"object-group\": $fa-var-object-group,\n  \"chart-line\": $fa-var-chart-line,\n  \"line-chart\": $fa-var-line-chart,\n  \"mask-ventilator\": $fa-var-mask-ventilator,\n  \"arrow-right\": $fa-var-arrow-right,\n  \"signs-post\": $fa-var-signs-post,\n  \"map-signs\": $fa-var-map-signs,\n  \"cash-register\": $fa-var-cash-register,\n  \"person-circle-question\": $fa-var-person-circle-question,\n  \"h\": $fa-var-h,\n  \"tarp\": $fa-var-tarp,\n  \"screwdriver-wrench\": $fa-var-screwdriver-wrench,\n  \"tools\": $fa-var-tools,\n  \"arrows-to-eye\": $fa-var-arrows-to-eye,\n  \"plug-circle-bolt\": $fa-var-plug-circle-bolt,\n  \"heart\": $fa-var-heart,\n  \"mars-and-venus\": $fa-var-mars-and-venus,\n  \"house-user\": $fa-var-house-user,\n  \"home-user\": $fa-var-home-user,\n  \"dumpster-fire\": $fa-var-dumpster-fire,\n  \"house-crack\": $fa-var-house-crack,\n  \"martini-glass-citrus\": $fa-var-martini-glass-citrus,\n  \"cocktail\": $fa-var-cocktail,\n  \"face-surprise\": $fa-var-face-surprise,\n  \"surprise\": $fa-var-surprise,\n  \"bottle-water\": $fa-var-bottle-water,\n  \"circle-pause\": $fa-var-circle-pause,\n  \"pause-circle\": $fa-var-pause-circle,\n  \"toilet-paper-slash\": $fa-var-toilet-paper-slash,\n  \"apple-whole\": $fa-var-apple-whole,\n  \"apple-alt\": $fa-var-apple-alt,\n  \"kitchen-set\": $fa-var-kitchen-set,\n  \"r\": $fa-var-r,\n  \"temperature-quarter\": $fa-var-temperature-quarter,\n  \"temperature-1\": $fa-var-temperature-1,\n  \"thermometer-1\": $fa-var-thermometer-1,\n  \"thermometer-quarter\": $fa-var-thermometer-quarter,\n  \"cube\": $fa-var-cube,\n  \"bitcoin-sign\": $fa-var-bitcoin-sign,\n  \"shield-dog\": $fa-var-shield-dog,\n  \"solar-panel\": $fa-var-solar-panel,\n  \"lock-open\": $fa-var-lock-open,\n  \"elevator\": $fa-var-elevator,\n  \"money-bill-transfer\": $fa-var-money-bill-transfer,\n  \"money-bill-trend-up\": $fa-var-money-bill-trend-up,\n  \"house-flood-water-circle-arrow-right\": $fa-var-house-flood-water-circle-arrow-right,\n  \"square-poll-horizontal\": $fa-var-square-poll-horizontal,\n  \"poll-h\": $fa-var-poll-h,\n  \"circle\": $fa-var-circle,\n  \"backward-fast\": $fa-var-backward-fast,\n  \"fast-backward\": $fa-var-fast-backward,\n  \"recycle\": $fa-var-recycle,\n  \"user-astronaut\": $fa-var-user-astronaut,\n  \"plane-slash\": $fa-var-plane-slash,\n  \"trademark\": $fa-var-trademark,\n  \"basketball\": $fa-var-basketball,\n  \"basketball-ball\": $fa-var-basketball-ball,\n  \"satellite-dish\": $fa-var-satellite-dish,\n  \"circle-up\": $fa-var-circle-up,\n  \"arrow-alt-circle-up\": $fa-var-arrow-alt-circle-up,\n  \"mobile-screen-button\": $fa-var-mobile-screen-button,\n  \"mobile-alt\": $fa-var-mobile-alt,\n  \"volume-high\": $fa-var-volume-high,\n  \"volume-up\": $fa-var-volume-up,\n  \"users-rays\": $fa-var-users-rays,\n  \"wallet\": $fa-var-wallet,\n  \"clipboard-check\": $fa-var-clipboard-check,\n  \"file-audio\": $fa-var-file-audio,\n  \"burger\": $fa-var-burger,\n  \"hamburger\": $fa-var-hamburger,\n  \"wrench\": $fa-var-wrench,\n  \"bugs\": $fa-var-bugs,\n  \"rupee-sign\": $fa-var-rupee-sign,\n  \"rupee\": $fa-var-rupee,\n  \"file-image\": $fa-var-file-image,\n  \"circle-question\": $fa-var-circle-question,\n  \"question-circle\": $fa-var-question-circle,\n  \"plane-departure\": $fa-var-plane-departure,\n  \"handshake-slash\": $fa-var-handshake-slash,\n  \"book-bookmark\": $fa-var-book-bookmark,\n  \"code-branch\": $fa-var-code-branch,\n  \"hat-cowboy\": $fa-var-hat-cowboy,\n  \"bridge\": $fa-var-bridge,\n  \"phone-flip\": $fa-var-phone-flip,\n  \"phone-alt\": $fa-var-phone-alt,\n  \"truck-front\": $fa-var-truck-front,\n  \"cat\": $fa-var-cat,\n  \"anchor-circle-exclamation\": $fa-var-anchor-circle-exclamation,\n  \"truck-field\": $fa-var-truck-field,\n  \"route\": $fa-var-route,\n  \"clipboard-question\": $fa-var-clipboard-question,\n  \"panorama\": $fa-var-panorama,\n  \"comment-medical\": $fa-var-comment-medical,\n  \"teeth-open\": $fa-var-teeth-open,\n  \"file-circle-minus\": $fa-var-file-circle-minus,\n  \"tags\": $fa-var-tags,\n  \"wine-glass\": $fa-var-wine-glass,\n  \"forward-fast\": $fa-var-forward-fast,\n  \"fast-forward\": $fa-var-fast-forward,\n  \"face-meh-blank\": $fa-var-face-meh-blank,\n  \"meh-blank\": $fa-var-meh-blank,\n  \"square-parking\": $fa-var-square-parking,\n  \"parking\": $fa-var-parking,\n  \"house-signal\": $fa-var-house-signal,\n  \"bars-progress\": $fa-var-bars-progress,\n  \"tasks-alt\": $fa-var-tasks-alt,\n  \"faucet-drip\": $fa-var-faucet-drip,\n  \"cart-flatbed\": $fa-var-cart-flatbed,\n  \"dolly-flatbed\": $fa-var-dolly-flatbed,\n  \"ban-smoking\": $fa-var-ban-smoking,\n  \"smoking-ban\": $fa-var-smoking-ban,\n  \"terminal\": $fa-var-terminal,\n  \"mobile-button\": $fa-var-mobile-button,\n  \"house-medical-flag\": $fa-var-house-medical-flag,\n  \"basket-shopping\": $fa-var-basket-shopping,\n  \"shopping-basket\": $fa-var-shopping-basket,\n  \"tape\": $fa-var-tape,\n  \"bus-simple\": $fa-var-bus-simple,\n  \"bus-alt\": $fa-var-bus-alt,\n  \"eye\": $fa-var-eye,\n  \"face-sad-cry\": $fa-var-face-sad-cry,\n  \"sad-cry\": $fa-var-sad-cry,\n  \"audio-description\": $fa-var-audio-description,\n  \"person-military-to-person\": $fa-var-person-military-to-person,\n  \"file-shield\": $fa-var-file-shield,\n  \"user-slash\": $fa-var-user-slash,\n  \"pen\": $fa-var-pen,\n  \"tower-observation\": $fa-var-tower-observation,\n  \"file-code\": $fa-var-file-code,\n  \"signal\": $fa-var-signal,\n  \"signal-5\": $fa-var-signal-5,\n  \"signal-perfect\": $fa-var-signal-perfect,\n  \"bus\": $fa-var-bus,\n  \"heart-circle-xmark\": $fa-var-heart-circle-xmark,\n  \"house-chimney\": $fa-var-house-chimney,\n  \"home-lg\": $fa-var-home-lg,\n  \"window-maximize\": $fa-var-window-maximize,\n  \"face-frown\": $fa-var-face-frown,\n  \"frown\": $fa-var-frown,\n  \"prescription\": $fa-var-prescription,\n  \"shop\": $fa-var-shop,\n  \"store-alt\": $fa-var-store-alt,\n  \"floppy-disk\": $fa-var-floppy-disk,\n  \"save\": $fa-var-save,\n  \"vihara\": $fa-var-vihara,\n  \"scale-unbalanced\": $fa-var-scale-unbalanced,\n  \"balance-scale-left\": $fa-var-balance-scale-left,\n  \"sort-up\": $fa-var-sort-up,\n  \"sort-asc\": $fa-var-sort-asc,\n  \"comment-dots\": $fa-var-comment-dots,\n  \"commenting\": $fa-var-commenting,\n  \"plant-wilt\": $fa-var-plant-wilt,\n  \"diamond\": $fa-var-diamond,\n  \"face-grin-squint\": $fa-var-face-grin-squint,\n  \"grin-squint\": $fa-var-grin-squint,\n  \"hand-holding-dollar\": $fa-var-hand-holding-dollar,\n  \"hand-holding-usd\": $fa-var-hand-holding-usd,\n  \"bacterium\": $fa-var-bacterium,\n  \"hand-pointer\": $fa-var-hand-pointer,\n  \"drum-steelpan\": $fa-var-drum-steelpan,\n  \"hand-scissors\": $fa-var-hand-scissors,\n  \"hands-praying\": $fa-var-hands-praying,\n  \"praying-hands\": $fa-var-praying-hands,\n  \"arrow-rotate-right\": $fa-var-arrow-rotate-right,\n  \"arrow-right-rotate\": $fa-var-arrow-right-rotate,\n  \"arrow-rotate-forward\": $fa-var-arrow-rotate-forward,\n  \"redo\": $fa-var-redo,\n  \"biohazard\": $fa-var-biohazard,\n  \"location-crosshairs\": $fa-var-location-crosshairs,\n  \"location\": $fa-var-location,\n  \"mars-double\": $fa-var-mars-double,\n  \"child-dress\": $fa-var-child-dress,\n  \"users-between-lines\": $fa-var-users-between-lines,\n  \"lungs-virus\": $fa-var-lungs-virus,\n  \"face-grin-tears\": $fa-var-face-grin-tears,\n  \"grin-tears\": $fa-var-grin-tears,\n  \"phone\": $fa-var-phone,\n  \"calendar-xmark\": $fa-var-calendar-xmark,\n  \"calendar-times\": $fa-var-calendar-times,\n  \"child-reaching\": $fa-var-child-reaching,\n  \"head-side-virus\": $fa-var-head-side-virus,\n  \"user-gear\": $fa-var-user-gear,\n  \"user-cog\": $fa-var-user-cog,\n  \"arrow-up-1-9\": $fa-var-arrow-up-1-9,\n  \"sort-numeric-up\": $fa-var-sort-numeric-up,\n  \"door-closed\": $fa-var-door-closed,\n  \"shield-virus\": $fa-var-shield-virus,\n  \"dice-six\": $fa-var-dice-six,\n  \"mosquito-net\": $fa-var-mosquito-net,\n  \"bridge-water\": $fa-var-bridge-water,\n  \"person-booth\": $fa-var-person-booth,\n  \"text-width\": $fa-var-text-width,\n  \"hat-wizard\": $fa-var-hat-wizard,\n  \"pen-fancy\": $fa-var-pen-fancy,\n  \"person-digging\": $fa-var-person-digging,\n  \"digging\": $fa-var-digging,\n  \"trash\": $fa-var-trash,\n  \"gauge-simple\": $fa-var-gauge-simple,\n  \"gauge-simple-med\": $fa-var-gauge-simple-med,\n  \"tachometer-average\": $fa-var-tachometer-average,\n  \"book-medical\": $fa-var-book-medical,\n  \"poo\": $fa-var-poo,\n  \"quote-right\": $fa-var-quote-right,\n  \"quote-right-alt\": $fa-var-quote-right-alt,\n  \"shirt\": $fa-var-shirt,\n  \"t-shirt\": $fa-var-t-shirt,\n  \"tshirt\": $fa-var-tshirt,\n  \"cubes\": $fa-var-cubes,\n  \"divide\": $fa-var-divide,\n  \"tenge-sign\": $fa-var-tenge-sign,\n  \"tenge\": $fa-var-tenge,\n  \"headphones\": $fa-var-headphones,\n  \"hands-holding\": $fa-var-hands-holding,\n  \"hands-clapping\": $fa-var-hands-clapping,\n  \"republican\": $fa-var-republican,\n  \"arrow-left\": $fa-var-arrow-left,\n  \"person-circle-xmark\": $fa-var-person-circle-xmark,\n  \"ruler\": $fa-var-ruler,\n  \"align-left\": $fa-var-align-left,\n  \"dice-d6\": $fa-var-dice-d6,\n  \"restroom\": $fa-var-restroom,\n  \"j\": $fa-var-j,\n  \"users-viewfinder\": $fa-var-users-viewfinder,\n  \"file-video\": $fa-var-file-video,\n  \"up-right-from-square\": $fa-var-up-right-from-square,\n  \"external-link-alt\": $fa-var-external-link-alt,\n  \"table-cells\": $fa-var-table-cells,\n  \"th\": $fa-var-th,\n  \"file-pdf\": $fa-var-file-pdf,\n  \"book-bible\": $fa-var-book-bible,\n  \"bible\": $fa-var-bible,\n  \"o\": $fa-var-o,\n  \"suitcase-medical\": $fa-var-suitcase-medical,\n  \"medkit\": $fa-var-medkit,\n  \"user-secret\": $fa-var-user-secret,\n  \"otter\": $fa-var-otter,\n  \"person-dress\": $fa-var-person-dress,\n  \"female\": $fa-var-female,\n  \"comment-dollar\": $fa-var-comment-dollar,\n  \"business-time\": $fa-var-business-time,\n  \"briefcase-clock\": $fa-var-briefcase-clock,\n  \"table-cells-large\": $fa-var-table-cells-large,\n  \"th-large\": $fa-var-th-large,\n  \"book-tanakh\": $fa-var-book-tanakh,\n  \"tanakh\": $fa-var-tanakh,\n  \"phone-volume\": $fa-var-phone-volume,\n  \"volume-control-phone\": $fa-var-volume-control-phone,\n  \"hat-cowboy-side\": $fa-var-hat-cowboy-side,\n  \"clipboard-user\": $fa-var-clipboard-user,\n  \"child\": $fa-var-child,\n  \"lira-sign\": $fa-var-lira-sign,\n  \"satellite\": $fa-var-satellite,\n  \"plane-lock\": $fa-var-plane-lock,\n  \"tag\": $fa-var-tag,\n  \"comment\": $fa-var-comment,\n  \"cake-candles\": $fa-var-cake-candles,\n  \"birthday-cake\": $fa-var-birthday-cake,\n  \"cake\": $fa-var-cake,\n  \"envelope\": $fa-var-envelope,\n  \"angles-up\": $fa-var-angles-up,\n  \"angle-double-up\": $fa-var-angle-double-up,\n  \"paperclip\": $fa-var-paperclip,\n  \"arrow-right-to-city\": $fa-var-arrow-right-to-city,\n  \"ribbon\": $fa-var-ribbon,\n  \"lungs\": $fa-var-lungs,\n  \"arrow-up-9-1\": $fa-var-arrow-up-9-1,\n  \"sort-numeric-up-alt\": $fa-var-sort-numeric-up-alt,\n  \"litecoin-sign\": $fa-var-litecoin-sign,\n  \"border-none\": $fa-var-border-none,\n  \"circle-nodes\": $fa-var-circle-nodes,\n  \"parachute-box\": $fa-var-parachute-box,\n  \"indent\": $fa-var-indent,\n  \"truck-field-un\": $fa-var-truck-field-un,\n  \"hourglass\": $fa-var-hourglass,\n  \"hourglass-empty\": $fa-var-hourglass-empty,\n  \"mountain\": $fa-var-mountain,\n  \"user-doctor\": $fa-var-user-doctor,\n  \"user-md\": $fa-var-user-md,\n  \"circle-info\": $fa-var-circle-info,\n  \"info-circle\": $fa-var-info-circle,\n  \"cloud-meatball\": $fa-var-cloud-meatball,\n  \"camera\": $fa-var-camera,\n  \"camera-alt\": $fa-var-camera-alt,\n  \"square-virus\": $fa-var-square-virus,\n  \"meteor\": $fa-var-meteor,\n  \"car-on\": $fa-var-car-on,\n  \"sleigh\": $fa-var-sleigh,\n  \"arrow-down-1-9\": $fa-var-arrow-down-1-9,\n  \"sort-numeric-asc\": $fa-var-sort-numeric-asc,\n  \"sort-numeric-down\": $fa-var-sort-numeric-down,\n  \"hand-holding-droplet\": $fa-var-hand-holding-droplet,\n  \"hand-holding-water\": $fa-var-hand-holding-water,\n  \"water\": $fa-var-water,\n  \"calendar-check\": $fa-var-calendar-check,\n  \"braille\": $fa-var-braille,\n  \"prescription-bottle-medical\": $fa-var-prescription-bottle-medical,\n  \"prescription-bottle-alt\": $fa-var-prescription-bottle-alt,\n  \"landmark\": $fa-var-landmark,\n  \"truck\": $fa-var-truck,\n  \"crosshairs\": $fa-var-crosshairs,\n  \"person-cane\": $fa-var-person-cane,\n  \"tent\": $fa-var-tent,\n  \"vest-patches\": $fa-var-vest-patches,\n  \"check-double\": $fa-var-check-double,\n  \"arrow-down-a-z\": $fa-var-arrow-down-a-z,\n  \"sort-alpha-asc\": $fa-var-sort-alpha-asc,\n  \"sort-alpha-down\": $fa-var-sort-alpha-down,\n  \"money-bill-wheat\": $fa-var-money-bill-wheat,\n  \"cookie\": $fa-var-cookie,\n  \"arrow-rotate-left\": $fa-var-arrow-rotate-left,\n  \"arrow-left-rotate\": $fa-var-arrow-left-rotate,\n  \"arrow-rotate-back\": $fa-var-arrow-rotate-back,\n  \"arrow-rotate-backward\": $fa-var-arrow-rotate-backward,\n  \"undo\": $fa-var-undo,\n  \"hard-drive\": $fa-var-hard-drive,\n  \"hdd\": $fa-var-hdd,\n  \"face-grin-squint-tears\": $fa-var-face-grin-squint-tears,\n  \"grin-squint-tears\": $fa-var-grin-squint-tears,\n  \"dumbbell\": $fa-var-dumbbell,\n  \"rectangle-list\": $fa-var-rectangle-list,\n  \"list-alt\": $fa-var-list-alt,\n  \"tarp-droplet\": $fa-var-tarp-droplet,\n  \"house-medical-circle-check\": $fa-var-house-medical-circle-check,\n  \"person-skiing-nordic\": $fa-var-person-skiing-nordic,\n  \"skiing-nordic\": $fa-var-skiing-nordic,\n  \"calendar-plus\": $fa-var-calendar-plus,\n  \"plane-arrival\": $fa-var-plane-arrival,\n  \"circle-left\": $fa-var-circle-left,\n  \"arrow-alt-circle-left\": $fa-var-arrow-alt-circle-left,\n  \"train-subway\": $fa-var-train-subway,\n  \"subway\": $fa-var-subway,\n  \"chart-gantt\": $fa-var-chart-gantt,\n  \"indian-rupee-sign\": $fa-var-indian-rupee-sign,\n  \"indian-rupee\": $fa-var-indian-rupee,\n  \"inr\": $fa-var-inr,\n  \"crop-simple\": $fa-var-crop-simple,\n  \"crop-alt\": $fa-var-crop-alt,\n  \"money-bill-1\": $fa-var-money-bill-1,\n  \"money-bill-alt\": $fa-var-money-bill-alt,\n  \"left-long\": $fa-var-left-long,\n  \"long-arrow-alt-left\": $fa-var-long-arrow-alt-left,\n  \"dna\": $fa-var-dna,\n  \"virus-slash\": $fa-var-virus-slash,\n  \"minus\": $fa-var-minus,\n  \"subtract\": $fa-var-subtract,\n  \"chess\": $fa-var-chess,\n  \"arrow-left-long\": $fa-var-arrow-left-long,\n  \"long-arrow-left\": $fa-var-long-arrow-left,\n  \"plug-circle-check\": $fa-var-plug-circle-check,\n  \"street-view\": $fa-var-street-view,\n  \"franc-sign\": $fa-var-franc-sign,\n  \"volume-off\": $fa-var-volume-off,\n  \"hands-asl-interpreting\": $fa-var-hands-asl-interpreting,\n  \"american-sign-language-interpreting\": $fa-var-american-sign-language-interpreting,\n  \"asl-interpreting\": $fa-var-asl-interpreting,\n  \"hands-american-sign-language-interpreting\": $fa-var-hands-american-sign-language-interpreting,\n  \"gear\": $fa-var-gear,\n  \"cog\": $fa-var-cog,\n  \"droplet-slash\": $fa-var-droplet-slash,\n  \"tint-slash\": $fa-var-tint-slash,\n  \"mosque\": $fa-var-mosque,\n  \"mosquito\": $fa-var-mosquito,\n  \"star-of-david\": $fa-var-star-of-david,\n  \"person-military-rifle\": $fa-var-person-military-rifle,\n  \"cart-shopping\": $fa-var-cart-shopping,\n  \"shopping-cart\": $fa-var-shopping-cart,\n  \"vials\": $fa-var-vials,\n  \"plug-circle-plus\": $fa-var-plug-circle-plus,\n  \"place-of-worship\": $fa-var-place-of-worship,\n  \"grip-vertical\": $fa-var-grip-vertical,\n  \"arrow-turn-up\": $fa-var-arrow-turn-up,\n  \"level-up\": $fa-var-level-up,\n  \"u\": $fa-var-u,\n  \"square-root-variable\": $fa-var-square-root-variable,\n  \"square-root-alt\": $fa-var-square-root-alt,\n  \"clock\": $fa-var-clock,\n  \"clock-four\": $fa-var-clock-four,\n  \"backward-step\": $fa-var-backward-step,\n  \"step-backward\": $fa-var-step-backward,\n  \"pallet\": $fa-var-pallet,\n  \"faucet\": $fa-var-faucet,\n  \"baseball-bat-ball\": $fa-var-baseball-bat-ball,\n  \"s\": $fa-var-s,\n  \"timeline\": $fa-var-timeline,\n  \"keyboard\": $fa-var-keyboard,\n  \"caret-down\": $fa-var-caret-down,\n  \"house-chimney-medical\": $fa-var-house-chimney-medical,\n  \"clinic-medical\": $fa-var-clinic-medical,\n  \"temperature-three-quarters\": $fa-var-temperature-three-quarters,\n  \"temperature-3\": $fa-var-temperature-3,\n  \"thermometer-3\": $fa-var-thermometer-3,\n  \"thermometer-three-quarters\": $fa-var-thermometer-three-quarters,\n  \"mobile-screen\": $fa-var-mobile-screen,\n  \"mobile-android-alt\": $fa-var-mobile-android-alt,\n  \"plane-up\": $fa-var-plane-up,\n  \"piggy-bank\": $fa-var-piggy-bank,\n  \"battery-half\": $fa-var-battery-half,\n  \"battery-3\": $fa-var-battery-3,\n  \"mountain-city\": $fa-var-mountain-city,\n  \"coins\": $fa-var-coins,\n  \"khanda\": $fa-var-khanda,\n  \"sliders\": $fa-var-sliders,\n  \"sliders-h\": $fa-var-sliders-h,\n  \"folder-tree\": $fa-var-folder-tree,\n  \"network-wired\": $fa-var-network-wired,\n  \"map-pin\": $fa-var-map-pin,\n  \"hamsa\": $fa-var-hamsa,\n  \"cent-sign\": $fa-var-cent-sign,\n  \"flask\": $fa-var-flask,\n  \"person-pregnant\": $fa-var-person-pregnant,\n  \"wand-sparkles\": $fa-var-wand-sparkles,\n  \"ellipsis-vertical\": $fa-var-ellipsis-vertical,\n  \"ellipsis-v\": $fa-var-ellipsis-v,\n  \"ticket\": $fa-var-ticket,\n  \"power-off\": $fa-var-power-off,\n  \"right-long\": $fa-var-right-long,\n  \"long-arrow-alt-right\": $fa-var-long-arrow-alt-right,\n  \"flag-usa\": $fa-var-flag-usa,\n  \"laptop-file\": $fa-var-laptop-file,\n  \"tty\": $fa-var-tty,\n  \"teletype\": $fa-var-teletype,\n  \"diagram-next\": $fa-var-diagram-next,\n  \"person-rifle\": $fa-var-person-rifle,\n  \"house-medical-circle-exclamation\": $fa-var-house-medical-circle-exclamation,\n  \"closed-captioning\": $fa-var-closed-captioning,\n  \"person-hiking\": $fa-var-person-hiking,\n  \"hiking\": $fa-var-hiking,\n  \"venus-double\": $fa-var-venus-double,\n  \"images\": $fa-var-images,\n  \"calculator\": $fa-var-calculator,\n  \"people-pulling\": $fa-var-people-pulling,\n  \"n\": $fa-var-n,\n  \"cable-car\": $fa-var-cable-car,\n  \"tram\": $fa-var-tram,\n  \"cloud-rain\": $fa-var-cloud-rain,\n  \"building-circle-xmark\": $fa-var-building-circle-xmark,\n  \"ship\": $fa-var-ship,\n  \"arrows-down-to-line\": $fa-var-arrows-down-to-line,\n  \"download\": $fa-var-download,\n  \"face-grin\": $fa-var-face-grin,\n  \"grin\": $fa-var-grin,\n  \"delete-left\": $fa-var-delete-left,\n  \"backspace\": $fa-var-backspace,\n  \"eye-dropper\": $fa-var-eye-dropper,\n  \"eye-dropper-empty\": $fa-var-eye-dropper-empty,\n  \"eyedropper\": $fa-var-eyedropper,\n  \"file-circle-check\": $fa-var-file-circle-check,\n  \"forward\": $fa-var-forward,\n  \"mobile\": $fa-var-mobile,\n  \"mobile-android\": $fa-var-mobile-android,\n  \"mobile-phone\": $fa-var-mobile-phone,\n  \"face-meh\": $fa-var-face-meh,\n  \"meh\": $fa-var-meh,\n  \"align-center\": $fa-var-align-center,\n  \"book-skull\": $fa-var-book-skull,\n  \"book-dead\": $fa-var-book-dead,\n  \"id-card\": $fa-var-id-card,\n  \"drivers-license\": $fa-var-drivers-license,\n  \"outdent\": $fa-var-outdent,\n  \"dedent\": $fa-var-dedent,\n  \"heart-circle-exclamation\": $fa-var-heart-circle-exclamation,\n  \"house\": $fa-var-house,\n  \"home\": $fa-var-home,\n  \"home-alt\": $fa-var-home-alt,\n  \"home-lg-alt\": $fa-var-home-lg-alt,\n  \"calendar-week\": $fa-var-calendar-week,\n  \"laptop-medical\": $fa-var-laptop-medical,\n  \"b\": $fa-var-b,\n  \"file-medical\": $fa-var-file-medical,\n  \"dice-one\": $fa-var-dice-one,\n  \"kiwi-bird\": $fa-var-kiwi-bird,\n  \"arrow-right-arrow-left\": $fa-var-arrow-right-arrow-left,\n  \"exchange\": $fa-var-exchange,\n  \"rotate-right\": $fa-var-rotate-right,\n  \"redo-alt\": $fa-var-redo-alt,\n  \"rotate-forward\": $fa-var-rotate-forward,\n  \"utensils\": $fa-var-utensils,\n  \"cutlery\": $fa-var-cutlery,\n  \"arrow-up-wide-short\": $fa-var-arrow-up-wide-short,\n  \"sort-amount-up\": $fa-var-sort-amount-up,\n  \"mill-sign\": $fa-var-mill-sign,\n  \"bowl-rice\": $fa-var-bowl-rice,\n  \"skull\": $fa-var-skull,\n  \"tower-broadcast\": $fa-var-tower-broadcast,\n  \"broadcast-tower\": $fa-var-broadcast-tower,\n  \"truck-pickup\": $fa-var-truck-pickup,\n  \"up-long\": $fa-var-up-long,\n  \"long-arrow-alt-up\": $fa-var-long-arrow-alt-up,\n  \"stop\": $fa-var-stop,\n  \"code-merge\": $fa-var-code-merge,\n  \"upload\": $fa-var-upload,\n  \"hurricane\": $fa-var-hurricane,\n  \"mound\": $fa-var-mound,\n  \"toilet-portable\": $fa-var-toilet-portable,\n  \"compact-disc\": $fa-var-compact-disc,\n  \"file-arrow-down\": $fa-var-file-arrow-down,\n  \"file-download\": $fa-var-file-download,\n  \"caravan\": $fa-var-caravan,\n  \"shield-cat\": $fa-var-shield-cat,\n  \"bolt\": $fa-var-bolt,\n  \"zap\": $fa-var-zap,\n  \"glass-water\": $fa-var-glass-water,\n  \"oil-well\": $fa-var-oil-well,\n  \"vault\": $fa-var-vault,\n  \"mars\": $fa-var-mars,\n  \"toilet\": $fa-var-toilet,\n  \"plane-circle-xmark\": $fa-var-plane-circle-xmark,\n  \"yen-sign\": $fa-var-yen-sign,\n  \"cny\": $fa-var-cny,\n  \"jpy\": $fa-var-jpy,\n  \"rmb\": $fa-var-rmb,\n  \"yen\": $fa-var-yen,\n  \"ruble-sign\": $fa-var-ruble-sign,\n  \"rouble\": $fa-var-rouble,\n  \"rub\": $fa-var-rub,\n  \"ruble\": $fa-var-ruble,\n  \"sun\": $fa-var-sun,\n  \"guitar\": $fa-var-guitar,\n  \"face-laugh-wink\": $fa-var-face-laugh-wink,\n  \"laugh-wink\": $fa-var-laugh-wink,\n  \"horse-head\": $fa-var-horse-head,\n  \"bore-hole\": $fa-var-bore-hole,\n  \"industry\": $fa-var-industry,\n  \"circle-down\": $fa-var-circle-down,\n  \"arrow-alt-circle-down\": $fa-var-arrow-alt-circle-down,\n  \"arrows-turn-to-dots\": $fa-var-arrows-turn-to-dots,\n  \"florin-sign\": $fa-var-florin-sign,\n  \"arrow-down-short-wide\": $fa-var-arrow-down-short-wide,\n  \"sort-amount-desc\": $fa-var-sort-amount-desc,\n  \"sort-amount-down-alt\": $fa-var-sort-amount-down-alt,\n  \"less-than\": $fa-var-less-than,\n  \"angle-down\": $fa-var-angle-down,\n  \"car-tunnel\": $fa-var-car-tunnel,\n  \"head-side-cough\": $fa-var-head-side-cough,\n  \"grip-lines\": $fa-var-grip-lines,\n  \"thumbs-down\": $fa-var-thumbs-down,\n  \"user-lock\": $fa-var-user-lock,\n  \"arrow-right-long\": $fa-var-arrow-right-long,\n  \"long-arrow-right\": $fa-var-long-arrow-right,\n  \"anchor-circle-xmark\": $fa-var-anchor-circle-xmark,\n  \"ellipsis\": $fa-var-ellipsis,\n  \"ellipsis-h\": $fa-var-ellipsis-h,\n  \"chess-pawn\": $fa-var-chess-pawn,\n  \"kit-medical\": $fa-var-kit-medical,\n  \"first-aid\": $fa-var-first-aid,\n  \"person-through-window\": $fa-var-person-through-window,\n  \"toolbox\": $fa-var-toolbox,\n  \"hands-holding-circle\": $fa-var-hands-holding-circle,\n  \"bug\": $fa-var-bug,\n  \"credit-card\": $fa-var-credit-card,\n  \"credit-card-alt\": $fa-var-credit-card-alt,\n  \"car\": $fa-var-car,\n  \"automobile\": $fa-var-automobile,\n  \"hand-holding-hand\": $fa-var-hand-holding-hand,\n  \"book-open-reader\": $fa-var-book-open-reader,\n  \"book-reader\": $fa-var-book-reader,\n  \"mountain-sun\": $fa-var-mountain-sun,\n  \"arrows-left-right-to-line\": $fa-var-arrows-left-right-to-line,\n  \"dice-d20\": $fa-var-dice-d20,\n  \"truck-droplet\": $fa-var-truck-droplet,\n  \"file-circle-xmark\": $fa-var-file-circle-xmark,\n  \"temperature-arrow-up\": $fa-var-temperature-arrow-up,\n  \"temperature-up\": $fa-var-temperature-up,\n  \"medal\": $fa-var-medal,\n  \"bed\": $fa-var-bed,\n  \"square-h\": $fa-var-square-h,\n  \"h-square\": $fa-var-h-square,\n  \"podcast\": $fa-var-podcast,\n  \"temperature-full\": $fa-var-temperature-full,\n  \"temperature-4\": $fa-var-temperature-4,\n  \"thermometer-4\": $fa-var-thermometer-4,\n  \"thermometer-full\": $fa-var-thermometer-full,\n  \"bell\": $fa-var-bell,\n  \"superscript\": $fa-var-superscript,\n  \"plug-circle-xmark\": $fa-var-plug-circle-xmark,\n  \"star-of-life\": $fa-var-star-of-life,\n  \"phone-slash\": $fa-var-phone-slash,\n  \"paint-roller\": $fa-var-paint-roller,\n  \"handshake-angle\": $fa-var-handshake-angle,\n  \"hands-helping\": $fa-var-hands-helping,\n  \"location-dot\": $fa-var-location-dot,\n  \"map-marker-alt\": $fa-var-map-marker-alt,\n  \"file\": $fa-var-file,\n  \"greater-than\": $fa-var-greater-than,\n  \"person-swimming\": $fa-var-person-swimming,\n  \"swimmer\": $fa-var-swimmer,\n  \"arrow-down\": $fa-var-arrow-down,\n  \"droplet\": $fa-var-droplet,\n  \"tint\": $fa-var-tint,\n  \"eraser\": $fa-var-eraser,\n  \"earth-americas\": $fa-var-earth-americas,\n  \"earth\": $fa-var-earth,\n  \"earth-america\": $fa-var-earth-america,\n  \"globe-americas\": $fa-var-globe-americas,\n  \"person-burst\": $fa-var-person-burst,\n  \"dove\": $fa-var-dove,\n  \"battery-empty\": $fa-var-battery-empty,\n  \"battery-0\": $fa-var-battery-0,\n  \"socks\": $fa-var-socks,\n  \"inbox\": $fa-var-inbox,\n  \"section\": $fa-var-section,\n  \"gauge-high\": $fa-var-gauge-high,\n  \"tachometer-alt\": $fa-var-tachometer-alt,\n  \"tachometer-alt-fast\": $fa-var-tachometer-alt-fast,\n  \"envelope-open-text\": $fa-var-envelope-open-text,\n  \"hospital\": $fa-var-hospital,\n  \"hospital-alt\": $fa-var-hospital-alt,\n  \"hospital-wide\": $fa-var-hospital-wide,\n  \"wine-bottle\": $fa-var-wine-bottle,\n  \"chess-rook\": $fa-var-chess-rook,\n  \"bars-staggered\": $fa-var-bars-staggered,\n  \"reorder\": $fa-var-reorder,\n  \"stream\": $fa-var-stream,\n  \"dharmachakra\": $fa-var-dharmachakra,\n  \"hotdog\": $fa-var-hotdog,\n  \"person-walking-with-cane\": $fa-var-person-walking-with-cane,\n  \"blind\": $fa-var-blind,\n  \"drum\": $fa-var-drum,\n  \"ice-cream\": $fa-var-ice-cream,\n  \"heart-circle-bolt\": $fa-var-heart-circle-bolt,\n  \"fax\": $fa-var-fax,\n  \"paragraph\": $fa-var-paragraph,\n  \"check-to-slot\": $fa-var-check-to-slot,\n  \"vote-yea\": $fa-var-vote-yea,\n  \"star-half\": $fa-var-star-half,\n  \"boxes-stacked\": $fa-var-boxes-stacked,\n  \"boxes\": $fa-var-boxes,\n  \"boxes-alt\": $fa-var-boxes-alt,\n  \"link\": $fa-var-link,\n  \"chain\": $fa-var-chain,\n  \"ear-listen\": $fa-var-ear-listen,\n  \"assistive-listening-systems\": $fa-var-assistive-listening-systems,\n  \"tree-city\": $fa-var-tree-city,\n  \"play\": $fa-var-play,\n  \"font\": $fa-var-font,\n  \"table-cells-row-lock\": $fa-var-table-cells-row-lock,\n  \"rupiah-sign\": $fa-var-rupiah-sign,\n  \"magnifying-glass\": $fa-var-magnifying-glass,\n  \"search\": $fa-var-search,\n  \"table-tennis-paddle-ball\": $fa-var-table-tennis-paddle-ball,\n  \"ping-pong-paddle-ball\": $fa-var-ping-pong-paddle-ball,\n  \"table-tennis\": $fa-var-table-tennis,\n  \"person-dots-from-line\": $fa-var-person-dots-from-line,\n  \"diagnoses\": $fa-var-diagnoses,\n  \"trash-can-arrow-up\": $fa-var-trash-can-arrow-up,\n  \"trash-restore-alt\": $fa-var-trash-restore-alt,\n  \"naira-sign\": $fa-var-naira-sign,\n  \"cart-arrow-down\": $fa-var-cart-arrow-down,\n  \"walkie-talkie\": $fa-var-walkie-talkie,\n  \"file-pen\": $fa-var-file-pen,\n  \"file-edit\": $fa-var-file-edit,\n  \"receipt\": $fa-var-receipt,\n  \"square-pen\": $fa-var-square-pen,\n  \"pen-square\": $fa-var-pen-square,\n  \"pencil-square\": $fa-var-pencil-square,\n  \"suitcase-rolling\": $fa-var-suitcase-rolling,\n  \"person-circle-exclamation\": $fa-var-person-circle-exclamation,\n  \"chevron-down\": $fa-var-chevron-down,\n  \"battery-full\": $fa-var-battery-full,\n  \"battery\": $fa-var-battery,\n  \"battery-5\": $fa-var-battery-5,\n  \"skull-crossbones\": $fa-var-skull-crossbones,\n  \"code-compare\": $fa-var-code-compare,\n  \"list-ul\": $fa-var-list-ul,\n  \"list-dots\": $fa-var-list-dots,\n  \"school-lock\": $fa-var-school-lock,\n  \"tower-cell\": $fa-var-tower-cell,\n  \"down-long\": $fa-var-down-long,\n  \"long-arrow-alt-down\": $fa-var-long-arrow-alt-down,\n  \"ranking-star\": $fa-var-ranking-star,\n  \"chess-king\": $fa-var-chess-king,\n  \"person-harassing\": $fa-var-person-harassing,\n  \"brazilian-real-sign\": $fa-var-brazilian-real-sign,\n  \"landmark-dome\": $fa-var-landmark-dome,\n  \"landmark-alt\": $fa-var-landmark-alt,\n  \"arrow-up\": $fa-var-arrow-up,\n  \"tv\": $fa-var-tv,\n  \"television\": $fa-var-television,\n  \"tv-alt\": $fa-var-tv-alt,\n  \"shrimp\": $fa-var-shrimp,\n  \"list-check\": $fa-var-list-check,\n  \"tasks\": $fa-var-tasks,\n  \"jug-detergent\": $fa-var-jug-detergent,\n  \"circle-user\": $fa-var-circle-user,\n  \"user-circle\": $fa-var-user-circle,\n  \"user-shield\": $fa-var-user-shield,\n  \"wind\": $fa-var-wind,\n  \"car-burst\": $fa-var-car-burst,\n  \"car-crash\": $fa-var-car-crash,\n  \"y\": $fa-var-y,\n  \"person-snowboarding\": $fa-var-person-snowboarding,\n  \"snowboarding\": $fa-var-snowboarding,\n  \"truck-fast\": $fa-var-truck-fast,\n  \"shipping-fast\": $fa-var-shipping-fast,\n  \"fish\": $fa-var-fish,\n  \"user-graduate\": $fa-var-user-graduate,\n  \"circle-half-stroke\": $fa-var-circle-half-stroke,\n  \"adjust\": $fa-var-adjust,\n  \"clapperboard\": $fa-var-clapperboard,\n  \"circle-radiation\": $fa-var-circle-radiation,\n  \"radiation-alt\": $fa-var-radiation-alt,\n  \"baseball\": $fa-var-baseball,\n  \"baseball-ball\": $fa-var-baseball-ball,\n  \"jet-fighter-up\": $fa-var-jet-fighter-up,\n  \"diagram-project\": $fa-var-diagram-project,\n  \"project-diagram\": $fa-var-project-diagram,\n  \"copy\": $fa-var-copy,\n  \"volume-xmark\": $fa-var-volume-xmark,\n  \"volume-mute\": $fa-var-volume-mute,\n  \"volume-times\": $fa-var-volume-times,\n  \"hand-sparkles\": $fa-var-hand-sparkles,\n  \"grip\": $fa-var-grip,\n  \"grip-horizontal\": $fa-var-grip-horizontal,\n  \"share-from-square\": $fa-var-share-from-square,\n  \"share-square\": $fa-var-share-square,\n  \"child-combatant\": $fa-var-child-combatant,\n  \"child-rifle\": $fa-var-child-rifle,\n  \"gun\": $fa-var-gun,\n  \"square-phone\": $fa-var-square-phone,\n  \"phone-square\": $fa-var-phone-square,\n  \"plus\": $fa-var-plus,\n  \"add\": $fa-var-add,\n  \"expand\": $fa-var-expand,\n  \"computer\": $fa-var-computer,\n  \"xmark\": $fa-var-xmark,\n  \"close\": $fa-var-close,\n  \"multiply\": $fa-var-multiply,\n  \"remove\": $fa-var-remove,\n  \"times\": $fa-var-times,\n  \"arrows-up-down-left-right\": $fa-var-arrows-up-down-left-right,\n  \"arrows\": $fa-var-arrows,\n  \"chalkboard-user\": $fa-var-chalkboard-user,\n  \"chalkboard-teacher\": $fa-var-chalkboard-teacher,\n  \"peso-sign\": $fa-var-peso-sign,\n  \"building-shield\": $fa-var-building-shield,\n  \"baby\": $fa-var-baby,\n  \"users-line\": $fa-var-users-line,\n  \"quote-left\": $fa-var-quote-left,\n  \"quote-left-alt\": $fa-var-quote-left-alt,\n  \"tractor\": $fa-var-tractor,\n  \"trash-arrow-up\": $fa-var-trash-arrow-up,\n  \"trash-restore\": $fa-var-trash-restore,\n  \"arrow-down-up-lock\": $fa-var-arrow-down-up-lock,\n  \"lines-leaning\": $fa-var-lines-leaning,\n  \"ruler-combined\": $fa-var-ruler-combined,\n  \"copyright\": $fa-var-copyright,\n  \"equals\": $fa-var-equals,\n  \"blender\": $fa-var-blender,\n  \"teeth\": $fa-var-teeth,\n  \"shekel-sign\": $fa-var-shekel-sign,\n  \"ils\": $fa-var-ils,\n  \"shekel\": $fa-var-shekel,\n  \"sheqel\": $fa-var-sheqel,\n  \"sheqel-sign\": $fa-var-sheqel-sign,\n  \"map\": $fa-var-map,\n  \"rocket\": $fa-var-rocket,\n  \"photo-film\": $fa-var-photo-film,\n  \"photo-video\": $fa-var-photo-video,\n  \"folder-minus\": $fa-var-folder-minus,\n  \"store\": $fa-var-store,\n  \"arrow-trend-up\": $fa-var-arrow-trend-up,\n  \"plug-circle-minus\": $fa-var-plug-circle-minus,\n  \"sign-hanging\": $fa-var-sign-hanging,\n  \"sign\": $fa-var-sign,\n  \"bezier-curve\": $fa-var-bezier-curve,\n  \"bell-slash\": $fa-var-bell-slash,\n  \"tablet\": $fa-var-tablet,\n  \"tablet-android\": $fa-var-tablet-android,\n  \"school-flag\": $fa-var-school-flag,\n  \"fill\": $fa-var-fill,\n  \"angle-up\": $fa-var-angle-up,\n  \"drumstick-bite\": $fa-var-drumstick-bite,\n  \"holly-berry\": $fa-var-holly-berry,\n  \"chevron-left\": $fa-var-chevron-left,\n  \"bacteria\": $fa-var-bacteria,\n  \"hand-lizard\": $fa-var-hand-lizard,\n  \"notdef\": $fa-var-notdef,\n  \"disease\": $fa-var-disease,\n  \"briefcase-medical\": $fa-var-briefcase-medical,\n  \"genderless\": $fa-var-genderless,\n  \"chevron-right\": $fa-var-chevron-right,\n  \"retweet\": $fa-var-retweet,\n  \"car-rear\": $fa-var-car-rear,\n  \"car-alt\": $fa-var-car-alt,\n  \"pump-soap\": $fa-var-pump-soap,\n  \"video-slash\": $fa-var-video-slash,\n  \"battery-quarter\": $fa-var-battery-quarter,\n  \"battery-2\": $fa-var-battery-2,\n  \"radio\": $fa-var-radio,\n  \"baby-carriage\": $fa-var-baby-carriage,\n  \"carriage-baby\": $fa-var-carriage-baby,\n  \"traffic-light\": $fa-var-traffic-light,\n  \"thermometer\": $fa-var-thermometer,\n  \"vr-cardboard\": $fa-var-vr-cardboard,\n  \"hand-middle-finger\": $fa-var-hand-middle-finger,\n  \"percent\": $fa-var-percent,\n  \"percentage\": $fa-var-percentage,\n  \"truck-moving\": $fa-var-truck-moving,\n  \"glass-water-droplet\": $fa-var-glass-water-droplet,\n  \"display\": $fa-var-display,\n  \"face-smile\": $fa-var-face-smile,\n  \"smile\": $fa-var-smile,\n  \"thumbtack\": $fa-var-thumbtack,\n  \"thumb-tack\": $fa-var-thumb-tack,\n  \"trophy\": $fa-var-trophy,\n  \"person-praying\": $fa-var-person-praying,\n  \"pray\": $fa-var-pray,\n  \"hammer\": $fa-var-hammer,\n  \"hand-peace\": $fa-var-hand-peace,\n  \"rotate\": $fa-var-rotate,\n  \"sync-alt\": $fa-var-sync-alt,\n  \"spinner\": $fa-var-spinner,\n  \"robot\": $fa-var-robot,\n  \"peace\": $fa-var-peace,\n  \"gears\": $fa-var-gears,\n  \"cogs\": $fa-var-cogs,\n  \"warehouse\": $fa-var-warehouse,\n  \"arrow-up-right-dots\": $fa-var-arrow-up-right-dots,\n  \"splotch\": $fa-var-splotch,\n  \"face-grin-hearts\": $fa-var-face-grin-hearts,\n  \"grin-hearts\": $fa-var-grin-hearts,\n  \"dice-four\": $fa-var-dice-four,\n  \"sim-card\": $fa-var-sim-card,\n  \"transgender\": $fa-var-transgender,\n  \"transgender-alt\": $fa-var-transgender-alt,\n  \"mercury\": $fa-var-mercury,\n  \"arrow-turn-down\": $fa-var-arrow-turn-down,\n  \"level-down\": $fa-var-level-down,\n  \"person-falling-burst\": $fa-var-person-falling-burst,\n  \"award\": $fa-var-award,\n  \"ticket-simple\": $fa-var-ticket-simple,\n  \"ticket-alt\": $fa-var-ticket-alt,\n  \"building\": $fa-var-building,\n  \"angles-left\": $fa-var-angles-left,\n  \"angle-double-left\": $fa-var-angle-double-left,\n  \"qrcode\": $fa-var-qrcode,\n  \"clock-rotate-left\": $fa-var-clock-rotate-left,\n  \"history\": $fa-var-history,\n  \"face-grin-beam-sweat\": $fa-var-face-grin-beam-sweat,\n  \"grin-beam-sweat\": $fa-var-grin-beam-sweat,\n  \"file-export\": $fa-var-file-export,\n  \"arrow-right-from-file\": $fa-var-arrow-right-from-file,\n  \"shield\": $fa-var-shield,\n  \"shield-blank\": $fa-var-shield-blank,\n  \"arrow-up-short-wide\": $fa-var-arrow-up-short-wide,\n  \"sort-amount-up-alt\": $fa-var-sort-amount-up-alt,\n  \"house-medical\": $fa-var-house-medical,\n  \"golf-ball-tee\": $fa-var-golf-ball-tee,\n  \"golf-ball\": $fa-var-golf-ball,\n  \"circle-chevron-left\": $fa-var-circle-chevron-left,\n  \"chevron-circle-left\": $fa-var-chevron-circle-left,\n  \"house-chimney-window\": $fa-var-house-chimney-window,\n  \"pen-nib\": $fa-var-pen-nib,\n  \"tent-arrow-turn-left\": $fa-var-tent-arrow-turn-left,\n  \"tents\": $fa-var-tents,\n  \"wand-magic\": $fa-var-wand-magic,\n  \"magic\": $fa-var-magic,\n  \"dog\": $fa-var-dog,\n  \"carrot\": $fa-var-carrot,\n  \"moon\": $fa-var-moon,\n  \"wine-glass-empty\": $fa-var-wine-glass-empty,\n  \"wine-glass-alt\": $fa-var-wine-glass-alt,\n  \"cheese\": $fa-var-cheese,\n  \"yin-yang\": $fa-var-yin-yang,\n  \"music\": $fa-var-music,\n  \"code-commit\": $fa-var-code-commit,\n  \"temperature-low\": $fa-var-temperature-low,\n  \"person-biking\": $fa-var-person-biking,\n  \"biking\": $fa-var-biking,\n  \"broom\": $fa-var-broom,\n  \"shield-heart\": $fa-var-shield-heart,\n  \"gopuram\": $fa-var-gopuram,\n  \"earth-oceania\": $fa-var-earth-oceania,\n  \"globe-oceania\": $fa-var-globe-oceania,\n  \"square-xmark\": $fa-var-square-xmark,\n  \"times-square\": $fa-var-times-square,\n  \"xmark-square\": $fa-var-xmark-square,\n  \"hashtag\": $fa-var-hashtag,\n  \"up-right-and-down-left-from-center\": $fa-var-up-right-and-down-left-from-center,\n  \"expand-alt\": $fa-var-expand-alt,\n  \"oil-can\": $fa-var-oil-can,\n  \"t\": $fa-var-t,\n  \"hippo\": $fa-var-hippo,\n  \"chart-column\": $fa-var-chart-column,\n  \"infinity\": $fa-var-infinity,\n  \"vial-circle-check\": $fa-var-vial-circle-check,\n  \"person-arrow-down-to-line\": $fa-var-person-arrow-down-to-line,\n  \"voicemail\": $fa-var-voicemail,\n  \"fan\": $fa-var-fan,\n  \"person-walking-luggage\": $fa-var-person-walking-luggage,\n  \"up-down\": $fa-var-up-down,\n  \"arrows-alt-v\": $fa-var-arrows-alt-v,\n  \"cloud-moon-rain\": $fa-var-cloud-moon-rain,\n  \"calendar\": $fa-var-calendar,\n  \"trailer\": $fa-var-trailer,\n  \"bahai\": $fa-var-bahai,\n  \"haykal\": $fa-var-haykal,\n  \"sd-card\": $fa-var-sd-card,\n  \"dragon\": $fa-var-dragon,\n  \"shoe-prints\": $fa-var-shoe-prints,\n  \"circle-plus\": $fa-var-circle-plus,\n  \"plus-circle\": $fa-var-plus-circle,\n  \"face-grin-tongue-wink\": $fa-var-face-grin-tongue-wink,\n  \"grin-tongue-wink\": $fa-var-grin-tongue-wink,\n  \"hand-holding\": $fa-var-hand-holding,\n  \"plug-circle-exclamation\": $fa-var-plug-circle-exclamation,\n  \"link-slash\": $fa-var-link-slash,\n  \"chain-broken\": $fa-var-chain-broken,\n  \"chain-slash\": $fa-var-chain-slash,\n  \"unlink\": $fa-var-unlink,\n  \"clone\": $fa-var-clone,\n  \"person-walking-arrow-loop-left\": $fa-var-person-walking-arrow-loop-left,\n  \"arrow-up-z-a\": $fa-var-arrow-up-z-a,\n  \"sort-alpha-up-alt\": $fa-var-sort-alpha-up-alt,\n  \"fire-flame-curved\": $fa-var-fire-flame-curved,\n  \"fire-alt\": $fa-var-fire-alt,\n  \"tornado\": $fa-var-tornado,\n  \"file-circle-plus\": $fa-var-file-circle-plus,\n  \"book-quran\": $fa-var-book-quran,\n  \"quran\": $fa-var-quran,\n  \"anchor\": $fa-var-anchor,\n  \"border-all\": $fa-var-border-all,\n  \"face-angry\": $fa-var-face-angry,\n  \"angry\": $fa-var-angry,\n  \"cookie-bite\": $fa-var-cookie-bite,\n  \"arrow-trend-down\": $fa-var-arrow-trend-down,\n  \"rss\": $fa-var-rss,\n  \"feed\": $fa-var-feed,\n  \"draw-polygon\": $fa-var-draw-polygon,\n  \"scale-balanced\": $fa-var-scale-balanced,\n  \"balance-scale\": $fa-var-balance-scale,\n  \"gauge-simple-high\": $fa-var-gauge-simple-high,\n  \"tachometer\": $fa-var-tachometer,\n  \"tachometer-fast\": $fa-var-tachometer-fast,\n  \"shower\": $fa-var-shower,\n  \"desktop\": $fa-var-desktop,\n  \"desktop-alt\": $fa-var-desktop-alt,\n  \"m\": $fa-var-m,\n  \"table-list\": $fa-var-table-list,\n  \"th-list\": $fa-var-th-list,\n  \"comment-sms\": $fa-var-comment-sms,\n  \"sms\": $fa-var-sms,\n  \"book\": $fa-var-book,\n  \"user-plus\": $fa-var-user-plus,\n  \"check\": $fa-var-check,\n  \"battery-three-quarters\": $fa-var-battery-three-quarters,\n  \"battery-4\": $fa-var-battery-4,\n  \"house-circle-check\": $fa-var-house-circle-check,\n  \"angle-left\": $fa-var-angle-left,\n  \"diagram-successor\": $fa-var-diagram-successor,\n  \"truck-arrow-right\": $fa-var-truck-arrow-right,\n  \"arrows-split-up-and-left\": $fa-var-arrows-split-up-and-left,\n  \"hand-fist\": $fa-var-hand-fist,\n  \"fist-raised\": $fa-var-fist-raised,\n  \"cloud-moon\": $fa-var-cloud-moon,\n  \"briefcase\": $fa-var-briefcase,\n  \"person-falling\": $fa-var-person-falling,\n  \"image-portrait\": $fa-var-image-portrait,\n  \"portrait\": $fa-var-portrait,\n  \"user-tag\": $fa-var-user-tag,\n  \"rug\": $fa-var-rug,\n  \"earth-europe\": $fa-var-earth-europe,\n  \"globe-europe\": $fa-var-globe-europe,\n  \"cart-flatbed-suitcase\": $fa-var-cart-flatbed-suitcase,\n  \"luggage-cart\": $fa-var-luggage-cart,\n  \"rectangle-xmark\": $fa-var-rectangle-xmark,\n  \"rectangle-times\": $fa-var-rectangle-times,\n  \"times-rectangle\": $fa-var-times-rectangle,\n  \"window-close\": $fa-var-window-close,\n  \"baht-sign\": $fa-var-baht-sign,\n  \"book-open\": $fa-var-book-open,\n  \"book-journal-whills\": $fa-var-book-journal-whills,\n  \"journal-whills\": $fa-var-journal-whills,\n  \"handcuffs\": $fa-var-handcuffs,\n  \"triangle-exclamation\": $fa-var-triangle-exclamation,\n  \"exclamation-triangle\": $fa-var-exclamation-triangle,\n  \"warning\": $fa-var-warning,\n  \"database\": $fa-var-database,\n  \"share\": $fa-var-share,\n  \"mail-forward\": $fa-var-mail-forward,\n  \"bottle-droplet\": $fa-var-bottle-droplet,\n  \"mask-face\": $fa-var-mask-face,\n  \"hill-rockslide\": $fa-var-hill-rockslide,\n  \"right-left\": $fa-var-right-left,\n  \"exchange-alt\": $fa-var-exchange-alt,\n  \"paper-plane\": $fa-var-paper-plane,\n  \"road-circle-exclamation\": $fa-var-road-circle-exclamation,\n  \"dungeon\": $fa-var-dungeon,\n  \"align-right\": $fa-var-align-right,\n  \"money-bill-1-wave\": $fa-var-money-bill-1-wave,\n  \"money-bill-wave-alt\": $fa-var-money-bill-wave-alt,\n  \"life-ring\": $fa-var-life-ring,\n  \"hands\": $fa-var-hands,\n  \"sign-language\": $fa-var-sign-language,\n  \"signing\": $fa-var-signing,\n  \"calendar-day\": $fa-var-calendar-day,\n  \"water-ladder\": $fa-var-water-ladder,\n  \"ladder-water\": $fa-var-ladder-water,\n  \"swimming-pool\": $fa-var-swimming-pool,\n  \"arrows-up-down\": $fa-var-arrows-up-down,\n  \"arrows-v\": $fa-var-arrows-v,\n  \"face-grimace\": $fa-var-face-grimace,\n  \"grimace\": $fa-var-grimace,\n  \"wheelchair-move\": $fa-var-wheelchair-move,\n  \"wheelchair-alt\": $fa-var-wheelchair-alt,\n  \"turn-down\": $fa-var-turn-down,\n  \"level-down-alt\": $fa-var-level-down-alt,\n  \"person-walking-arrow-right\": $fa-var-person-walking-arrow-right,\n  \"square-envelope\": $fa-var-square-envelope,\n  \"envelope-square\": $fa-var-envelope-square,\n  \"dice\": $fa-var-dice,\n  \"bowling-ball\": $fa-var-bowling-ball,\n  \"brain\": $fa-var-brain,\n  \"bandage\": $fa-var-bandage,\n  \"band-aid\": $fa-var-band-aid,\n  \"calendar-minus\": $fa-var-calendar-minus,\n  \"circle-xmark\": $fa-var-circle-xmark,\n  \"times-circle\": $fa-var-times-circle,\n  \"xmark-circle\": $fa-var-xmark-circle,\n  \"gifts\": $fa-var-gifts,\n  \"hotel\": $fa-var-hotel,\n  \"earth-asia\": $fa-var-earth-asia,\n  \"globe-asia\": $fa-var-globe-asia,\n  \"id-card-clip\": $fa-var-id-card-clip,\n  \"id-card-alt\": $fa-var-id-card-alt,\n  \"magnifying-glass-plus\": $fa-var-magnifying-glass-plus,\n  \"search-plus\": $fa-var-search-plus,\n  \"thumbs-up\": $fa-var-thumbs-up,\n  \"user-clock\": $fa-var-user-clock,\n  \"hand-dots\": $fa-var-hand-dots,\n  \"allergies\": $fa-var-allergies,\n  \"file-invoice\": $fa-var-file-invoice,\n  \"window-minimize\": $fa-var-window-minimize,\n  \"mug-saucer\": $fa-var-mug-saucer,\n  \"coffee\": $fa-var-coffee,\n  \"brush\": $fa-var-brush,\n  \"mask\": $fa-var-mask,\n  \"magnifying-glass-minus\": $fa-var-magnifying-glass-minus,\n  \"search-minus\": $fa-var-search-minus,\n  \"ruler-vertical\": $fa-var-ruler-vertical,\n  \"user-large\": $fa-var-user-large,\n  \"user-alt\": $fa-var-user-alt,\n  \"train-tram\": $fa-var-train-tram,\n  \"user-nurse\": $fa-var-user-nurse,\n  \"syringe\": $fa-var-syringe,\n  \"cloud-sun\": $fa-var-cloud-sun,\n  \"stopwatch-20\": $fa-var-stopwatch-20,\n  \"square-full\": $fa-var-square-full,\n  \"magnet\": $fa-var-magnet,\n  \"jar\": $fa-var-jar,\n  \"note-sticky\": $fa-var-note-sticky,\n  \"sticky-note\": $fa-var-sticky-note,\n  \"bug-slash\": $fa-var-bug-slash,\n  \"arrow-up-from-water-pump\": $fa-var-arrow-up-from-water-pump,\n  \"bone\": $fa-var-bone,\n  \"user-injured\": $fa-var-user-injured,\n  \"face-sad-tear\": $fa-var-face-sad-tear,\n  \"sad-tear\": $fa-var-sad-tear,\n  \"plane\": $fa-var-plane,\n  \"tent-arrows-down\": $fa-var-tent-arrows-down,\n  \"exclamation\": $fa-var-exclamation,\n  \"arrows-spin\": $fa-var-arrows-spin,\n  \"print\": $fa-var-print,\n  \"turkish-lira-sign\": $fa-var-turkish-lira-sign,\n  \"try\": $fa-var-try,\n  \"turkish-lira\": $fa-var-turkish-lira,\n  \"dollar-sign\": $fa-var-dollar-sign,\n  \"dollar\": $fa-var-dollar,\n  \"usd\": $fa-var-usd,\n  \"x\": $fa-var-x,\n  \"magnifying-glass-dollar\": $fa-var-magnifying-glass-dollar,\n  \"search-dollar\": $fa-var-search-dollar,\n  \"users-gear\": $fa-var-users-gear,\n  \"users-cog\": $fa-var-users-cog,\n  \"person-military-pointing\": $fa-var-person-military-pointing,\n  \"building-columns\": $fa-var-building-columns,\n  \"bank\": $fa-var-bank,\n  \"institution\": $fa-var-institution,\n  \"museum\": $fa-var-museum,\n  \"university\": $fa-var-university,\n  \"umbrella\": $fa-var-umbrella,\n  \"trowel\": $fa-var-trowel,\n  \"d\": $fa-var-d,\n  \"stapler\": $fa-var-stapler,\n  \"masks-theater\": $fa-var-masks-theater,\n  \"theater-masks\": $fa-var-theater-masks,\n  \"kip-sign\": $fa-var-kip-sign,\n  \"hand-point-left\": $fa-var-hand-point-left,\n  \"handshake-simple\": $fa-var-handshake-simple,\n  \"handshake-alt\": $fa-var-handshake-alt,\n  \"jet-fighter\": $fa-var-jet-fighter,\n  \"fighter-jet\": $fa-var-fighter-jet,\n  \"square-share-nodes\": $fa-var-square-share-nodes,\n  \"share-alt-square\": $fa-var-share-alt-square,\n  \"barcode\": $fa-var-barcode,\n  \"plus-minus\": $fa-var-plus-minus,\n  \"video\": $fa-var-video,\n  \"video-camera\": $fa-var-video-camera,\n  \"graduation-cap\": $fa-var-graduation-cap,\n  \"mortar-board\": $fa-var-mortar-board,\n  \"hand-holding-medical\": $fa-var-hand-holding-medical,\n  \"person-circle-check\": $fa-var-person-circle-check,\n  \"turn-up\": $fa-var-turn-up,\n  \"level-up-alt\": $fa-var-level-up-alt,\n);\n\n$fa-brand-icons: (\n  \"monero\": $fa-var-monero,\n  \"hooli\": $fa-var-hooli,\n  \"yelp\": $fa-var-yelp,\n  \"cc-visa\": $fa-var-cc-visa,\n  \"lastfm\": $fa-var-lastfm,\n  \"shopware\": $fa-var-shopware,\n  \"creative-commons-nc\": $fa-var-creative-commons-nc,\n  \"aws\": $fa-var-aws,\n  \"redhat\": $fa-var-redhat,\n  \"yoast\": $fa-var-yoast,\n  \"cloudflare\": $fa-var-cloudflare,\n  \"ups\": $fa-var-ups,\n  \"pixiv\": $fa-var-pixiv,\n  \"wpexplorer\": $fa-var-wpexplorer,\n  \"dyalog\": $fa-var-dyalog,\n  \"bity\": $fa-var-bity,\n  \"stackpath\": $fa-var-stackpath,\n  \"buysellads\": $fa-var-buysellads,\n  \"first-order\": $fa-var-first-order,\n  \"modx\": $fa-var-modx,\n  \"guilded\": $fa-var-guilded,\n  \"vnv\": $fa-var-vnv,\n  \"square-js\": $fa-var-square-js,\n  \"js-square\": $fa-var-js-square,\n  \"microsoft\": $fa-var-microsoft,\n  \"qq\": $fa-var-qq,\n  \"orcid\": $fa-var-orcid,\n  \"java\": $fa-var-java,\n  \"invision\": $fa-var-invision,\n  \"creative-commons-pd-alt\": $fa-var-creative-commons-pd-alt,\n  \"centercode\": $fa-var-centercode,\n  \"glide-g\": $fa-var-glide-g,\n  \"drupal\": $fa-var-drupal,\n  \"jxl\": $fa-var-jxl,\n  \"hire-a-helper\": $fa-var-hire-a-helper,\n  \"creative-commons-by\": $fa-var-creative-commons-by,\n  \"unity\": $fa-var-unity,\n  \"whmcs\": $fa-var-whmcs,\n  \"rocketchat\": $fa-var-rocketchat,\n  \"vk\": $fa-var-vk,\n  \"untappd\": $fa-var-untappd,\n  \"mailchimp\": $fa-var-mailchimp,\n  \"css3-alt\": $fa-var-css3-alt,\n  \"square-reddit\": $fa-var-square-reddit,\n  \"reddit-square\": $fa-var-reddit-square,\n  \"vimeo-v\": $fa-var-vimeo-v,\n  \"contao\": $fa-var-contao,\n  \"square-font-awesome\": $fa-var-square-font-awesome,\n  \"deskpro\": $fa-var-deskpro,\n  \"brave\": $fa-var-brave,\n  \"sistrix\": $fa-var-sistrix,\n  \"square-instagram\": $fa-var-square-instagram,\n  \"instagram-square\": $fa-var-instagram-square,\n  \"battle-net\": $fa-var-battle-net,\n  \"the-red-yeti\": $fa-var-the-red-yeti,\n  \"square-hacker-news\": $fa-var-square-hacker-news,\n  \"hacker-news-square\": $fa-var-hacker-news-square,\n  \"edge\": $fa-var-edge,\n  \"threads\": $fa-var-threads,\n  \"napster\": $fa-var-napster,\n  \"square-snapchat\": $fa-var-square-snapchat,\n  \"snapchat-square\": $fa-var-snapchat-square,\n  \"google-plus-g\": $fa-var-google-plus-g,\n  \"artstation\": $fa-var-artstation,\n  \"markdown\": $fa-var-markdown,\n  \"sourcetree\": $fa-var-sourcetree,\n  \"google-plus\": $fa-var-google-plus,\n  \"diaspora\": $fa-var-diaspora,\n  \"foursquare\": $fa-var-foursquare,\n  \"stack-overflow\": $fa-var-stack-overflow,\n  \"github-alt\": $fa-var-github-alt,\n  \"phoenix-squadron\": $fa-var-phoenix-squadron,\n  \"pagelines\": $fa-var-pagelines,\n  \"algolia\": $fa-var-algolia,\n  \"red-river\": $fa-var-red-river,\n  \"creative-commons-sa\": $fa-var-creative-commons-sa,\n  \"safari\": $fa-var-safari,\n  \"google\": $fa-var-google,\n  \"square-font-awesome-stroke\": $fa-var-square-font-awesome-stroke,\n  \"font-awesome-alt\": $fa-var-font-awesome-alt,\n  \"atlassian\": $fa-var-atlassian,\n  \"linkedin-in\": $fa-var-linkedin-in,\n  \"digital-ocean\": $fa-var-digital-ocean,\n  \"nimblr\": $fa-var-nimblr,\n  \"chromecast\": $fa-var-chromecast,\n  \"evernote\": $fa-var-evernote,\n  \"hacker-news\": $fa-var-hacker-news,\n  \"creative-commons-sampling\": $fa-var-creative-commons-sampling,\n  \"adversal\": $fa-var-adversal,\n  \"creative-commons\": $fa-var-creative-commons,\n  \"watchman-monitoring\": $fa-var-watchman-monitoring,\n  \"fonticons\": $fa-var-fonticons,\n  \"weixin\": $fa-var-weixin,\n  \"shirtsinbulk\": $fa-var-shirtsinbulk,\n  \"codepen\": $fa-var-codepen,\n  \"git-alt\": $fa-var-git-alt,\n  \"lyft\": $fa-var-lyft,\n  \"rev\": $fa-var-rev,\n  \"windows\": $fa-var-windows,\n  \"wizards-of-the-coast\": $fa-var-wizards-of-the-coast,\n  \"square-viadeo\": $fa-var-square-viadeo,\n  \"viadeo-square\": $fa-var-viadeo-square,\n  \"meetup\": $fa-var-meetup,\n  \"centos\": $fa-var-centos,\n  \"adn\": $fa-var-adn,\n  \"cloudsmith\": $fa-var-cloudsmith,\n  \"opensuse\": $fa-var-opensuse,\n  \"pied-piper-alt\": $fa-var-pied-piper-alt,\n  \"square-dribbble\": $fa-var-square-dribbble,\n  \"dribbble-square\": $fa-var-dribbble-square,\n  \"codiepie\": $fa-var-codiepie,\n  \"node\": $fa-var-node,\n  \"mix\": $fa-var-mix,\n  \"steam\": $fa-var-steam,\n  \"cc-apple-pay\": $fa-var-cc-apple-pay,\n  \"scribd\": $fa-var-scribd,\n  \"debian\": $fa-var-debian,\n  \"openid\": $fa-var-openid,\n  \"instalod\": $fa-var-instalod,\n  \"expeditedssl\": $fa-var-expeditedssl,\n  \"sellcast\": $fa-var-sellcast,\n  \"square-twitter\": $fa-var-square-twitter,\n  \"twitter-square\": $fa-var-twitter-square,\n  \"r-project\": $fa-var-r-project,\n  \"delicious\": $fa-var-delicious,\n  \"freebsd\": $fa-var-freebsd,\n  \"vuejs\": $fa-var-vuejs,\n  \"accusoft\": $fa-var-accusoft,\n  \"ioxhost\": $fa-var-ioxhost,\n  \"fonticons-fi\": $fa-var-fonticons-fi,\n  \"app-store\": $fa-var-app-store,\n  \"cc-mastercard\": $fa-var-cc-mastercard,\n  \"itunes-note\": $fa-var-itunes-note,\n  \"golang\": $fa-var-golang,\n  \"kickstarter\": $fa-var-kickstarter,\n  \"square-kickstarter\": $fa-var-square-kickstarter,\n  \"grav\": $fa-var-grav,\n  \"weibo\": $fa-var-weibo,\n  \"uncharted\": $fa-var-uncharted,\n  \"firstdraft\": $fa-var-firstdraft,\n  \"square-youtube\": $fa-var-square-youtube,\n  \"youtube-square\": $fa-var-youtube-square,\n  \"wikipedia-w\": $fa-var-wikipedia-w,\n  \"wpressr\": $fa-var-wpressr,\n  \"rendact\": $fa-var-rendact,\n  \"angellist\": $fa-var-angellist,\n  \"galactic-republic\": $fa-var-galactic-republic,\n  \"nfc-directional\": $fa-var-nfc-directional,\n  \"skype\": $fa-var-skype,\n  \"joget\": $fa-var-joget,\n  \"fedora\": $fa-var-fedora,\n  \"stripe-s\": $fa-var-stripe-s,\n  \"meta\": $fa-var-meta,\n  \"laravel\": $fa-var-laravel,\n  \"hotjar\": $fa-var-hotjar,\n  \"bluetooth-b\": $fa-var-bluetooth-b,\n  \"square-letterboxd\": $fa-var-square-letterboxd,\n  \"sticker-mule\": $fa-var-sticker-mule,\n  \"creative-commons-zero\": $fa-var-creative-commons-zero,\n  \"hips\": $fa-var-hips,\n  \"behance\": $fa-var-behance,\n  \"reddit\": $fa-var-reddit,\n  \"discord\": $fa-var-discord,\n  \"chrome\": $fa-var-chrome,\n  \"app-store-ios\": $fa-var-app-store-ios,\n  \"cc-discover\": $fa-var-cc-discover,\n  \"wpbeginner\": $fa-var-wpbeginner,\n  \"confluence\": $fa-var-confluence,\n  \"shoelace\": $fa-var-shoelace,\n  \"mdb\": $fa-var-mdb,\n  \"dochub\": $fa-var-dochub,\n  \"accessible-icon\": $fa-var-accessible-icon,\n  \"ebay\": $fa-var-ebay,\n  \"amazon\": $fa-var-amazon,\n  \"unsplash\": $fa-var-unsplash,\n  \"yarn\": $fa-var-yarn,\n  \"square-steam\": $fa-var-square-steam,\n  \"steam-square\": $fa-var-steam-square,\n  \"500px\": $fa-var-500px,\n  \"square-vimeo\": $fa-var-square-vimeo,\n  \"vimeo-square\": $fa-var-vimeo-square,\n  \"asymmetrik\": $fa-var-asymmetrik,\n  \"font-awesome\": $fa-var-font-awesome,\n  \"font-awesome-flag\": $fa-var-font-awesome-flag,\n  \"font-awesome-logo-full\": $fa-var-font-awesome-logo-full,\n  \"gratipay\": $fa-var-gratipay,\n  \"apple\": $fa-var-apple,\n  \"hive\": $fa-var-hive,\n  \"gitkraken\": $fa-var-gitkraken,\n  \"keybase\": $fa-var-keybase,\n  \"apple-pay\": $fa-var-apple-pay,\n  \"padlet\": $fa-var-padlet,\n  \"amazon-pay\": $fa-var-amazon-pay,\n  \"square-github\": $fa-var-square-github,\n  \"github-square\": $fa-var-github-square,\n  \"stumbleupon\": $fa-var-stumbleupon,\n  \"fedex\": $fa-var-fedex,\n  \"phoenix-framework\": $fa-var-phoenix-framework,\n  \"shopify\": $fa-var-shopify,\n  \"neos\": $fa-var-neos,\n  \"square-threads\": $fa-var-square-threads,\n  \"hackerrank\": $fa-var-hackerrank,\n  \"researchgate\": $fa-var-researchgate,\n  \"swift\": $fa-var-swift,\n  \"angular\": $fa-var-angular,\n  \"speakap\": $fa-var-speakap,\n  \"angrycreative\": $fa-var-angrycreative,\n  \"y-combinator\": $fa-var-y-combinator,\n  \"empire\": $fa-var-empire,\n  \"envira\": $fa-var-envira,\n  \"google-scholar\": $fa-var-google-scholar,\n  \"square-gitlab\": $fa-var-square-gitlab,\n  \"gitlab-square\": $fa-var-gitlab-square,\n  \"studiovinari\": $fa-var-studiovinari,\n  \"pied-piper\": $fa-var-pied-piper,\n  \"wordpress\": $fa-var-wordpress,\n  \"product-hunt\": $fa-var-product-hunt,\n  \"firefox\": $fa-var-firefox,\n  \"linode\": $fa-var-linode,\n  \"goodreads\": $fa-var-goodreads,\n  \"square-odnoklassniki\": $fa-var-square-odnoklassniki,\n  \"odnoklassniki-square\": $fa-var-odnoklassniki-square,\n  \"jsfiddle\": $fa-var-jsfiddle,\n  \"sith\": $fa-var-sith,\n  \"themeisle\": $fa-var-themeisle,\n  \"page4\": $fa-var-page4,\n  \"hashnode\": $fa-var-hashnode,\n  \"react\": $fa-var-react,\n  \"cc-paypal\": $fa-var-cc-paypal,\n  \"squarespace\": $fa-var-squarespace,\n  \"cc-stripe\": $fa-var-cc-stripe,\n  \"creative-commons-share\": $fa-var-creative-commons-share,\n  \"bitcoin\": $fa-var-bitcoin,\n  \"keycdn\": $fa-var-keycdn,\n  \"opera\": $fa-var-opera,\n  \"itch-io\": $fa-var-itch-io,\n  \"umbraco\": $fa-var-umbraco,\n  \"galactic-senate\": $fa-var-galactic-senate,\n  \"ubuntu\": $fa-var-ubuntu,\n  \"draft2digital\": $fa-var-draft2digital,\n  \"stripe\": $fa-var-stripe,\n  \"houzz\": $fa-var-houzz,\n  \"gg\": $fa-var-gg,\n  \"dhl\": $fa-var-dhl,\n  \"square-pinterest\": $fa-var-square-pinterest,\n  \"pinterest-square\": $fa-var-pinterest-square,\n  \"xing\": $fa-var-xing,\n  \"blackberry\": $fa-var-blackberry,\n  \"creative-commons-pd\": $fa-var-creative-commons-pd,\n  \"playstation\": $fa-var-playstation,\n  \"quinscape\": $fa-var-quinscape,\n  \"less\": $fa-var-less,\n  \"blogger-b\": $fa-var-blogger-b,\n  \"opencart\": $fa-var-opencart,\n  \"vine\": $fa-var-vine,\n  \"signal-messenger\": $fa-var-signal-messenger,\n  \"paypal\": $fa-var-paypal,\n  \"gitlab\": $fa-var-gitlab,\n  \"typo3\": $fa-var-typo3,\n  \"reddit-alien\": $fa-var-reddit-alien,\n  \"yahoo\": $fa-var-yahoo,\n  \"dailymotion\": $fa-var-dailymotion,\n  \"affiliatetheme\": $fa-var-affiliatetheme,\n  \"pied-piper-pp\": $fa-var-pied-piper-pp,\n  \"bootstrap\": $fa-var-bootstrap,\n  \"odnoklassniki\": $fa-var-odnoklassniki,\n  \"nfc-symbol\": $fa-var-nfc-symbol,\n  \"mintbit\": $fa-var-mintbit,\n  \"ethereum\": $fa-var-ethereum,\n  \"speaker-deck\": $fa-var-speaker-deck,\n  \"creative-commons-nc-eu\": $fa-var-creative-commons-nc-eu,\n  \"patreon\": $fa-var-patreon,\n  \"avianex\": $fa-var-avianex,\n  \"ello\": $fa-var-ello,\n  \"gofore\": $fa-var-gofore,\n  \"bimobject\": $fa-var-bimobject,\n  \"brave-reverse\": $fa-var-brave-reverse,\n  \"facebook-f\": $fa-var-facebook-f,\n  \"square-google-plus\": $fa-var-square-google-plus,\n  \"google-plus-square\": $fa-var-google-plus-square,\n  \"web-awesome\": $fa-var-web-awesome,\n  \"mandalorian\": $fa-var-mandalorian,\n  \"first-order-alt\": $fa-var-first-order-alt,\n  \"osi\": $fa-var-osi,\n  \"google-wallet\": $fa-var-google-wallet,\n  \"d-and-d-beyond\": $fa-var-d-and-d-beyond,\n  \"periscope\": $fa-var-periscope,\n  \"fulcrum\": $fa-var-fulcrum,\n  \"cloudscale\": $fa-var-cloudscale,\n  \"forumbee\": $fa-var-forumbee,\n  \"mizuni\": $fa-var-mizuni,\n  \"schlix\": $fa-var-schlix,\n  \"square-xing\": $fa-var-square-xing,\n  \"xing-square\": $fa-var-xing-square,\n  \"bandcamp\": $fa-var-bandcamp,\n  \"wpforms\": $fa-var-wpforms,\n  \"cloudversify\": $fa-var-cloudversify,\n  \"usps\": $fa-var-usps,\n  \"megaport\": $fa-var-megaport,\n  \"magento\": $fa-var-magento,\n  \"spotify\": $fa-var-spotify,\n  \"optin-monster\": $fa-var-optin-monster,\n  \"fly\": $fa-var-fly,\n  \"aviato\": $fa-var-aviato,\n  \"itunes\": $fa-var-itunes,\n  \"cuttlefish\": $fa-var-cuttlefish,\n  \"blogger\": $fa-var-blogger,\n  \"flickr\": $fa-var-flickr,\n  \"viber\": $fa-var-viber,\n  \"soundcloud\": $fa-var-soundcloud,\n  \"digg\": $fa-var-digg,\n  \"tencent-weibo\": $fa-var-tencent-weibo,\n  \"letterboxd\": $fa-var-letterboxd,\n  \"symfony\": $fa-var-symfony,\n  \"maxcdn\": $fa-var-maxcdn,\n  \"etsy\": $fa-var-etsy,\n  \"facebook-messenger\": $fa-var-facebook-messenger,\n  \"audible\": $fa-var-audible,\n  \"think-peaks\": $fa-var-think-peaks,\n  \"bilibili\": $fa-var-bilibili,\n  \"erlang\": $fa-var-erlang,\n  \"x-twitter\": $fa-var-x-twitter,\n  \"cotton-bureau\": $fa-var-cotton-bureau,\n  \"dashcube\": $fa-var-dashcube,\n  \"42-group\": $fa-var-42-group,\n  \"innosoft\": $fa-var-innosoft,\n  \"stack-exchange\": $fa-var-stack-exchange,\n  \"elementor\": $fa-var-elementor,\n  \"square-pied-piper\": $fa-var-square-pied-piper,\n  \"pied-piper-square\": $fa-var-pied-piper-square,\n  \"creative-commons-nd\": $fa-var-creative-commons-nd,\n  \"palfed\": $fa-var-palfed,\n  \"superpowers\": $fa-var-superpowers,\n  \"resolving\": $fa-var-resolving,\n  \"xbox\": $fa-var-xbox,\n  \"square-web-awesome-stroke\": $fa-var-square-web-awesome-stroke,\n  \"searchengin\": $fa-var-searchengin,\n  \"tiktok\": $fa-var-tiktok,\n  \"square-facebook\": $fa-var-square-facebook,\n  \"facebook-square\": $fa-var-facebook-square,\n  \"renren\": $fa-var-renren,\n  \"linux\": $fa-var-linux,\n  \"glide\": $fa-var-glide,\n  \"linkedin\": $fa-var-linkedin,\n  \"hubspot\": $fa-var-hubspot,\n  \"deploydog\": $fa-var-deploydog,\n  \"twitch\": $fa-var-twitch,\n  \"ravelry\": $fa-var-ravelry,\n  \"mixer\": $fa-var-mixer,\n  \"square-lastfm\": $fa-var-square-lastfm,\n  \"lastfm-square\": $fa-var-lastfm-square,\n  \"vimeo\": $fa-var-vimeo,\n  \"mendeley\": $fa-var-mendeley,\n  \"uniregistry\": $fa-var-uniregistry,\n  \"figma\": $fa-var-figma,\n  \"creative-commons-remix\": $fa-var-creative-commons-remix,\n  \"cc-amazon-pay\": $fa-var-cc-amazon-pay,\n  \"dropbox\": $fa-var-dropbox,\n  \"instagram\": $fa-var-instagram,\n  \"cmplid\": $fa-var-cmplid,\n  \"upwork\": $fa-var-upwork,\n  \"facebook\": $fa-var-facebook,\n  \"gripfire\": $fa-var-gripfire,\n  \"jedi-order\": $fa-var-jedi-order,\n  \"uikit\": $fa-var-uikit,\n  \"fort-awesome-alt\": $fa-var-fort-awesome-alt,\n  \"phabricator\": $fa-var-phabricator,\n  \"ussunnah\": $fa-var-ussunnah,\n  \"earlybirds\": $fa-var-earlybirds,\n  \"trade-federation\": $fa-var-trade-federation,\n  \"autoprefixer\": $fa-var-autoprefixer,\n  \"whatsapp\": $fa-var-whatsapp,\n  \"square-upwork\": $fa-var-square-upwork,\n  \"slideshare\": $fa-var-slideshare,\n  \"google-play\": $fa-var-google-play,\n  \"viadeo\": $fa-var-viadeo,\n  \"line\": $fa-var-line,\n  \"google-drive\": $fa-var-google-drive,\n  \"servicestack\": $fa-var-servicestack,\n  \"simplybuilt\": $fa-var-simplybuilt,\n  \"bitbucket\": $fa-var-bitbucket,\n  \"imdb\": $fa-var-imdb,\n  \"deezer\": $fa-var-deezer,\n  \"raspberry-pi\": $fa-var-raspberry-pi,\n  \"jira\": $fa-var-jira,\n  \"docker\": $fa-var-docker,\n  \"screenpal\": $fa-var-screenpal,\n  \"bluetooth\": $fa-var-bluetooth,\n  \"gitter\": $fa-var-gitter,\n  \"d-and-d\": $fa-var-d-and-d,\n  \"microblog\": $fa-var-microblog,\n  \"cc-diners-club\": $fa-var-cc-diners-club,\n  \"gg-circle\": $fa-var-gg-circle,\n  \"pied-piper-hat\": $fa-var-pied-piper-hat,\n  \"kickstarter-k\": $fa-var-kickstarter-k,\n  \"yandex\": $fa-var-yandex,\n  \"readme\": $fa-var-readme,\n  \"html5\": $fa-var-html5,\n  \"sellsy\": $fa-var-sellsy,\n  \"square-web-awesome\": $fa-var-square-web-awesome,\n  \"sass\": $fa-var-sass,\n  \"wirsindhandwerk\": $fa-var-wirsindhandwerk,\n  \"wsh\": $fa-var-wsh,\n  \"buromobelexperte\": $fa-var-buromobelexperte,\n  \"salesforce\": $fa-var-salesforce,\n  \"octopus-deploy\": $fa-var-octopus-deploy,\n  \"medapps\": $fa-var-medapps,\n  \"ns8\": $fa-var-ns8,\n  \"pinterest-p\": $fa-var-pinterest-p,\n  \"apper\": $fa-var-apper,\n  \"fort-awesome\": $fa-var-fort-awesome,\n  \"waze\": $fa-var-waze,\n  \"bluesky\": $fa-var-bluesky,\n  \"cc-jcb\": $fa-var-cc-jcb,\n  \"snapchat\": $fa-var-snapchat,\n  \"snapchat-ghost\": $fa-var-snapchat-ghost,\n  \"fantasy-flight-games\": $fa-var-fantasy-flight-games,\n  \"rust\": $fa-var-rust,\n  \"wix\": $fa-var-wix,\n  \"square-behance\": $fa-var-square-behance,\n  \"behance-square\": $fa-var-behance-square,\n  \"supple\": $fa-var-supple,\n  \"webflow\": $fa-var-webflow,\n  \"rebel\": $fa-var-rebel,\n  \"css3\": $fa-var-css3,\n  \"staylinked\": $fa-var-staylinked,\n  \"kaggle\": $fa-var-kaggle,\n  \"space-awesome\": $fa-var-space-awesome,\n  \"deviantart\": $fa-var-deviantart,\n  \"cpanel\": $fa-var-cpanel,\n  \"goodreads-g\": $fa-var-goodreads-g,\n  \"square-git\": $fa-var-square-git,\n  \"git-square\": $fa-var-git-square,\n  \"square-tumblr\": $fa-var-square-tumblr,\n  \"tumblr-square\": $fa-var-tumblr-square,\n  \"trello\": $fa-var-trello,\n  \"creative-commons-nc-jp\": $fa-var-creative-commons-nc-jp,\n  \"get-pocket\": $fa-var-get-pocket,\n  \"perbyte\": $fa-var-perbyte,\n  \"grunt\": $fa-var-grunt,\n  \"weebly\": $fa-var-weebly,\n  \"connectdevelop\": $fa-var-connectdevelop,\n  \"leanpub\": $fa-var-leanpub,\n  \"black-tie\": $fa-var-black-tie,\n  \"themeco\": $fa-var-themeco,\n  \"python\": $fa-var-python,\n  \"android\": $fa-var-android,\n  \"bots\": $fa-var-bots,\n  \"free-code-camp\": $fa-var-free-code-camp,\n  \"hornbill\": $fa-var-hornbill,\n  \"js\": $fa-var-js,\n  \"ideal\": $fa-var-ideal,\n  \"git\": $fa-var-git,\n  \"dev\": $fa-var-dev,\n  \"sketch\": $fa-var-sketch,\n  \"yandex-international\": $fa-var-yandex-international,\n  \"cc-amex\": $fa-var-cc-amex,\n  \"uber\": $fa-var-uber,\n  \"github\": $fa-var-github,\n  \"php\": $fa-var-php,\n  \"alipay\": $fa-var-alipay,\n  \"youtube\": $fa-var-youtube,\n  \"skyatlas\": $fa-var-skyatlas,\n  \"firefox-browser\": $fa-var-firefox-browser,\n  \"replyd\": $fa-var-replyd,\n  \"suse\": $fa-var-suse,\n  \"jenkins\": $fa-var-jenkins,\n  \"twitter\": $fa-var-twitter,\n  \"rockrms\": $fa-var-rockrms,\n  \"pinterest\": $fa-var-pinterest,\n  \"buffer\": $fa-var-buffer,\n  \"npm\": $fa-var-npm,\n  \"yammer\": $fa-var-yammer,\n  \"btc\": $fa-var-btc,\n  \"dribbble\": $fa-var-dribbble,\n  \"stumbleupon-circle\": $fa-var-stumbleupon-circle,\n  \"internet-explorer\": $fa-var-internet-explorer,\n  \"stubber\": $fa-var-stubber,\n  \"telegram\": $fa-var-telegram,\n  \"telegram-plane\": $fa-var-telegram-plane,\n  \"old-republic\": $fa-var-old-republic,\n  \"odysee\": $fa-var-odysee,\n  \"square-whatsapp\": $fa-var-square-whatsapp,\n  \"whatsapp-square\": $fa-var-whatsapp-square,\n  \"node-js\": $fa-var-node-js,\n  \"edge-legacy\": $fa-var-edge-legacy,\n  \"slack\": $fa-var-slack,\n  \"slack-hash\": $fa-var-slack-hash,\n  \"medrt\": $fa-var-medrt,\n  \"usb\": $fa-var-usb,\n  \"tumblr\": $fa-var-tumblr,\n  \"vaadin\": $fa-var-vaadin,\n  \"quora\": $fa-var-quora,\n  \"square-x-twitter\": $fa-var-square-x-twitter,\n  \"reacteurope\": $fa-var-reacteurope,\n  \"medium\": $fa-var-medium,\n  \"medium-m\": $fa-var-medium-m,\n  \"amilia\": $fa-var-amilia,\n  \"mixcloud\": $fa-var-mixcloud,\n  \"flipboard\": $fa-var-flipboard,\n  \"viacoin\": $fa-var-viacoin,\n  \"critical-role\": $fa-var-critical-role,\n  \"sitrox\": $fa-var-sitrox,\n  \"discourse\": $fa-var-discourse,\n  \"joomla\": $fa-var-joomla,\n  \"mastodon\": $fa-var-mastodon,\n  \"airbnb\": $fa-var-airbnb,\n  \"wolf-pack-battalion\": $fa-var-wolf-pack-battalion,\n  \"buy-n-large\": $fa-var-buy-n-large,\n  \"gulp\": $fa-var-gulp,\n  \"creative-commons-sampling-plus\": $fa-var-creative-commons-sampling-plus,\n  \"strava\": $fa-var-strava,\n  \"ember\": $fa-var-ember,\n  \"canadian-maple-leaf\": $fa-var-canadian-maple-leaf,\n  \"teamspeak\": $fa-var-teamspeak,\n  \"pushed\": $fa-var-pushed,\n  \"wordpress-simple\": $fa-var-wordpress-simple,\n  \"nutritionix\": $fa-var-nutritionix,\n  \"wodu\": $fa-var-wodu,\n  \"google-pay\": $fa-var-google-pay,\n  \"intercom\": $fa-var-intercom,\n  \"zhihu\": $fa-var-zhihu,\n  \"korvue\": $fa-var-korvue,\n  \"pix\": $fa-var-pix,\n  \"steam-symbol\": $fa-var-steam-symbol,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left {\n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right {\n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-bounce {\n  animation-name: #{$fa-css-prefix}-bounce;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(0.280, 0.840, 0.420, 1));\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-beat-fade {\n  animation-name: #{$fa-css-prefix}-beat-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-shake {\n  animation-name: #{$fa-css-prefix}-shake;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-bounce,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-beat-fade,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-shake,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-bounce {\n  0%   { transform: scale(1,1) translateY(0); }\n  10%  { transform: scale(var(--#{$fa-css-prefix}-bounce-start-scale-x, 1.1),var(--#{$fa-css-prefix}-bounce-start-scale-y, 0.9)) translateY(0); }\n  30%  { transform: scale(var(--#{$fa-css-prefix}-bounce-jump-scale-x, 0.9),var(--#{$fa-css-prefix}-bounce-jump-scale-y, 1.1)) translateY(var(--#{$fa-css-prefix}-bounce-height, -0.5em)); }\n  50%  { transform: scale(var(--#{$fa-css-prefix}-bounce-land-scale-x, 1.05),var(--#{$fa-css-prefix}-bounce-land-scale-y, 0.95)) translateY(0); }\n  57%  { transform: scale(1,1) translateY(var(--#{$fa-css-prefix}-bounce-rebound, -0.125em)); }\n  64%  { transform: scale(1,1) translateY(0); }\n  100% { transform: scale(1,1) translateY(0); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-beat-fade {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-beat-fade-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-shake {\n  0% { transform: rotate(-15deg); }\n  4% { transform: rotate(15deg); }\n  8%, 24% { transform: rotate(-18deg); }\n  12%, 28% { transform: rotate(18deg); }\n  16% { transform: rotate(-22deg); }\n  20% { transform: rotate(22deg); }\n  32% { transform: rotate(-12deg); }\n  36% { transform: rotate(12deg); }\n  40%, 100% { transform: rotate(0deg); }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, 0));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name}::before { content: unquote(\"\\\"#{ $icon }\\\"\"); }\n}\n\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.#{$fa-css-prefix}-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.#{$fa-css-prefix}-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-brands: 'Font Awesome 6 Brands';\n  --#{$fa-css-prefix}-font-brands: normal 400 1em/1 'Font Awesome 6 Brands';\n}\n\n@font-face {\n  font-family: 'Font Awesome 6 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-brands-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-brands-400.ttf') format('truetype');\n}\n\n.fab,\n.#{$fa-css-prefix}-brands {\n  font-weight: 400;\n}\n\n@each $name, $icon in $fa-brand-icons {\n  .#{$fa-css-prefix}-#{$name}:before { content: unquote(\"\\\"#{ $icon }\\\"\"); }\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-solid: normal 900 1em/1 '#{ $fa-style-family }';\n}\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.#{$fa-css-prefix}-solid {\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
